import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  LocalDate: any;
  LocalTime: any;
  Long: any;
  OffsetDateTime: any;
};

export type AccountDividendRequest = {
  amount: Scalars['Float'];
  currencyCode?: InputMaybe<Scalars['String']>;
  entryTime: Scalars['OffsetDateTime'];
  memo?: InputMaybe<Scalars['String']>;
  portfolioEntryId: Scalars['Long'];
  portfolioId: Scalars['Long'];
};

export type AccountEntry = {
  __typename?: 'AccountEntry';
  accountTypeDescriptionEn?: Maybe<Scalars['String']>;
  accountTypeId?: Maybe<Scalars['Long']>;
  amount: Scalars['Float'];
  buyCurrencyPrice?: Maybe<Scalars['Float']>;
  currencyCode?: Maybe<Scalars['String']>;
  entryTime: Scalars['OffsetDateTime'];
  fromQty?: Maybe<Scalars['Float']>;
  id: Scalars['Int'];
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['Int']>;
  memo?: Maybe<Scalars['String']>;
  portfolioEntryId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  securityDescription?: Maybe<Scalars['String']>;
  toQty?: Maybe<Scalars['Float']>;
};

export type AccountEntryInput = {
  accountTypeId: Scalars['Long'];
  amount: Scalars['Float'];
  entryTime: Scalars['OffsetDateTime'];
  memo?: InputMaybe<Scalars['String']>;
  portfolioEntryId?: InputMaybe<Scalars['Long']>;
};

export type AccountOperationType = {
  __typename?: 'AccountOperationType';
  id: Scalars['Long'];
  name: Scalars['String'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  houseNo?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type AlternativeDerivativeProductsBucket = {
  __typename?: 'AlternativeDerivativeProductsBucket';
  assetClass?: Maybe<AssetClass>;
  count?: Maybe<Scalars['Long']>;
  optionType?: Maybe<DerivativeOptionType>;
};

export type AlternativeDerivativeProductsCriteria = {
  issuerId?: InputMaybe<Scalars['Long']>;
};

export type Analysis = {
  __typename?: 'Analysis';
  analyst?: Maybe<Analyst>;
  body?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Int']>;
  date: Scalars['LocalDate'];
  group?: Maybe<InstrumentGroup>;
  headline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  institute?: Maybe<AnalystInstitute>;
  instrumentGroupId?: Maybe<Scalars['Long']>;
  isin: Scalars['String'];
  latest?: Maybe<Scalars['Boolean']>;
  recommendation?: Maybe<AnalysisRecommendation>;
  recommendationPrevious?: Maybe<AnalysisRecommendation>;
  referencePrice?: Maybe<Scalars['Float']>;
  targetPrice?: Maybe<Scalars['Float']>;
  targetPricePrevious?: Maybe<Scalars['Float']>;
  timeFrame?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['Boolean']>;
};

export type AnalysisConnection = {
  __typename?: 'AnalysisConnection';
  edges: Array<AnalysisEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type AnalysisCriteria = {
  created?: InputMaybe<LocalDateRangeValue>;
  institutes?: InputMaybe<Array<Scalars['String']>>;
  isin?: InputMaybe<Array<Scalars['String']>>;
  latest?: InputMaybe<Scalars['Boolean']>;
  recommendation?: InputMaybe<AnalysisRecommendation>;
  targetFrom?: InputMaybe<Scalars['LocalDate']>;
  targetTo?: InputMaybe<Scalars['LocalDate']>;
  timeFrame?: InputMaybe<Scalars['Int']>;
  updated?: InputMaybe<Scalars['Boolean']>;
};

export type AnalysisEdge = {
  __typename?: 'AnalysisEdge';
  cursor: Scalars['ID'];
  node: Analysis;
};

export enum AnalysisRecommendation {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type AnalysisReport = {
  __typename?: 'AnalysisReport';
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Int']>;
  negativeCount?: Maybe<Scalars['Int']>;
  neutralCount?: Maybe<Scalars['Int']>;
  positiveCount?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  recommendation?: Maybe<AnalysisRecommendation>;
  targets: Array<AnalysisReportTarget>;
};

export type AnalysisReportTarget = {
  __typename?: 'AnalysisReportTarget';
  count?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  recommendation?: Maybe<AnalysisRecommendation>;
};

export type Analyst = {
  __typename?: 'Analyst';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type AnalystInstitute = {
  __typename?: 'AnalystInstitute';
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type AssetClass = {
  __typename?: 'AssetClass';
  assetGroup: AssetGroup;
  id: Scalars['Int'];
  investmentRiskLevel?: Maybe<InvestmentRiskLevel>;
  leveraged: Scalars['Boolean'];
  name: Scalars['String'];
  typeGroups: Array<AssetTypeGroup>;
  /** @deprecated Field no longer supported */
  types: Array<AssetType>;
};

export enum AssetGroup {
  Bond = 'BOND',
  Cert = 'CERT',
  Comm = 'COMM',
  Cross = 'CROSS',
  Etc = 'ETC',
  Etf = 'ETF',
  Etn = 'ETN',
  Fund = 'FUND',
  Fut = 'FUT',
  Index = 'INDEX',
  Knock = 'KNOCK',
  Mmr = 'MMR',
  Multi = 'MULTI',
  Opt = 'OPT',
  Other = 'OTHER',
  RealEstate = 'REAL_ESTATE',
  Share = 'SHARE',
  Vwl = 'VWL',
  Warr = 'WARR'
}

export type AssetGroupBucket = {
  __typename?: 'AssetGroupBucket';
  assetGroup: AssetGroup;
  count: Scalars['Int'];
};

export type AssetPage = {
  __typename?: 'AssetPage';
  assetGroup?: Maybe<AssetGroup>;
  groupId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  robots?: Maybe<RobotsMetaConfiguration>;
};

export type AssetType = {
  __typename?: 'AssetType';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AssetTypeGroup = {
  __typename?: 'AssetTypeGroup';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  types: Array<AssetType>;
};

export type AssetTypeGroupBucket = {
  __typename?: 'AssetTypeGroupBucket';
  assetTypeGroup?: Maybe<AssetTypeGroup>;
  count?: Maybe<Scalars['Long']>;
};

export type AssetTypeGroupBucketCriteria = {
  assetClass?: InputMaybe<Scalars['Long']>;
  assetGroup?: InputMaybe<AssetGroup>;
  etfIssuerId?: InputMaybe<Scalars['Long']>;
};

export type BondIssueStatus = {
  __typename?: 'BondIssueStatus';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type BondIssuer = {
  __typename?: 'BondIssuer';
  englishName?: Maybe<Scalars['String']>;
  group?: Maybe<InstrumentGroup>;
  id?: Maybe<Scalars['Int']>;
  isin?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  lei?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
};

export enum BondKeyFigure {
  AccruedInterest = 'ACCRUED_INTEREST',
  DirtyPrice = 'DIRTY_PRICE',
  Duration = 'DURATION',
  IsmaYield = 'ISMA_YIELD',
  IssueSize = 'ISSUE_SIZE',
  MinAmountTradableLot = 'MIN_AMOUNT_TRADABLE_LOT',
  ModifiedDuration = 'MODIFIED_DURATION',
  NominalValue = 'NOMINAL_VALUE'
}

export type BondKeyFigureCriteria = {
  from?: InputMaybe<Scalars['Float']>;
  keyFigure?: InputMaybe<BondKeyFigure>;
  to?: InputMaybe<Scalars['Float']>;
};

export type BondPriceAttribute = {
  __typename?: 'BondPriceAttribute';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export enum BondSortField {
  AccruedInterest = 'ACCRUED_INTEREST',
  DirtyPrice = 'DIRTY_PRICE',
  IsmaYield = 'ISMA_YIELD',
  IssueSize = 'ISSUE_SIZE',
  MaturityDate = 'MATURITY_DATE',
  MinAmountTradableLot = 'MIN_AMOUNT_TRADABLE_LOT',
  NominalCurrency = 'NOMINAL_CURRENCY',
  NominalValue = 'NOMINAL_VALUE',
  PerformanceYear_1 = 'PERFORMANCE_YEAR_1',
  Region = 'REGION'
}

export type BondStatus = {
  __typename?: 'BondStatus';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type BondType = {
  __typename?: 'BondType';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type Broker = {
  __typename?: 'Broker';
  id: Scalars['Long'];
  name: Scalars['String'];
};

export enum CalculationPeriod {
  AllTime = 'ALL_TIME',
  CurrentYear = 'CURRENT_YEAR',
  Day9 = 'DAY9',
  Day25 = 'DAY25',
  Day38 = 'DAY38',
  Day200 = 'DAY200',
  Day250 = 'DAY250',
  Intraday = 'INTRADAY',
  Month1 = 'MONTH1',
  Month2 = 'MONTH2',
  Month3 = 'MONTH3',
  Month6 = 'MONTH6',
  Week1 = 'WEEK1',
  Week2 = 'WEEK2',
  Week52 = 'WEEK52',
  Year3 = 'YEAR3',
  Year5 = 'YEAR5',
  Year10 = 'YEAR10',
  Yesterday = 'YESTERDAY'
}

export type CalendarCategory = {
  __typename?: 'CalendarCategory';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type CalendarCountry = {
  __typename?: 'CalendarCountry';
  country?: Maybe<Country>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type CalendarCurrency = {
  __typename?: 'CalendarCurrency';
  currency?: Maybe<Currency>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  actual?: Maybe<Scalars['Float']>;
  allDay?: Maybe<Scalars['Boolean']>;
  category?: Maybe<CalendarCategory>;
  consensus?: Maybe<Scalars['Float']>;
  country?: Maybe<CalendarCountry>;
  currency?: Maybe<CalendarCurrency>;
  description?: Maybe<Scalars['String']>;
  eventType?: Maybe<EventType>;
  id?: Maybe<Scalars['ID']>;
  preliminary?: Maybe<Scalars['Boolean']>;
  previous?: Maybe<Scalars['Float']>;
  products?: Maybe<Array<Maybe<CalendarProduct>>>;
  relevance?: Maybe<EventRelevance>;
  relevantTime?: Maybe<Scalars['OffsetDateTime']>;
  revised?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  when?: Maybe<Scalars['OffsetDateTime']>;
};

export type CalendarEventConnection = {
  __typename?: 'CalendarEventConnection';
  count?: Maybe<Scalars['Long']>;
  edges: Array<CalendarEventEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type CalendarEventEdge = {
  __typename?: 'CalendarEventEdge';
  cursor: Scalars['ID'];
  node: CalendarEvent;
};

export type CalendarProduct = {
  __typename?: 'CalendarProduct';
  group?: Maybe<InstrumentGroup>;
  isin?: Maybe<Scalars['String']>;
};

export type CalendarSummary = {
  __typename?: 'CalendarSummary';
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['LocalDate']>;
};

export type Chart = {
  __typename?: 'Chart';
  id: Scalars['ID'];
  series: Array<ChartSeries>;
  threshold?: Maybe<ChartThreshold>;
};

export type ChartPoint = {
  __typename?: 'ChartPoint';
  value: Scalars['Float'];
  when?: Maybe<Scalars['OffsetDateTime']>;
};

export enum ChartScope {
  FiveYear = 'FIVE_YEAR',
  Intraday = 'INTRADAY',
  Month = 'MONTH',
  SixMonth = 'SIX_MONTH',
  TenYear = 'TEN_YEAR',
  ThreeMonth = 'THREE_MONTH',
  ThreeYear = 'THREE_YEAR',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type ChartSeries = {
  __typename?: 'ChartSeries';
  data: Array<ChartPoint>;
  label: Scalars['String'];
  type: QuoteType;
};

export type ChartThreshold = {
  __typename?: 'ChartThreshold';
  type: ChartThresholdType;
  value?: Maybe<Scalars['Float']>;
};

export enum ChartThresholdType {
  YesterdayClose = 'YESTERDAY_CLOSE'
}

export type ClosePortfolioEntryRequest = {
  charges: Scalars['Float'];
  closeTime: Scalars['OffsetDateTime'];
  currencyCode?: InputMaybe<Scalars['String']>;
  instrumentId?: InputMaybe<Scalars['Long']>;
  memo?: InputMaybe<Scalars['String']>;
  portfolioEntryId: Scalars['Long'];
  portfolioId: Scalars['Long'];
  price: Scalars['Float'];
  quantity: Scalars['Float'];
};

export type Company = {
  __typename?: 'Company';
  accountingStandard?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Int']>;
  dividends?: Maybe<Array<CompanyDividend>>;
  employees?: Maybe<Array<CompanyEmployee>>;
  fiscal?: Maybe<CompanyFiscal>;
  id: Scalars['Int'];
  keyFigures?: Maybe<Array<FundamentalKeyFigures>>;
  name?: Maybe<Scalars['String']>;
  outstandingShares?: Maybe<Scalars['Long']>;
  performance?: Maybe<CompanyPerformance>;
  profile?: Maybe<CompanyProfile>;
  shareHolders?: Maybe<Array<CompanyShareHolder>>;
  statements?: Maybe<Array<CompanyStatement>>;
};


export type CompanyDividendsArgs = {
  criteria?: InputMaybe<CompanyDividendsCriteria>;
};


export type CompanyKeyFiguresArgs = {
  criteria?: InputMaybe<KeyFiguresCriteria>;
};


export type CompanyStatementsArgs = {
  criteria?: InputMaybe<CompanyStatementsCriteria>;
};

export type CompanyDividend = {
  __typename?: 'CompanyDividend';
  date?: Maybe<Scalars['LocalDate']>;
  value?: Maybe<Scalars['Float']>;
};

export type CompanyDividendsCriteria = {
  fromYear?: InputMaybe<Scalars['Int']>;
  toYear?: InputMaybe<Scalars['Int']>;
};

export type CompanyEmployee = {
  __typename?: 'CompanyEmployee';
  job?: Maybe<Scalars['String']>;
  member?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type CompanyFiscal = {
  __typename?: 'CompanyFiscal';
  day?: Maybe<Scalars['Int']>;
  month?: Maybe<Scalars['Int']>;
};

export type CompanyPerformance = {
  __typename?: 'CompanyPerformance';
  items: Array<CompanyPerformanceEntry>;
  keyFigures?: Maybe<FundamentalKeyFigures>;
};

export type CompanyPerformanceEntry = {
  __typename?: 'CompanyPerformanceEntry';
  cashFlowChange?: Maybe<Scalars['Float']>;
  cashFlowChangePercent?: Maybe<Scalars['Float']>;
  cashFlowPeriodTrend?: Maybe<Trend>;
  cashFlowYearChange?: Maybe<Scalars['Float']>;
  cashFlowYearChangePercent?: Maybe<Scalars['Float']>;
  cashFlowYearTrend?: Maybe<Trend>;
  dividendChange?: Maybe<Scalars['Float']>;
  dividendChangePercent?: Maybe<Scalars['Float']>;
  dividendPeriodTrend?: Maybe<Trend>;
  dividendYearChange?: Maybe<Scalars['Float']>;
  dividendYearChangePercent?: Maybe<Scalars['Float']>;
  dividendYearTrend?: Maybe<Trend>;
  dividendYieldAverage?: Maybe<Scalars['Float']>;
  dividendYieldChange?: Maybe<Scalars['Float']>;
  dividendYieldChangePercent?: Maybe<Scalars['Float']>;
  dividendYieldPeriodTrend?: Maybe<Trend>;
  dividendYieldYearChange?: Maybe<Scalars['Float']>;
  dividendYieldYearChangePercent?: Maybe<Scalars['Float']>;
  dividendYieldYearTrend?: Maybe<Trend>;
  netIncomeChange?: Maybe<Scalars['Float']>;
  netIncomeChangePercent?: Maybe<Scalars['Float']>;
  netIncomePeriodTrend?: Maybe<Trend>;
  netIncomeYearChange?: Maybe<Scalars['Float']>;
  netIncomeYearChangePercent?: Maybe<Scalars['Float']>;
  netIncomeYearTrend?: Maybe<Trend>;
  salesChange?: Maybe<Scalars['Float']>;
  salesChangePercent?: Maybe<Scalars['Float']>;
  salesPerEmployeeChange?: Maybe<Scalars['Float']>;
  salesPerEmployeeChangePercent?: Maybe<Scalars['Float']>;
  salesPerEmployeePeriodTrend?: Maybe<Trend>;
  salesPerEmployeeYearChange?: Maybe<Scalars['Float']>;
  salesPerEmployeeYearChangePercent?: Maybe<Scalars['Float']>;
  salesPerEmployeeYearTrend?: Maybe<Trend>;
  salesPeriodTrend?: Maybe<Trend>;
  salesYearChange?: Maybe<Scalars['Float']>;
  salesYearChangePercent?: Maybe<Scalars['Float']>;
  salesYearTrend?: Maybe<Trend>;
  year?: Maybe<Scalars['Int']>;
  yearPeriod?: Maybe<Scalars['Int']>;
};

export type CompanyProfile = {
  __typename?: 'CompanyProfile';
  address?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  foundationDate?: Maybe<Scalars['LocalDate']>;
  phone?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type CompanyShareHolder = {
  __typename?: 'CompanyShareHolder';
  announcedOn?: Maybe<Scalars['OffsetDateTime']>;
  name?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Float']>;
};

export type CompanyStatement = {
  __typename?: 'CompanyStatement';
  category?: Maybe<CompanyStatementCategory>;
  important?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Int']>;
};

export enum CompanyStatementCategory {
  Benchmark = 'BENCHMARK',
  Cashflow = 'CASHFLOW',
  Employee = 'EMPLOYEE',
  FinancialstatementAssets = 'FINANCIALSTATEMENT_ASSETS',
  FinancialstatementEquity = 'FINANCIALSTATEMENT_EQUITY',
  FinancialstatementLiabilities = 'FINANCIALSTATEMENT_LIABILITIES',
  IncomestatementIncome = 'INCOMESTATEMENT_INCOME',
  IncomestatementOtheroperatingresults = 'INCOMESTATEMENT_OTHEROPERATINGRESULTS',
  IncomestatementRevenue = 'INCOMESTATEMENT_REVENUE',
  Other = 'OTHER',
  Snapshot = 'SNAPSHOT'
}

export type CompanyStatementsCriteria = {
  category?: InputMaybe<Array<CompanyStatementCategory>>;
  fromYear?: InputMaybe<Scalars['Int']>;
  toYear?: InputMaybe<Scalars['Int']>;
};

export type CompositionPerformacePeriod = {
  __typename?: 'CompositionPerformacePeriod';
  current?: Maybe<CompositionPerformanceValue>;
  max?: Maybe<CompositionPerformanceValue>;
  min?: Maybe<CompositionPerformanceValue>;
  period?: Maybe<CalculationPeriod>;
};

export type CompositionPerformance = {
  __typename?: 'CompositionPerformance';
  periods?: Maybe<Array<CompositionPerformacePeriod>>;
};

export type CompositionPerformanceValue = {
  __typename?: 'CompositionPerformanceValue';
  group?: Maybe<InstrumentGroup>;
  price?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type Contact = {
  __typename?: 'Contact';
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type Country = {
  __typename?: 'Country';
  currencyId?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  internalVwdId?: Maybe<Scalars['String']>;
  isoAlpha2: Scalars['String'];
  isoAlpha3: Scalars['String'];
  name: Scalars['String'];
  numericCode?: Maybe<Scalars['Int']>;
};

export enum CrossRateSortField {
  ForeignCurrencyCode = 'FOREIGN_CURRENCY_CODE',
  HomeCurrencyCode = 'HOME_CURRENCY_CODE',
  Name = 'NAME',
  PerformanceMonth1 = 'PERFORMANCE_MONTH1',
  PerformanceMonth6 = 'PERFORMANCE_MONTH6',
  PerformanceWeek1 = 'PERFORMANCE_WEEK1',
  PerformanceWeek52 = 'PERFORMANCE_WEEK52',
  PerformanceYear3 = 'PERFORMANCE_YEAR3'
}

export type Currency = {
  __typename?: 'Currency';
  alphaCode?: Maybe<Scalars['String']>;
  displayCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  sign?: Maybe<Scalars['String']>;
};

export type CurrencyBucket = {
  __typename?: 'CurrencyBucket';
  count?: Maybe<Scalars['Long']>;
  currency?: Maybe<Currency>;
};

export type CurrencyPair = {
  __typename?: 'CurrencyPair';
  baseCurrency: Currency;
  group?: Maybe<InstrumentGroup>;
  quoteCurrency: Currency;
};

export type DefaultServiceResponse = {
  __typename?: 'DefaultServiceResponse';
  id: Scalars['Long'];
  responseCode: Scalars['Int'];
  responseMessage: Scalars['String'];
};

export type DerivativeAssetClassBucket = {
  __typename?: 'DerivativeAssetClassBucket';
  assetClass?: Maybe<AssetClass>;
  count?: Maybe<Scalars['Long']>;
};

export type DerivativeAssetClassBucketCriteria = {
  assetGroup?: InputMaybe<AssetGroup>;
  optionType?: InputMaybe<DerivativeOptionType>;
};

export type DerivativeAssetTypeBucket = {
  __typename?: 'DerivativeAssetTypeBucket';
  assetType?: Maybe<AssetType>;
  count?: Maybe<Scalars['Long']>;
};

export type DerivativeAssetTypeBucketCriteria = {
  assetClass?: InputMaybe<Scalars['Long']>;
  assetGroup?: InputMaybe<AssetGroup>;
  assetTypeGroup?: InputMaybe<Scalars['String']>;
};

export type DerivativeAssetTypeGroupBucket = {
  __typename?: 'DerivativeAssetTypeGroupBucket';
  assetTypeGroup?: Maybe<AssetTypeGroup>;
  count?: Maybe<Scalars['Long']>;
};

export type DerivativeAssetTypeGroupBucketCriteria = {
  assetClass?: InputMaybe<Scalars['Long']>;
  assetGroup?: InputMaybe<AssetGroup>;
};

export enum DerivativeExerciseStyle {
  American = 'AMERICAN',
  Bermudan = 'BERMUDAN',
  European = 'EUROPEAN'
}

export type DerivativeInstrumentKeyFigures = {
  __typename?: 'DerivativeInstrumentKeyFigures';
  accruedInterest?: Maybe<Scalars['Float']>;
  agio?: Maybe<Scalars['Float']>;
  agioAnnual?: Maybe<Scalars['Float']>;
  bonusAnnualReturn?: Maybe<Scalars['Float']>;
  bonusBuffer?: Maybe<Scalars['Float']>;
  bonusBufferAbsolute?: Maybe<Scalars['Float']>;
  bonusReturn?: Maybe<Scalars['Float']>;
  bonusReturnAbsolute?: Maybe<Scalars['Float']>;
  breakEven?: Maybe<Scalars['Float']>;
  delta?: Maybe<Scalars['Float']>;
  deltaBonusLevel?: Maybe<Scalars['Float']>;
  deltaBonusLevelAbsolute?: Maybe<Scalars['Float']>;
  deltaCap?: Maybe<Scalars['Float']>;
  deltaCapAbsolute?: Maybe<Scalars['Float']>;
  deltaSecurityLevel?: Maybe<Scalars['Float']>;
  deltaStopLoss?: Maybe<Scalars['Float']>;
  deltaStopLossAbsolute?: Maybe<Scalars['Float']>;
  deltaStrike?: Maybe<Scalars['Float']>;
  deltaStrikeAbsolute?: Maybe<Scalars['Float']>;
  dirtyPrice?: Maybe<Scalars['Float']>;
  /** @deprecated Field no longer supported */
  discount?: Maybe<Scalars['Float']>;
  discountAbsolute?: Maybe<Scalars['Float']>;
  discountPercent?: Maybe<Scalars['Float']>;
  duration?: Maybe<Scalars['Float']>;
  fairValue?: Maybe<Scalars['Float']>;
  gamma?: Maybe<Scalars['Float']>;
  gearing?: Maybe<Scalars['Float']>;
  implicitVolatility?: Maybe<Scalars['Float']>;
  intrinsicValue?: Maybe<Scalars['Float']>;
  ismaYield?: Maybe<Scalars['Float']>;
  maxAnnualReturn?: Maybe<Scalars['Float']>;
  maxRedemptionPrice?: Maybe<Scalars['Float']>;
  maxReturn?: Maybe<Scalars['Float']>;
  maxReturnAbsolute?: Maybe<Scalars['Float']>;
  modifiedDuration?: Maybe<Scalars['Float']>;
  moneyness?: Maybe<Scalars['Float']>;
  omega?: Maybe<Scalars['Float']>;
  outperformanceLevel?: Maybe<Scalars['Float']>;
  parity?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  premiumAbsolute?: Maybe<Scalars['Float']>;
  premiumAnnual?: Maybe<Scalars['Float']>;
  rho?: Maybe<Scalars['Float']>;
  sidewaysAnnualReturn?: Maybe<Scalars['Float']>;
  sidewaysReturn?: Maybe<Scalars['Float']>;
  sidewaysReturnAbsolute?: Maybe<Scalars['Float']>;
  spread?: Maybe<Scalars['Float']>;
  spreadHomogenous?: Maybe<Scalars['Float']>;
  spreadRelative?: Maybe<Scalars['Float']>;
  theta?: Maybe<Scalars['Float']>;
  timeValuePremium?: Maybe<Scalars['Float']>;
  update?: Maybe<InstrumentKeyFiguresUpdate>;
  vega?: Maybe<Scalars['Float']>;
};

export type DerivativeIssuerBucket = {
  __typename?: 'DerivativeIssuerBucket';
  count?: Maybe<Scalars['Long']>;
  issuer?: Maybe<Issuer>;
};

export type DerivativeIssuerCriteria = {
  assetClass?: InputMaybe<Scalars['Long']>;
  assetType?: InputMaybe<Scalars['String']>;
  assetTypeGroup?: InputMaybe<Scalars['String']>;
  optionType?: InputMaybe<DerivativeOptionType>;
};

export enum DerivativeKeyFigure {
  BonusBarrier = 'BONUS_BARRIER',
  BonusBufferAbsolute = 'BONUS_BUFFER_ABSOLUTE',
  BonusLevel = 'BONUS_LEVEL',
  BonusReturnAnnual = 'BONUS_RETURN_ANNUAL',
  Cap = 'CAP',
  DiscountAbsolute = 'DISCOUNT_ABSOLUTE',
  Gearing = 'GEARING',
  KnockIn = 'KNOCK_IN',
  KnockInLower = 'KNOCK_IN_LOWER',
  KnockInUpper = 'KNOCK_IN_UPPER',
  KnockOut = 'KNOCK_OUT',
  KnockOutLowerBarrier = 'KNOCK_OUT_LOWER_BARRIER',
  KnockOutUpperBarrier = 'KNOCK_OUT_UPPER_BARRIER',
  MaxReturnAnnual = 'MAX_RETURN_ANNUAL',
  Moneyness = 'MONEYNESS',
  PerformanceMonth1 = 'PERFORMANCE_MONTH1',
  PremiumAnnual = 'PREMIUM_ANNUAL',
  SidewaysReturnAnnual = 'SIDEWAYS_RETURN_ANNUAL',
  StopLossBarrier = 'STOP_LOSS_BARRIER',
  Strike = 'STRIKE'
}

export type DerivativeKeyFigureCriteria = {
  from?: InputMaybe<Scalars['Float']>;
  keyFigure?: InputMaybe<DerivativeKeyFigure>;
  to?: InputMaybe<Scalars['Float']>;
};

export type DerivativeKeyFigureRangeBucket = {
  __typename?: 'DerivativeKeyFigureRangeBucket';
  count?: Maybe<Scalars['Long']>;
  from?: Maybe<Scalars['Float']>;
  optionType?: Maybe<DerivativeOptionType>;
  to?: Maybe<Scalars['Float']>;
};

export type DerivativeKeyFigureRangeBucketCriteria = {
  assetClass?: InputMaybe<Scalars['Long']>;
  assetType?: InputMaybe<Scalars['String']>;
};

export type DerivativeKeyFigureRangeBucketRanges = {
  gearing?: InputMaybe<Array<FloatRangeValue>>;
};

export enum DerivativeOptionType {
  Call = 'CALL',
  Put = 'PUT'
}

export enum DerivativeQuotationType {
  Clean = 'CLEAN',
  Flat = 'FLAT',
  Xflat = 'XFLAT'
}

export enum DerivativeRollingFrequency {
  Annually = 'ANNUALLY',
  Monthly = 'MONTHLY',
  Once = 'ONCE',
  Quarterly = 'QUARTERLY',
  SemiAnnually = 'SEMI_ANNUALLY'
}

export enum DerivativeRollingStrategy {
  Defensive = 'DEFENSIVE',
  Neutral = 'NEUTRAL',
  Offensive = 'OFFENSIVE'
}

export enum DerivativeSettlementType {
  Both = 'BOTH',
  CashSettlement = 'CASH_SETTLEMENT',
  PhysicalDelivery = 'PHYSICAL_DELIVERY'
}

export enum DerivativeSortField {
  BonusBarrier = 'BONUS_BARRIER',
  BonusBufferAbsolute = 'BONUS_BUFFER_ABSOLUTE',
  BonusLevel = 'BONUS_LEVEL',
  BonusReturnAnnual = 'BONUS_RETURN_ANNUAL',
  Cap = 'CAP',
  DiscountAbsolute = 'DISCOUNT_ABSOLUTE',
  Gearing = 'GEARING',
  KnockIn = 'KNOCK_IN',
  KnockInLower = 'KNOCK_IN_LOWER',
  KnockInUpper = 'KNOCK_IN_UPPER',
  KnockOut = 'KNOCK_OUT',
  KnockOutLowerBarrier = 'KNOCK_OUT_LOWER_BARRIER',
  KnockOutUpperBarrier = 'KNOCK_OUT_UPPER_BARRIER',
  MaturityDate = 'MATURITY_DATE',
  MaxReturnAnnual = 'MAX_RETURN_ANNUAL',
  Moneyness = 'MONEYNESS',
  PerformanceMonth1 = 'PERFORMANCE_MONTH1',
  PremiumAnnual = 'PREMIUM_ANNUAL',
  SidewaysReturnAnnual = 'SIDEWAYS_RETURN_ANNUAL',
  StopLossBarrier = 'STOP_LOSS_BARRIER',
  Strike = 'STRIKE'
}

export type DistributionFrequency = {
  __typename?: 'DistributionFrequency';
  id: Scalars['String'];
  month: Scalars['Int'];
  name: Scalars['String'];
};

export type EditPortfolioEntryRequest = {
  charges: Scalars['Float'];
  currencyCode?: InputMaybe<Scalars['String']>;
  entryTime: Scalars['OffsetDateTime'];
  instrumentId: Scalars['Long'];
  memo?: InputMaybe<Scalars['String']>;
  portfolioEntryId: Scalars['Long'];
  portfolioId: Scalars['Long'];
  price: Scalars['Float'];
  quantity: Scalars['Float'];
};

export type EditWatchlistEntryRequest = {
  memo?: InputMaybe<Scalars['String']>;
  watchlistEntryId: Scalars['Long'];
  watchlistId: Scalars['Long'];
};

export type Estimates = {
  __typename?: 'Estimates';
  current?: Maybe<FundamentalKeyFigures>;
  next?: Maybe<FundamentalKeyFigures>;
};

export type EtfAllocation = {
  __typename?: 'EtfAllocation';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type EtfDomicile = {
  __typename?: 'EtfDomicile';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type EtfIssuer = {
  __typename?: 'EtfIssuer';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export enum EtfKeyFigure {
  AllTimeHigh = 'ALL_TIME_HIGH',
  BetaFactor = 'BETA_FACTOR',
  JensenAlpha = 'JENSEN_ALPHA',
  LongestLoosingPeriod = 'LONGEST_LOOSING_PERIOD',
  MaxLoosing_6Month = 'MAX_LOOSING_6_MONTH',
  NegativeRegression = 'NEGATIVE_REGRESSION',
  PerformanceMonth_1 = 'PERFORMANCE_MONTH_1',
  PerformanceMonth_6 = 'PERFORMANCE_MONTH_6',
  PerformanceYear_1 = 'PERFORMANCE_YEAR_1',
  PerformanceYear_3 = 'PERFORMANCE_YEAR_3',
  PerformanceYear_5 = 'PERFORMANCE_YEAR_5',
  PositiveRegression = 'POSITIVE_REGRESSION',
  TotalExpenseRatio = 'TOTAL_EXPENSE_RATIO',
  TrackingError = 'TRACKING_ERROR',
  Volume = 'VOLUME'
}

export type EtfKeyFigureCriteria = {
  from?: InputMaybe<Scalars['Float']>;
  keyFigure?: InputMaybe<EtfKeyFigure>;
  to?: InputMaybe<Scalars['Float']>;
};

export type EtfKeyFigures = {
  __typename?: 'EtfKeyFigures';
  betaFactor?: Maybe<Scalars['Float']>;
  jensenAlpha?: Maybe<Scalars['Float']>;
  longestLoosingPeriod?: Maybe<Scalars['Int']>;
  maxLoosing6Month?: Maybe<Scalars['Float']>;
  negativeRegression?: Maybe<Scalars['Float']>;
  positiveRegression?: Maybe<Scalars['Float']>;
  totalExpenseRatio?: Maybe<Scalars['Float']>;
  trackingError?: Maybe<Scalars['Float']>;
};

export type EtfPeerGroup = {
  __typename?: 'EtfPeerGroup';
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  performance?: Maybe<Array<PeerGroupPerformancePeriod>>;
};

export type EtfPosition = {
  __typename?: 'EtfPosition';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export enum EtfPositionType {
  Long = 'LONG',
  Short = 'SHORT'
}

export type EtfRegion = {
  __typename?: 'EtfRegion';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type EtfReplication = {
  __typename?: 'EtfReplication';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type EtfSector = {
  __typename?: 'EtfSector';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export enum EtfSortField {
  BetaFactor = 'BETA_FACTOR',
  JensenAlpha = 'JENSEN_ALPHA',
  LongestLoosingPeriod = 'LONGEST_LOOSING_PERIOD',
  MaxLoosing_6Month = 'MAX_LOOSING_6_MONTH',
  Name = 'NAME',
  NegativeRegression = 'NEGATIVE_REGRESSION',
  PerformanceMonth_1 = 'PERFORMANCE_MONTH_1',
  PerformanceMonth_6 = 'PERFORMANCE_MONTH_6',
  PerformanceYear_1 = 'PERFORMANCE_YEAR_1',
  PerformanceYear_3 = 'PERFORMANCE_YEAR_3',
  PerformanceYear_5 = 'PERFORMANCE_YEAR_5',
  PositiveRegression = 'POSITIVE_REGRESSION',
  TotalExpenseRatio = 'TOTAL_EXPENSE_RATIO',
  TrackingError = 'TRACKING_ERROR',
  Volume = 'VOLUME'
}

export type EtfStrategy = {
  __typename?: 'EtfStrategy';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export enum EventRelevance {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type EventReportEntry = {
  __typename?: 'EventReportEntry';
  group: InstrumentGroup;
  instrumentGroupId: Scalars['Int'];
};

export enum EventType {
  Company = 'COMPANY',
  Economic = 'ECONOMIC'
}

export type Exchange = {
  __typename?: 'Exchange';
  closingTime?: Maybe<Scalars['LocalTime']>;
  code?: Maybe<Scalars['String']>;
  delay?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  openingTime?: Maybe<Scalars['LocalTime']>;
  type?: Maybe<ExchangeType>;
};

export enum ExchangeType {
  InvestmentFund = 'INVESTMENT_FUND',
  Regular = 'REGULAR'
}

export type FeedbackRequest = {
  body: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
};

export type FeedbackResponse = {
  __typename?: 'FeedbackResponse';
  orderId?: Maybe<Scalars['String']>;
};

export type FieldChangeBooleanRequest = {
  id: Scalars['Long'];
  value: Scalars['Boolean'];
};

export type FieldChangeBooleanResponse = {
  __typename?: 'FieldChangeBooleanResponse';
  id: Scalars['Long'];
  value: Scalars['Boolean'];
};

export type FloatRangeValue = {
  from?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['Float']>;
};

export type Fund = {
  __typename?: 'Fund';
  advisor?: Maybe<FundAdvisor>;
  benchmark?: Maybe<FundBenchmark>;
  company?: Maybe<FundCompany>;
  currency?: Maybe<FundCurrency>;
  exchangeTradedFund?: Maybe<Scalars['Boolean']>;
  id: Scalars['Long'];
  indexFund?: Maybe<Scalars['Boolean']>;
  investmentConcept?: Maybe<Scalars['String']>;
  investmentVolume?: Maybe<InvestmentVolume>;
  managers?: Maybe<Array<FundManager>>;
  name: Scalars['String'];
  portfolios: Array<FundPortfolio>;
  region?: Maybe<FundRegion>;
  strategy?: Maybe<FundStrategy>;
  topic?: Maybe<FundTopic>;
  type?: Maybe<FundType>;
};

export type FundAdvisor = {
  __typename?: 'FundAdvisor';
  address?: Maybe<Address>;
  contact?: Maybe<Contact>;
  name?: Maybe<Scalars['String']>;
};

export type FundBenchmark = {
  __typename?: 'FundBenchmark';
  group?: Maybe<InstrumentGroup>;
  isin?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type FundCompany = {
  __typename?: 'FundCompany';
  address?: Maybe<Address>;
  contact?: Maybe<Contact>;
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
};

export type FundCurrency = {
  __typename?: 'FundCurrency';
  currency?: Maybe<Currency>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FundDocument = {
  __typename?: 'FundDocument';
  creationDate?: Maybe<Scalars['LocalDate']>;
  type?: Maybe<FundDocumentType>;
  url?: Maybe<Scalars['String']>;
};

export type FundDocumentType = {
  __typename?: 'FundDocumentType';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum FundKeyFigure {
  FundTrancheVolume = 'FUND_TRANCHE_VOLUME',
  FundVolume = 'FUND_VOLUME',
  PerformanceMonth_1 = 'PERFORMANCE_MONTH_1',
  PerformanceMonth_6 = 'PERFORMANCE_MONTH_6',
  PerformanceWeek_1 = 'PERFORMANCE_WEEK_1',
  PerformanceYear_1 = 'PERFORMANCE_YEAR_1',
  PerformanceYear_3 = 'PERFORMANCE_YEAR_3',
  PerformanceYear_5 = 'PERFORMANCE_YEAR_5',
  PerformanceYear_10 = 'PERFORMANCE_YEAR_10',
  SharperatioMonth_1 = 'SHARPERATIO_MONTH_1',
  SharperatioMonth_6 = 'SHARPERATIO_MONTH_6',
  SharperatioWeek_1 = 'SHARPERATIO_WEEK_1',
  SharperatioYear_1 = 'SHARPERATIO_YEAR_1',
  SharperatioYear_3 = 'SHARPERATIO_YEAR_3',
  SharperatioYear_5 = 'SHARPERATIO_YEAR_5',
  SharperatioYear_10 = 'SHARPERATIO_YEAR_10',
  TotalExpenseRatio = 'TOTAL_EXPENSE_RATIO',
  VolaMonth_1 = 'VOLA_MONTH_1',
  VolaMonth_6 = 'VOLA_MONTH_6',
  VolaWeek_1 = 'VOLA_WEEK_1',
  VolaYear_1 = 'VOLA_YEAR_1',
  VolaYear_3 = 'VOLA_YEAR_3',
  VolaYear_5 = 'VOLA_YEAR_5',
  VolaYear_10 = 'VOLA_YEAR_10'
}

export type FundKeyFigureCriteria = {
  from?: InputMaybe<Scalars['Float']>;
  keyFigure?: InputMaybe<FundKeyFigure>;
  to?: InputMaybe<Scalars['Float']>;
};

export type FundManager = {
  __typename?: 'FundManager';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  preference?: Maybe<Scalars['Int']>;
};

export type FundPortfolio = {
  __typename?: 'FundPortfolio';
  entries: Array<FundPortfolioEntry>;
  name?: Maybe<Scalars['String']>;
};

export type FundPortfolioEntry = {
  __typename?: 'FundPortfolioEntry';
  name?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Float']>;
};

export type FundRegion = {
  __typename?: 'FundRegion';
  country?: Maybe<Country>;
  countryIsoAlpha3?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum FundSortField {
  FundTrancheVolume = 'FUND_TRANCHE_VOLUME',
  FundVolume = 'FUND_VOLUME',
  Name = 'NAME',
  TotalExpenseRatio = 'TOTAL_EXPENSE_RATIO'
}

export type FundStrategy = {
  __typename?: 'FundStrategy';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FundTopic = {
  __typename?: 'FundTopic';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FundTranchePeerGroup = {
  __typename?: 'FundTranchePeerGroup';
  id: Scalars['Long'];
  name?: Maybe<Scalars['String']>;
  performance?: Maybe<Array<PeerGroupPerformancePeriod>>;
};

export type FundTrancheSyntheticRiskAndRewardIndicator = {
  __typename?: 'FundTrancheSyntheticRiskAndRewardIndicator';
  value?: Maybe<Scalars['Int']>;
  when?: Maybe<Scalars['LocalDate']>;
};

export type FundType = {
  __typename?: 'FundType';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type FundTypeBucket = {
  __typename?: 'FundTypeBucket';
  count?: Maybe<Scalars['Int']>;
  fundType?: Maybe<FundType>;
};

export type FundTypeBucketCriteria = {
  assetClass?: InputMaybe<Scalars['Long']>;
  assetType?: InputMaybe<Scalars['String']>;
  assetTypeGroup?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Long']>;
};

export type FundamentalKeyFigures = {
  __typename?: 'FundamentalKeyFigures';
  cashFlowPerShare?: Maybe<Scalars['Float']>;
  cashGrade1?: Maybe<Scalars['Float']>;
  cashGrade2?: Maybe<Scalars['Float']>;
  cashGrade3?: Maybe<Scalars['Float']>;
  cashRatioGrade1?: Maybe<Scalars['Float']>;
  cashRatioGrade2?: Maybe<Scalars['Float']>;
  cashRatioGrade3?: Maybe<Scalars['Float']>;
  debtEquityRatio?: Maybe<Scalars['Float']>;
  debtRatio?: Maybe<Scalars['Float']>;
  dilutedEarningPerShare?: Maybe<Scalars['Float']>;
  dividendPayoutRatio?: Maybe<Scalars['Float']>;
  dividendPerShare?: Maybe<Scalars['Float']>;
  dividendYield?: Maybe<Scalars['Float']>;
  earningPerShare?: Maybe<Scalars['Float']>;
  employees?: Maybe<Scalars['Float']>;
  equityRatio?: Maybe<Scalars['Float']>;
  equityReturn?: Maybe<Scalars['Float']>;
  intensityOfInvestments?: Maybe<Scalars['Float']>;
  intensityOfLabor?: Maybe<Scalars['Float']>;
  netIncome?: Maybe<Scalars['Float']>;
  operatingCashFlow?: Maybe<Scalars['Float']>;
  personnelExpenses?: Maybe<Scalars['Float']>;
  priceToCashFlowRatio?: Maybe<Scalars['Float']>;
  priceToEarningsRatio?: Maybe<Scalars['Float']>;
  priceToSalesRatio?: Maybe<Scalars['Float']>;
  returnOnAssets?: Maybe<Scalars['Float']>;
  returnOnInvestment?: Maybe<Scalars['Float']>;
  sales?: Maybe<Scalars['Float']>;
  salesPerEmployee?: Maybe<Scalars['Float']>;
  salesPerShare?: Maybe<Scalars['Float']>;
  salesRatio?: Maybe<Scalars['Float']>;
  workingCapital?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Int']>;
};

export type HistoryQuote = {
  __typename?: 'HistoryQuote';
  cumulativeVolume?: Maybe<Scalars['Long']>;
  firstPrice?: Maybe<Scalars['Float']>;
  highPrice?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  lastPrice?: Maybe<Scalars['Float']>;
  lowPrice?: Maybe<Scalars['Float']>;
  start?: Maybe<Scalars['OffsetDateTime']>;
};

export enum HistoryQuoteAggregation {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Month = 'MONTH',
  Tick = 'TICK',
  Week = 'WEEK'
}

export type HistoryQuoteConnection = {
  __typename?: 'HistoryQuoteConnection';
  edges: Array<HistoryQuoteEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type HistoryQuoteCriteria = {
  aggregation?: InputMaybe<HistoryQuoteAggregation>;
  from: Scalars['OffsetDateTime'];
  to: Scalars['OffsetDateTime'];
};

export type HistoryQuoteEdge = {
  __typename?: 'HistoryQuoteEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<HistoryQuote>;
};

export type Instrument = {
  __typename?: 'Instrument';
  bestWarrantRnd?: Maybe<IssuerBestInstrument>;
  chart?: Maybe<Chart>;
  country?: Maybe<Country>;
  countryId: Scalars['Int'];
  currency: Currency;
  currencyId: Scalars['Int'];
  derivativeKeyFigures?: Maybe<DerivativeInstrumentKeyFigures>;
  exchange: Exchange;
  exchangeId: Scalars['Int'];
  firstTradingDay?: Maybe<Scalars['LocalDate']>;
  group: InstrumentGroup;
  groupId: Scalars['Int'];
  historyQuote: HistoryQuoteConnection;
  id: Scalars['Int'];
  indicators?: Maybe<InstrumentIndicators>;
  isin?: Maybe<Scalars['String']>;
  /** @deprecated Field no longer supported */
  keyFigures?: Maybe<DerivativeInstrumentKeyFigures>;
  lastTradingDay?: Maybe<Scalars['LocalDate']>;
  main: Scalars['Boolean'];
  marketCapitalization?: Maybe<Scalars['Float']>;
  monteCarlo?: Maybe<MonteCarloResult>;
  name: Scalars['String'];
  performance: Array<InstrumentPerformance>;
  previousSnapQuote?: Maybe<SnapQuote>;
  /** @deprecated Field no longer supported */
  quoteHistory: QuoteHistoryConnection;
  rangeCharts?: Maybe<InstrumentRangeCharts>;
  /** @deprecated Field no longer supported */
  sector?: Maybe<Sector>;
  /** @deprecated Field no longer supported */
  sectorId?: Maybe<Scalars['Int']>;
  /** @deprecated Field no longer supported */
  securityCategoryId?: Maybe<AssetGroup>;
  /** @deprecated Field no longer supported */
  seoTag?: Maybe<Scalars['String']>;
  snapQuote?: Maybe<SnapQuote>;
  stats: Array<InstrumentStatistics>;
  tickerSymbol?: Maybe<Scalars['String']>;
  timeAndSales: InstrumentTimeAndSalesConnection;
  wkn?: Maybe<Scalars['String']>;
};


export type InstrumentBestWarrantRndArgs = {
  days: Scalars['Int'];
};


export type InstrumentChartArgs = {
  scope: ChartScope;
};


export type InstrumentHistoryQuoteArgs = {
  criteria?: InputMaybe<HistoryQuoteCriteria>;
};


export type InstrumentMonteCarloArgs = {
  days: Scalars['Int'];
};


export type InstrumentPerformanceArgs = {
  period?: InputMaybe<Array<CalculationPeriod>>;
};


export type InstrumentQuoteHistoryArgs = {
  from: Scalars['LocalDate'];
  to: Scalars['LocalDate'];
};


export type InstrumentStatsArgs = {
  periods?: InputMaybe<Array<CalculationPeriod>>;
};


export type InstrumentTimeAndSalesArgs = {
  before?: InputMaybe<Scalars['ID']>;
  criteria?: InputMaybe<TimeAndSalesCriteria>;
  last?: InputMaybe<Scalars['Int']>;
};

export type InstrumentConnection = {
  __typename?: 'InstrumentConnection';
  count?: Maybe<Scalars['Long']>;
  edges: Array<InstrumentEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type InstrumentDetailConnection = {
  __typename?: 'InstrumentDetailConnection';
  assetGroups: Array<AssetGroupBucket>;
  count?: Maybe<Scalars['Long']>;
  edges: Array<InstrumentEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type InstrumentEdge = {
  __typename?: 'InstrumentEdge';
  cursor: Scalars['ID'];
  node: Instrument;
};

export type InstrumentGroup = {
  __typename?: 'InstrumentGroup';
  alternativeDerivativeProducts: Array<AlternativeDerivativeProductsBucket>;
  alternativeFundTranches?: Maybe<Array<InstrumentGroupFundTranche>>;
  analysis: AnalysisConnection;
  analysisReport?: Maybe<AnalysisReport>;
  assetClass?: Maybe<AssetClass>;
  assetGroup?: Maybe<AssetGroup>;
  assetType?: Maybe<AssetType>;
  assetTypeGroup?: Maybe<AssetTypeGroup>;
  bond?: Maybe<InstrumentGroupBond>;
  calendarEvents: InstrumentGroupSearchCalendarEventConnection;
  company?: Maybe<Company>;
  composition?: Maybe<InstrumentGroupComposition>;
  compositionPerformance?: Maybe<CompositionPerformance>;
  compositions: Array<InstrumentGroupComposition>;
  content: Array<Instrument>;
  crossRate?: Maybe<InstrumentGroupCrossRate>;
  derivative?: Maybe<InstrumentGroupDerivative>;
  derivativeAssetClassBucket: Array<DerivativeAssetClassBucket>;
  derivativeAssetTypeBucket: Array<DerivativeAssetTypeBucket>;
  derivativeAssetTypeGroupBucket: Array<DerivativeAssetTypeGroupBucket>;
  derivativeIssuer: Array<DerivativeIssuerBucket>;
  derivativeKeyFigureRangeBucket: Array<DerivativeKeyFigureRangeBucket>;
  description?: Maybe<InstrumentGroupDescription>;
  estimates?: Maybe<Estimates>;
  etf?: Maybe<InstrumentGroupExchangeTradedFund>;
  fund?: Maybe<Fund>;
  fundTranche?: Maybe<InstrumentGroupFundTranche>;
  id?: Maybe<Scalars['Int']>;
  indexParticipation: Array<InstrumentGroup>;
  interestRateInformation?: Maybe<InstrumentGroupInterestRateInformation>;
  isin?: Maybe<Scalars['String']>;
  issuer?: Maybe<Issuer>;
  issuerId?: Maybe<Scalars['Int']>;
  main?: Maybe<Instrument>;
  name: Scalars['String'];
  news: NewsConnection;
  peerGroup: Array<InstrumentGroup>;
  peerGroupCompare?: Maybe<Array<PeerGroupCompare>>;
  refCountry?: Maybe<Country>;
  refCountryId?: Maybe<Scalars['Int']>;
  refMarketCapitalization?: Maybe<InstrumentGroupMarketCapitalization>;
  refundRelativeScenario?: Maybe<Array<RefundRelativeScenario>>;
  sector?: Maybe<Sector>;
  sectorId?: Maybe<Scalars['Int']>;
  seoTag?: Maybe<Scalars['String']>;
  theScreenerRating?: Maybe<TheScreenerRating>;
  ticker?: Maybe<Scalars['String']>;
  tickerSymbol?: Maybe<Scalars['String']>;
  topFlop?: Maybe<Array<InstrumentTopFlop>>;
  underlying?: Maybe<Scalars['Boolean']>;
  underlyings?: Maybe<Array<InstrumentGroupUnderlying>>;
  wkn?: Maybe<Scalars['String']>;
};


export type InstrumentGroupAlternativeDerivativeProductsArgs = {
  criteria?: InputMaybe<AlternativeDerivativeProductsCriteria>;
};


export type InstrumentGroupAnalysisArgs = {
  after?: InputMaybe<Scalars['ID']>;
  criteria?: InputMaybe<InstrumentGroupAnalysisCriteria>;
  first?: InputMaybe<Scalars['Int']>;
};


export type InstrumentGroupCalendarEventsArgs = {
  after?: InputMaybe<Scalars['ID']>;
  criteria?: InputMaybe<InstrumentGroupSearchCalendarEventsCriteria>;
  first?: InputMaybe<Scalars['Int']>;
};


export type InstrumentGroupCompositionArgs = {
  compositionId: Scalars['Int'];
};


export type InstrumentGroupDerivativeAssetClassBucketArgs = {
  criteria?: InputMaybe<DerivativeAssetClassBucketCriteria>;
};


export type InstrumentGroupDerivativeAssetTypeBucketArgs = {
  criteria?: InputMaybe<DerivativeAssetTypeBucketCriteria>;
};


export type InstrumentGroupDerivativeAssetTypeGroupBucketArgs = {
  criteria?: InputMaybe<DerivativeAssetTypeGroupBucketCriteria>;
};


export type InstrumentGroupDerivativeIssuerArgs = {
  criteria?: InputMaybe<DerivativeIssuerCriteria>;
};


export type InstrumentGroupDerivativeKeyFigureRangeBucketArgs = {
  criteria?: InputMaybe<DerivativeKeyFigureRangeBucketCriteria>;
  ranges?: InputMaybe<DerivativeKeyFigureRangeBucketRanges>;
};


export type InstrumentGroupNewsArgs = {
  after?: InputMaybe<Scalars['ID']>;
  criteria?: InputMaybe<InstrumentGroupNewsCriteria>;
  first?: InputMaybe<Scalars['Int']>;
};


export type InstrumentGroupTopFlopArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

export type InstrumentGroupAnalysisCriteria = {
  from?: InputMaybe<Scalars['LocalDate']>;
};

export type InstrumentGroupBond = {
  __typename?: 'InstrumentGroupBond';
  fiatIssuance?: Maybe<Scalars['Boolean']>;
  firstTradingDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  interestLoan?: Maybe<Scalars['Float']>;
  isin?: Maybe<Scalars['String']>;
  issueDate?: Maybe<Scalars['LocalDate']>;
  issueSize?: Maybe<Scalars['Long']>;
  issueStatus?: Maybe<BondIssueStatus>;
  issuer?: Maybe<BondIssuer>;
  maturityDate?: Maybe<Scalars['LocalDate']>;
  minAmountTradableLot?: Maybe<Scalars['Float']>;
  minTradableLot?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  nominalCurrency?: Maybe<Currency>;
  nominalCurrencyCode?: Maybe<Scalars['String']>;
  nominalValue?: Maybe<Scalars['Float']>;
  priceAttribute?: Maybe<BondPriceAttribute>;
  settlementCurrency?: Maybe<Currency>;
  settlementCurrencyCode?: Maybe<Scalars['String']>;
  status?: Maybe<BondStatus>;
  subordinatedDebt?: Maybe<Scalars['Boolean']>;
  subscriptionEnd?: Maybe<Scalars['OffsetDateTime']>;
  subscriptionStart?: Maybe<Scalars['OffsetDateTime']>;
  tradingCurrency?: Maybe<Currency>;
  tradingCurrencyCode?: Maybe<Scalars['String']>;
  type?: Maybe<BondType>;
  wkn?: Maybe<Scalars['String']>;
};

export type InstrumentGroupComposition = {
  __typename?: 'InstrumentGroupComposition';
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Int']>;
  delay?: Maybe<Scalars['Int']>;
  entries: Array<Instrument>;
  exchange?: Maybe<Exchange>;
  exchangeId?: Maybe<Scalars['Int']>;
  group: InstrumentGroup;
  groupId: Scalars['Int'];
  id: Scalars['Int'];
  /** @deprecated Field no longer supported */
  mainInstrument?: Maybe<Instrument>;
  /** @deprecated Field no longer supported */
  mainInstrumentId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type InstrumentGroupCrossRate = {
  __typename?: 'InstrumentGroupCrossRate';
  foreignCurrency: Currency;
  foreignCurrencyId: Scalars['Int'];
  homeCurrency: Currency;
  homeCurrencyId: Scalars['Int'];
};

export type InstrumentGroupDerivative = {
  __typename?: 'InstrumentGroupDerivative';
  automaticExercise?: Maybe<Scalars['Boolean']>;
  capitalProtection?: Maybe<Scalars['Boolean']>;
  currencyQuanto?: Maybe<Scalars['Boolean']>;
  dayCountConvention?: Maybe<Scalars['Int']>;
  deltaAtIssuance?: Maybe<Scalars['Float']>;
  exercisePeriodStart?: Maybe<Scalars['LocalDate']>;
  exerciseStyle?: Maybe<DerivativeExerciseStyle>;
  finalValuationDate?: Maybe<Scalars['LocalDate']>;
  hasIssuerRightOfTermination?: Maybe<Scalars['Boolean']>;
  hasManagementFees?: Maybe<Scalars['Boolean']>;
  hasRollingFeature?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  interestMarkup?: Maybe<Scalars['Float']>;
  isPrivatePlacement?: Maybe<Scalars['Boolean']>;
  issueDate?: Maybe<Scalars['LocalDate']>;
  issuePrice?: Maybe<Scalars['Float']>;
  issueSize?: Maybe<Scalars['Long']>;
  issueValueDate?: Maybe<Scalars['LocalDate']>;
  lockIn?: Maybe<Scalars['Boolean']>;
  managementFee?: Maybe<Scalars['Float']>;
  maturityDate?: Maybe<Scalars['LocalDate']>;
  nameTermSheet?: Maybe<Scalars['String']>;
  nominalAmount?: Maybe<Scalars['Float']>;
  optionType?: Maybe<DerivativeOptionType>;
  paymentDate?: Maybe<Scalars['LocalDate']>;
  preferenceInterestRate?: Maybe<Scalars['String']>;
  quotationType?: Maybe<DerivativeQuotationType>;
  rollingFrequency?: Maybe<DerivativeRollingFrequency>;
  rollingStrategy?: Maybe<DerivativeRollingStrategy>;
  securedInstrument?: Maybe<Scalars['Boolean']>;
  settlementType?: Maybe<DerivativeSettlementType>;
  stuttgartDerivativeName?: Maybe<Scalars['String']>;
  usWithholding?: Maybe<Scalars['Boolean']>;
};

export type InstrumentGroupDescription = {
  __typename?: 'InstrumentGroupDescription';
  natural?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  tradingIdea?: Maybe<Scalars['String']>;
};

export type InstrumentGroupExchangeTradedFund = {
  __typename?: 'InstrumentGroupExchangeTradedFund';
  allocation?: Maybe<EtfAllocation>;
  benchmark?: Maybe<FundBenchmark>;
  charge?: Maybe<Scalars['Float']>;
  distributing?: Maybe<Scalars['Boolean']>;
  domicile?: Maybe<EtfDomicile>;
  foundationDate?: Maybe<Scalars['LocalDate']>;
  id: Scalars['Int'];
  investmentConcept?: Maybe<Scalars['String']>;
  investmentVolume?: Maybe<InvestmentVolume>;
  issuer?: Maybe<EtfIssuer>;
  keyFigures?: Maybe<EtfKeyFigures>;
  participationFactor?: Maybe<Scalars['Float']>;
  peerGroup?: Maybe<EtfPeerGroup>;
  portfolios: Array<FundPortfolio>;
  position?: Maybe<EtfPositionType>;
  quanto?: Maybe<Scalars['Boolean']>;
  region?: Maybe<EtfRegion>;
  replication?: Maybe<EtfReplication>;
  sector?: Maybe<EtfSector>;
  strategy?: Maybe<EtfStrategy>;
  underlyingRatio?: Maybe<Scalars['Float']>;
};

export type InstrumentGroupFundTranche = {
  __typename?: 'InstrumentGroupFundTranche';
  assetBasedFee?: Maybe<Scalars['Float']>;
  charge?: Maybe<Scalars['Float']>;
  currency?: Maybe<Currency>;
  /** @deprecated Field no longer supported */
  currencyCode?: Maybe<Scalars['String']>;
  depositFee?: Maybe<Scalars['Float']>;
  distributing?: Maybe<Scalars['Boolean']>;
  distributionFrequency?: Maybe<DistributionFrequency>;
  documents?: Maybe<Array<FundDocument>>;
  foundationDate?: Maybe<Scalars['LocalDate']>;
  fund?: Maybe<Fund>;
  germanRiesterCapable?: Maybe<Scalars['Boolean']>;
  germanVwlCapable?: Maybe<Scalars['Boolean']>;
  group?: Maybe<InstrumentGroup>;
  id: Scalars['Long'];
  investmentVolume?: Maybe<InvestmentVolume>;
  isin?: Maybe<Scalars['String']>;
  main?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  peerGroup?: Maybe<FundTranchePeerGroup>;
  rePurchasePrice?: Maybe<Scalars['Float']>;
  savingPlanCapable?: Maybe<Scalars['Boolean']>;
  srri?: Maybe<FundTrancheSyntheticRiskAndRewardIndicator>;
  totalExpenseRatio?: Maybe<Scalars['Float']>;
};

export type InstrumentGroupIncludedResponse = {
  __typename?: 'InstrumentGroupIncludedResponse';
  limits: Scalars['Long'];
  limitsLower: Scalars['Long'];
  limitsUpper: Scalars['Long'];
  portfolios: Scalars['Long'];
  totalLimits: Scalars['Long'];
  totalPortfolios: Scalars['Long'];
  totalWatchlists: Scalars['Long'];
  watchlists: Scalars['Long'];
};

export type InstrumentGroupInterestRateInformation = {
  __typename?: 'InstrumentGroupInterestRateInformation';
  finalPaymentDate?: Maybe<Scalars['LocalDate']>;
  interestRate?: Maybe<Scalars['Float']>;
  lastPaymentDate?: Maybe<Scalars['LocalDate']>;
  nextPaymentDate?: Maybe<Scalars['LocalDate']>;
};

export type InstrumentGroupMarketCapitalization = {
  __typename?: 'InstrumentGroupMarketCapitalization';
  currency?: Maybe<Currency>;
  currencyId: Scalars['Long'];
  value: Scalars['Float'];
};

export type InstrumentGroupNewsCriteria = {
  feeds?: InputMaybe<Array<NewsFeed>>;
};

export type InstrumentGroupSearchCalendarEventConnection = {
  __typename?: 'InstrumentGroupSearchCalendarEventConnection';
  edges: Array<CalendarEventEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type InstrumentGroupSearchCalendarEventsCriteria = {
  categoryId?: InputMaybe<Scalars['ID']>;
  countryId?: InputMaybe<Scalars['ID']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  from?: InputMaybe<Scalars['LocalDate']>;
  future?: InputMaybe<Scalars['Boolean']>;
  relevance?: InputMaybe<Array<EventRelevance>>;
  to?: InputMaybe<Scalars['LocalDate']>;
};

export type InstrumentGroupTrade = {
  __typename?: 'InstrumentGroupTrade';
  group: InstrumentGroup;
  portfolios: Scalars['Long'];
  profiles: Scalars['Long'];
  quantity: Scalars['Float'];
  trades: Scalars['Long'];
};

export type InstrumentGroupUnderlying = {
  __typename?: 'InstrumentGroupUnderlying';
  bonusBarrier?: Maybe<Scalars['Float']>;
  cap?: Maybe<Scalars['Float']>;
  capitalGuarantee?: Maybe<Scalars['Float']>;
  conditionalCouponTriggerLevel?: Maybe<Scalars['Float']>;
  conditionalCouponTriggerLevelLower?: Maybe<Scalars['Float']>;
  conditionalCouponTriggerLevelUpper?: Maybe<Scalars['Float']>;
  currency?: Maybe<Currency>;
  currencyId?: Maybe<Scalars['Long']>;
  exchageId?: Maybe<Scalars['Long']>;
  exchange?: Maybe<Exchange>;
  group?: Maybe<InstrumentGroup>;
  groupId?: Maybe<Scalars['Long']>;
  id?: Maybe<Scalars['Long']>;
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['Long']>;
  isin?: Maybe<Scalars['String']>;
  knockIn?: Maybe<Scalars['Float']>;
  knockInLower?: Maybe<Scalars['Float']>;
  knockInTriggeredAt?: Maybe<Scalars['OffsetDateTime']>;
  knockInUpper?: Maybe<Scalars['Float']>;
  knockOut?: Maybe<Scalars['Float']>;
  knockOutLower?: Maybe<Scalars['Float']>;
  knockOutTriggeredAt?: Maybe<Scalars['OffsetDateTime']>;
  knockOutUpper?: Maybe<Scalars['Float']>;
  leverageFactor?: Maybe<Scalars['Float']>;
  lockIn?: Maybe<Scalars['Float']>;
  multiplier?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  participation?: Maybe<Scalars['Float']>;
  percentage?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  redemption?: Maybe<Scalars['Float']>;
  referencePrice?: Maybe<Scalars['Float']>;
  reverseLevel?: Maybe<Scalars['Float']>;
  security?: Maybe<Scalars['Float']>;
  securityBarrierObservationEndAt?: Maybe<Scalars['LocalDate']>;
  securityBarrierObservationStartAt?: Maybe<Scalars['LocalDate']>;
  securityBarrierTriggeredAt?: Maybe<Scalars['LocalDate']>;
  start?: Maybe<Scalars['Float']>;
  strike?: Maybe<Scalars['Float']>;
};

export type InstrumentIncludedResponse = {
  __typename?: 'InstrumentIncludedResponse';
  limitsNumber: Scalars['Long'];
  portfolios: Array<PortfolioItem>;
  watchlists: Array<WatchlistItem>;
};

export type InstrumentIndicators = {
  __typename?: 'InstrumentIndicators';
  movingAverage?: Maybe<MovingAverageIndicator>;
  relativeStrengthIndex?: Maybe<RelativeStrengthIndex>;
  relativeStrengthLevy?: Maybe<RelativeStrengthLevyIndicator>;
};

export type InstrumentKeyFiguresUpdate = {
  __typename?: 'InstrumentKeyFiguresUpdate';
  type?: Maybe<QuoteType>;
  underlyingValue?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
  when?: Maybe<Scalars['OffsetDateTime']>;
};

export type InstrumentLimit = {
  __typename?: 'InstrumentLimit';
  instrument: Instrument;
  limitValue: Scalars['Float'];
  upper: Scalars['Boolean'];
};

export type InstrumentPerformance = {
  __typename?: 'InstrumentPerformance';
  alpha?: Maybe<Scalars['Float']>;
  averagePrice?: Maybe<Scalars['Float']>;
  averageVolume?: Maybe<Scalars['Float']>;
  basePrice?: Maybe<Scalars['Float']>;
  benchmark?: Maybe<Scalars['Float']>;
  beta?: Maybe<Scalars['Float']>;
  betaBear?: Maybe<Scalars['Float']>;
  betaBull?: Maybe<Scalars['Float']>;
  correlation?: Maybe<Scalars['Float']>;
  cumulativeTurnover?: Maybe<Scalars['Float']>;
  cumulativeVolume?: Maybe<Scalars['Long']>;
  deltaAveragePrice?: Maybe<Scalars['Float']>;
  maxLoss?: Maybe<Scalars['Float']>;
  performance?: Maybe<Scalars['Float']>;
  performanceAbsolute?: Maybe<Scalars['Float']>;
  period: CalculationPeriod;
  sharpe?: Maybe<Scalars['Float']>;
  treynor?: Maybe<Scalars['Float']>;
  vola?: Maybe<Scalars['Float']>;
  volatility?: Maybe<Scalars['Float']>;
  volatilityMid?: Maybe<Scalars['Float']>;
};

export type InstrumentRangeCharts = {
  __typename?: 'InstrumentRangeCharts';
  intraday?: Maybe<RangeChart>;
  year?: Maybe<RangeChart>;
};

export type InstrumentStatistics = {
  __typename?: 'InstrumentStatistics';
  deltaHighPrice?: Maybe<Scalars['Float']>;
  deltaLowPrice?: Maybe<Scalars['Float']>;
  highPrice?: Maybe<Scalars['Float']>;
  highPriceDate?: Maybe<Scalars['LocalDate']>;
  lowPrice?: Maybe<Scalars['Float']>;
  lowPriceDate?: Maybe<Scalars['LocalDate']>;
  period: CalculationPeriod;
};

export type InstrumentTimeAndSales = {
  __typename?: 'InstrumentTimeAndSales';
  askPrice?: Maybe<Scalars['Float']>;
  askVolume?: Maybe<Scalars['Long']>;
  bidPrice?: Maybe<Scalars['Float']>;
  bidVolume?: Maybe<Scalars['Long']>;
  firstPrice?: Maybe<Scalars['Float']>;
  highPrice?: Maybe<Scalars['Float']>;
  lastPrice?: Maybe<Scalars['Float']>;
  lowPrice?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Long']>;
  when?: Maybe<Scalars['OffsetDateTime']>;
};

export type InstrumentTimeAndSalesConnection = {
  __typename?: 'InstrumentTimeAndSalesConnection';
  edges: Array<InstrumentTimeAndSalesEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type InstrumentTimeAndSalesEdge = {
  __typename?: 'InstrumentTimeAndSalesEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<InstrumentTimeAndSales>;
};

export type InstrumentTopFlop = {
  __typename?: 'InstrumentTopFlop';
  instrument: Instrument;
  snapQuote: SnapQuote;
};

export type InstrumentTrade = {
  __typename?: 'InstrumentTrade';
  buy: Scalars['Boolean'];
  instrument: Instrument;
  price: Scalars['Float'];
  quantity: Scalars['Float'];
};

export type InvestmentRiskLevel = {
  __typename?: 'InvestmentRiskLevel';
  level?: Maybe<RiskLevel>;
  name?: Maybe<Scalars['String']>;
};

export type InvestmentVolume = {
  __typename?: 'InvestmentVolume';
  currency?: Maybe<Currency>;
  /** @deprecated Field no longer supported */
  currencyCode?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['LocalDate']>;
  value?: Maybe<Scalars['Float']>;
};

export type Issuer = {
  __typename?: 'Issuer';
  id?: Maybe<Scalars['Long']>;
  name?: Maybe<Scalars['String']>;
  partner?: Maybe<Scalars['Boolean']>;
};

export type IssuerBestInstrument = {
  __typename?: 'IssuerBestInstrument';
  instrument?: Maybe<Instrument>;
  issuerGroupId: Scalars['Long'];
  issuerName?: Maybe<Scalars['String']>;
};

export type KeyFiguresCriteria = {
  fromYear?: InputMaybe<Scalars['Int']>;
  toYear?: InputMaybe<Scalars['Int']>;
};

export type LastSearchedReportEntry = {
  __typename?: 'LastSearchedReportEntry';
  group: InstrumentGroup;
  instrumentGroupId: Scalars['Int'];
  when: Scalars['OffsetDateTime'];
};

export type LimitEntry = {
  __typename?: 'LimitEntry';
  effectiveLimitValue?: Maybe<Scalars['Float']>;
  hitStatus?: Maybe<Scalars['Boolean']>;
  hitTime?: Maybe<Scalars['OffsetDateTime']>;
  hitValue?: Maybe<Scalars['Float']>;
  id: Scalars['Long'];
  initialTime?: Maybe<Scalars['OffsetDateTime']>;
  initialValue?: Maybe<Scalars['Float']>;
  instrument?: Maybe<Instrument>;
  instrumentId?: Maybe<Scalars['Long']>;
  limitValue?: Maybe<Scalars['Float']>;
  mailNotification?: Maybe<Scalars['Boolean']>;
  memo?: Maybe<Scalars['String']>;
  percent?: Maybe<Scalars['Boolean']>;
  quoteType?: Maybe<QuoteType>;
  smsNotification?: Maybe<Scalars['Boolean']>;
  trailing?: Maybe<Scalars['Boolean']>;
  upper?: Maybe<Scalars['Boolean']>;
};

export type LimitEntryRequest = {
  instrumentId?: InputMaybe<Scalars['Long']>;
  limitValue?: InputMaybe<Scalars['Float']>;
  mailNotification?: InputMaybe<Scalars['Boolean']>;
  memo?: InputMaybe<Scalars['String']>;
  percent?: InputMaybe<Scalars['Boolean']>;
  quoteType?: InputMaybe<QuoteType>;
  smsNotification?: InputMaybe<Scalars['Boolean']>;
  trailing?: InputMaybe<Scalars['Boolean']>;
  upper?: InputMaybe<Scalars['Boolean']>;
};

export type List = {
  __typename?: 'List';
  content?: Maybe<Array<Instrument>>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type LocalDateRangeValue = {
  from?: InputMaybe<Scalars['LocalDate']>;
  to?: InputMaybe<Scalars['LocalDate']>;
};

export type MonteCarloResult = {
  __typename?: 'MonteCarloResult';
  avg?: Maybe<Scalars['Float']>;
  down?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  up?: Maybe<Scalars['Float']>;
};

export type MovingAverageIndicator = {
  __typename?: 'MovingAverageIndicator';
  deltaLine10Day?: Maybe<Scalars['Float']>;
  deltaLine20Day?: Maybe<Scalars['Float']>;
  deltaLine38Day?: Maybe<Scalars['Float']>;
  deltaLine90Day?: Maybe<Scalars['Float']>;
  deltaLine200Day?: Maybe<Scalars['Float']>;
  line10Day?: Maybe<Scalars['Float']>;
  line20Day?: Maybe<Scalars['Float']>;
  line38Day?: Maybe<Scalars['Float']>;
  line90Day?: Maybe<Scalars['Float']>;
  line200Day?: Maybe<Scalars['Float']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  accountDeposit: AccountEntry;
  accountDividend: AccountEntry;
  accountWithdrawal: AccountEntry;
  addAccountEntry: AccountEntry;
  addLimit: LimitEntry;
  closePortfolioEntry?: Maybe<PortfolioEntry>;
  copyPortfolioEntry: PortfolioEntry;
  copyWatchlistEntry: WatchlistEntry;
  createNewWatchlist?: Maybe<Watchlist>;
  createPortfolio?: Maybe<PortfolioResponse>;
  createPortfolioEntry?: Maybe<PortfolioEntry>;
  createWatchlistEntry?: Maybe<WatchlistEntry>;
  deleteAccountEntry: DefaultServiceResponse;
  deleteLimit: DefaultServiceResponse;
  deletePortfolio: DefaultServiceResponse;
  deletePortfolioEntry: DefaultServiceResponse;
  deletePortfolioEntryDetail: PortfolioResponse;
  deleteProfile: DefaultServiceResponse;
  deleteWatchlist: DefaultServiceResponse;
  deleteWatchlistEntry: DefaultServiceResponse;
  editAccountEntry: AccountEntry;
  editLimit: LimitEntry;
  editLimitOrder: DefaultServiceResponse;
  editLimitView: DefaultServiceResponse;
  editPortfolioEntry?: Maybe<PortfolioEntry>;
  editPortfolioEntryDetail: PortfolioResponse;
  editPortfolioOrder: DefaultServiceResponse;
  editPortfolioOverviewOrder: DefaultServiceResponse;
  editPortfolioView: DefaultServiceResponse;
  editWatchlistEntry?: Maybe<WatchlistEntry>;
  editWatchlistOrder: DefaultServiceResponse;
  editWatchlistOverviewOrder: DefaultServiceResponse;
  editWatchlistView: DefaultServiceResponse;
  feedback: FeedbackResponse;
  importProfile: DefaultServiceResponse;
  importRecords: Array<Maybe<UploadRecordResponse>>;
  movePortfolioEntry: PortfolioEntry;
  moveWatchlistEntry: WatchlistEntry;
  removePortfolioEntry: DefaultServiceResponse;
  renamePortfolio?: Maybe<PortfolioResponse>;
  renameWatchlist?: Maybe<Watchlist>;
  requestChangeProfileEmail: DefaultServiceResponse;
  requestChangeProfilePassword: DefaultServiceResponse;
  sellPortfolioEntryDetail: PortfolioResponse;
  splitPortfolioEntry?: Maybe<PortfolioEntry>;
  updatePortfolio?: Maybe<Portfolio>;
  updatePortfolioAlert?: Maybe<Portfolio>;
  updatePortfolioMaster?: Maybe<Array<FieldChangeBooleanResponse>>;
  updatePushToken: DefaultServiceResponse;
  updateWatchlist?: Maybe<Watchlist>;
  updateWatchlistMaster?: Maybe<Array<FieldChangeBooleanResponse>>;
  uploadFile: UploadFileResponse;
};


export type MutationAccountDepositArgs = {
  amount: Scalars['Float'];
  portfolioId: Scalars['Long'];
};


export type MutationAccountDividendArgs = {
  entry: AccountDividendRequest;
};


export type MutationAccountWithdrawalArgs = {
  amount: Scalars['Float'];
  portfolioId: Scalars['Long'];
};


export type MutationAddAccountEntryArgs = {
  entry: AccountEntryInput;
  portfolioId: Scalars['Long'];
};


export type MutationAddLimitArgs = {
  entry: LimitEntryRequest;
};


export type MutationClosePortfolioEntryArgs = {
  entry: ClosePortfolioEntryRequest;
};


export type MutationCopyPortfolioEntryArgs = {
  fromPortfolioId: Scalars['Long'];
  portfolioEntryId: Scalars['Long'];
  toPortfolioId: Scalars['Long'];
};


export type MutationCopyWatchlistEntryArgs = {
  fromWatchlistId: Scalars['Long'];
  toWatchlistId: Scalars['Long'];
  watchlistEntryId: Scalars['Long'];
};


export type MutationCreateNewWatchlistArgs = {
  name: Scalars['String'];
};


export type MutationCreatePortfolioArgs = {
  broker?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  real?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreatePortfolioEntryArgs = {
  entry: PortfolioEntryRequest;
};


export type MutationCreateWatchlistEntryArgs = {
  entry: WatchlistEntryRequest;
};


export type MutationDeleteAccountEntryArgs = {
  accountEntryId: Scalars['Long'];
  portfolioId: Scalars['Long'];
};


export type MutationDeleteLimitArgs = {
  limitId: Scalars['Long'];
};


export type MutationDeletePortfolioArgs = {
  portfolioId: Scalars['Long'];
};


export type MutationDeletePortfolioEntryArgs = {
  portfolioEntryId: Scalars['Long'];
  portfolioId: Scalars['Long'];
};


export type MutationDeletePortfolioEntryDetailArgs = {
  portfolioEntryDetailId: Scalars['Long'];
  portfolioEntryId: Scalars['Long'];
  portfolioId: Scalars['Long'];
};


export type MutationDeleteWatchlistArgs = {
  watchlistId: Scalars['Long'];
};


export type MutationDeleteWatchlistEntryArgs = {
  watchlistEntryId: Scalars['Long'];
  watchlistId: Scalars['Long'];
};


export type MutationEditAccountEntryArgs = {
  accountEntryId: Scalars['Long'];
  entry: AccountEntryInput;
  portfolioId: Scalars['Long'];
};


export type MutationEditLimitArgs = {
  entry: LimitEntryRequest;
  limitId: Scalars['Long'];
};


export type MutationEditLimitOrderArgs = {
  viewOrder: Scalars['String'];
  viewOrderAsc?: InputMaybe<Scalars['Boolean']>;
};


export type MutationEditLimitViewArgs = {
  viewType: Scalars['String'];
};


export type MutationEditPortfolioEntryArgs = {
  entry: EditPortfolioEntryRequest;
};


export type MutationEditPortfolioEntryDetailArgs = {
  entry: PortfolioEntryDetailInput;
  portfolioEntryId: Scalars['Long'];
  portfolioId: Scalars['Long'];
};


export type MutationEditPortfolioOrderArgs = {
  portfolioId?: InputMaybe<Scalars['Long']>;
  viewOrder: Scalars['String'];
  viewOrderAsc?: InputMaybe<Scalars['Boolean']>;
};


export type MutationEditPortfolioOverviewOrderArgs = {
  viewOrder: Scalars['String'];
  viewOrderAsc?: InputMaybe<Scalars['Boolean']>;
};


export type MutationEditPortfolioViewArgs = {
  portfolioId?: InputMaybe<Scalars['Long']>;
  viewType: Scalars['String'];
};


export type MutationEditWatchlistEntryArgs = {
  entry: EditWatchlistEntryRequest;
};


export type MutationEditWatchlistOrderArgs = {
  viewOrder: Scalars['String'];
  viewOrderAsc?: InputMaybe<Scalars['Boolean']>;
  watchlistId?: InputMaybe<Scalars['Long']>;
};


export type MutationEditWatchlistOverviewOrderArgs = {
  viewOrder: Scalars['String'];
  viewOrderAsc?: InputMaybe<Scalars['Boolean']>;
};


export type MutationEditWatchlistViewArgs = {
  viewType: Scalars['String'];
  watchlistId?: InputMaybe<Scalars['Long']>;
};


export type MutationFeedbackArgs = {
  feedback: FeedbackRequest;
};


export type MutationImportProfileArgs = {
  includeLimits: Scalars['Boolean'];
  password: Scalars['String'];
  portfolioFilter: Array<InputMaybe<Scalars['Long']>>;
  userName: Scalars['String'];
  watchlistFilter: Array<InputMaybe<Scalars['Long']>>;
};


export type MutationImportRecordsArgs = {
  portfolioId: Scalars['Long'];
  records: Array<UploadFileRecordInput>;
};


export type MutationMovePortfolioEntryArgs = {
  fromPortfolioId: Scalars['Long'];
  portfolioEntryId: Scalars['Long'];
  toPortfolioId: Scalars['Long'];
};


export type MutationMoveWatchlistEntryArgs = {
  fromWatchlistId: Scalars['Long'];
  toWatchlistId: Scalars['Long'];
  watchlistEntryId: Scalars['Long'];
};


export type MutationRemovePortfolioEntryArgs = {
  amount: Scalars['Float'];
  date: Scalars['OffsetDateTime'];
  portfolioEntryId: Scalars['Long'];
  portfolioId: Scalars['Long'];
};


export type MutationRenamePortfolioArgs = {
  newName: Scalars['String'];
  portfolioId: Scalars['Long'];
};


export type MutationRenameWatchlistArgs = {
  newName: Scalars['String'];
  watchlistId: Scalars['Long'];
};


export type MutationRequestChangeProfileEmailArgs = {
  email: Scalars['String'];
};


export type MutationSellPortfolioEntryDetailArgs = {
  entry: PortfolioEntryDetailInput;
  portfolioEntryId: Scalars['Long'];
  portfolioId: Scalars['Long'];
};


export type MutationSplitPortfolioEntryArgs = {
  entry: SplitPortfolioEntryRequest;
};


export type MutationUpdatePortfolioArgs = {
  entry: PortfolioUpdateRequest;
};


export type MutationUpdatePortfolioAlertArgs = {
  entry: PortfolioAlertRequest;
};


export type MutationUpdatePortfolioMasterArgs = {
  changes: Array<FieldChangeBooleanRequest>;
};


export type MutationUpdatePushTokenArgs = {
  newToken: Scalars['String'];
  oldToken?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateWatchlistArgs = {
  entry: WatchlistUpdateRequest;
};


export type MutationUpdateWatchlistMasterArgs = {
  changes: Array<FieldChangeBooleanRequest>;
};


export type MutationUploadFileArgs = {
  fileContent: Scalars['String'];
  fileName?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['Long'];
};

export type News = Node & {
  __typename?: 'News';
  body?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Scalars['String']>>;
  feed?: Maybe<NewsFeed>;
  headline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instruments?: Maybe<Array<NewsInstrument>>;
  keywords?: Maybe<Array<Scalars['String']>>;
  links?: Maybe<Array<NewsLink>>;
  medias?: Maybe<Array<NewsMedia>>;
  source?: Maybe<NewsSource>;
  streams?: Maybe<Array<NewsStream>>;
  teaser?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['String']>;
  when?: Maybe<Scalars['OffsetDateTime']>;
};

export type NewsConnection = {
  __typename?: 'NewsConnection';
  edges: Array<NewsEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type NewsCriteria = {
  feeds?: InputMaybe<Array<Scalars['ID']>>;
  intervalEnd?: InputMaybe<Scalars['OffsetDateTime']>;
  intervalStart?: InputMaybe<Scalars['OffsetDateTime']>;
  isin?: InputMaybe<Array<Scalars['String']>>;
  searchString?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Array<Scalars['ID']>>;
  topic?: InputMaybe<Array<Scalars['ID']>>;
};

export type NewsDailyCountCriteria = {
  endDate?: InputMaybe<Scalars['LocalDate']>;
  isins: Array<Scalars['String']>;
  startDate: Scalars['LocalDate'];
};

export type NewsDailyCountEdge = {
  __typename?: 'NewsDailyCountEdge';
  count?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['LocalDate']>;
  isin?: Maybe<Scalars['String']>;
};

export type NewsEdge = {
  __typename?: 'NewsEdge';
  cursor: Scalars['ID'];
  node: News;
};

export enum NewsFeed {
  EditorialFeed = 'EDITORIAL_FEED',
  NewsFeed = 'NEWS_FEED',
  VideoFeed = 'VIDEO_FEED'
}

export type NewsInstrument = {
  __typename?: 'NewsInstrument';
  group?: Maybe<InstrumentGroup>;
  /** @deprecated Field no longer supported */
  groupId?: Maybe<Scalars['Int']>;
  /** @deprecated Field no longer supported */
  instrument?: Maybe<Instrument>;
  /** @deprecated Field no longer supported */
  instrumentId?: Maybe<Scalars['Int']>;
  isin: Scalars['String'];
  /** @deprecated Field no longer supported */
  name?: Maybe<Scalars['String']>;
};

export type NewsIsinCountCriteria = {
  endDate?: InputMaybe<Scalars['LocalDate']>;
  isins: Array<Scalars['String']>;
  startDate: Scalars['LocalDate'];
};

export type NewsIsinCountEdge = {
  __typename?: 'NewsIsinCountEdge';
  date?: Maybe<Scalars['LocalDate']>;
  isin?: Maybe<Scalars['String']>;
  newsCount?: Maybe<Scalars['Int']>;
};

export type NewsLink = {
  __typename?: 'NewsLink';
  href?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type NewsMedia = {
  __typename?: 'NewsMedia';
  alt?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  mime?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  producer?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type NewsProductCountEdge = {
  __typename?: 'NewsProductCountEdge';
  count: Scalars['Int'];
  group?: Maybe<InstrumentGroup>;
  isin: Scalars['String'];
};

export type NewsSource = {
  __typename?: 'NewsSource';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type NewsStream = {
  __typename?: 'NewsStream';
  duration?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  mimeType?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
};

export type NewsTopic = {
  __typename?: 'NewsTopic';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  videoCapable?: Maybe<Scalars['Boolean']>;
};

export type Node = {
  id: Scalars['ID'];
};

export enum OperationType {
  Buy = 'BUY',
  Dividend = 'DIVIDEND',
  Remove = 'REMOVE',
  Sell = 'SELL',
  Split = 'SPLIT'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['ID']>;
};

export type PeerGroupCompare = {
  __typename?: 'PeerGroupCompare';
  chart?: Maybe<PeerGroupCompareChart>;
  type: PeerGroupCompareType;
  value: Scalars['Float'];
};

export type PeerGroupCompareChart = {
  __typename?: 'PeerGroupCompareChart';
  breakPoint: Scalars['Float'];
  current: PeerGroupCompareChartPoint;
  max: PeerGroupCompareChartPoint;
  min: PeerGroupCompareChartPoint;
};

export type PeerGroupCompareChartPoint = {
  __typename?: 'PeerGroupCompareChartPoint';
  group?: Maybe<InstrumentGroup>;
  isin?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export enum PeerGroupCompareType {
  DividendPayoutRatio = 'DIVIDEND_PAYOUT_RATIO',
  NetDividendYield = 'NET_DIVIDEND_YIELD',
  PriceCashflowRatio = 'PRICE_CASHFLOW_RATIO',
  PriceEarningsRatio = 'PRICE_EARNINGS_RATIO',
  PriceEarningToGrowth = 'PRICE_EARNING_TO_GROWTH',
  PriceToSalesRatio = 'PRICE_TO_SALES_RATIO'
}

export type PeerGroupPerformancePeriod = {
  __typename?: 'PeerGroupPerformancePeriod';
  average: Scalars['Float'];
  instrumentGroupMax: InstrumentGroup;
  instrumentGroupMin: InstrumentGroup;
  isinMax?: Maybe<Scalars['String']>;
  isinMin?: Maybe<Scalars['String']>;
  maximum: Scalars['Float'];
  minimum: Scalars['Float'];
  period: CalculationPeriod;
};

export enum Period {
  Last_1Month = 'LAST_1_MONTH',
  Last_1Year = 'LAST_1_YEAR',
  Last_3Years = 'LAST_3_YEARS',
  Last_5Years = 'LAST_5_YEARS',
  Last_6Month = 'LAST_6_MONTH',
  Last_10Years = 'LAST_10_YEARS'
}

export type Portfolio = {
  __typename?: 'Portfolio';
  accountEntries?: Maybe<Array<AccountEntry>>;
  broker?: Maybe<Scalars['String']>;
  entries?: Maybe<Array<PortfolioEntry>>;
  eom: Scalars['Boolean'];
  id: Scalars['Int'];
  inMasterPortfolio: Scalars['Boolean'];
  memo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  performanceEntries?: Maybe<Array<PortfolioPerformanceEntry>>;
  portfolioAlert: Scalars['Boolean'];
  portfolioLowerLimit?: Maybe<Scalars['Float']>;
  portfolioUpperLimit?: Maybe<Scalars['Float']>;
  positionAlert: Scalars['Boolean'];
  positionLowerLimit?: Maybe<Scalars['Float']>;
  positionUpperLimit?: Maybe<Scalars['Float']>;
  real: Scalars['Boolean'];
  realAccountNo?: Maybe<Scalars['String']>;
  viewOrder?: Maybe<Scalars['String']>;
  viewOrderAsc?: Maybe<Scalars['Boolean']>;
  viewType?: Maybe<Scalars['String']>;
  wd1: Scalars['Boolean'];
  wd2: Scalars['Boolean'];
  wd3: Scalars['Boolean'];
  wd4: Scalars['Boolean'];
  wd5: Scalars['Boolean'];
  wd6: Scalars['Boolean'];
  wd7: Scalars['Boolean'];
  wdTime: Scalars['OffsetDateTime'];
};

export type PortfolioAlertRequest = {
  portfolioAlert?: InputMaybe<Scalars['Boolean']>;
  portfolioId: Scalars['Long'];
  portfolioLowerLimit?: InputMaybe<Scalars['Float']>;
  portfolioUpperLimit?: InputMaybe<Scalars['Float']>;
  positionAlert?: InputMaybe<Scalars['Boolean']>;
  positionLowerLimit?: InputMaybe<Scalars['Float']>;
  positionUpperLimit?: InputMaybe<Scalars['Float']>;
};

export type PortfolioEntry = {
  __typename?: 'PortfolioEntry';
  buyCharges: Scalars['Float'];
  buyCurrencyPrice?: Maybe<Scalars['Float']>;
  currencyCode?: Maybe<Scalars['String']>;
  currentCurrencyPrice?: Maybe<Scalars['Float']>;
  details: Array<PortfolioEntryDetail>;
  entryTime: Scalars['OffsetDateTime'];
  id: Scalars['Int'];
  instrument?: Maybe<Instrument>;
  instrumentGroupId?: Maybe<Scalars['Int']>;
  instrumentId?: Maybe<Scalars['Int']>;
  intradayPrices?: Maybe<Array<ChartSeries>>;
  memo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nominalCurrency?: Maybe<Scalars['String']>;
  nominalValue?: Maybe<Scalars['Float']>;
  previousCurrencyPrice?: Maybe<Scalars['Float']>;
  price: Scalars['Float'];
  quantity: Scalars['Float'];
  snapQuote?: Maybe<SnapQuote>;
};

export type PortfolioEntryDetail = {
  __typename?: 'PortfolioEntryDetail';
  buyCurrencyPrice: Scalars['Float'];
  charges: Scalars['Float'];
  currencyCode?: Maybe<Scalars['String']>;
  currentCurrencyPrice?: Maybe<Scalars['Float']>;
  effectiveQuantity: Scalars['Float'];
  entryTime: Scalars['OffsetDateTime'];
  id: Scalars['Int'];
  instrumentId: Scalars['Long'];
  memo?: Maybe<Scalars['String']>;
  nominalCurrency?: Maybe<Scalars['String']>;
  nominalValue?: Maybe<Scalars['Float']>;
  operation: OperationType;
  previousCurrencyPrice?: Maybe<Scalars['Float']>;
  price: Scalars['Float'];
  quantity: Scalars['Float'];
};

export type PortfolioEntryDetailInput = {
  charges: Scalars['Float'];
  currencyCode?: InputMaybe<Scalars['String']>;
  entryTime: Scalars['OffsetDateTime'];
  id: Scalars['Int'];
  instrumentId: Scalars['Long'];
  memo?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity: Scalars['Float'];
};

export type PortfolioEntryRequest = {
  charges: Scalars['Float'];
  currencyCode?: InputMaybe<Scalars['String']>;
  entryTime: Scalars['OffsetDateTime'];
  instrumentId: Scalars['Long'];
  memo?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['Long'];
  price: Scalars['Float'];
  quantity: Scalars['Float'];
};

export type PortfolioItem = {
  __typename?: 'PortfolioItem';
  id: Scalars['Int'];
  name: Scalars['String'];
  real: Scalars['Boolean'];
};

export type PortfolioPerformanceEntry = {
  __typename?: 'PortfolioPerformanceEntry';
  date: Scalars['OffsetDateTime'];
  value: Scalars['Float'];
};

export type PortfolioResponse = {
  __typename?: 'PortfolioResponse';
  data?: Maybe<Portfolio>;
  result: DefaultServiceResponse;
};

export type PortfolioUpdateRequest = {
  eom?: InputMaybe<Scalars['Boolean']>;
  memo?: InputMaybe<Scalars['String']>;
  portfolioId: Scalars['Long'];
  wd1?: InputMaybe<Scalars['Boolean']>;
  wd2?: InputMaybe<Scalars['Boolean']>;
  wd3?: InputMaybe<Scalars['Boolean']>;
  wd4?: InputMaybe<Scalars['Boolean']>;
  wd5?: InputMaybe<Scalars['Boolean']>;
  wd6?: InputMaybe<Scalars['Boolean']>;
  wd7?: InputMaybe<Scalars['Boolean']>;
  wdTime?: InputMaybe<Scalars['OffsetDateTime']>;
};

export type ProfileKeyFigures = {
  __typename?: 'ProfileKeyFigures';
  accountTotal?: Maybe<Scalars['Float']>;
  ertrage?: Maybe<Scalars['Float']>;
};

export type ProfileOverviewResponse = {
  __typename?: 'ProfileOverviewResponse';
  data?: Maybe<UserProfile>;
  result: DefaultServiceResponse;
};

export type ProfileSettings = {
  __typename?: 'ProfileSettings';
  id: Scalars['Long'];
  limitViewOrder?: Maybe<Scalars['String']>;
  limitViewOrderAsc?: Maybe<Scalars['Boolean']>;
  limitViewType?: Maybe<Scalars['String']>;
  portfolioOverviewOrder?: Maybe<Scalars['String']>;
  portfolioOverviewOrderAsc?: Maybe<Scalars['Boolean']>;
  portfolioOverviewType?: Maybe<Scalars['String']>;
  portfolioViewOrder?: Maybe<Scalars['String']>;
  portfolioViewOrderAsc?: Maybe<Scalars['Boolean']>;
  portfolioViewType?: Maybe<Scalars['String']>;
  watchlistOverviewOrder?: Maybe<Scalars['String']>;
  watchlistOverviewOrderAsc?: Maybe<Scalars['Boolean']>;
  watchlistOverviewType?: Maybe<Scalars['String']>;
  watchlistViewOrder?: Maybe<Scalars['String']>;
  watchlistViewOrderAsc?: Maybe<Scalars['Boolean']>;
  watchlistViewType?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  accountOperationTypes: Array<AccountOperationType>;
  analysesIsinCount: Array<NewsIsinCountEdge>;
  analysis?: Maybe<Analysis>;
  analysisInstitute?: Maybe<Array<AnalystInstitute>>;
  analysisSearch: AnalysisConnection;
  assetPage?: Maybe<AssetPage>;
  assetTypeGroupBucket: Array<AssetTypeGroupBucket>;
  bestWarrantRnd?: Maybe<IssuerBestInstrument>;
  bestWarrantsByIssuer: Array<IssuerBestInstrument>;
  bondIssuers: Array<BondIssuer>;
  bondNominalCurrencyBuckets: Array<CurrencyBucket>;
  bondTradingCurrencyBuckets: Array<CurrencyBucket>;
  bondTypes: Array<BondType>;
  brokers: Array<Broker>;
  calendarCategories: Array<Maybe<CalendarCategory>>;
  calendarCountries: Array<Maybe<CalendarCountry>>;
  calendarEventSummary: Array<CalendarSummary>;
  checkProfile: DefaultServiceResponse;
  classification: Array<AssetClass>;
  currencyHistory?: Maybe<QuoteHistory>;
  currencyPairs: Array<CurrencyPair>;
  currencyQuote?: Maybe<SnapQuote>;
  etfAllocation: Array<EtfAllocation>;
  etfIssuers: Array<EtfIssuer>;
  etfPosition: Array<EtfPosition>;
  etfRegions: Array<EtfRegion>;
  etfReplications: Array<EtfReplication>;
  etfSectors: Array<EtfSector>;
  etfStrategies: Array<EtfStrategy>;
  fetchProfileOverview: ProfileOverviewResponse;
  fundCompanies: Array<FundCompany>;
  fundCurrencies: Array<FundCurrency>;
  fundRegions: Array<Maybe<FundRegion>>;
  fundStrategies: Array<FundStrategy>;
  fundTopics: Array<Maybe<FundTopic>>;
  fundTypeBucket: Array<Maybe<FundTypeBucket>>;
  fundTypes: Array<Maybe<FundType>>;
  group?: Maybe<InstrumentGroup>;
  instrument?: Maybe<Instrument>;
  instrumentGroup?: Maybe<Array<Instrument>>;
  instrumentGroupIncluded: InstrumentGroupIncludedResponse;
  instrumentGroupLimits: Array<Maybe<InstrumentLimit>>;
  instrumentGroupTrades: Array<Maybe<InstrumentTrade>>;
  instrumentGroupTradesTopTrades: Array<Maybe<InstrumentGroupTrade>>;
  instrumentGroupTradesTopVolume: Array<Maybe<InstrumentGroupTrade>>;
  instrumentIncluded?: Maybe<InstrumentIncludedResponse>;
  issuers: Array<Issuer>;
  limits: Array<LimitEntry>;
  list?: Maybe<List>;
  mostSearchedReport?: Maybe<Array<EventReportEntry>>;
  news?: Maybe<News>;
  newsDailyCount: Array<NewsDailyCountEdge>;
  newsProductCount: Array<NewsProductCountEdge>;
  newsSearch: NewsConnection;
  newsSource?: Maybe<Array<NewsSource>>;
  newsTopics?: Maybe<Array<NewsTopic>>;
  portfolio?: Maybe<Portfolio>;
  portfolioEntryDetails?: Maybe<Array<PortfolioEntryDetail>>;
  portfolioPerformance: Array<PortfolioPerformanceEntry>;
  profileSettings?: Maybe<ProfileSettings>;
  regions: Array<Region>;
  search: InstrumentDetailConnection;
  searchBond: InstrumentConnection;
  searchCalendarEvents: CalendarEventConnection;
  searchCrossRate: InstrumentConnection;
  searchDerivative: InstrumentConnection;
  searchEtf: InstrumentConnection;
  searchFund: InstrumentConnection;
  searchIndex: InstrumentConnection;
  searchShare: InstrumentConnection;
  sectors: Array<Sector>;
  theScreenerRatingSearch: Array<TheScreenerRating>;
  user?: Maybe<User>;
  userOverview?: Maybe<UserOverviewResponse>;
};


export type QueryAnalysesIsinCountArgs = {
  criteria?: InputMaybe<NewsIsinCountCriteria>;
};


export type QueryAnalysisArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryAnalysisSearchArgs = {
  after?: InputMaybe<Scalars['ID']>;
  before?: InputMaybe<Scalars['ID']>;
  criteria?: InputMaybe<AnalysisCriteria>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryAssetPageArgs = {
  seoTag: Scalars['String'];
};


export type QueryAssetTypeGroupBucketArgs = {
  criteria?: InputMaybe<AssetTypeGroupBucketCriteria>;
};


export type QueryBestWarrantRndArgs = {
  months: Scalars['Long'];
  pctChange: Scalars['Float'];
  underlyingIsin: Scalars['String'];
};


export type QueryBestWarrantsByIssuerArgs = {
  months: Scalars['Long'];
  pctChange: Scalars['Float'];
  underlyingIsin: Scalars['String'];
};


export type QueryCalendarEventSummaryArgs = {
  from?: InputMaybe<Scalars['LocalDate']>;
  to?: InputMaybe<Scalars['LocalDate']>;
};


export type QueryClassificationArgs = {
  category?: InputMaybe<Array<AssetGroup>>;
  leveraged?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCurrencyHistoryArgs = {
  baseCode: Scalars['String'];
  quoteCode: Scalars['String'];
  time: Scalars['OffsetDateTime'];
};


export type QueryCurrencyPairsArgs = {
  baseCode: Scalars['String'];
};


export type QueryCurrencyQuoteArgs = {
  baseCode: Scalars['String'];
  quoteCode: Scalars['String'];
};


export type QueryFetchProfileOverviewArgs = {
  password: Scalars['String'];
  userName: Scalars['String'];
};


export type QueryFundTypeBucketArgs = {
  criteria?: InputMaybe<FundTypeBucketCriteria>;
};


export type QueryGroupArgs = {
  id: Scalars['Int'];
};


export type QueryInstrumentArgs = {
  id: Scalars['Int'];
};


export type QueryInstrumentGroupArgs = {
  instrumentGroupId: Scalars['Int'];
};


export type QueryInstrumentGroupIncludedArgs = {
  instrumentGroupId: Scalars['Long'];
};


export type QueryInstrumentGroupLimitsArgs = {
  instrumentGroupId: Scalars['Long'];
};


export type QueryInstrumentGroupTradesArgs = {
  days: Scalars['Long'];
  instrumentGroupId: Scalars['Long'];
};


export type QueryInstrumentGroupTradesTopTradesArgs = {
  buy: Scalars['Boolean'];
  days: Scalars['Long'];
  itemsReturned: Scalars['Long'];
};


export type QueryInstrumentGroupTradesTopVolumeArgs = {
  buy: Scalars['Boolean'];
  days: Scalars['Long'];
  itemsReturned: Scalars['Long'];
};


export type QueryInstrumentIncludedArgs = {
  id: Scalars['Int'];
};


export type QueryListArgs = {
  id: Scalars['String'];
};


export type QueryMostSearchedReportArgs = {
  period?: InputMaybe<ReportPeriod>;
};


export type QueryNewsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryNewsDailyCountArgs = {
  criteria?: InputMaybe<NewsDailyCountCriteria>;
};


export type QueryNewsProductCountArgs = {
  period?: InputMaybe<ReportPeriod>;
};


export type QueryNewsSearchArgs = {
  after?: InputMaybe<Scalars['ID']>;
  criteria?: InputMaybe<NewsCriteria>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryPortfolioArgs = {
  id: Scalars['Long'];
};


export type QueryPortfolioEntryDetailsArgs = {
  portfolioEntryId: Scalars['Long'];
  portfolioId: Scalars['Long'];
};


export type QueryPortfolioPerformanceArgs = {
  id: Scalars['Int'];
};


export type QuerySearchArgs = {
  after?: InputMaybe<Scalars['ID']>;
  criteria?: InputMaybe<SearchCriteria>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchBondArgs = {
  after?: InputMaybe<Scalars['ID']>;
  criterion?: InputMaybe<SearchBondCriterion>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SearchBondSort>>;
};


export type QuerySearchCalendarEventsArgs = {
  after?: InputMaybe<Scalars['ID']>;
  criteria?: InputMaybe<SearchCalendarEventsCriteria>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchCrossRateArgs = {
  after?: InputMaybe<Scalars['ID']>;
  criteria?: InputMaybe<SearchCrossRateCriteria>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SearchCrossRateSort>>;
};


export type QuerySearchDerivativeArgs = {
  after?: InputMaybe<Scalars['ID']>;
  criterion?: InputMaybe<SearchDerivativeCriterion>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SearchDerivativeSort>>;
};


export type QuerySearchEtfArgs = {
  after?: InputMaybe<Scalars['ID']>;
  criterion?: InputMaybe<SearchEtfCriterion>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SearchEtfSort>>;
};


export type QuerySearchFundArgs = {
  after?: InputMaybe<Scalars['ID']>;
  criterion?: InputMaybe<SearchFundCriterion>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SearchFundSort>>;
};


export type QuerySearchIndexArgs = {
  after?: InputMaybe<Scalars['ID']>;
  criteria?: InputMaybe<SearchIndexCriteria>;
  first?: InputMaybe<Scalars['Int']>;
};


export type QuerySearchShareArgs = {
  after?: InputMaybe<Scalars['ID']>;
  criterion?: InputMaybe<SearchShareCriterion>;
  first?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<SearchShareSort>>;
};


export type QueryTheScreenerRatingSearchArgs = {
  criteria?: InputMaybe<TheScreenerSearchCriteria>;
  first?: InputMaybe<Scalars['Int']>;
};

export type Quote = {
  __typename?: 'Quote';
  change?: Maybe<Scalars['Float']>;
  delay?: Maybe<Scalars['Int']>;
  percentChange?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Int']>;
  type?: Maybe<QuoteType>;
  value?: Maybe<Scalars['Float']>;
  when?: Maybe<Scalars['OffsetDateTime']>;
};

export type QuoteHistory = {
  __typename?: 'QuoteHistory';
  changePercent?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['LocalDate']>;
  firstPrice?: Maybe<Scalars['Float']>;
  highPrice?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  lastPrice?: Maybe<Scalars['Float']>;
  lowPrice?: Maybe<Scalars['Float']>;
  trades?: Maybe<Scalars['Int']>;
  turnOver?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['Long']>;
};

export type QuoteHistoryConnection = {
  __typename?: 'QuoteHistoryConnection';
  edges: Array<QuoteHistoryEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type QuoteHistoryEdge = {
  __typename?: 'QuoteHistoryEdge';
  cursor?: Maybe<Scalars['ID']>;
  node?: Maybe<QuoteHistory>;
};

export enum QuoteType {
  Ask = 'ASK',
  Bid = 'BID',
  IssuePrice = 'ISSUE_PRICE',
  NetAssetValue = 'NET_ASSET_VALUE',
  RedemptionPrice = 'REDEMPTION_PRICE',
  Trade = 'TRADE'
}

export type RangeChart = {
  __typename?: 'RangeChart';
  current?: Maybe<Scalars['Float']>;
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  threshold?: Maybe<Scalars['Float']>;
};

export type RefundRelativeScenario = {
  __typename?: 'RefundRelativeScenario';
  performance?: Maybe<Scalars['Float']>;
  underlyingPerformance?: Maybe<Scalars['Float']>;
  underlyingValue?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type Region = {
  __typename?: 'Region';
  countries: Array<Country>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
};

export type RelativeStrengthIndex = {
  __typename?: 'RelativeStrengthIndex';
  last7Days?: Maybe<Scalars['Float']>;
  last9Days?: Maybe<Scalars['Float']>;
  last14Days?: Maybe<Scalars['Float']>;
  last25Days?: Maybe<Scalars['Float']>;
};

export type RelativeStrengthLevyIndicator = {
  __typename?: 'RelativeStrengthLevyIndicator';
  deltaMedian?: Maybe<Scalars['Float']>;
  indicator?: Maybe<Scalars['Float']>;
};

export enum ReportPeriod {
  Last_7D = 'LAST_7D',
  Last_24H = 'LAST_24H',
  Last_48H = 'LAST_48H'
}

export enum RiskLevel {
  High = 'HIGH',
  Low = 'LOW',
  Moderate = 'MODERATE',
  VeryHigh = 'VERY_HIGH',
  VeryLow = 'VERY_LOW'
}

export type RobotsMetaConfiguration = {
  __typename?: 'RobotsMetaConfiguration';
  follow?: Maybe<Scalars['Boolean']>;
  index?: Maybe<Scalars['Boolean']>;
};

export type SearchBondCriterion = {
  assetClass?: InputMaybe<Scalars['Long']>;
  assetType?: InputMaybe<Scalars['String']>;
  assetTypeGroup?: InputMaybe<Scalars['String']>;
  hasSubordinatedDebt?: InputMaybe<Scalars['Boolean']>;
  issuerId?: InputMaybe<Scalars['Long']>;
  keyFigures?: InputMaybe<Array<BondKeyFigureCriteria>>;
  maturityDateFrom?: InputMaybe<Scalars['LocalDate']>;
  maturityDateTo?: InputMaybe<Scalars['LocalDate']>;
  nominalCurrencyId?: InputMaybe<Scalars['Long']>;
  tradingCurrencyId?: InputMaybe<Scalars['Long']>;
  typeId?: InputMaybe<Scalars['Long']>;
};

export type SearchBondSort = {
  descending?: InputMaybe<Scalars['Boolean']>;
  keyFigure?: InputMaybe<BondSortField>;
};

export type SearchCalendarEventsCriteria = {
  categoryId?: InputMaybe<Scalars['ID']>;
  countryId?: InputMaybe<Scalars['ID']>;
  currencyId?: InputMaybe<Scalars['ID']>;
  eventType?: InputMaybe<EventType>;
  from?: InputMaybe<Scalars['LocalDate']>;
  future?: InputMaybe<Scalars['Boolean']>;
  relevance?: InputMaybe<Array<EventRelevance>>;
  to?: InputMaybe<Scalars['LocalDate']>;
};

export type SearchCriteria = {
  assetClass?: InputMaybe<Scalars['Long']>;
  assetGroup?: InputMaybe<Array<AssetGroup>>;
  assetType?: InputMaybe<Scalars['String']>;
  assetTypeGroup?: InputMaybe<Scalars['String']>;
  issuerId?: InputMaybe<Scalars['Long']>;
  searchString?: InputMaybe<Scalars['String']>;
  underlying?: InputMaybe<Scalars['Boolean']>;
  underlyingInstrumentGroupId?: InputMaybe<Scalars['Long']>;
};

export type SearchCrossRateCriteria = {
  assetClass?: InputMaybe<Scalars['Long']>;
  assetType?: InputMaybe<Scalars['String']>;
  assetTypeGroup?: InputMaybe<Scalars['String']>;
  foreignCurrencyCode?: InputMaybe<Scalars['String']>;
  foreignCurrencyId?: InputMaybe<Scalars['Long']>;
  homeCurrencyCode?: InputMaybe<Scalars['String']>;
  homeCurrencyId?: InputMaybe<Scalars['Long']>;
};

export type SearchCrossRateSort = {
  descending?: InputMaybe<Scalars['Boolean']>;
  field?: InputMaybe<CrossRateSortField>;
};

export type SearchDerivativeCriterion = {
  assetClass?: InputMaybe<Scalars['Long']>;
  assetGroup?: InputMaybe<AssetGroup>;
  assetType?: InputMaybe<Scalars['String']>;
  assetTypeGroup?: InputMaybe<Scalars['String']>;
  issuerId?: InputMaybe<Array<Scalars['Long']>>;
  keyFigures?: InputMaybe<Array<DerivativeKeyFigureCriteria>>;
  maturityDate?: InputMaybe<LocalDateRangeValue>;
  optionType?: InputMaybe<DerivativeOptionType>;
  underlyingInstrumentGroupId?: InputMaybe<Scalars['Int']>;
};

export type SearchDerivativeSort = {
  descending?: InputMaybe<Scalars['Boolean']>;
  field?: InputMaybe<DerivativeSortField>;
};

export type SearchEtfCriterion = {
  allocationId?: InputMaybe<Scalars['Long']>;
  assetClass?: InputMaybe<Scalars['Long']>;
  assetType?: InputMaybe<Scalars['String']>;
  assetTypeGroup?: InputMaybe<Scalars['String']>;
  benchmarkId?: InputMaybe<Scalars['Long']>;
  distributing?: InputMaybe<Scalars['Boolean']>;
  domicileId?: InputMaybe<Scalars['Long']>;
  foundationDateFrom?: InputMaybe<Scalars['LocalDate']>;
  foundationDateTo?: InputMaybe<Scalars['LocalDate']>;
  issuerId?: InputMaybe<Scalars['Long']>;
  keyFigures?: InputMaybe<Array<EtfKeyFigureCriteria>>;
  positionId?: InputMaybe<Scalars['Long']>;
  quanto?: InputMaybe<Scalars['Boolean']>;
  regionId?: InputMaybe<Scalars['Long']>;
  replicationId?: InputMaybe<Scalars['Long']>;
  sectorId?: InputMaybe<Scalars['Long']>;
  strategyId?: InputMaybe<Scalars['Long']>;
};

export type SearchEtfSort = {
  descending?: InputMaybe<Scalars['Boolean']>;
  field?: InputMaybe<EtfSortField>;
};

export type SearchFundCriterion = {
  distributing?: InputMaybe<Scalars['Boolean']>;
  foundationDateFrom?: InputMaybe<Scalars['LocalDate']>;
  foundationDateTo?: InputMaybe<Scalars['LocalDate']>;
  fundCompanyId?: InputMaybe<Scalars['Int']>;
  fundCurrencyId?: InputMaybe<Scalars['Int']>;
  fundRegionId?: InputMaybe<Scalars['Int']>;
  fundStrategyId?: InputMaybe<Scalars['Int']>;
  fundTopicId?: InputMaybe<Scalars['Int']>;
  fundTypeId?: InputMaybe<Scalars['Int']>;
  germanRiesterCapable?: InputMaybe<Scalars['Boolean']>;
  germanVwlCapable?: InputMaybe<Scalars['Boolean']>;
  keyFigures?: InputMaybe<Array<FundKeyFigureCriteria>>;
  savingPlanCapable?: InputMaybe<Scalars['Boolean']>;
  srriFrom?: InputMaybe<Scalars['Int']>;
  srriTo?: InputMaybe<Scalars['Int']>;
};

export type SearchFundSort = {
  descending?: InputMaybe<Scalars['Boolean']>;
  field?: InputMaybe<FundSortField>;
};

export type SearchIndexCriteria = {
  assetClass?: InputMaybe<Scalars['Long']>;
  assetType?: InputMaybe<Scalars['String']>;
  assetTypeGroup?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['Long']>;
  sectorId?: InputMaybe<Scalars['Long']>;
};

export type SearchShareCriterion = {
  allTimeHigh?: InputMaybe<LocalDateRangeValue>;
  marketCapitalization?: InputMaybe<FloatRangeValue>;
  period?: InputMaybe<Period>;
  ranges: Array<ShareRangeCriteria>;
  regionId?: InputMaybe<Scalars['Long']>;
  trends: Array<ShareKeyFigureTrend>;
};

export type SearchShareSort = {
  descending?: InputMaybe<Scalars['Boolean']>;
  field?: InputMaybe<ShareSortField>;
};

export type Sector = {
  __typename?: 'Sector';
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  nameShort?: Maybe<Scalars['String']>;
};

export type ShareKeyFigureTrend = {
  keyFigure: ShareSearchKeyFigure;
  type: TrendType;
  value: Trend;
};

export type ShareRangeCriteria = {
  from?: InputMaybe<Scalars['Float']>;
  keyFigure: ShareSearchKeyFigure;
  to?: InputMaybe<Scalars['Float']>;
};

export enum ShareSearchKeyFigure {
  CashFlowChangePercent = 'CASH_FLOW_CHANGE_PERCENT',
  DividendChangePercent = 'DIVIDEND_CHANGE_PERCENT',
  DividendPayoutRatio = 'DIVIDEND_PAYOUT_RATIO',
  DividendYield = 'DIVIDEND_YIELD',
  DividendYieldAverage = 'DIVIDEND_YIELD_AVERAGE',
  NetIncomeChangePercent = 'NET_INCOME_CHANGE_PERCENT',
  Performance = 'PERFORMANCE',
  SalesChangePercent = 'SALES_CHANGE_PERCENT',
  SalesPerEmployeeChangePercent = 'SALES_PER_EMPLOYEE_CHANGE_PERCENT',
  Volatility = 'VOLATILITY'
}

export enum ShareSortField {
  AllTimeHighDate = 'ALL_TIME_HIGH_DATE',
  AllTimeHighPrice = 'ALL_TIME_HIGH_PRICE',
  CashFlowChangePercent = 'CASH_FLOW_CHANGE_PERCENT',
  DividendChangePercent = 'DIVIDEND_CHANGE_PERCENT',
  DividendPayoutRatio = 'DIVIDEND_PAYOUT_RATIO',
  DividendYield = 'DIVIDEND_YIELD',
  DividendYieldAverage = 'DIVIDEND_YIELD_AVERAGE',
  MarketCapitalization = 'MARKET_CAPITALIZATION',
  NetIncomeChangePercent = 'NET_INCOME_CHANGE_PERCENT',
  Performance = 'PERFORMANCE',
  SalesChangePercent = 'SALES_CHANGE_PERCENT',
  SalesPerEmployeeChangePercent = 'SALES_PER_EMPLOYEE_CHANGE_PERCENT',
  Volatility = 'VOLATILITY'
}

export type SnapQuote = {
  __typename?: 'SnapQuote';
  cumulativeTrades?: Maybe<Scalars['Int']>;
  cumulativeTurnover?: Maybe<Scalars['Float']>;
  cumulativeVolume?: Maybe<Scalars['Long']>;
  delay?: Maybe<Scalars['Int']>;
  firstPrice?: Maybe<Scalars['Float']>;
  highPrice?: Maybe<Scalars['Float']>;
  instrumentId: Scalars['Int'];
  lastChange?: Maybe<Scalars['OffsetDateTime']>;
  lastPrice?: Maybe<Scalars['Float']>;
  lowPrice?: Maybe<Scalars['Float']>;
  quote?: Maybe<Quote>;
  quotes: Array<Maybe<Quote>>;
  yesterdayPrice?: Maybe<Scalars['Float']>;
};


export type SnapQuoteQuoteArgs = {
  type: QuoteType;
};

export type SplitPortfolioEntryRequest = {
  from: Scalars['Float'];
  portfolioEntryId: Scalars['Long'];
  portfolioId: Scalars['Long'];
  splitTime: Scalars['OffsetDateTime'];
  to: Scalars['Float'];
};

export type Subscription = {
  __typename?: 'Subscription';
  lastSearchedReport: Array<LastSearchedReportEntry>;
  update: SnapQuote;
};


export type SubscriptionUpdateArgs = {
  instrument: Scalars['Int'];
};

export type TheScreenerRating = {
  __typename?: 'TheScreenerRating';
  badNews?: Maybe<TheScreenerRatingBadNewsFactor>;
  bearMarket?: Maybe<TheScreenerRatingBearMarket>;
  beta?: Maybe<Scalars['Int']>;
  correlation?: Maybe<Scalars['Float']>;
  currency?: Maybe<Currency>;
  currencyCode?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['Long']>;
  date?: Maybe<Scalars['LocalDate']>;
  dividend?: Maybe<Scalars['Float']>;
  earningsPerShareRevision?: Maybe<Scalars['Float']>;
  earningsRevisionTrend?: Maybe<TheScreenerRatingEarningsRevisionTrend>;
  globalEvaluation?: Maybe<TheScreenerRatingGlobalEvaluation>;
  globalPriceEarningsRatio?: Maybe<Scalars['Float']>;
  group: InstrumentGroup;
  isin: Scalars['String'];
  longTermGrowth?: Maybe<TheScreenerRatingLongTermGrowth>;
  longTermPriceEarnings?: Maybe<Scalars['Float']>;
  marketCapitalisation?: Maybe<Scalars['Float']>;
  mediumTermTechnicalTrend?: Maybe<TheScreenerRatingMediumTermTechnicalTrend>;
  numberOfAnalysts?: Maybe<Scalars['Int']>;
  payout?: Maybe<Scalars['Float']>;
  performance2week?: Maybe<Scalars['Float']>;
  premium?: Maybe<Scalars['Float']>;
  previousRating?: Maybe<Scalars['Int']>;
  previousRatingIssuanceDate?: Maybe<Scalars['LocalDate']>;
  rating?: Maybe<Scalars['Int']>;
  referenceIndexName?: Maybe<Scalars['String']>;
  risk?: Maybe<TheScreenerRatingRisk>;
  technicalReverse?: Maybe<TheScreenerRatingTechnicalReverse>;
  valuationRating?: Maybe<Scalars['Int']>;
  valueAtRisk?: Maybe<TheScreenerRatingValueAtRisk>;
};

export type TheScreenerRatingBadNewsFactor = {
  __typename?: 'TheScreenerRatingBadNewsFactor';
  factor?: Maybe<Scalars['Int']>;
  riskZone?: Maybe<Scalars['Int']>;
};

export type TheScreenerRatingBearMarket = {
  __typename?: 'TheScreenerRatingBearMarket';
  factor?: Maybe<Scalars['Int']>;
  riskZone?: Maybe<Scalars['Int']>;
};

export enum TheScreenerRatingChange {
  Downgrade = 'DOWNGRADE',
  Upgrade = 'UPGRADE'
}

export type TheScreenerRatingEarningsRevisionTrend = {
  __typename?: 'TheScreenerRatingEarningsRevisionTrend';
  date?: Maybe<Scalars['LocalDate']>;
  price?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Int']>;
};

export type TheScreenerRatingGlobalEvaluation = {
  __typename?: 'TheScreenerRatingGlobalEvaluation';
  date?: Maybe<Scalars['LocalDate']>;
  value?: Maybe<Scalars['Int']>;
};

export type TheScreenerRatingLongTermGrowth = {
  __typename?: 'TheScreenerRatingLongTermGrowth';
  value?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Int']>;
};

export type TheScreenerRatingMediumTermTechnicalTrend = {
  __typename?: 'TheScreenerRatingMediumTermTechnicalTrend';
  date?: Maybe<Scalars['LocalDate']>;
  value?: Maybe<Scalars['Int']>;
};

export type TheScreenerRatingRisk = {
  __typename?: 'TheScreenerRatingRisk';
  date?: Maybe<Scalars['LocalDate']>;
  zone?: Maybe<Scalars['Int']>;
};

export type TheScreenerRatingTechnicalReverse = {
  __typename?: 'TheScreenerRatingTechnicalReverse';
  max?: Maybe<Scalars['Float']>;
  min?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type TheScreenerRatingValueAtRisk = {
  __typename?: 'TheScreenerRatingValueAtRisk';
  relative?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

export type TheScreenerSearchCriteria = {
  change?: InputMaybe<TheScreenerRatingChange>;
  instrumentGroupId?: InputMaybe<Scalars['Int']>;
  update?: InputMaybe<Scalars['Boolean']>;
};

export type TimeAndSalesCriteria = {
  from?: InputMaybe<Scalars['OffsetDateTime']>;
  to?: InputMaybe<Scalars['OffsetDateTime']>;
};

export enum Trend {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export enum TrendType {
  Annual = 'ANNUAL',
  Period = 'PERIOD'
}

export type UploadFileRecord = {
  __typename?: 'UploadFileRecord';
  accountNumber: Scalars['String'];
  charges: Scalars['Float'];
  currencyCode?: Maybe<Scalars['String']>;
  currencyPrice: Scalars['Float'];
  entryTime: Scalars['OffsetDateTime'];
  exchange?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  group: InstrumentGroup;
  id: Scalars['Long'];
  instrument?: Maybe<Instrument>;
  instrumentGroupId: Scalars['Long'];
  instrumentId?: Maybe<Scalars['Long']>;
  isin?: Maybe<Scalars['String']>;
  operationType: OperationType;
  price: Scalars['Float'];
  quantity: Scalars['Float'];
  wkn?: Maybe<Scalars['String']>;
};

export type UploadFileRecordInput = {
  accountNumber: Scalars['String'];
  charges: Scalars['Float'];
  currencyCode?: InputMaybe<Scalars['String']>;
  currencyPrice: Scalars['Float'];
  entryTime: Scalars['OffsetDateTime'];
  exchange?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  id: Scalars['Long'];
  instrumentGroupId: Scalars['Long'];
  instrumentId?: InputMaybe<Scalars['Long']>;
  isin?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  operationType: OperationType;
  price: Scalars['Float'];
  quantity: Scalars['Float'];
  wkn?: InputMaybe<Scalars['String']>;
};

export type UploadFileResponse = {
  __typename?: 'UploadFileResponse';
  data?: Maybe<UploadFileRecord>;
  fileName: Scalars['String'];
  result: DefaultServiceResponse;
};

export type UploadRecordResponse = {
  __typename?: 'UploadRecordResponse';
  data?: Maybe<PortfolioEntry>;
  result: DefaultServiceResponse;
};

export type User = {
  __typename?: 'User';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  profile?: Maybe<UserProfile>;
  username?: Maybe<Scalars['String']>;
};

export type UserOverviewResponse = {
  __typename?: 'UserOverviewResponse';
  limitsNumber: Scalars['Long'];
  portfolios: Array<PortfolioItem>;
  watchlists: Array<WatchlistItem>;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  id: Scalars['Long'];
  keyFigures?: Maybe<ProfileKeyFigures>;
  limitViewOrder?: Maybe<Scalars['String']>;
  limitViewOrderAsc?: Maybe<Scalars['Boolean']>;
  limitViewType?: Maybe<Scalars['String']>;
  limits?: Maybe<Array<LimitEntry>>;
  portfolioOverviewOrder?: Maybe<Scalars['String']>;
  portfolioOverviewOrderAsc?: Maybe<Scalars['Boolean']>;
  portfolioOverviewType?: Maybe<Scalars['String']>;
  portfolioViewOrder?: Maybe<Scalars['String']>;
  portfolioViewOrderAsc?: Maybe<Scalars['Boolean']>;
  portfolioViewType?: Maybe<Scalars['String']>;
  portfolios?: Maybe<Array<Portfolio>>;
  settings?: Maybe<ProfileSettings>;
  watchlistOverviewOrder?: Maybe<Scalars['String']>;
  watchlistOverviewOrderAsc?: Maybe<Scalars['Boolean']>;
  watchlistOverviewType?: Maybe<Scalars['String']>;
  watchlistViewOrder?: Maybe<Scalars['String']>;
  watchlistViewOrderAsc?: Maybe<Scalars['Boolean']>;
  watchlistViewType?: Maybe<Scalars['String']>;
  watchlists?: Maybe<Array<Watchlist>>;
};

export type Watchlist = {
  __typename?: 'Watchlist';
  createdOn: Scalars['OffsetDateTime'];
  entries?: Maybe<Array<WatchlistEntry>>;
  eom: Scalars['Boolean'];
  id: Scalars['Int'];
  inMasterPortfolio: Scalars['Boolean'];
  memo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  viewOrder?: Maybe<Scalars['String']>;
  viewOrderAsc?: Maybe<Scalars['Boolean']>;
  viewType?: Maybe<Scalars['String']>;
  wd1: Scalars['Boolean'];
  wd2: Scalars['Boolean'];
  wd3: Scalars['Boolean'];
  wd4: Scalars['Boolean'];
  wd5: Scalars['Boolean'];
  wd6: Scalars['Boolean'];
  wd7: Scalars['Boolean'];
  wdTime: Scalars['OffsetDateTime'];
};

export type WatchlistEntry = {
  __typename?: 'WatchlistEntry';
  entryTime: Scalars['OffsetDateTime'];
  id: Scalars['Int'];
  instrument?: Maybe<Instrument>;
  intradayPrices?: Maybe<Array<ChartSeries>>;
  memo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  quantity: Scalars['Float'];
  snapQuote?: Maybe<SnapQuote>;
};

export type WatchlistEntryRequest = {
  instrumentId: Scalars['Long'];
  memo?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  watchlistId: Scalars['Long'];
};

export type WatchlistItem = {
  __typename?: 'WatchlistItem';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type WatchlistUpdateRequest = {
  eom?: InputMaybe<Scalars['Boolean']>;
  memo?: InputMaybe<Scalars['String']>;
  watchlistId: Scalars['Long'];
  wd1?: InputMaybe<Scalars['Boolean']>;
  wd2?: InputMaybe<Scalars['Boolean']>;
  wd3?: InputMaybe<Scalars['Boolean']>;
  wd4?: InputMaybe<Scalars['Boolean']>;
  wd5?: InputMaybe<Scalars['Boolean']>;
  wd6?: InputMaybe<Scalars['Boolean']>;
  wd7?: InputMaybe<Scalars['Boolean']>;
  wdTime?: InputMaybe<Scalars['OffsetDateTime']>;
};

export type GetCertInfoQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetCertInfoQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, assetGroup?: AssetGroup | null, isin?: string | null, wkn?: string | null, assetClass?: { __typename?: 'AssetClass', id: number, name: string } | null, issuer?: { __typename?: 'Issuer', id?: any | null, name?: string | null } | null, interestRateInformation?: { __typename?: 'InstrumentGroupInterestRateInformation', interestRate?: number | null, finalPaymentDate?: any | null, lastPaymentDate?: any | null, nextPaymentDate?: any | null } | null, derivative?: { __typename?: 'InstrumentGroupDerivative', optionType?: DerivativeOptionType | null, maturityDate?: any | null, securedInstrument?: boolean | null, nominalAmount?: number | null, managementFee?: number | null } | null, main?: { __typename?: 'Instrument', currency: { __typename?: 'Currency', displayCode?: string | null }, derivativeKeyFigures?: { __typename?: 'DerivativeInstrumentKeyFigures', gearing?: number | null, premium?: number | null, premiumAbsolute?: number | null, premiumAnnual?: number | null, implicitVolatility?: number | null, breakEven?: number | null, moneyness?: number | null, intrinsicValue?: number | null, timeValuePremium?: number | null, spread?: number | null, spreadHomogenous?: number | null, spreadRelative?: number | null, deltaStopLoss?: number | null, deltaStopLossAbsolute?: number | null, agio?: number | null, agioAnnual?: number | null, omega?: number | null, delta?: number | null, gamma?: number | null, theta?: number | null, rho?: number | null, vega?: number | null, discountAbsolute?: number | null, discountPercent?: number | null, sidewaysReturn?: number | null, sidewaysReturnAbsolute?: number | null, sidewaysAnnualReturn?: number | null, outperformanceLevel?: number | null, maxAnnualReturn?: number | null, maxReturn?: number | null, maxReturnAbsolute?: number | null, maxRedemptionPrice?: number | null, deltaCap?: number | null, deltaCapAbsolute?: number | null, fairValue?: number | null, bonusAnnualReturn?: number | null, bonusBuffer?: number | null, bonusBufferAbsolute?: number | null, bonusReturn?: number | null, bonusReturnAbsolute?: number | null, deltaBonusLevel?: number | null, deltaBonusLevelAbsolute?: number | null, deltaStrike?: number | null, deltaStrikeAbsolute?: number | null, deltaSecurityLevel?: number | null, dirtyPrice?: number | null, parity?: number | null, ismaYield?: number | null, accruedInterest?: number | null, duration?: number | null, modifiedDuration?: number | null, update?: { __typename?: 'InstrumentKeyFiguresUpdate', when?: any | null, type?: QuoteType | null, value?: number | null, underlyingValue?: number | null } | null } | null, snapQuote?: { __typename?: 'SnapQuote', delay?: number | null, lastChange?: any | null, instrumentId: number, lastPrice?: number | null, quotes: Array<{ __typename?: 'Quote', value?: number | null, type?: QuoteType | null } | null> } | null } | null, assetType?: { __typename?: 'AssetType', name?: string | null, id?: string | null } | null, description?: { __typename?: 'InstrumentGroupDescription', text?: string | null } | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', groupId?: any | null, referencePrice?: number | null, multiplier?: number | null, quantity?: number | null, percentage?: number | null, leverageFactor?: number | null, bonusBarrier?: number | null, cap?: number | null, capitalGuarantee?: number | null, conditionalCouponTriggerLevel?: number | null, conditionalCouponTriggerLevelLower?: number | null, conditionalCouponTriggerLevelUpper?: number | null, knockIn?: number | null, knockInLower?: number | null, knockInUpper?: number | null, knockOut?: number | null, knockOutLower?: number | null, knockOutUpper?: number | null, lockIn?: number | null, participation?: number | null, redemption?: number | null, reverseLevel?: number | null, security?: number | null, start?: number | null, strike?: number | null, securityBarrierObservationStartAt?: any | null, securityBarrierObservationEndAt?: any | null, securityBarrierTriggeredAt?: any | null, instrument?: { __typename?: 'Instrument', currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, value?: number | null } | null> } | null } | null }> | null, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, countryId: number, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', size?: number | null, delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null }> } | null };

export type GetCommodityInfoQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetCommodityInfoQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, wkn?: string | null, name: string, assetGroup?: AssetGroup | null, underlying?: boolean | null, description?: { __typename?: 'InstrumentGroupDescription', natural?: string | null, text?: string | null } | null, main?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null } } | null, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, marketCapitalization?: number | null, countryId: number, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null, id?: number | null, isin?: string | null, name: string, underlying?: boolean | null, wkn?: string | null, sector?: { __typename?: 'Sector', name?: string | null } | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', delay?: number | null, lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', size?: number | null, delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, indicators?: { __typename?: 'InstrumentIndicators', relativeStrengthLevy?: { __typename?: 'RelativeStrengthLevyIndicator', deltaMedian?: number | null, indicator?: number | null } | null, movingAverage?: { __typename?: 'MovingAverageIndicator', deltaLine200Day?: number | null, deltaLine38Day?: number | null } | null } | null, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null }> } | null };

export type GetCurrencyInfoQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetCurrencyInfoQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, wkn?: string | null, assetGroup?: AssetGroup | null, underlying?: boolean | null, description?: { __typename?: 'InstrumentGroupDescription', natural?: string | null, text?: string | null } | null, main?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null } } | null, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, seoTag?: string | null, marketCapitalization?: number | null, countryId: number, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null, id?: number | null, isin?: string | null, name: string, underlying?: boolean | null, wkn?: string | null, sector?: { __typename?: 'Sector', name?: string | null } | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', delay?: number | null, lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', size?: number | null, delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, indicators?: { __typename?: 'InstrumentIndicators', relativeStrengthLevy?: { __typename?: 'RelativeStrengthLevyIndicator', deltaMedian?: number | null, indicator?: number | null } | null, movingAverage?: { __typename?: 'MovingAverageIndicator', deltaLine200Day?: number | null, deltaLine38Day?: number | null } | null } | null, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null }> } | null };

export type GetAlternativeDerivativeProductsQueryVariables = Exact<{
  underlyingInstrumentGroupId: Scalars['Int'];
  issuerId: Scalars['Long'];
}>;


export type GetAlternativeDerivativeProductsQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, alternativeDerivativeProducts: Array<{ __typename?: 'AlternativeDerivativeProductsBucket', optionType?: DerivativeOptionType | null, count?: any | null, assetClass?: { __typename?: 'AssetClass', id: number, name: string, investmentRiskLevel?: { __typename?: 'InvestmentRiskLevel', level?: RiskLevel | null, name?: string | null } | null } | null }> } | null };

export type GetAlternativeIssuerProductsQueryVariables = Exact<{
  underlyingInstrumentGroupId: Scalars['Int'];
  assetType: Scalars['String'];
  optionType?: InputMaybe<DerivativeOptionType>;
}>;


export type GetAlternativeIssuerProductsQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, derivativeIssuer: Array<{ __typename?: 'DerivativeIssuerBucket', count?: any | null, issuer?: { __typename?: 'Issuer', id?: any | null, name?: string | null } | null }> } | null };

export type GetInstrumentChartQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  chartScope: ChartScope;
}>;


export type GetInstrumentChartQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null };

export type GetDerivativePerformanceCompareQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetDerivativePerformanceCompareQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, wkn?: string | null, assetGroup?: AssetGroup | null, main?: { __typename?: 'Instrument', performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, performance?: number | null }> } | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', isin?: string | null, group?: { __typename?: 'InstrumentGroup', wkn?: string | null } | null, instrument?: { __typename?: 'Instrument', id: number, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, performance?: number | null }> } | null }> | null } | null };

export type GetDerivativeUnderlyingProductsQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetDerivativeUnderlyingProductsQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', id?: any | null, isin?: string | null, name?: string | null, currency?: { __typename?: 'Currency', alphaCode?: string | null, sign?: string | null, name?: string | null, displayCode?: string | null } | null, exchange?: { __typename?: 'Exchange', code?: string | null, delay?: number | null, id: number, name?: string | null, openingTime?: any | null, closingTime?: any | null } | null, group?: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, id?: number | null, name: string, underlying?: boolean | null, seoTag?: string | null, isin?: string | null, wkn?: string | null } | null, instrument?: { __typename?: 'Instrument', id: number, exchange: { __typename?: 'Exchange', name?: string | null, id: number }, snapQuote?: { __typename?: 'SnapQuote', instrumentId: number, delay?: number | null, highPrice?: number | null, lastPrice?: number | null, lowPrice?: number | null, yesterdayPrice?: number | null, quote?: { __typename?: 'Quote', delay?: number | null, value?: number | null, change?: number | null, percentChange?: number | null, when?: any | null } | null, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, change?: number | null, percentChange?: number | null, value?: number | null, when?: any | null } | null> } | null } | null }> | null } | null };

export type GetRefundRelativeScenarioQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetRefundRelativeScenarioQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', instrument?: { __typename?: 'Instrument', currency: { __typename?: 'Currency', displayCode?: string | null } } | null }> | null, refundRelativeScenario?: Array<{ __typename?: 'RefundRelativeScenario', performance?: number | null, value?: number | null, underlyingValue?: number | null, underlyingPerformance?: number | null }> | null } | null };

export type GetWarrantKeyfiguresQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetWarrantKeyfiguresQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, main?: { __typename?: 'Instrument', derivativeKeyFigures?: { __typename?: 'DerivativeInstrumentKeyFigures', gearing?: number | null, premium?: number | null, premiumAbsolute?: number | null, premiumAnnual?: number | null, implicitVolatility?: number | null, breakEven?: number | null, moneyness?: number | null, intrinsicValue?: number | null, timeValuePremium?: number | null, spread?: number | null, spreadHomogenous?: number | null, spreadRelative?: number | null, deltaStopLoss?: number | null, deltaStopLossAbsolute?: number | null, agio?: number | null, agioAnnual?: number | null, omega?: number | null, delta?: number | null, gamma?: number | null, theta?: number | null, rho?: number | null, vega?: number | null, discountAbsolute?: number | null, discountPercent?: number | null, sidewaysReturn?: number | null, sidewaysReturnAbsolute?: number | null, sidewaysAnnualReturn?: number | null, outperformanceLevel?: number | null, maxAnnualReturn?: number | null, maxReturn?: number | null, maxReturnAbsolute?: number | null, maxRedemptionPrice?: number | null, deltaCap?: number | null, deltaCapAbsolute?: number | null, fairValue?: number | null, bonusAnnualReturn?: number | null, bonusBuffer?: number | null, bonusBufferAbsolute?: number | null, bonusReturn?: number | null, bonusReturnAbsolute?: number | null, deltaBonusLevel?: number | null, deltaBonusLevelAbsolute?: number | null, deltaStrike?: number | null, deltaStrikeAbsolute?: number | null, deltaSecurityLevel?: number | null, dirtyPrice?: number | null, parity?: number | null, ismaYield?: number | null, accruedInterest?: number | null, duration?: number | null, modifiedDuration?: number | null, update?: { __typename?: 'InstrumentKeyFiguresUpdate', when?: any | null, type?: QuoteType | null, value?: number | null, underlyingValue?: number | null } | null } | null, keyFigures?: { __typename?: 'DerivativeInstrumentKeyFigures', gearing?: number | null, premium?: number | null, premiumAbsolute?: number | null, premiumAnnual?: number | null, implicitVolatility?: number | null, breakEven?: number | null, moneyness?: number | null, intrinsicValue?: number | null, timeValuePremium?: number | null, spread?: number | null, spreadHomogenous?: number | null, spreadRelative?: number | null, deltaStopLoss?: number | null, deltaStopLossAbsolute?: number | null, agio?: number | null, omega?: number | null, delta?: number | null, gamma?: number | null, theta?: number | null, rho?: number | null, vega?: number | null, discount?: number | null, discountAbsolute?: number | null, sidewaysReturn?: number | null, sidewaysAnnualReturn?: number | null, outperformanceLevel?: number | null, maxAnnualReturn?: number | null, maxReturn?: number | null, maxReturnAbsolute?: number | null, deltaCap?: number | null, deltaCapAbsolute?: number | null, bonusAnnualReturn?: number | null, bonusBuffer?: number | null, bonusBufferAbsolute?: number | null, bonusReturn?: number | null, sidewaysReturnAbsolute?: number | null, accruedInterest?: number | null, dirtyPrice?: number | null, parity?: number | null, maxRedemptionPrice?: number | null, update?: { __typename?: 'InstrumentKeyFiguresUpdate', type?: QuoteType | null, underlyingValue?: number | null, value?: number | null, when?: any | null } | null } | null, currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', value?: number | null, type?: QuoteType | null } | null> } | null } | null, derivative?: { __typename?: 'InstrumentGroupDerivative', maturityDate?: any | null, currencyQuanto?: boolean | null, optionType?: DerivativeOptionType | null, settlementType?: DerivativeSettlementType | null, nominalAmount?: number | null } | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', id?: any | null, isin?: string | null, name?: string | null, referencePrice?: number | null, multiplier?: number | null, quantity?: number | null, percentage?: number | null, leverageFactor?: number | null, bonusBarrier?: number | null, cap?: number | null, capitalGuarantee?: number | null, conditionalCouponTriggerLevel?: number | null, conditionalCouponTriggerLevelLower?: number | null, conditionalCouponTriggerLevelUpper?: number | null, knockIn?: number | null, knockInLower?: number | null, knockInUpper?: number | null, knockOut?: number | null, knockOutLower?: number | null, knockOutUpper?: number | null, knockInTriggeredAt?: any | null, knockOutTriggeredAt?: any | null, lockIn?: number | null, participation?: number | null, redemption?: number | null, reverseLevel?: number | null, security?: number | null, start?: number | null, strike?: number | null, exchange?: { __typename?: 'Exchange', name?: string | null, closingTime?: any | null, openingTime?: any | null } | null, instrument?: { __typename?: 'Instrument', snapQuote?: { __typename?: 'SnapQuote', instrumentId: number, quote?: { __typename?: 'Quote', change?: number | null } | null, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, when?: any | null, change?: number | null } | null> } | null } | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null }> | null, interestRateInformation?: { __typename?: 'InstrumentGroupInterestRateInformation', interestRate?: number | null, nextPaymentDate?: any | null, lastPaymentDate?: any | null, finalPaymentDate?: any | null } | null } | null };

export type GetWarrantStaticDataQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetWarrantStaticDataQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, main?: { __typename?: 'Instrument', firstTradingDay?: any | null, lastTradingDay?: any | null, exchange: { __typename?: 'Exchange', openingTime?: any | null, closingTime?: any | null, name?: string | null }, currency: { __typename?: 'Currency', displayCode?: string | null } } | null, derivative?: { __typename?: 'InstrumentGroupDerivative', issueSize?: any | null, issueDate?: any | null, issuePrice?: number | null, paymentDate?: any | null, nameTermSheet?: string | null, maturityDate?: any | null } | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', referencePrice?: number | null, strike?: number | null, exchange?: { __typename?: 'Exchange', name?: string | null } | null, instrument?: { __typename?: 'Instrument', snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lastPrice?: number | null } | null } | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null }> | null, issuer?: { __typename?: 'Issuer', name?: string | null, id?: any | null, partner?: boolean | null } | null } | null };

export type GetEtcAdnEtnInfoQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetEtcAdnEtnInfoQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, assetGroup?: AssetGroup | null, description?: { __typename?: 'InstrumentGroupDescription', natural?: string | null, text?: string | null } | null, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, marketCapitalization?: number | null, countryId: number, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null, sector?: { __typename?: 'Sector', name?: string | null } | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', delay?: number | null, lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', size?: number | null, delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, indicators?: { __typename?: 'InstrumentIndicators', relativeStrengthLevy?: { __typename?: 'RelativeStrengthLevyIndicator', deltaMedian?: number | null, indicator?: number | null } | null, movingAverage?: { __typename?: 'MovingAverageIndicator', deltaLine200Day?: number | null, deltaLine38Day?: number | null } | null } | null, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null }> } | null };

export type GetEtfInfoQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetEtfInfoQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, wkn?: string | null, assetGroup?: AssetGroup | null, assetClass?: { __typename?: 'AssetClass', name: string } | null, assetType?: { __typename?: 'AssetType', name?: string | null } | null, description?: { __typename?: 'InstrumentGroupDescription', natural?: string | null, text?: string | null } | null, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, marketCapitalization?: number | null, countryId: number, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null, sector?: { __typename?: 'Sector', name?: string | null } | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', delay?: number | null, lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', size?: number | null, delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null, alpha?: number | null, beta?: number | null, betaBear?: number | null, betaBull?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, indicators?: { __typename?: 'InstrumentIndicators', relativeStrengthLevy?: { __typename?: 'RelativeStrengthLevyIndicator', deltaMedian?: number | null, indicator?: number | null } | null, movingAverage?: { __typename?: 'MovingAverageIndicator', deltaLine200Day?: number | null, deltaLine38Day?: number | null } | null } | null, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null }>, etf?: { __typename?: 'InstrumentGroupExchangeTradedFund', id: number, investmentConcept?: string | null, participationFactor?: number | null, underlyingRatio?: number | null, position?: EtfPositionType | null, charge?: number | null, distributing?: boolean | null, foundationDate?: any | null, quanto?: boolean | null, benchmark?: { __typename?: 'FundBenchmark', name?: string | null, group?: { __typename?: 'InstrumentGroup', name: string, assetType?: { __typename?: 'AssetType', name?: string | null } | null, main?: { __typename?: 'Instrument', currency: { __typename?: 'Currency', displayCode?: string | null } } | null } | null } | null, issuer?: { __typename?: 'EtfIssuer', id: number, name?: string | null } | null, sector?: { __typename?: 'EtfSector', name?: string | null } | null, region?: { __typename?: 'EtfRegion', name?: string | null } | null, allocation?: { __typename?: 'EtfAllocation', name?: string | null } | null, domicile?: { __typename?: 'EtfDomicile', name?: string | null } | null, strategy?: { __typename?: 'EtfStrategy', name?: string | null } | null, replication?: { __typename?: 'EtfReplication', name?: string | null } | null, investmentVolume?: { __typename?: 'InvestmentVolume', date?: any | null, value?: number | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null } | null, keyFigures?: { __typename?: 'EtfKeyFigures', totalExpenseRatio?: number | null, jensenAlpha?: number | null, betaFactor?: number | null, negativeRegression?: number | null, positiveRegression?: number | null, maxLoosing6Month?: number | null, longestLoosingPeriod?: number | null, trackingError?: number | null } | null, portfolios: Array<{ __typename?: 'FundPortfolio', name?: string | null, entries: Array<{ __typename?: 'FundPortfolioEntry', name?: string | null, percent?: number | null }> }> } | null } | null };

export type GetEtfTypeBucketQueryVariables = Exact<{
  issuerId?: InputMaybe<Scalars['Long']>;
}>;


export type GetEtfTypeBucketQuery = { __typename?: 'Query', assetTypeGroupBucket: Array<{ __typename?: 'AssetTypeGroupBucket', count?: any | null, assetTypeGroup?: { __typename?: 'AssetTypeGroup', id?: string | null, name?: string | null } | null }> };

export type GetFutureInfoQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetFutureInfoQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, assetGroup?: AssetGroup | null, underlying?: boolean | null, description?: { __typename?: 'InstrumentGroupDescription', natural?: string | null, text?: string | null } | null, main?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null } } | null, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, marketCapitalization?: number | null, countryId: number, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null, id?: number | null, isin?: string | null, name: string, underlying?: boolean | null, wkn?: string | null, sector?: { __typename?: 'Sector', name?: string | null } | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', size?: number | null, delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, indicators?: { __typename?: 'InstrumentIndicators', relativeStrengthLevy?: { __typename?: 'RelativeStrengthLevyIndicator', deltaMedian?: number | null, indicator?: number | null } | null, movingAverage?: { __typename?: 'MovingAverageIndicator', deltaLine200Day?: number | null, deltaLine38Day?: number | null } | null } | null, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null }> } | null };

export type GetFundTypeBucketQueryVariables = Exact<{
  assetClass?: InputMaybe<Scalars['Long']>;
  assetTypeGroup?: InputMaybe<Scalars['String']>;
  assetType?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['Long']>;
}>;


export type GetFundTypeBucketQuery = { __typename?: 'Query', fundTypeBucket: Array<{ __typename?: 'FundTypeBucket', count?: number | null, fundType?: { __typename?: 'FundType', id: string, name: string } | null } | null> };

export type GetInstrumentChartComparisonPeerGroupQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  chartScope: ChartScope;
}>;


export type GetInstrumentChartComparisonPeerGroupQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, wkn?: string | null }, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null };

export type GetInstrumentFundChartDetailsQueryVariables = Exact<{
  instrumentCurrentId: Scalars['Int'];
  instrumentMinId: Scalars['Int'];
  instrumentMaxId: Scalars['Int'];
  chartScope: ChartScope;
}>;


export type GetInstrumentFundChartDetailsQuery = { __typename?: 'Query', current?: { __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, wkn?: string | null }, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null, min?: { __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, wkn?: string | null }, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null, max?: { __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, wkn?: string | null }, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null };

export type GetInstrumentFundEtfPeergroupsQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetInstrumentFundEtfPeergroupsQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, fundTranche?: { __typename?: 'InstrumentGroupFundTranche', id: any, name?: string | null, peerGroup?: { __typename?: 'FundTranchePeerGroup', id: any, name?: string | null, performance?: Array<{ __typename?: 'PeerGroupPerformancePeriod', minimum: number, maximum: number, average: number, period: CalculationPeriod, instrumentGroupMin: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, assetGroup?: AssetGroup | null, wkn?: string | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number } | null }, instrumentGroupMax: { __typename?: 'InstrumentGroup', id?: number | null, name: string, assetGroup?: AssetGroup | null, isin?: string | null, wkn?: string | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number } | null } }> | null } | null } | null, etf?: { __typename?: 'InstrumentGroupExchangeTradedFund', id: number, peerGroup?: { __typename?: 'EtfPeerGroup', performance?: Array<{ __typename?: 'PeerGroupPerformancePeriod', minimum: number, isinMin?: string | null, maximum: number, isinMax?: string | null, average: number, period: CalculationPeriod, instrumentGroupMin: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, wkn?: string | null, assetGroup?: AssetGroup | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number } | null }, instrumentGroupMax: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, assetGroup?: AssetGroup | null, wkn?: string | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number } | null } }> | null } | null } | null } | null };

export type GetFundsPageQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetFundsPageQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, assetGroup?: AssetGroup | null, wkn?: string | null, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, marketCapitalization?: number | null, countryId: number, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null, sector?: { __typename?: 'Sector', name?: string | null } | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null, type?: ExchangeType | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', delay?: number | null, lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', size?: number | null, delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, deltaAveragePrice?: number | null, sharpe?: number | null, alpha?: number | null, beta?: number | null, betaBear?: number | null, betaBull?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, indicators?: { __typename?: 'InstrumentIndicators', relativeStrengthLevy?: { __typename?: 'RelativeStrengthLevyIndicator', deltaMedian?: number | null, indicator?: number | null } | null, movingAverage?: { __typename?: 'MovingAverageIndicator', deltaLine200Day?: number | null, deltaLine38Day?: number | null } | null } | null, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null }>, fundTranche?: { __typename?: 'InstrumentGroupFundTranche', main?: boolean | null, germanRiesterCapable?: boolean | null, germanVwlCapable?: boolean | null, savingPlanCapable?: boolean | null, distributing?: boolean | null, charge?: number | null, depositFee?: number | null, assetBasedFee?: number | null, totalExpenseRatio?: number | null, rePurchasePrice?: number | null, foundationDate?: any | null, srri?: { __typename?: 'FundTrancheSyntheticRiskAndRewardIndicator', value?: number | null } | null, documents?: Array<{ __typename?: 'FundDocument', url?: string | null, creationDate?: any | null, type?: { __typename?: 'FundDocumentType', code?: string | null, name?: string | null } | null }> | null, distributionFrequency?: { __typename?: 'DistributionFrequency', name: string, month: number } | null, currency?: { __typename?: 'Currency', name?: string | null } | null, group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, wkn?: string | null, assetGroup?: AssetGroup | null, seoTag?: string | null } | null, investmentVolume?: { __typename?: 'InvestmentVolume', date?: any | null, value?: number | null } | null } | null, assetType?: { __typename?: 'AssetType', name?: string | null } | null, fund?: { __typename?: 'Fund', id: any, investmentConcept?: string | null, exchangeTradedFund?: boolean | null, indexFund?: boolean | null, region?: { __typename?: 'FundRegion', id: string, name: string } | null, topic?: { __typename?: 'FundTopic', id: string, name: string } | null, currency?: { __typename?: 'FundCurrency', id: string, name: string } | null, type?: { __typename?: 'FundType', id: string, name: string } | null, strategy?: { __typename?: 'FundStrategy', id: string, name: string } | null, advisor?: { __typename?: 'FundAdvisor', name?: string | null, contact?: { __typename?: 'Contact', phone?: string | null, fax?: string | null, email?: string | null, website?: string | null } | null, address?: { __typename?: 'Address', postCode?: string | null, city?: string | null, street?: string | null, houseNo?: string | null } | null } | null, company?: { __typename?: 'FundCompany', id?: any | null, name?: string | null, contact?: { __typename?: 'Contact', phone?: string | null, fax?: string | null, email?: string | null, website?: string | null } | null, address?: { __typename?: 'Address', postCode?: string | null, city?: string | null, street?: string | null, houseNo?: string | null } | null } | null, benchmark?: { __typename?: 'FundBenchmark', name?: string | null, isin?: string | null, group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null } | null } | null, portfolios: Array<{ __typename?: 'FundPortfolio', name?: string | null, entries: Array<{ __typename?: 'FundPortfolioEntry', name?: string | null, percent?: number | null }> }>, managers?: Array<{ __typename?: 'FundManager', firstName?: string | null, lastName?: string | null, preference?: number | null }> | null, investmentVolume?: { __typename?: 'InvestmentVolume', date?: any | null, value?: number | null, currency?: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null } | null } | null } | null, alternativeFundTranches?: Array<{ __typename?: 'InstrumentGroupFundTranche', name?: string | null, isin?: string | null, main?: boolean | null, germanRiesterCapable?: boolean | null, germanVwlCapable?: boolean | null, distributing?: boolean | null, charge?: number | null, depositFee?: number | null, assetBasedFee?: number | null, totalExpenseRatio?: number | null, rePurchasePrice?: number | null, distributionFrequency?: { __typename?: 'DistributionFrequency', name: string, month: number } | null, group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, wkn?: string | null, assetGroup?: AssetGroup | null, seoTag?: string | null } | null }> | null } | null };

export type GetImportantIndicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetImportantIndicesQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', group: { __typename?: 'InstrumentGroup', name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } }> | null } | null };

export type GetInstrumentGroupCompositionCompareQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetInstrumentGroupCompositionCompareQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, compositionPerformance?: { __typename?: 'CompositionPerformance', periods?: Array<{ __typename?: 'CompositionPerformacePeriod', period?: CalculationPeriod | null, current?: { __typename?: 'CompositionPerformanceValue', value?: number | null, price?: number | null, group?: { __typename?: 'InstrumentGroup', name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } | null } | null, min?: { __typename?: 'CompositionPerformanceValue', value?: number | null, price?: number | null, group?: { __typename?: 'InstrumentGroup', name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } | null } | null, max?: { __typename?: 'CompositionPerformanceValue', value?: number | null, price?: number | null, group?: { __typename?: 'InstrumentGroup', name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } | null } | null }> | null } | null } | null };

export type GetScreenerRatingIndexesQueryVariables = Exact<{
  first: Scalars['Int'];
  change?: InputMaybe<TheScreenerRatingChange>;
  instrumentGroupId: Scalars['Int'];
}>;


export type GetScreenerRatingIndexesQuery = { __typename?: 'Query', theScreenerRatingSearch: Array<{ __typename?: 'TheScreenerRating', isin: string, previousRating?: number | null, rating?: number | null, date?: any | null, group: { __typename?: 'InstrumentGroup', name: string, isin?: string | null, seoTag?: string | null, assetGroup?: AssetGroup | null } }> };

export type GetIndexQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetIndexQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, assetGroup?: AssetGroup | null, wkn?: string | null, isin?: string | null, underlying?: boolean | null, description?: { __typename?: 'InstrumentGroupDescription', text?: string | null } | null, main?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', id?: number | null, displayCode?: string | null } } | null, compositions: Array<{ __typename?: 'InstrumentGroupComposition', id: number }>, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, seoTag?: string | null, countryId: number, group: { __typename?: 'InstrumentGroup', id?: number | null, assetGroup?: AssetGroup | null, seoTag?: string | null, isin?: string | null, name: string, underlying?: boolean | null, wkn?: string | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', delay?: number | null, lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', size?: number | null, delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null }> } | null };

export type GetKnockOutInfoQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetKnockOutInfoQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, assetGroup?: AssetGroup | null, isin?: string | null, wkn?: string | null, assetClass?: { __typename?: 'AssetClass', id: number, leveraged: boolean, name: string } | null, assetType?: { __typename?: 'AssetType', name?: string | null, id?: string | null } | null, issuer?: { __typename?: 'Issuer', id?: any | null, name?: string | null } | null, derivative?: { __typename?: 'InstrumentGroupDerivative', optionType?: DerivativeOptionType | null } | null, description?: { __typename?: 'InstrumentGroupDescription', text?: string | null } | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', groupId?: any | null, instrumentId?: any | null, strike?: number | null, knockOut?: number | null }> | null, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, countryId: number, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', delay?: number | null, lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', size?: number | null, delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null }> } | null };

export type GetMmrInfoQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetMmrInfoQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, wkn?: string | null, name: string, assetGroup?: AssetGroup | null, underlying?: boolean | null, description?: { __typename?: 'InstrumentGroupDescription', natural?: string | null, text?: string | null } | null, main?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null } } | null, indexParticipation: Array<{ __typename?: 'InstrumentGroup', main?: { __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } } | null }>, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, marketCapitalization?: number | null, countryId: number, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null, id?: number | null, isin?: string | null, name: string, underlying?: boolean | null, wkn?: string | null, sector?: { __typename?: 'Sector', name?: string | null } | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', size?: number | null, delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, indicators?: { __typename?: 'InstrumentIndicators', relativeStrengthLevy?: { __typename?: 'RelativeStrengthLevyIndicator', deltaMedian?: number | null, indicator?: number | null } | null, movingAverage?: { __typename?: 'MovingAverageIndicator', deltaLine200Day?: number | null, deltaLine38Day?: number | null } | null } | null, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null }> } | null };

export type GetWarrInfoQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetWarrInfoQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, wkn?: string | null, name: string, assetGroup?: AssetGroup | null, underlying?: boolean | null, description?: { __typename?: 'InstrumentGroupDescription', natural?: string | null, text?: string | null } | null, assetType?: { __typename?: 'AssetType', name?: string | null, id?: string | null } | null, issuer?: { __typename?: 'Issuer', id?: any | null, name?: string | null } | null, derivative?: { __typename?: 'InstrumentGroupDerivative', optionType?: DerivativeOptionType | null } | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', groupId?: any | null, instrumentId?: any | null, strike?: number | null }> | null, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, countryId: number, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', delay?: number | null, lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', size?: number | null, delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null }> } | null };

export type ChartAnalysesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
  isin?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  institutes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  targetFrom?: InputMaybe<Scalars['LocalDate']>;
  targetTo?: InputMaybe<Scalars['LocalDate']>;
  timeFrame?: InputMaybe<Scalars['Int']>;
  updated?: InputMaybe<Scalars['Boolean']>;
  recommendation?: InputMaybe<AnalysisRecommendation>;
}>;


export type ChartAnalysesQuery = { __typename?: 'Query', analysisSearch: { __typename?: 'AnalysisConnection', edges: Array<{ __typename?: 'AnalysisEdge', cursor: string, node: { __typename?: 'Analysis', id: string, date: any, timeFrame?: number | null, recommendation?: AnalysisRecommendation | null, targetPrice?: number | null, referencePrice?: number | null, updated?: boolean | null, latest?: boolean | null, body?: string | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null, group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null, main?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null } | null } | null } | null } | null } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetAnalyseReportQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetAnalyseReportQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, analysisReport?: { __typename?: 'AnalysisReport', neutralCount?: number | null, negativeCount?: number | null, positiveCount?: number | null, recommendation?: AnalysisRecommendation | null, price?: number | null, currency?: { __typename?: 'Currency', displayCode?: string | null, sign?: string | null } | null, targets: Array<{ __typename?: 'AnalysisReportTarget', recommendation?: AnalysisRecommendation | null, price?: number | null, count?: number | null }> } | null } | null };

export type GetShortCompanyInfomartionQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetShortCompanyInfomartionQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, company?: { __typename?: 'Company', id: number, name?: string | null, profile?: { __typename?: 'CompanyProfile', text?: string | null } | null, shareHolders?: Array<{ __typename?: 'CompanyShareHolder', name?: string | null, percent?: number | null }> | null } | null } | null };

export type GetCompanyDividendQueryVariables = Exact<{
  groupId: Scalars['Int'];
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
}>;


export type GetCompanyDividendQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, company?: { __typename?: 'Company', id: number, name?: string | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null, dividends?: Array<{ __typename?: 'CompanyDividend', date?: any | null, value?: number | null }> | null } | null } | null };

export type GetShareEstimatesQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetShareEstimatesQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, company?: { __typename?: 'Company', currency?: { __typename?: 'Currency', displayCode?: string | null } | null } | null, estimates?: { __typename?: 'Estimates', current?: { __typename?: 'FundamentalKeyFigures', year?: number | null, dividendYield?: number | null, dividendPerShare?: number | null, priceToCashFlowRatio?: number | null, priceToEarningsRatio?: number | null, priceToSalesRatio?: number | null } | null, next?: { __typename?: 'FundamentalKeyFigures', year?: number | null, dividendYield?: number | null, dividendPerShare?: number | null, priceToCashFlowRatio?: number | null, priceToEarningsRatio?: number | null, priceToSalesRatio?: number | null } | null } | null } | null };

export type GetScreenerRatingQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetScreenerRatingQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, theScreenerRating?: { __typename?: 'TheScreenerRating', rating?: number | null, previousRating?: number | null, marketCapitalisation?: number | null, beta?: number | null, correlation?: number | null, earningsPerShareRevision?: number | null, referenceIndexName?: string | null, numberOfAnalysts?: number | null, payout?: number | null, performance2week?: number | null, premium?: number | null, date?: any | null, valuationRating?: number | null, dividend?: number | null, globalPriceEarningsRatio?: number | null, longTermPriceEarnings?: number | null, currency?: { __typename?: 'Currency', name?: string | null, sign?: string | null, displayCode?: string | null } | null, badNews?: { __typename?: 'TheScreenerRatingBadNewsFactor', factor?: number | null, riskZone?: number | null } | null, earningsRevisionTrend?: { __typename?: 'TheScreenerRatingEarningsRevisionTrend', value?: number | null, price?: number | null, date?: any | null } | null, globalEvaluation?: { __typename?: 'TheScreenerRatingGlobalEvaluation', value?: number | null, date?: any | null } | null, mediumTermTechnicalTrend?: { __typename?: 'TheScreenerRatingMediumTermTechnicalTrend', value?: number | null, date?: any | null } | null, longTermGrowth?: { __typename?: 'TheScreenerRatingLongTermGrowth', year?: number | null, value?: number | null } | null, risk?: { __typename?: 'TheScreenerRatingRisk', date?: any | null, zone?: number | null } | null, technicalReverse?: { __typename?: 'TheScreenerRatingTechnicalReverse', value?: number | null, min?: number | null, max?: number | null } | null, valueAtRisk?: { __typename?: 'TheScreenerRatingValueAtRisk', value?: number | null, relative?: number | null } | null, bearMarket?: { __typename?: 'TheScreenerRatingBearMarket', riskZone?: number | null, factor?: number | null } | null } | null } | null };

export type GetSharePeerGroupComparesQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetSharePeerGroupComparesQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, peerGroupCompare?: Array<{ __typename?: 'PeerGroupCompare', type: PeerGroupCompareType, value: number, chart?: { __typename?: 'PeerGroupCompareChart', breakPoint: number, min: { __typename?: 'PeerGroupCompareChartPoint', value?: number | null, group?: { __typename?: 'InstrumentGroup', name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } | null }, max: { __typename?: 'PeerGroupCompareChartPoint', value?: number | null, group?: { __typename?: 'InstrumentGroup', name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } | null }, current: { __typename?: 'PeerGroupCompareChartPoint', value?: number | null, group?: { __typename?: 'InstrumentGroup', name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } | null } } | null }> | null } | null };

export type GetPerformancePercentQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  from: Scalars['LocalDate'];
  to: Scalars['LocalDate'];
}>;


export type GetPerformancePercentQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, quoteHistory: { __typename?: 'QuoteHistoryConnection', edges: Array<{ __typename?: 'QuoteHistoryEdge', cursor?: string | null, node?: { __typename?: 'QuoteHistory', date?: any | null, changePercent?: number | null } | null }> } } | null };

export type GetShareInfoQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetShareInfoQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, wkn?: string | null, name: string, assetGroup?: AssetGroup | null, underlying?: boolean | null, description?: { __typename?: 'InstrumentGroupDescription', natural?: string | null, text?: string | null } | null, company?: { __typename?: 'Company', id: number } | null, main?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null } } | null, indexParticipation: Array<{ __typename?: 'InstrumentGroup', main?: { __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } } | null }>, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, marketCapitalization?: number | null, countryId: number, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null, id?: number | null, isin?: string | null, name: string, underlying?: boolean | null, wkn?: string | null, sector?: { __typename?: 'Sector', name?: string | null } | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', delay?: number | null, lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', size?: number | null, delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, indicators?: { __typename?: 'InstrumentIndicators', relativeStrengthIndex?: { __typename?: 'RelativeStrengthIndex', last7Days?: number | null, last9Days?: number | null, last14Days?: number | null, last25Days?: number | null } | null, movingAverage?: { __typename?: 'MovingAverageIndicator', deltaLine10Day?: number | null, line10Day?: number | null, deltaLine20Day?: number | null, line20Day?: number | null, deltaLine38Day?: number | null, line38Day?: number | null, deltaLine90Day?: number | null, line90Day?: number | null, deltaLine200Day?: number | null, line200Day?: number | null } | null } | null, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null }> } | null };

export type GetCompanyBalanceSheetQueryVariables = Exact<{
  groupId: Scalars['Int'];
  categories?: InputMaybe<Array<CompanyStatementCategory> | CompanyStatementCategory>;
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
}>;


export type GetCompanyBalanceSheetQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, company?: { __typename?: 'Company', id: number, name?: string | null, accountingStandard?: string | null, currency?: { __typename?: 'Currency', name?: string | null } | null, fiscal?: { __typename?: 'CompanyFiscal', day?: number | null, month?: number | null } | null, statements?: Array<{ __typename?: 'CompanyStatement', name?: string | null, category?: CompanyStatementCategory | null, value?: number | null, important?: boolean | null, year?: number | null }> | null } | null } | null };

export type GetCompanyInformationNewsQueryVariables = Exact<{
  isin: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
}>;


export type GetCompanyInformationNewsQuery = { __typename?: 'Query', newsSearch: { __typename?: 'NewsConnection', edges: Array<{ __typename?: 'NewsEdge', cursor: string, node: { __typename?: 'News', id: string, when?: any | null, body?: string | null, headline?: string | null, teaser?: string | null, feed?: NewsFeed | null, keywords?: Array<string> | null, links?: Array<{ __typename?: 'NewsLink', name?: string | null, href?: string | null }> | null, source?: { __typename?: 'NewsSource', id?: string | null, name?: string | null } | null, medias?: Array<{ __typename?: 'NewsMedia', source?: string | null, width?: number | null, height?: number | null }> | null, streams?: Array<{ __typename?: 'NewsStream', mimeType?: string | null, duration?: number | null, width?: number | null, height?: number | null, source?: string | null }> | null, instruments?: Array<{ __typename?: 'NewsInstrument', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, assetGroup?: AssetGroup | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, currency: { __typename?: 'Currency', displayCode?: string | null } } | null } | null }> | null } }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } | null } };

export type GetCompanyInformationQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetCompanyInformationQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, company?: { __typename?: 'Company', id: number, name?: string | null, profile?: { __typename?: 'CompanyProfile', text?: string | null, website?: string | null, address?: string | null, phone?: string | null, fax?: string | null, email?: string | null } | null, shareHolders?: Array<{ __typename?: 'CompanyShareHolder', name?: string | null, percent?: number | null }> | null, employees?: Array<{ __typename?: 'CompanyEmployee', name?: string | null, member?: boolean | null, job?: string | null, role?: string | null }> | null } | null } | null };

export type GetCompanyKeyFiguresQueryVariables = Exact<{
  groupId: Scalars['Int'];
  fromYear: Scalars['Int'];
  toYear: Scalars['Int'];
}>;


export type GetCompanyKeyFiguresQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, company?: { __typename?: 'Company', keyFigures?: Array<{ __typename?: 'FundamentalKeyFigures', year?: number | null, dividendYield?: number | null, dividendPerShare?: number | null, priceToCashFlowRatio?: number | null, priceToEarningsRatio?: number | null, priceToSalesRatio?: number | null, salesPerShare?: number | null, cashFlowPerShare?: number | null, workingCapital?: number | null, equityReturn?: number | null, salesRatio?: number | null, returnOnAssets?: number | null, returnOnInvestment?: number | null, intensityOfInvestments?: number | null, intensityOfLabor?: number | null, equityRatio?: number | null, debtEquityRatio?: number | null, cashGrade1?: number | null, cashGrade2?: number | null, cashGrade3?: number | null, cashRatioGrade1?: number | null, cashRatioGrade2?: number | null, cashRatioGrade3?: number | null, debtRatio?: number | null, earningPerShare?: number | null, dilutedEarningPerShare?: number | null, employees?: number | null, personnelExpenses?: number | null, salesPerEmployee?: number | null }> | null } | null } | null };

export type GetCompanyKeyFiguresEstimatesQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetCompanyKeyFiguresEstimatesQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, estimates?: { __typename?: 'Estimates', current?: { __typename?: 'FundamentalKeyFigures', year?: number | null, dividendYield?: number | null, dividendPerShare?: number | null, priceToCashFlowRatio?: number | null, priceToEarningsRatio?: number | null, priceToSalesRatio?: number | null } | null, next?: { __typename?: 'FundamentalKeyFigures', year?: number | null, dividendYield?: number | null, dividendPerShare?: number | null, priceToCashFlowRatio?: number | null, priceToEarningsRatio?: number | null, priceToSalesRatio?: number | null } | null } | null } | null };

export type GetCashFlowTableQueryVariables = Exact<{
  groupId: Scalars['Int'];
  category: CompanyStatementCategory;
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
}>;


export type GetCashFlowTableQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, company?: { __typename?: 'Company', id: number, name?: string | null, accountingStandard?: string | null, currency?: { __typename?: 'Currency', name?: string | null } | null, fiscal?: { __typename?: 'CompanyFiscal', day?: number | null, month?: number | null } | null, statements?: Array<{ __typename?: 'CompanyStatement', name?: string | null, category?: CompanyStatementCategory | null, value?: number | null, important?: boolean | null, year?: number | null }> | null } | null } | null };

export type GetSnapShotTableQueryVariables = Exact<{
  groupId: Scalars['Int'];
  category: CompanyStatementCategory;
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
}>;


export type GetSnapShotTableQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, company?: { __typename?: 'Company', id: number, outstandingShares?: any | null, statements?: Array<{ __typename?: 'CompanyStatement', name?: string | null, category?: CompanyStatementCategory | null, value?: number | null, important?: boolean | null, year?: number | null }> | null } | null } | null };

export type GetWinLossTableQueryVariables = Exact<{
  groupId: Scalars['Int'];
  category: CompanyStatementCategory;
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
}>;


export type GetWinLossTableQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, company?: { __typename?: 'Company', id: number, name?: string | null, accountingStandard?: string | null, currency?: { __typename?: 'Currency', name?: string | null } | null, fiscal?: { __typename?: 'CompanyFiscal', day?: number | null, month?: number | null } | null, statements?: Array<{ __typename?: 'CompanyStatement', name?: string | null, category?: CompanyStatementCategory | null, value?: number | null, important?: boolean | null, year?: number | null }> | null } | null } | null };

export type GetTradedAssetsQueryVariables = Exact<{
  days: Scalars['Long'];
  buy: Scalars['Boolean'];
  itemsReturned: Scalars['Long'];
}>;


export type GetTradedAssetsQuery = { __typename?: 'Query', instrumentGroupTradesTopVolume: Array<{ __typename?: 'InstrumentGroupTrade', quantity: number, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, main?: { __typename?: 'Instrument', id: number, name: string, exchange: { __typename?: 'Exchange', code?: string | null }, group: { __typename?: 'InstrumentGroup', seoTag?: string | null, assetGroup?: AssetGroup | null }, currency: { __typename?: 'Currency', displayCode?: string | null } } | null } } | null>, instrumentGroupTradesTopTrades: Array<{ __typename?: 'InstrumentGroupTrade', trades: any, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, main?: { __typename?: 'Instrument', id: number, name: string, exchange: { __typename?: 'Exchange', code?: string | null }, group: { __typename?: 'InstrumentGroup', seoTag?: string | null, assetGroup?: AssetGroup | null }, currency: { __typename?: 'Currency', displayCode?: string | null } } | null } } | null> };

export type GetInstrumentsHotQueryVariables = Exact<{
  id: Scalars['String'];
  chartScope: ChartScope;
}>;


export type GetInstrumentsHotQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', id: number, name: string, wkn?: string | null, isin?: string | null, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null, underlying?: boolean | null, assetClass?: { __typename?: 'AssetClass', name: string } | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', name?: string | null, strike?: number | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null }> | null }, currency: { __typename?: 'Currency', displayCode?: string | null }, exchange: { __typename?: 'Exchange', code?: string | null, delay?: number | null }, snapQuote?: { __typename?: 'SnapQuote', instrumentId: number, lastChange?: any | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, change?: number | null, percentChange?: number | null, value?: number | null, when?: any | null, size?: number | null } | null> } | null, bestWarrantRnd?: { __typename?: 'IssuerBestInstrument', issuerGroupId: any, issuerName?: string | null, instrument?: { __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, name: string, seoTag?: string | null, currencyId: number, countryId: number, sectorId?: number | null, exchangeId: number, securityCategoryId?: AssetGroup | null, tickerSymbol?: string | null, firstTradingDay?: any | null, lastTradingDay?: any | null, country?: { __typename?: 'Country', name: string } | null, snapQuote?: { __typename?: 'SnapQuote', instrumentId: number, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, change?: number | null, percentChange?: number | null, value?: number | null, when?: any | null, size?: number | null } | null> } | null, keyFigures?: { __typename?: 'DerivativeInstrumentKeyFigures', gearing?: number | null } | null, currency: { __typename?: 'Currency', name?: string | null }, exchange: { __typename?: 'Exchange', name?: string | null }, sector?: { __typename?: 'Sector', name?: string | null } | null, group: { __typename?: 'InstrumentGroup', id?: number | null, seoTag?: string | null, assetGroup?: AssetGroup | null, underlying?: boolean | null, derivative?: { __typename?: 'InstrumentGroupDerivative', optionType?: DerivativeOptionType | null, issueDate?: any | null, maturityDate?: any | null } | null, issuer?: { __typename?: 'Issuer', id?: any | null, name?: string | null, partner?: boolean | null } | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', strike?: number | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null }> | null } } | null } | null }> | null } | null };

export type GetIndexListSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIndexListSectionQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', id: number, name: string, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', type?: QuoteType | null, when?: any | null, delay?: number | null, value?: number | null, percentChange?: number | null, change?: number | null } | null } | null, currency: { __typename?: 'Currency', displayCode?: string | null }, exchange: { __typename?: 'Exchange', code?: string | null }, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } }> | null } | null };

export type GetAnalysesQueryVariables = Exact<{
  instrumentGroupId: Scalars['Int'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetAnalysesQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, analysis: { __typename: 'AnalysisConnection', edges: Array<{ __typename: 'AnalysisEdge', cursor: string, node: { __typename: 'Analysis', id: string, date: any, timeFrame?: number | null, recommendation?: AnalysisRecommendation | null, targetPrice?: number | null, referencePrice?: number | null, updated?: boolean | null, latest?: boolean | null, headline?: string | null, body?: string | null, currency?: { __typename: 'Currency', displayCode?: string | null } | null, institute?: { __typename: 'AnalystInstitute', id?: string | null, name: string } | null, analyst?: { __typename: 'Analyst', firstName?: string | null, lastName?: string | null } | null, group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null, main?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null } | null } | null } | null } | null } }>, pageInfo?: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } } | null };

export type GetHomeAnalysesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
  isin?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  institutes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  targetFrom?: InputMaybe<Scalars['LocalDate']>;
  targetTo?: InputMaybe<Scalars['LocalDate']>;
  timeFrame?: InputMaybe<Scalars['Int']>;
  updated?: InputMaybe<Scalars['Boolean']>;
  recommendation?: InputMaybe<AnalysisRecommendation>;
}>;


export type GetHomeAnalysesQuery = { __typename?: 'Query', analysisSearch: { __typename?: 'AnalysisConnection', edges: Array<{ __typename?: 'AnalysisEdge', cursor: string, node: { __typename?: 'Analysis', id: string, date: any, timeFrame?: number | null, recommendation?: AnalysisRecommendation | null, targetPrice?: number | null, referencePrice?: number | null, updated?: boolean | null, latest?: boolean | null, headline?: string | null, body?: string | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null, institute?: { __typename?: 'AnalystInstitute', id?: string | null, name: string } | null, analyst?: { __typename?: 'Analyst', firstName?: string | null, lastName?: string | null } | null, group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, seoTag?: string | null, assetGroup?: AssetGroup | null, main?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null, type?: QuoteType | null } | null> } | null } | null } | null } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetNewsAllTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsAllTopicsQuery = { __typename?: 'Query', newsTopics?: Array<{ __typename?: 'NewsTopic', id?: string | null, name?: string | null, videoCapable?: boolean | null }> | null };

export type GetNewsOverviewFeedQueryVariables = Exact<{
  source?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  topic?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetNewsOverviewFeedQuery = { __typename?: 'Query', newsSearch: { __typename: 'NewsConnection', edges: Array<{ __typename?: 'NewsEdge', cursor: string, node: { __typename?: 'News', id: string, when?: any | null, body?: string | null, headline?: string | null, teaser?: string | null, feed?: NewsFeed | null, keywords?: Array<string> | null, links?: Array<{ __typename?: 'NewsLink', name?: string | null, href?: string | null }> | null, source?: { __typename?: 'NewsSource', id?: string | null, name?: string | null } | null, medias?: Array<{ __typename?: 'NewsMedia', source?: string | null, width?: number | null, height?: number | null }> | null, streams?: Array<{ __typename?: 'NewsStream', mimeType?: string | null, duration?: number | null, width?: number | null, height?: number | null, source?: string | null }> | null, instruments?: Array<{ __typename?: 'NewsInstrument', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, assetGroup?: AssetGroup | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, currency: { __typename?: 'Currency', displayCode?: string | null } } | null } | null }> | null } }>, pageInfo?: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } | null } };

export type GetSecuritiesInFocusQueryVariables = Exact<{
  period?: InputMaybe<ReportPeriod>;
}>;


export type GetSecuritiesInFocusQuery = { __typename?: 'Query', newsProductCount: Array<{ __typename?: 'NewsProductCountEdge', isin: string, count: number, group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, wkn?: string | null, assetGroup?: AssetGroup | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number, snapQuote?: { __typename?: 'SnapQuote', instrumentId: number, lastChange?: any | null, lastPrice?: number | null, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, percentChange?: number | null, value?: number | null } | null> } | null } | null, news: { __typename?: 'NewsConnection', edges: Array<{ __typename?: 'NewsEdge', node: { __typename?: 'News', id: string, headline?: string | null, body?: string | null, feed?: NewsFeed | null, when?: any | null, source?: { __typename?: 'NewsSource', name?: string | null } | null } }> } } | null }> };

export type GetTopFlopContentQueryVariables = Exact<{
  groupId: Scalars['Int'];
  historyFrom: Scalars['OffsetDateTime'];
  historyTo: Scalars['OffsetDateTime'];
}>;


export type GetTopFlopContentQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null, main?: { __typename?: 'Instrument', id: number } | null, topFlop?: Array<{ __typename?: 'InstrumentTopFlop', instrument: { __typename?: 'Instrument', id: number, name: string, isin?: string | null, group: { __typename?: 'InstrumentGroup', name: string, seoTag?: string | null, assetGroup?: AssetGroup | null, sector?: { __typename?: 'Sector', name?: string | null } | null }, currency: { __typename?: 'Currency', displayCode?: string | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, bestWarrantRnd?: { __typename?: 'IssuerBestInstrument', instrument?: { __typename?: 'Instrument', id: number, name: string, wkn?: string | null, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null, issuer?: { __typename?: 'Issuer', id?: any | null, name?: string | null, partner?: boolean | null } | null, sector?: { __typename?: 'Sector', name?: string | null } | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', strike?: number | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null }> | null }, currency: { __typename?: 'Currency', displayCode?: string | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, keyFigures?: { __typename?: 'DerivativeInstrumentKeyFigures', gearing?: number | null } | null, snapQuote?: { __typename?: 'SnapQuote', instrumentId: number, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, percentChange?: number | null, size?: number | null, value?: number | null, when?: any | null } | null> } | null } | null } | null, historyQuote: { __typename?: 'HistoryQuoteConnection', edges: Array<{ __typename?: 'HistoryQuoteEdge', node?: { __typename?: 'HistoryQuote', id?: string | null, firstPrice?: number | null, lastPrice?: number | null, start?: any | null } | null }> }, monteCarlo?: { __typename?: 'MonteCarloResult', min?: number | null, max?: number | null } | null }, snapQuote: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', percentChange?: number | null, value?: number | null, when?: any | null } | null } }> | null } | null };

export type GetTopFlopInstrumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopFlopInstrumentsQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null } }> | null } | null };

export type GetApplicationMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApplicationMetadataQuery = { __typename?: 'Query', classification: Array<{ __typename?: 'AssetClass', id: number, name: string, assetGroup: AssetGroup, typeGroups: Array<{ __typename?: 'AssetTypeGroup', id?: string | null, name?: string | null }> }>, etfAllocation: Array<{ __typename?: 'EtfAllocation', id: number, name?: string | null }>, etfPosition: Array<{ __typename?: 'EtfPosition', id: number, name?: string | null }>, etfRegions: Array<{ __typename?: 'EtfRegion', id: number, name?: string | null }>, etfSectors: Array<{ __typename?: 'EtfSector', id: number, name?: string | null }>, etfStrategies: Array<{ __typename?: 'EtfStrategy', id: number, name?: string | null }>, etfReplications: Array<{ __typename?: 'EtfReplication', id: number, name?: string | null }>, etfIssuers: Array<{ __typename?: 'EtfIssuer', id: number, name?: string | null }>, bondNominalCurrencyBuckets: Array<{ __typename?: 'CurrencyBucket', count?: any | null, currency?: { __typename?: 'Currency', id?: number | null, displayCode?: string | null, alphaCode?: string | null, name?: string | null } | null }>, bondTradingCurrencyBuckets: Array<{ __typename?: 'CurrencyBucket', count?: any | null, currency?: { __typename?: 'Currency', id?: number | null, displayCode?: string | null, alphaCode?: string | null, name?: string | null } | null }>, bondTypes: Array<{ __typename?: 'BondType', name: string, id: number }>, bondIssuers: Array<{ __typename?: 'BondIssuer', id?: number | null, legalName?: string | null }>, fundCurrencies: Array<{ __typename?: 'FundCurrency', id: string, name: string }>, fundRegions: Array<{ __typename?: 'FundRegion', id: string, name: string, countryIsoAlpha3?: string | null } | null>, fundTopics: Array<{ __typename?: 'FundTopic', id: string, name: string } | null>, fundStrategies: Array<{ __typename?: 'FundStrategy', id: string, name: string }>, fundTypes: Array<{ __typename?: 'FundType', id: string, name: string } | null>, regions: Array<{ __typename?: 'Region', id: number, name?: string | null }> };

export type AnalysisQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type AnalysisQuery = { __typename?: 'Query', analysis?: { __typename?: 'Analysis', id: string, date: any, timeFrame?: number | null, recommendation?: AnalysisRecommendation | null, targetPrice?: number | null, referencePrice?: number | null, updated?: boolean | null, latest?: boolean | null, headline?: string | null, body?: string | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null, institute?: { __typename?: 'AnalystInstitute', id?: string | null, name: string } | null, analyst?: { __typename?: 'Analyst', firstName?: string | null, lastName?: string | null } | null, group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, seoTag?: string | null, assetGroup?: AssetGroup | null, main?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null, type?: QuoteType | null } | null> } | null } | null } | null } | null };

export type GetAnalysisHistoryQueryVariables = Exact<{
  isin: Scalars['String'];
  institute: Scalars['String'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetAnalysisHistoryQuery = { __typename?: 'Query', analysisSearch: { __typename?: 'AnalysisConnection', edges: Array<{ __typename?: 'AnalysisEdge', node: { __typename?: 'Analysis', id: string, date: any, recommendation?: AnalysisRecommendation | null, recommendationPrevious?: AnalysisRecommendation | null, targetPrice?: number | null, targetPricePrevious?: number | null, updated?: boolean | null, group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null, main?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null } | null } | null } | null } | null } }> } };

export type GetAnalysisInstitutesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnalysisInstitutesQuery = { __typename?: 'Query', analysisInstitute?: Array<{ __typename?: 'AnalystInstitute', id?: string | null, name: string }> | null };

export type GetAnalysesPageQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
  isin?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  institutes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  targetFrom?: InputMaybe<Scalars['LocalDate']>;
  targetTo?: InputMaybe<Scalars['LocalDate']>;
  timeFrame?: InputMaybe<Scalars['Int']>;
  updated?: InputMaybe<Scalars['Boolean']>;
  recommendation?: InputMaybe<AnalysisRecommendation>;
}>;


export type GetAnalysesPageQuery = { __typename?: 'Query', analysisSearch: { __typename?: 'AnalysisConnection', edges: Array<{ __typename?: 'AnalysisEdge', cursor: string, node: { __typename?: 'Analysis', id: string, date: any, timeFrame?: number | null, recommendation?: AnalysisRecommendation | null, targetPrice?: number | null, referencePrice?: number | null, updated?: boolean | null, latest?: boolean | null, headline?: string | null, body?: string | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null, institute?: { __typename?: 'AnalystInstitute', id?: string | null, name: string } | null, analyst?: { __typename?: 'Analyst', firstName?: string | null, lastName?: string | null } | null, group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, seoTag?: string | null, assetGroup?: AssetGroup | null, main?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null, type?: QuoteType | null } | null> } | null } | null } | null } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetBondPageQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetBondPageQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, wkn?: string | null, assetGroup?: AssetGroup | null, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, countryId: number, country?: { __typename?: 'Country', name: string } | null, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null, sector?: { __typename?: 'Sector', name?: string | null } | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null, type?: ExchangeType | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', delay?: number | null, lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', size?: number | null, delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, deltaAveragePrice?: number | null, sharpe?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, indicators?: { __typename?: 'InstrumentIndicators', relativeStrengthLevy?: { __typename?: 'RelativeStrengthLevyIndicator', deltaMedian?: number | null, indicator?: number | null } | null, movingAverage?: { __typename?: 'MovingAverageIndicator', deltaLine200Day?: number | null, deltaLine38Day?: number | null } | null } | null, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null, derivativeKeyFigures?: { __typename?: 'DerivativeInstrumentKeyFigures', dirtyPrice?: number | null, ismaYield?: number | null, accruedInterest?: number | null, duration?: number | null, modifiedDuration?: number | null, spread?: number | null, spreadRelative?: number | null } | null }>, assetType?: { __typename?: 'AssetType', name?: string | null } | null, bond?: { __typename?: 'InstrumentGroupBond', name?: string | null, isin?: string | null, issueSize?: any | null, issueDate?: any | null, firstTradingDate?: any | null, maturityDate?: any | null, minTradableLot?: number | null, interestLoan?: number | null, minAmountTradableLot?: number | null, fiatIssuance?: boolean | null, subordinatedDebt?: boolean | null, nominalValue?: number | null, status?: { __typename?: 'BondStatus', id: number, name?: string | null } | null, type?: { __typename?: 'BondType', id: number, name: string } | null, nominalCurrency?: { __typename?: 'Currency', id?: number | null, alphaCode?: string | null, name?: string | null, displayCode?: string | null } | null, tradingCurrency?: { __typename?: 'Currency', id?: number | null, alphaCode?: string | null, displayCode?: string | null, name?: string | null } | null, settlementCurrency?: { __typename?: 'Currency', id?: number | null, alphaCode?: string | null, displayCode?: string | null, name?: string | null } | null, priceAttribute?: { __typename?: 'BondPriceAttribute', id: number, name: string } | null, issuer?: { __typename?: 'BondIssuer', id?: number | null, lei?: string | null, legalName?: string | null, name?: string | null, isin?: string | null, group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, assetGroup?: AssetGroup | null, assetClass?: { __typename?: 'AssetClass', id: number, name: string } | null } | null } | null } | null } | null };

export type GetBondSearchCountQueryVariables = Exact<{
  criterion?: InputMaybe<SearchBondCriterion>;
  sort?: InputMaybe<Array<SearchBondSort> | SearchBondSort>;
}>;


export type GetBondSearchCountQuery = { __typename?: 'Query', searchBond: { __typename?: 'InstrumentConnection', count?: any | null } };

export type GetBondSearchMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBondSearchMetadataQuery = { __typename?: 'Query', classification: Array<{ __typename?: 'AssetClass', id: number, name: string }>, bondTypes: Array<{ __typename?: 'BondType', id: number, name: string }>, bondNominalCurrencyBuckets: Array<{ __typename?: 'CurrencyBucket', count?: any | null, currency?: { __typename?: 'Currency', id?: number | null, displayCode?: string | null, alphaCode?: string | null, name?: string | null } | null }>, bondTradingCurrencyBuckets: Array<{ __typename?: 'CurrencyBucket', count?: any | null, currency?: { __typename?: 'Currency', id?: number | null, displayCode?: string | null, alphaCode?: string | null, name?: string | null } | null }>, bondIssuers: Array<{ __typename?: 'BondIssuer', id?: number | null, legalName?: string | null }> };

export type GetBondSearchResultQueryVariables = Exact<{
  criterion?: InputMaybe<SearchBondCriterion>;
  sort?: InputMaybe<Array<SearchBondSort> | SearchBondSort>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetBondSearchResultQuery = { __typename?: 'Query', searchBond: { __typename?: 'InstrumentConnection', count?: any | null, edges: Array<{ __typename?: 'InstrumentEdge', node: { __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, assetGroup?: AssetGroup | null, seoTag?: string | null, assetClass?: { __typename?: 'AssetClass', name: string } | null, bond?: { __typename?: 'InstrumentGroupBond', name?: string | null, isin?: string | null, issueSize?: any | null, issueDate?: any | null, firstTradingDate?: any | null, maturityDate?: any | null, minTradableLot?: number | null, interestLoan?: number | null, minAmountTradableLot?: number | null, fiatIssuance?: boolean | null, subordinatedDebt?: boolean | null, nominalValue?: number | null, status?: { __typename?: 'BondStatus', id: number, name?: string | null } | null, type?: { __typename?: 'BondType', id: number, name: string } | null, nominalCurrency?: { __typename?: 'Currency', id?: number | null, alphaCode?: string | null, name?: string | null, displayCode?: string | null } | null, tradingCurrency?: { __typename?: 'Currency', id?: number | null, alphaCode?: string | null, displayCode?: string | null, name?: string | null } | null, settlementCurrency?: { __typename?: 'Currency', id?: number | null, alphaCode?: string | null, displayCode?: string | null, name?: string | null } | null, priceAttribute?: { __typename?: 'BondPriceAttribute', id: number, name: string } | null, issuer?: { __typename?: 'BondIssuer', id?: number | null, lei?: string | null, legalName?: string | null, name?: string | null, isin?: string | null, group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, assetGroup?: AssetGroup | null, assetClass?: { __typename?: 'AssetClass', id: number, name: string } | null } | null } | null } | null }, currency: { __typename?: 'Currency', displayCode?: string | null, sign?: string | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, value?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, performance?: number | null, deltaAveragePrice?: number | null }>, derivativeKeyFigures?: { __typename?: 'DerivativeInstrumentKeyFigures', dirtyPrice?: number | null, ismaYield?: number | null, accruedInterest?: number | null, duration?: number | null, modifiedDuration?: number | null, spread?: number | null, spreadRelative?: number | null } | null } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetCommodityInstrumentsQueryVariables = Exact<{
  chartScope: ChartScope;
}>;


export type GetCommodityInstrumentsQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', id: number, name: string, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null, main?: { __typename?: 'Instrument', stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, indicators?: { __typename?: 'InstrumentIndicators', relativeStrengthLevy?: { __typename?: 'RelativeStrengthLevyIndicator', deltaMedian?: number | null, indicator?: number | null } | null, movingAverage?: { __typename?: 'MovingAverageIndicator', deltaLine200Day?: number | null, deltaLine38Day?: number | null } | null } | null, chart?: { __typename?: 'Chart', series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null }, currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null } | null } | null }> | null } | null };

export type GetEtfSearchCountQueryVariables = Exact<{
  criterion?: InputMaybe<SearchEtfCriterion>;
  sort?: InputMaybe<Array<SearchEtfSort> | SearchEtfSort>;
}>;


export type GetEtfSearchCountQuery = { __typename?: 'Query', searchEtf: { __typename?: 'InstrumentConnection', count?: any | null } };

export type GetEtfSearchMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEtfSearchMetadataQuery = { __typename?: 'Query', classification: Array<{ __typename?: 'AssetClass', id: number, name: string, typeGroups: Array<{ __typename?: 'AssetTypeGroup', id?: string | null, name?: string | null }> }>, etfAllocation: Array<{ __typename?: 'EtfAllocation', id: number, name?: string | null }>, etfPosition: Array<{ __typename?: 'EtfPosition', id: number, name?: string | null }>, etfRegions: Array<{ __typename?: 'EtfRegion', id: number, name?: string | null }>, etfSectors: Array<{ __typename?: 'EtfSector', id: number, name?: string | null }>, etfStrategies: Array<{ __typename?: 'EtfStrategy', id: number, name?: string | null }>, etfReplications: Array<{ __typename?: 'EtfReplication', id: number, name?: string | null }>, etfIssuers: Array<{ __typename?: 'EtfIssuer', id: number, name?: string | null }> };

export type GetEtfSearchResultQueryVariables = Exact<{
  criterion?: InputMaybe<SearchEtfCriterion>;
  sort?: InputMaybe<Array<SearchEtfSort> | SearchEtfSort>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetEtfSearchResultQuery = { __typename?: 'Query', searchEtf: { __typename?: 'InstrumentConnection', count?: any | null, edges: Array<{ __typename?: 'InstrumentEdge', node: { __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, averagePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, group: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null, assetClass?: { __typename?: 'AssetClass', name: string } | null, assetTypeGroup?: { __typename?: 'AssetTypeGroup', name?: string | null } | null, assetType?: { __typename?: 'AssetType', name?: string | null } | null, etf?: { __typename?: 'InstrumentGroupExchangeTradedFund', id: number, investmentConcept?: string | null, participationFactor?: number | null, underlyingRatio?: number | null, position?: EtfPositionType | null, charge?: number | null, distributing?: boolean | null, foundationDate?: any | null, quanto?: boolean | null, issuer?: { __typename?: 'EtfIssuer', name?: string | null } | null, sector?: { __typename?: 'EtfSector', name?: string | null } | null, region?: { __typename?: 'EtfRegion', name?: string | null } | null, allocation?: { __typename?: 'EtfAllocation', name?: string | null } | null, domicile?: { __typename?: 'EtfDomicile', name?: string | null } | null, strategy?: { __typename?: 'EtfStrategy', name?: string | null } | null, replication?: { __typename?: 'EtfReplication', name?: string | null } | null, investmentVolume?: { __typename?: 'InvestmentVolume', date?: any | null, value?: number | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null } | null, keyFigures?: { __typename?: 'EtfKeyFigures', totalExpenseRatio?: number | null, jensenAlpha?: number | null, betaFactor?: number | null, negativeRegression?: number | null, positiveRegression?: number | null, maxLoosing6Month?: number | null, longestLoosingPeriod?: number | null, trackingError?: number | null } | null } | null } } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetCommoditiesQueryVariables = Exact<{
  assetGroup?: InputMaybe<Array<AssetGroup> | AssetGroup>;
  searchString: Scalars['String'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetCommoditiesQuery = { __typename?: 'Query', search: { __typename?: 'InstrumentDetailConnection', edges: Array<{ __typename?: 'InstrumentEdge', cursor: string, node: { __typename?: 'Instrument', id: number, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, wkn?: string | null, seoTag?: string | null, assetGroup?: AssetGroup | null, main?: { __typename?: 'Instrument', id: number, country?: { __typename?: 'Country', name: string, isoAlpha3: string } | null, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, indicators?: { __typename?: 'InstrumentIndicators', movingAverage?: { __typename?: 'MovingAverageIndicator', deltaLine200Day?: number | null } | null } | null } | null, compositions: Array<{ __typename?: 'InstrumentGroupComposition', id: number, name?: string | null }> }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null } | null } | null } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } | null } };

export type GetInstrumentGroupIncludedQueryVariables = Exact<{
  instrumentGroupId: Scalars['Long'];
  days: Scalars['Long'];
}>;


export type GetInstrumentGroupIncludedQuery = { __typename?: 'Query', instrumentGroupIncluded: { __typename?: 'InstrumentGroupIncludedResponse', portfolios: any, totalPortfolios: any, watchlists: any, totalWatchlists: any, limitsUpper: any, limitsLower: any, limits: any, totalLimits: any }, instrumentGroupTrades: Array<{ __typename?: 'InstrumentTrade', price: number, quantity: number, buy: boolean, instrument: { __typename?: 'Instrument', id: number } } | null> };

export type GetInstrumentChartPerformanceQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  from: Scalars['LocalDate'];
  to: Scalars['LocalDate'];
}>;


export type GetInstrumentChartPerformanceQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, name: string, isin?: string | null, monteCarlo?: { __typename?: 'MonteCarloResult', min?: number | null, avg?: number | null, max?: number | null, up?: number | null, down?: number | null } | null, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null } | null } | null, currency: { __typename?: 'Currency', id?: number | null, displayCode?: string | null }, quoteHistory: { __typename?: 'QuoteHistoryConnection', edges: Array<{ __typename?: 'QuoteHistoryEdge', node?: { __typename?: 'QuoteHistory', date?: any | null, lastPrice?: number | null } | null }> } } | null };

export type GetInstrumentChartForCompareQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  chartScope: ChartScope;
}>;


export type GetInstrumentChartForCompareQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string }, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null };

export type GetInstrumentChartToolModalQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  chartScope: ChartScope;
  criteria: HistoryQuoteCriteria;
}>;


export type GetInstrumentChartToolModalQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string }, historyQuote: { __typename?: 'HistoryQuoteConnection', edges: Array<{ __typename?: 'HistoryQuoteEdge', node?: { __typename?: 'HistoryQuote', cumulativeVolume?: any | null, start?: any | null, firstPrice?: number | null, highPrice?: number | null, id?: string | null, lastPrice?: number | null, lowPrice?: number | null } | null }> }, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null };

export type GetTopsFlopsIndicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopsFlopsIndicesQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } }> | null } | null };

export type GetInstrumentChartBannerQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  chartScope: ChartScope;
}>;


export type GetInstrumentChartBannerQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null };

export type GetInstrumentSnapQuoteCardInfoQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
}>;


export type GetInstrumentSnapQuoteCardInfoQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, delay?: number | null, value?: number | null, change?: number | null, percentChange?: number | null, when?: any | null } | null> } | null, exchange: { __typename?: 'Exchange', id: number, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, displayCode?: string | null } } | null };

export type GetInstrumentSnapQuoteChartQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
}>;


export type GetInstrumentSnapQuoteChartQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null };

export type GetInstrumentChartComparisonQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  chartScope: ChartScope;
}>;


export type GetInstrumentChartComparisonQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, name: string, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null };

export type GetModalAnalysesReportQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetModalAnalysesReportQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, analysisReport?: { __typename?: 'AnalysisReport', neutralCount?: number | null, negativeCount?: number | null, positiveCount?: number | null, recommendation?: AnalysisRecommendation | null, price?: number | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null, targets: Array<{ __typename?: 'AnalysisReportTarget', recommendation?: AnalysisRecommendation | null, price?: number | null, count?: number | null }> } | null } | null };

export type GetInstrumentHistoryInfoQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  from: Scalars['LocalDate'];
  to: Scalars['LocalDate'];
}>;


export type GetInstrumentHistoryInfoQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, firstPrice?: number | null, lowPrice?: number | null, highPrice?: number | null, cumulativeVolume?: any | null, quote?: { __typename?: 'Quote', value?: number | null, when?: any | null } | null } | null, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null }, quoteHistory: { __typename?: 'QuoteHistoryConnection', edges: Array<{ __typename?: 'QuoteHistoryEdge', node?: { __typename?: 'QuoteHistory', date?: any | null, firstPrice?: number | null, lastPrice?: number | null, lowPrice?: number | null, highPrice?: number | null, volume?: any | null } | null }> } } | null };

export type GetProfilePortfolioQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfilePortfolioQuery = { __typename?: 'Query', user?: { __typename?: 'User', username?: string | null, profile?: { __typename?: 'UserProfile', portfolioViewType?: string | null, portfolios?: Array<{ __typename?: 'Portfolio', id: number, name?: string | null, real: boolean, entries?: Array<{ __typename?: 'PortfolioEntry', id: number, name?: string | null, instrumentId?: number | null, instrumentGroupId?: number | null, quantity: number, price: number, buyCharges: number, buyCurrencyPrice?: number | null, entryTime: any, memo?: string | null, instrument?: { __typename?: 'Instrument', id: number, name: string, exchange: { __typename?: 'Exchange', id: number, name?: string | null }, currency: { __typename?: 'Currency', id?: number | null, displayCode?: string | null } } | null }> | null }> | null } | null } | null };

export type InstrumentIncludedQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type InstrumentIncludedQuery = { __typename?: 'Query', instrumentIncluded?: { __typename?: 'InstrumentIncludedResponse', limitsNumber: any, portfolios: Array<{ __typename?: 'PortfolioItem', id: number, name: string, real: boolean }>, watchlists: Array<{ __typename?: 'WatchlistItem', id: number, name: string }> } | null };

export type GetInstrumentQuoteHistoryInfoQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  from: Scalars['LocalDate'];
  to: Scalars['LocalDate'];
}>;


export type GetInstrumentQuoteHistoryInfoQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', currency: { __typename?: 'Currency', displayCode?: string | null }, quoteHistory: { __typename?: 'QuoteHistoryConnection', edges: Array<{ __typename?: 'QuoteHistoryEdge', node?: { __typename?: 'QuoteHistory', date?: any | null, firstPrice?: number | null, lastPrice?: number | null, lowPrice?: number | null, highPrice?: number | null, volume?: any | null } | null }> } } | null };

export type GetTimeAndSalesQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  from: Scalars['OffsetDateTime'];
  to: Scalars['OffsetDateTime'];
  before?: InputMaybe<Scalars['ID']>;
}>;


export type GetTimeAndSalesQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', currency: { __typename?: 'Currency', displayCode?: string | null }, timeAndSales: { __typename?: 'InstrumentTimeAndSalesConnection', pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null } | null, edges: Array<{ __typename?: 'InstrumentTimeAndSalesEdge', cursor?: string | null, node?: { __typename?: 'InstrumentTimeAndSales', when?: any | null, firstPrice?: number | null, lowPrice?: number | null, highPrice?: number | null, lastPrice?: number | null, askVolume?: any | null, bidVolume?: any | null, volume?: any | null } | null }> } } | null };

export type GetAssetNewsFeedQueryVariables = Exact<{
  isin: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetAssetNewsFeedQuery = { __typename?: 'Query', newsSearch: { __typename?: 'NewsConnection', edges: Array<{ __typename?: 'NewsEdge', cursor: string, node: { __typename?: 'News', id: string, headline?: string | null, teaser?: string | null, body?: string | null, feed?: NewsFeed | null, when?: any | null, links?: Array<{ __typename?: 'NewsLink', name?: string | null, href?: string | null }> | null, source?: { __typename?: 'NewsSource', id?: string | null, name?: string | null } | null, instruments?: Array<{ __typename?: 'NewsInstrument', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, assetGroup?: AssetGroup | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, currency: { __typename?: 'Currency', alphaCode?: string | null, sign?: string | null, name?: string | null, displayCode?: string | null } } | null } | null }> | null, medias?: Array<{ __typename?: 'NewsMedia', source?: string | null, width?: number | null, height?: number | null }> | null, streams?: Array<{ __typename?: 'NewsStream', mimeType?: string | null, duration?: number | null, width?: number | null, height?: number | null, source?: string | null }> | null } }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } | null } };

export type GetNewsEditorialFeedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsEditorialFeedQuery = { __typename?: 'Query', newsSearch: { __typename: 'NewsConnection', edges: Array<{ __typename?: 'NewsEdge', cursor: string, node: { __typename?: 'News', id: string, when?: any | null, body?: string | null, headline?: string | null, teaser?: string | null, feed?: NewsFeed | null, keywords?: Array<string> | null, links?: Array<{ __typename?: 'NewsLink', name?: string | null, href?: string | null }> | null, source?: { __typename?: 'NewsSource', id?: string | null, name?: string | null } | null, medias?: Array<{ __typename?: 'NewsMedia', source?: string | null, width?: number | null, height?: number | null }> | null, streams?: Array<{ __typename?: 'NewsStream', mimeType?: string | null, duration?: number | null, width?: number | null, height?: number | null, source?: string | null }> | null, instruments?: Array<{ __typename?: 'NewsInstrument', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, assetGroup?: AssetGroup | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, currency: { __typename?: 'Currency', displayCode?: string | null } } | null } | null }> | null } }>, pageInfo?: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } | null } };

export type GetNewsGridModalQueryVariables = Exact<{
  criteria?: InputMaybe<NewsCriteria>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetNewsGridModalQuery = { __typename?: 'Query', newsSearch: { __typename?: 'NewsConnection', edges: Array<{ __typename?: 'NewsEdge', cursor: string, node: { __typename?: 'News', id: string, when?: any | null, body?: string | null, headline?: string | null, teaser?: string | null, feed?: NewsFeed | null, keywords?: Array<string> | null, links?: Array<{ __typename?: 'NewsLink', name?: string | null, href?: string | null }> | null, source?: { __typename?: 'NewsSource', id?: string | null, name?: string | null } | null, medias?: Array<{ __typename?: 'NewsMedia', source?: string | null, width?: number | null, height?: number | null }> | null, streams?: Array<{ __typename?: 'NewsStream', mimeType?: string | null, duration?: number | null, width?: number | null, height?: number | null, source?: string | null }> | null, instruments?: Array<{ __typename?: 'NewsInstrument', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, assetGroup?: AssetGroup | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number, snapQuote?: { __typename?: 'SnapQuote', instrumentId: number, lastChange?: any | null, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, currency: { __typename?: 'Currency', displayCode?: string | null } } | null } | null }> | null } }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } | null } };

export type GetInstrumentSnapQuoteQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
}>;


export type GetInstrumentSnapQuoteQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null } | null } | null } | null };

export type GetNewsInstrumentSnapQuoteQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
}>;


export type GetNewsInstrumentSnapQuoteQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null } | null };

export type GetCurrentNewsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCurrentNewsQuery = { __typename?: 'Query', news?: { __typename?: 'News', id: string, when?: any | null, body?: string | null, headline?: string | null, teaser?: string | null, feed?: NewsFeed | null, keywords?: Array<string> | null, links?: Array<{ __typename?: 'NewsLink', name?: string | null, href?: string | null }> | null, source?: { __typename?: 'NewsSource', id?: string | null, name?: string | null } | null, medias?: Array<{ __typename?: 'NewsMedia', source?: string | null, width?: number | null, height?: number | null }> | null, streams?: Array<{ __typename?: 'NewsStream', mimeType?: string | null, duration?: number | null, width?: number | null, height?: number | null, source?: string | null }> | null, instruments?: Array<{ __typename?: 'NewsInstrument', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, assetGroup?: AssetGroup | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, currency: { __typename?: 'Currency', displayCode?: string | null } } | null } | null }> | null } | null };

export type GetNewsUrlModalQueryVariables = Exact<{
  criteria?: InputMaybe<NewsCriteria>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetNewsUrlModalQuery = { __typename?: 'Query', newsSearch: { __typename?: 'NewsConnection', edges: Array<{ __typename?: 'NewsEdge', cursor: string, node: { __typename?: 'News', id: string, when?: any | null, body?: string | null, headline?: string | null, teaser?: string | null, feed?: NewsFeed | null, keywords?: Array<string> | null, links?: Array<{ __typename?: 'NewsLink', name?: string | null, href?: string | null }> | null, source?: { __typename?: 'NewsSource', id?: string | null, name?: string | null } | null, medias?: Array<{ __typename?: 'NewsMedia', source?: string | null, width?: number | null, height?: number | null }> | null, streams?: Array<{ __typename?: 'NewsStream', mimeType?: string | null, duration?: number | null, width?: number | null, height?: number | null, source?: string | null }> | null, instruments?: Array<{ __typename?: 'NewsInstrument', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, assetGroup?: AssetGroup | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, currency: { __typename?: 'Currency', displayCode?: string | null } } | null } | null }> | null } }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } | null } };

export type GetNewsMainModalQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetNewsMainModalQuery = { __typename?: 'Query', news?: { __typename?: 'News', id: string, headline?: string | null, teaser?: string | null, body?: string | null, feed?: NewsFeed | null, keywords?: Array<string> | null, when?: any | null, links?: Array<{ __typename?: 'NewsLink', name?: string | null, href?: string | null }> | null, source?: { __typename?: 'NewsSource', id?: string | null, name?: string | null } | null, instruments?: Array<{ __typename?: 'NewsInstrument', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, assetGroup?: AssetGroup | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, currency: { __typename?: 'Currency', alphaCode?: string | null, sign?: string | null, name?: string | null, displayCode?: string | null } } | null } | null }> | null, medias?: Array<{ __typename?: 'NewsMedia', source?: string | null, width?: number | null, height?: number | null }> | null, streams?: Array<{ __typename?: 'NewsStream', mimeType?: string | null, duration?: number | null, width?: number | null, height?: number | null, source?: string | null }> | null } | null };

export type ClosePortfolioEntryMutationVariables = Exact<{
  portfolioId: Scalars['Long'];
  portfolioEntryId: Scalars['Long'];
  instrumentId?: InputMaybe<Scalars['Long']>;
  price: Scalars['Float'];
  quantity: Scalars['Float'];
  charges: Scalars['Float'];
  closeTime: Scalars['OffsetDateTime'];
  memo?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
}>;


export type ClosePortfolioEntryMutation = { __typename?: 'Mutation', closePortfolioEntry?: { __typename?: 'PortfolioEntry', id: number, name?: string | null, price: number, quantity: number, memo?: string | null } | null };

export type CreatePortfolioEntryMutationVariables = Exact<{
  portfolioId: Scalars['Long'];
  instrumentId: Scalars['Long'];
  price: Scalars['Float'];
  quantity: Scalars['Float'];
  charges: Scalars['Float'];
  entryTime: Scalars['OffsetDateTime'];
  memo?: InputMaybe<Scalars['String']>;
  currencyCode?: InputMaybe<Scalars['String']>;
}>;


export type CreatePortfolioEntryMutation = { __typename?: 'Mutation', createPortfolioEntry?: { __typename?: 'PortfolioEntry', id: number, name?: string | null, price: number, quantity: number, memo?: string | null } | null };

export type GetInstrumentGroupUserPortfoliosQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetInstrumentGroupUserPortfoliosQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, content: Array<{ __typename?: 'Instrument', id: number, main: boolean, isin?: string | null, name: string, countryId: number, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, group: { __typename?: 'InstrumentGroup', id?: number | null, seoTag?: string | null, assetGroup?: AssetGroup | null, sector?: { __typename?: 'Sector', name?: string | null } | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, size?: number | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, highPrice?: number | null }> }> } | null };

export type GetInstrumentUserPortfoliosQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
}>;


export type GetInstrumentUserPortfoliosQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, name: string, isin?: string | null, exchange: { __typename?: 'Exchange', id: number, name?: string | null }, group: { __typename?: 'InstrumentGroup', id?: number | null, assetGroup?: AssetGroup | null, bond?: { __typename?: 'InstrumentGroupBond', nominalCurrencyCode?: string | null } | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lastPrice?: number | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, currency: { __typename?: 'Currency', id?: number | null, displayCode?: string | null } } | null };

export type GetUserPortfoliosAddQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPortfoliosAddQuery = { __typename?: 'Query', user?: { __typename?: 'User', username?: string | null, profile?: { __typename?: 'UserProfile', id: any, portfolios?: Array<{ __typename?: 'Portfolio', id: number, name?: string | null }> | null } | null } | null };

export type CreateWatchlistEntryMutationVariables = Exact<{
  watchlistId: Scalars['Long'];
  instrumentId: Scalars['Long'];
  price: Scalars['Float'];
  memo?: InputMaybe<Scalars['String']>;
}>;


export type CreateWatchlistEntryMutation = { __typename?: 'Mutation', createWatchlistEntry?: { __typename?: 'WatchlistEntry', id: number, name?: string | null, price: number, quantity: number, memo?: string | null } | null };

export type GetInstrumentGroupUserWatchListQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetInstrumentGroupUserWatchListQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, content: Array<{ __typename?: 'Instrument', id: number, main: boolean, isin?: string | null, name: string, countryId: number, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, group: { __typename?: 'InstrumentGroup', id?: number | null, seoTag?: string | null, assetGroup?: AssetGroup | null, sector?: { __typename?: 'Sector', name?: string | null } | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, size?: number | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null }> } | null };

export type GetInstrumentUserWatchListQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
}>;


export type GetInstrumentUserWatchListQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, name: string, isin?: string | null, exchange: { __typename?: 'Exchange', id: number, name?: string | null }, currency: { __typename?: 'Currency', id?: number | null, displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', instrumentId: number, lastPrice?: number | null } | null } | null };

export type GetUserWatchListsAddQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserWatchListsAddQuery = { __typename?: 'Query', user?: { __typename?: 'User', username?: string | null, profile?: { __typename?: 'UserProfile', id: any, watchlists?: Array<{ __typename?: 'Watchlist', id: number, name?: string | null }> | null } | null } | null };

export type GetInstrumentGroupSelectedQueryVariables = Exact<{
  assetGroup?: InputMaybe<Array<AssetGroup> | AssetGroup>;
  searchString: Scalars['String'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetInstrumentGroupSelectedQuery = { __typename?: 'Query', search: { __typename?: 'InstrumentDetailConnection', edges: Array<{ __typename?: 'InstrumentEdge', cursor: string, node: { __typename?: 'Instrument', id: number, name: string, wkn?: string | null, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, assetGroup?: AssetGroup | null, seoTag?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, value?: number | null, change?: number | null, when?: any | null } | null> } | null } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } | null, assetGroups: Array<{ __typename?: 'AssetGroupBucket', assetGroup: AssetGroup, count: number }> } };

export type GetInstrumentGroupSelectedCountQueryVariables = Exact<{
  searchString: Scalars['String'];
}>;


export type GetInstrumentGroupSelectedCountQuery = { __typename?: 'Query', search: { __typename?: 'InstrumentDetailConnection', assetGroups: Array<{ __typename?: 'AssetGroupBucket', assetGroup: AssetGroup, count: number }> } };

export type GetAssetTypeGroupQueryVariables = Exact<{
  underlyingInstrumentGroupId: Scalars['Int'];
  assetClassId: Scalars['Long'];
}>;


export type GetAssetTypeGroupQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, derivativeAssetTypeGroupBucket: Array<{ __typename?: 'DerivativeAssetTypeGroupBucket', count?: any | null, assetTypeGroup?: { __typename?: 'AssetTypeGroup', id?: string | null, name?: string | null } | null }> } | null };

export type DerivativeAssetTypeBucketQueryVariables = Exact<{
  instrumentGroupId: Scalars['Int'];
  assetClassId?: InputMaybe<Scalars['Long']>;
}>;


export type DerivativeAssetTypeBucketQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', derivativeAssetTypeBucket: Array<{ __typename?: 'DerivativeAssetTypeBucket', count?: any | null, assetType?: { __typename?: 'AssetType', name?: string | null } | null }> } | null };

export type GetDerivativeOverviewAnalogeResultQueryVariables = Exact<{
  assetClass?: InputMaybe<Scalars['Long']>;
  underlyingInstrumentGroupId?: InputMaybe<Scalars['Int']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetDerivativeOverviewAnalogeResultQuery = { __typename?: 'Query', searchDerivative: { __typename?: 'InstrumentConnection', count?: any | null, edges: Array<{ __typename?: 'InstrumentEdge', cursor: string, node: { __typename?: 'Instrument', id: number, name: string, wkn?: string | null, keyFigures?: { __typename?: 'DerivativeInstrumentKeyFigures', gearing?: number | null, deltaStopLoss?: number | null, deltaStopLossAbsolute?: number | null, moneyness?: number | null, premiumAnnual?: number | null, sidewaysAnnualReturn?: number | null } | null, group: { __typename?: 'InstrumentGroup', id?: number | null, seoTag?: string | null, assetGroup?: AssetGroup | null, issuerId?: number | null, assetTypeGroup?: { __typename?: 'AssetTypeGroup', id?: string | null, name?: string | null } | null, assetType?: { __typename?: 'AssetType', id?: string | null, name?: string | null } | null, issuer?: { __typename?: 'Issuer', name?: string | null, partner?: boolean | null } | null, derivative?: { __typename?: 'InstrumentGroupDerivative', id: number, maturityDate?: any | null, optionType?: DerivativeOptionType | null } | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', id?: any | null, strike?: number | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null }> | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, value?: number | null, when?: any | null } | null> } | null } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetDerivativeOverviewResultQueryVariables = Exact<{
  assetClass?: InputMaybe<Scalars['Long']>;
  underlyingInstrumentGroupId: Scalars['Int'];
  gearingFrom?: InputMaybe<Scalars['Float']>;
  gearingTo?: InputMaybe<Scalars['Float']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetDerivativeOverviewResultQuery = { __typename?: 'Query', callOption: { __typename?: 'InstrumentConnection', edges: Array<{ __typename?: 'InstrumentEdge', node: { __typename?: 'Instrument', id: number, name: string, wkn?: string | null, derivativeKeyFigures?: { __typename?: 'DerivativeInstrumentKeyFigures', gearing?: number | null, premiumAnnual?: number | null } | null, group: { __typename?: 'InstrumentGroup', id?: number | null, seoTag?: string | null, assetGroup?: AssetGroup | null, issuerId?: number | null, assetType?: { __typename?: 'AssetType', id?: string | null, name?: string | null } | null, issuer?: { __typename?: 'Issuer', name?: string | null, partner?: boolean | null } | null, derivative?: { __typename?: 'InstrumentGroupDerivative', id: number, maturityDate?: any | null, optionType?: DerivativeOptionType | null } | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, value?: number | null, when?: any | null } | null> } | null } }> }, putOption: { __typename?: 'InstrumentConnection', edges: Array<{ __typename?: 'InstrumentEdge', node: { __typename?: 'Instrument', id: number, name: string, wkn?: string | null, derivativeKeyFigures?: { __typename?: 'DerivativeInstrumentKeyFigures', gearing?: number | null, premiumAnnual?: number | null } | null, group: { __typename?: 'InstrumentGroup', id?: number | null, seoTag?: string | null, assetGroup?: AssetGroup | null, issuerId?: number | null, assetType?: { __typename?: 'AssetType', id?: string | null, name?: string | null } | null, issuer?: { __typename?: 'Issuer', name?: string | null, partner?: boolean | null } | null, derivative?: { __typename?: 'InstrumentGroupDerivative', id: number, maturityDate?: any | null, optionType?: DerivativeOptionType | null } | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, value?: number | null, when?: any | null } | null> } | null } }> }, buckets?: { __typename?: 'InstrumentGroup', derivativeKeyFigureRangeBucket: Array<{ __typename?: 'DerivativeKeyFigureRangeBucket', optionType?: DerivativeOptionType | null, from?: number | null, to?: number | null, count?: any | null }> } | null };

export type GetDerivativeSearchResultNewVersionQueryVariables = Exact<{
  optionType?: InputMaybe<DerivativeOptionType>;
  assetGroup?: InputMaybe<AssetGroup>;
  assetTypeGroup?: InputMaybe<Scalars['String']>;
  assetType?: InputMaybe<Scalars['String']>;
  underlyingInstrumentGroupId?: InputMaybe<Scalars['Int']>;
  keyFigures?: InputMaybe<Array<DerivativeKeyFigureCriteria> | DerivativeKeyFigureCriteria>;
  maturityDateFrom?: InputMaybe<Scalars['LocalDate']>;
  maturityDateTo?: InputMaybe<Scalars['LocalDate']>;
  issuerId?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  sort?: InputMaybe<Array<SearchDerivativeSort> | SearchDerivativeSort>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetDerivativeSearchResultNewVersionQuery = { __typename?: 'Query', searchDerivative: { __typename: 'InstrumentConnection', count?: any | null, edges: Array<{ __typename: 'InstrumentEdge', cursor: string, node: { __typename: 'Instrument', id: number, name: string, wkn?: string | null, group: { __typename: 'InstrumentGroup', id?: number | null, seoTag?: string | null, assetGroup?: AssetGroup | null, issuerId?: number | null, assetTypeGroup?: { __typename: 'AssetTypeGroup', id?: string | null, name?: string | null } | null, assetType?: { __typename: 'AssetType', id?: string | null, name?: string | null } | null, issuer?: { __typename: 'Issuer', name?: string | null, partner?: boolean | null } | null, main?: { __typename?: 'Instrument', lastTradingDay?: any | null } | null, derivative?: { __typename: 'InstrumentGroupDerivative', id: number, maturityDate?: any | null, optionType?: DerivativeOptionType | null, managementFee?: number | null } | null, underlyings?: Array<{ __typename: 'InstrumentGroupUnderlying', id?: any | null, strike?: number | null, knockOut?: number | null, knockOutLower?: number | null, knockOutUpper?: number | null, cap?: number | null, bonusBarrier?: number | null, security?: number | null, securityBarrierObservationStartAt?: any | null, securityBarrierTriggeredAt?: any | null, securityBarrierObservationEndAt?: any | null, currency?: { __typename: 'Currency', displayCode?: string | null } | null, instrument?: { __typename?: 'Instrument', snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', value?: number | null, type?: QuoteType | null } | null> } | null } | null }> | null, interestRateInformation?: { __typename?: 'InstrumentGroupInterestRateInformation', interestRate?: number | null, nextPaymentDate?: any | null, lastPaymentDate?: any | null, finalPaymentDate?: any | null } | null }, derivativeKeyFigures?: { __typename: 'DerivativeInstrumentKeyFigures', gearing?: number | null, premium?: number | null, premiumAbsolute?: number | null, premiumAnnual?: number | null, implicitVolatility?: number | null, breakEven?: number | null, moneyness?: number | null, intrinsicValue?: number | null, timeValuePremium?: number | null, spread?: number | null, spreadHomogenous?: number | null, spreadRelative?: number | null, deltaStopLoss?: number | null, deltaStopLossAbsolute?: number | null, agio?: number | null, agioAnnual?: number | null, omega?: number | null, delta?: number | null, gamma?: number | null, theta?: number | null, rho?: number | null, vega?: number | null, discountAbsolute?: number | null, discountPercent?: number | null, sidewaysReturn?: number | null, sidewaysReturnAbsolute?: number | null, sidewaysAnnualReturn?: number | null, outperformanceLevel?: number | null, maxAnnualReturn?: number | null, maxReturn?: number | null, maxReturnAbsolute?: number | null, maxRedemptionPrice?: number | null, deltaCap?: number | null, deltaCapAbsolute?: number | null, fairValue?: number | null, bonusAnnualReturn?: number | null, bonusBuffer?: number | null, bonusBufferAbsolute?: number | null, bonusReturn?: number | null, bonusReturnAbsolute?: number | null, deltaBonusLevel?: number | null, deltaBonusLevelAbsolute?: number | null, deltaStrike?: number | null, deltaStrikeAbsolute?: number | null, deltaSecurityLevel?: number | null, dirtyPrice?: number | null, parity?: number | null, ismaYield?: number | null, accruedInterest?: number | null, duration?: number | null, modifiedDuration?: number | null, update?: { __typename?: 'InstrumentKeyFiguresUpdate', when?: any | null, type?: QuoteType | null, value?: number | null, underlyingValue?: number | null } | null } | null, snapQuote?: { __typename: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename: 'InstrumentPerformance', period: CalculationPeriod, performance?: number | null }> } }>, pageInfo?: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type UnderlyingRangeBucketQueryVariables = Exact<{
  assetClassId?: InputMaybe<Scalars['Long']>;
  underlyingInstrumentGroupId: Scalars['Int'];
}>;


export type UnderlyingRangeBucketQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', derivativeKeyFigureRangeBucket: Array<{ __typename?: 'DerivativeKeyFigureRangeBucket', optionType?: DerivativeOptionType | null, from?: number | null, to?: number | null, count?: any | null }> } | null };

export type GetDerivativeSearchQuoteCellsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetDerivativeSearchQuoteCellsQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, when?: any | null } | null> } | null } | null };

export type GetInstrumentsQueryVariables = Exact<{
  assetGroup?: InputMaybe<Array<AssetGroup> | AssetGroup>;
  searchString: Scalars['String'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['ID']>;
  underlying?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetInstrumentsQuery = { __typename?: 'Query', search: { __typename?: 'InstrumentDetailConnection', edges: Array<{ __typename?: 'InstrumentEdge', cursor: string, node: { __typename?: 'Instrument', id: number, name: string, seoTag?: string | null, wkn?: string | null, isin?: string | null, group: { __typename?: 'InstrumentGroup', id?: number | null, assetGroup?: AssetGroup | null, name: string, seoTag?: string | null, underlying?: boolean | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', type?: QuoteType | null, when?: any | null, delay?: number | null, value?: number | null, percentChange?: number | null, change?: number | null } | null } | null, currency: { __typename?: 'Currency', displayCode?: string | null }, exchange: { __typename?: 'Exchange', code?: string | null } } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } | null } };

export type GetAssetClassQueryVariables = Exact<{
  underlyingInstrumentGroupId: Scalars['Int'];
}>;


export type GetAssetClassQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, derivativeAssetClassBucket: Array<{ __typename?: 'DerivativeAssetClassBucket', count?: any | null, assetClass?: { __typename?: 'AssetClass', id: number, name: string } | null }> } | null };

export type GetAssetTypeQueryVariables = Exact<{
  underlyingInstrumentGroupId: Scalars['Int'];
  assetTypeGroupId?: InputMaybe<Scalars['String']>;
}>;


export type GetAssetTypeQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, derivativeAssetTypeBucket: Array<{ __typename?: 'DerivativeAssetTypeBucket', count?: any | null, assetType?: { __typename?: 'AssetType', id?: string | null, name?: string | null } | null }> } | null };

export type GetAssetTypeClassIdQueryVariables = Exact<{
  underlyingInstrumentGroupId: Scalars['Int'];
  assetClassId: Scalars['Long'];
}>;


export type GetAssetTypeClassIdQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, derivativeAssetTypeBucket: Array<{ __typename?: 'DerivativeAssetTypeBucket', count?: any | null, assetType?: { __typename?: 'AssetType', id?: string | null, name?: string | null } | null }> } | null };

export type GetIssuersResultQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIssuersResultQuery = { __typename?: 'Query', issuers: Array<{ __typename?: 'Issuer', id?: any | null, name?: string | null }> };

export type GetDerivativeSearchResultQueryVariables = Exact<{
  optionType?: InputMaybe<DerivativeOptionType>;
  assetGroup?: InputMaybe<AssetGroup>;
  assetType?: InputMaybe<Scalars['String']>;
  underlyingInstrumentGroupId?: InputMaybe<Scalars['Int']>;
  strikeFrom?: InputMaybe<Scalars['Float']>;
  strikeTo?: InputMaybe<Scalars['Float']>;
  gearingFrom?: InputMaybe<Scalars['Float']>;
  gearingTo?: InputMaybe<Scalars['Float']>;
  moneynessFrom?: InputMaybe<Scalars['Float']>;
  moneynessTo?: InputMaybe<Scalars['Float']>;
  capFrom?: InputMaybe<Scalars['Float']>;
  capTo?: InputMaybe<Scalars['Float']>;
  knockInFrom?: InputMaybe<Scalars['Float']>;
  knockInTo?: InputMaybe<Scalars['Float']>;
  knockOutFrom?: InputMaybe<Scalars['Float']>;
  knockOutTo?: InputMaybe<Scalars['Float']>;
  knockInLowerFrom?: InputMaybe<Scalars['Float']>;
  knockInLowerTo?: InputMaybe<Scalars['Float']>;
  knockInUpperFrom?: InputMaybe<Scalars['Float']>;
  knockInUpperTo?: InputMaybe<Scalars['Float']>;
  maturityDateFrom?: InputMaybe<Scalars['LocalDate']>;
  maturityDateTo?: InputMaybe<Scalars['LocalDate']>;
  issuerId?: InputMaybe<Array<Scalars['Long']> | Scalars['Long']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetDerivativeSearchResultQuery = { __typename?: 'Query', searchDerivative: { __typename?: 'InstrumentConnection', count?: any | null, edges: Array<{ __typename?: 'InstrumentEdge', cursor: string, node: { __typename?: 'Instrument', id: number, name: string, wkn?: string | null, group: { __typename?: 'InstrumentGroup', id?: number | null, seoTag?: string | null, assetGroup?: AssetGroup | null, issuerId?: number | null, assetType?: { __typename?: 'AssetType', id?: string | null, name?: string | null } | null, issuer?: { __typename?: 'Issuer', name?: string | null, partner?: boolean | null } | null, main?: { __typename?: 'Instrument', id: number, keyFigures?: { __typename?: 'DerivativeInstrumentKeyFigures', gearing?: number | null, deltaStopLoss?: number | null, deltaStopLossAbsolute?: number | null, moneyness?: number | null } | null, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, when?: any | null } | null> } | null } | null, derivative?: { __typename?: 'InstrumentGroupDerivative', id: number, maturityDate?: any | null, optionType?: DerivativeOptionType | null } | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', id?: any | null, strike?: number | null, knockOut?: number | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null }> | null } } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetDerivativeTypeInputQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDerivativeTypeInputQuery = { __typename?: 'Query', classification: Array<{ __typename?: 'AssetClass', id: number, name: string, leveraged: boolean, assetGroup: AssetGroup, typeGroups: Array<{ __typename?: 'AssetTypeGroup', id?: string | null, name?: string | null }>, types: Array<{ __typename?: 'AssetType', id?: string | null, name?: string | null }> }> };

export type GetKnockOutSearchResultQueryVariables = Exact<{
  assetGroup?: InputMaybe<Array<AssetGroup> | AssetGroup>;
  assetType?: InputMaybe<Scalars['String']>;
  underlyingInstrumentGroupId?: InputMaybe<Scalars['Long']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetKnockOutSearchResultQuery = { __typename?: 'Query', search: { __typename?: 'InstrumentDetailConnection', edges: Array<{ __typename?: 'InstrumentEdge', cursor: string, node: { __typename?: 'Instrument', id: number, name: string, wkn?: string | null, group: { __typename?: 'InstrumentGroup', id?: number | null, seoTag?: string | null, assetGroup?: AssetGroup | null, issuerId?: number | null, issuer?: { __typename?: 'Issuer', name?: string | null, partner?: boolean | null } | null, main?: { __typename?: 'Instrument', keyFigures?: { __typename?: 'DerivativeInstrumentKeyFigures', gearing?: number | null, deltaStopLoss?: number | null, deltaStopLossAbsolute?: number | null } | null } | null, derivative?: { __typename?: 'InstrumentGroupDerivative', maturityDate?: any | null, optionType?: DerivativeOptionType | null } | null, underlyings?: Array<{ __typename?: 'InstrumentGroupUnderlying', strike?: number | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null }> | null } } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetMainQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetMainQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', main?: { __typename?: 'Instrument', id: number, name: string, seoTag?: string | null, wkn?: string | null, isin?: string | null, group: { __typename?: 'InstrumentGroup', id?: number | null, assetGroup?: AssetGroup | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', type?: QuoteType | null, when?: any | null, delay?: number | null, value?: number | null, percentChange?: number | null, change?: number | null } | null } | null, currency: { __typename?: 'Currency', displayCode?: string | null }, exchange: { __typename?: 'Exchange', code?: string | null } } | null } | null };

export type GetCardPairsCrossRatesQueryVariables = Exact<{
  homeCurrencyCode?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<CrossRateSortField>;
  descending?: InputMaybe<Scalars['Boolean']>;
  chartScope: ChartScope;
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetCardPairsCrossRatesQuery = { __typename?: 'Query', searchCrossRate: { __typename?: 'InstrumentConnection', count?: any | null, edges: Array<{ __typename?: 'InstrumentEdge', cursor: string, node: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null }, exchange: { __typename?: 'Exchange', code?: string | null }, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, wkn?: string | null, seoTag?: string | null, assetGroup?: AssetGroup | null, main?: { __typename?: 'Instrument', id: number, country?: { __typename?: 'Country', name: string, isoAlpha3: string } | null, snapQuote?: { __typename?: 'SnapQuote', instrumentId: number, quote?: { __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null } | null } | null, chart?: { __typename?: 'Chart', series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, averagePrice?: number | null, performance?: number | null, performanceAbsolute?: number | null }> } | null, crossRate?: { __typename?: 'InstrumentGroupCrossRate', homeCurrency: { __typename?: 'Currency', displayCode?: string | null }, foreignCurrency: { __typename?: 'Currency', displayCode?: string | null } } | null }, snapQuote?: { __typename?: 'SnapQuote', instrumentId: number, quote?: { __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null } | null } | null } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetCurrencyEntriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrencyEntriesQuery = { __typename?: 'Query', analysisInstitute?: Array<{ __typename?: 'AnalystInstitute', id?: string | null, name: string }> | null };

export type GetComparisonListQueryVariables = Exact<{
  listId: Scalars['String'];
  chartScope: ChartScope;
}>;


export type GetComparisonListQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', id: number, name: string, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null }> | null } | null };

export type CurrencyQuoteQueryVariables = Exact<{
  baseCode: Scalars['String'];
  quoteCode: Scalars['String'];
}>;


export type CurrencyQuoteQuery = { __typename?: 'Query', currencyQuote?: { __typename?: 'SnapQuote', lastPrice?: number | null } | null };

export type GetCurrencyMatrixQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetCurrencyMatrixQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', crossRate?: { __typename?: 'InstrumentGroupCrossRate', homeCurrency: { __typename?: 'Currency', alphaCode?: string | null }, foreignCurrency: { __typename?: 'Currency', alphaCode?: string | null } } | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lastPrice?: number | null } | null }> | null } | null };

export type GetPerformanceInstrumentDevisenQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
}>;


export type GetPerformanceInstrumentDevisenQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null }, currency: { __typename?: 'Currency', sign?: string | null, displayCode?: string | null }, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, basePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null }> } | null };

export type GetFundCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFundCompaniesQuery = { __typename?: 'Query', fundCompanies: Array<{ __typename?: 'FundCompany', id?: any | null, name?: string | null }> };

export type GetFundPerformanceChartQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  chartScope: ChartScope;
}>;


export type GetFundPerformanceChartQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }> } | null } | null };

export type GetFundSearchCountQueryVariables = Exact<{
  criterion?: InputMaybe<SearchFundCriterion>;
  sort?: InputMaybe<Array<SearchFundSort> | SearchFundSort>;
}>;


export type GetFundSearchCountQuery = { __typename?: 'Query', searchFund: { __typename?: 'InstrumentConnection', count?: any | null } };

export type GetFundSearchMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFundSearchMetadataQuery = { __typename?: 'Query', fundCurrencies: Array<{ __typename?: 'FundCurrency', id: string, name: string }>, fundRegions: Array<{ __typename?: 'FundRegion', id: string, name: string, countryIsoAlpha3?: string | null } | null>, fundTopics: Array<{ __typename?: 'FundTopic', id: string, name: string } | null>, fundStrategies: Array<{ __typename?: 'FundStrategy', id: string, name: string }>, fundTypes: Array<{ __typename?: 'FundType', id: string, name: string } | null> };

export type GetFundSearchResultQueryVariables = Exact<{
  criteria?: InputMaybe<SearchFundCriterion>;
  sort?: InputMaybe<Array<SearchFundSort> | SearchFundSort>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetFundSearchResultQuery = { __typename?: 'Query', searchFund: { __typename?: 'InstrumentConnection', count?: any | null, edges: Array<{ __typename?: 'InstrumentEdge', cursor: string, node: { __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, assetGroup?: AssetGroup | null, seoTag?: string | null, fundTranche?: { __typename?: 'InstrumentGroupFundTranche', main?: boolean | null, savingPlanCapable?: boolean | null, germanVwlCapable?: boolean | null, distributing?: boolean | null, totalExpenseRatio?: number | null, foundationDate?: any | null, currency?: { __typename?: 'Currency', name?: string | null, displayCode?: string | null } | null, investmentVolume?: { __typename?: 'InvestmentVolume', date?: any | null, value?: number | null } | null, srri?: { __typename?: 'FundTrancheSyntheticRiskAndRewardIndicator', value?: number | null } | null } | null, assetType?: { __typename?: 'AssetType', name?: string | null } | null, fund?: { __typename?: 'Fund', id: any, region?: { __typename?: 'FundRegion', name: string } | null, topic?: { __typename?: 'FundTopic', name: string } | null, currency?: { __typename?: 'FundCurrency', name: string } | null, type?: { __typename?: 'FundType', name: string } | null, strategy?: { __typename?: 'FundStrategy', name: string } | null, company?: { __typename?: 'FundCompany', name?: string | null } | null } | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, value?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', performance?: number | null, deltaAveragePrice?: number | null, period: CalculationPeriod }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, deltaHighPrice?: number | null }> } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetFundSearchResultCountQueryVariables = Exact<{
  fundTopicId?: InputMaybe<Scalars['Int']>;
  fundCurrencyId?: InputMaybe<Scalars['Int']>;
  fundRegionId?: InputMaybe<Scalars['Int']>;
  fundCompanyId?: InputMaybe<Scalars['Int']>;
  fundTypeId?: InputMaybe<Scalars['Int']>;
  fundStrategyId?: InputMaybe<Scalars['Int']>;
  keyFigures?: InputMaybe<Array<FundKeyFigureCriteria> | FundKeyFigureCriteria>;
  sort?: InputMaybe<Array<SearchFundSort> | SearchFundSort>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetFundSearchResultCountQuery = { __typename?: 'Query', searchFund: { __typename?: 'InstrumentConnection', count?: any | null } };

export type GetFundTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFundTypesQuery = { __typename?: 'Query', fundTypes: Array<{ __typename?: 'FundType', id: string, name: string } | null> };

export type GetRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionsQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', id: number, name?: string | null, countries: Array<{ __typename?: 'Country', currencyId?: number | null, name: string }> }> };

export type GetSectorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSectorsQuery = { __typename?: 'Query', sectors: Array<{ __typename?: 'Sector', id: number, name?: string | null }> };

export type SearchIndexQueryVariables = Exact<{
  regionId?: InputMaybe<Scalars['Long']>;
  sectorId?: InputMaybe<Scalars['Long']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type SearchIndexQuery = { __typename?: 'Query', searchIndex: { __typename?: 'InstrumentConnection', count?: any | null, edges: Array<{ __typename?: 'InstrumentEdge', cursor: string, node: { __typename?: 'Instrument', id: number, name: string, wkn?: string | null, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, wkn?: string | null, seoTag?: string | null, assetGroup?: AssetGroup | null, refCountry?: { __typename?: 'Country', name: string, isoAlpha3: string } | null, assetType?: { __typename?: 'AssetType', id?: string | null, name?: string | null } | null, main?: { __typename?: 'Instrument', id: number, country?: { __typename?: 'Country', name: string, isoAlpha3: string } | null, chart?: { __typename?: 'Chart', series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null, compositions: Array<{ __typename?: 'InstrumentGroupComposition', id: number, name?: string | null }> }, currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null } | null, quotes: Array<{ __typename?: 'Quote', type?: QuoteType | null, value?: number | null, change?: number | null, percentChange?: number | null } | null> } | null } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetIndexCompositionQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetIndexCompositionQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, wkn?: string | null, seoTag?: string | null, assetGroup?: AssetGroup | null, refCountry?: { __typename?: 'Country', name: string, isoAlpha3: string } | null, assetType?: { __typename?: 'AssetType', id?: string | null, name?: string | null } | null, main?: { __typename?: 'Instrument', id: number, country?: { __typename?: 'Country', name: string, isoAlpha3: string } | null, chart?: { __typename?: 'Chart', series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null, compositions: Array<{ __typename?: 'InstrumentGroupComposition', id: number, name?: string | null }> } | null };

export type GetIndexPageListSectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIndexPageListSectionQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', id: number, name: string, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', type?: QuoteType | null, when?: any | null, delay?: number | null, value?: number | null, percentChange?: number | null, change?: number | null } | null } | null, currency: { __typename?: 'Currency', displayCode?: string | null }, exchange: { __typename?: 'Exchange', code?: string | null }, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } }> | null } | null };

export type GetListInstrumentsChartQueryVariables = Exact<{
  listId: Scalars['String'];
}>;


export type GetListInstrumentsChartQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', name: string, id: number, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null }> | null } | null };

export type GetTopFlopInstrumentsWithAnalysisQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopFlopInstrumentsWithAnalysisQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null, analysisReport?: { __typename?: 'AnalysisReport', positiveCount?: number | null, neutralCount?: number | null, negativeCount?: number | null } | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null } }> | null } | null };

export type GetTopFlopInstrumentsIndexQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopFlopInstrumentsIndexQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } }> | null } | null };

export type UpdateStickyInstrumentSubscriptionVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UpdateStickyInstrumentSubscription = { __typename?: 'Subscription', update: { __typename?: 'SnapQuote', instrumentId: number, lastPrice?: number | null, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, cumulativeTrades?: number | null, cumulativeVolume?: any | null, cumulativeTurnover?: number | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, size?: number | null, when?: any | null } | null> } };

export type GetSingleInstrumentSearchQueryVariables = Exact<{
  assetGroup?: InputMaybe<Array<AssetGroup> | AssetGroup>;
  searchString: Scalars['String'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetSingleInstrumentSearchQuery = { __typename?: 'Query', search: { __typename?: 'InstrumentDetailConnection', edges: Array<{ __typename?: 'InstrumentEdge', cursor: string, node: { __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, wkn?: string | null, assetGroup?: AssetGroup | null } } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } | null } };

export type GetSimpleAssetSelectorDefaultListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSimpleAssetSelectorDefaultListQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, isin?: string | null, wkn?: string | null, seoTag?: string | null, assetGroup?: AssetGroup | null } }> | null } | null };

export type GetNewsSourceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsSourceQuery = { __typename?: 'Query', newsSource?: Array<{ __typename?: 'NewsSource', id?: string | null, name?: string | null, code?: string | null }> | null };

export type GetNewsTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsTopicsQuery = { __typename?: 'Query', newsTopics?: Array<{ __typename?: 'NewsTopic', id?: string | null, name?: string | null }> | null };

export type GetNewsFeedQueryVariables = Exact<{
  criteria?: InputMaybe<NewsCriteria>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetNewsFeedQuery = { __typename?: 'Query', newsSearch: { __typename?: 'NewsConnection', edges: Array<{ __typename?: 'NewsEdge', cursor: string, node: { __typename?: 'News', id: string, when?: any | null, body?: string | null, headline?: string | null, teaser?: string | null, feed?: NewsFeed | null, keywords?: Array<string> | null, source?: { __typename?: 'NewsSource', id?: string | null, name?: string | null } | null, medias?: Array<{ __typename?: 'NewsMedia', source?: string | null, width?: number | null, height?: number | null }> | null, streams?: Array<{ __typename?: 'NewsStream', mimeType?: string | null, duration?: number | null, width?: number | null, height?: number | null, source?: string | null }> | null, links?: Array<{ __typename?: 'NewsLink', name?: string | null, href?: string | null }> | null, instruments?: Array<{ __typename?: 'NewsInstrument', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, assetGroup?: AssetGroup | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, currency: { __typename?: 'Currency', displayCode?: string | null } } | null } | null }> | null } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } };

export type GetNewsMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNewsMetadataQuery = { __typename?: 'Query', newsSource?: Array<{ __typename?: 'NewsSource', id?: string | null, name?: string | null, code?: string | null }> | null, newsTopics?: Array<{ __typename?: 'NewsTopic', id?: string | null, name?: string | null }> | null };

export type GetInstrumentGroupUserLimitsQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetInstrumentGroupUserLimitsQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, assetGroup?: AssetGroup | null, name: string, isin?: string | null, wkn?: string | null, content: Array<{ __typename?: 'Instrument', id: number, main: boolean, isin?: string | null, name: string, countryId: number, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, group: { __typename?: 'InstrumentGroup', id?: number | null, seoTag?: string | null, assetGroup?: AssetGroup | null, sector?: { __typename?: 'Sector', name?: string | null } | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, size?: number | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, highPrice?: number | null }> }> } | null };

export type GetInstrumentUserLimitsQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
}>;


export type GetInstrumentUserLimitsQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, name: string, isin?: string | null, wkn?: string | null, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, displayCode?: string | null, alphaCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null, when?: any | null } | null } | null, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, assetGroup?: AssetGroup | null, seoTag?: string | null } } | null };

export type EditLimitOrderMutationVariables = Exact<{
  viewOrder: Scalars['String'];
  viewOrderAsc?: InputMaybe<Scalars['Boolean']>;
}>;


export type EditLimitOrderMutation = { __typename?: 'Mutation', editLimitOrder: { __typename?: 'DefaultServiceResponse', responseCode: number, responseMessage: string } };

export type EditLimitViewMutationVariables = Exact<{
  viewType: Scalars['String'];
}>;


export type EditLimitViewMutation = { __typename?: 'Mutation', editLimitView: { __typename?: 'DefaultServiceResponse', responseCode: number, responseMessage: string } };

export type GetProfileInstrumentChartQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  chartScope: ChartScope;
}>;


export type GetProfileInstrumentChartQuery = { __typename?: 'Query', instrument?: { __typename?: 'Instrument', id: number, chart?: { __typename?: 'Chart', id: string, series: Array<{ __typename?: 'ChartSeries', label: string, type: QuoteType, data: Array<{ __typename?: 'ChartPoint', value: number, when?: any | null }> }>, threshold?: { __typename?: 'ChartThreshold', type: ChartThresholdType, value?: number | null } | null } | null } | null };

export type GetDailyAnalysisCountQueryVariables = Exact<{
  isins: Array<Scalars['String']> | Scalars['String'];
  startDate: Scalars['LocalDate'];
  endDate?: InputMaybe<Scalars['LocalDate']>;
}>;


export type GetDailyAnalysisCountQuery = { __typename?: 'Query', analysesIsinCount: Array<{ __typename?: 'NewsIsinCountEdge', newsCount?: number | null, isin?: string | null, date?: any | null }> };

export type GetDailyNewsSummaryQueryVariables = Exact<{
  isins: Array<Scalars['String']> | Scalars['String'];
  date: Scalars['LocalDate'];
}>;


export type GetDailyNewsSummaryQuery = { __typename?: 'Query', newsDailyCount: Array<{ __typename?: 'NewsDailyCountEdge', count?: number | null, isin?: string | null, date?: any | null }> };

export type GetDailyNewsCountQueryVariables = Exact<{
  isins: Array<Scalars['String']> | Scalars['String'];
  startDate: Scalars['LocalDate'];
  endDate?: InputMaybe<Scalars['LocalDate']>;
}>;


export type GetDailyNewsCountQuery = { __typename?: 'Query', newsDailyCount: Array<{ __typename?: 'NewsDailyCountEdge', count?: number | null, isin?: string | null, date?: any | null }> };

export type GetBrokersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBrokersQuery = { __typename?: 'Query', brokers: Array<{ __typename?: 'Broker', id: any, name: string }> };

export type GetUserWatchlistsAddQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserWatchlistsAddQuery = { __typename?: 'Query', user?: { __typename?: 'User', username?: string | null, profile?: { __typename?: 'UserProfile', watchlists?: Array<{ __typename?: 'Watchlist', id: number, name?: string | null }> | null } | null } | null };

export type GetNewsCountQueryVariables = Exact<{
  isins: Array<Scalars['String']> | Scalars['String'];
  intervalStart?: InputMaybe<Scalars['OffsetDateTime']>;
  intervalEnd?: InputMaybe<Scalars['OffsetDateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetNewsCountQuery = { __typename?: 'Query', newsSearch: { __typename?: 'NewsConnection', edges: Array<{ __typename?: 'NewsEdge', node: { __typename?: 'News', id: string } }> } };

export type GetNewsInfoQueryVariables = Exact<{
  isins: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetNewsInfoQuery = { __typename?: 'Query', newsSearch: { __typename?: 'NewsConnection', edges: Array<{ __typename?: 'NewsEdge', node: { __typename?: 'News', id: string, when?: any | null } }> } };

export type GetNewsModalQueryVariables = Exact<{
  isins: Array<Scalars['String']> | Scalars['String'];
  intervalStart?: InputMaybe<Scalars['OffsetDateTime']>;
  intervalEnd?: InputMaybe<Scalars['OffsetDateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetNewsModalQuery = { __typename?: 'Query', newsSearch: { __typename?: 'NewsConnection', edges: Array<{ __typename?: 'NewsEdge', cursor: string, node: { __typename?: 'News', id: string, when?: any | null, body?: string | null, headline?: string | null, teaser?: string | null, feed?: NewsFeed | null, keywords?: Array<string> | null, links?: Array<{ __typename?: 'NewsLink', name?: string | null, href?: string | null }> | null, source?: { __typename?: 'NewsSource', id?: string | null, name?: string | null } | null, medias?: Array<{ __typename?: 'NewsMedia', source?: string | null, width?: number | null, height?: number | null }> | null, streams?: Array<{ __typename?: 'NewsStream', mimeType?: string | null, duration?: number | null, width?: number | null, height?: number | null, source?: string | null }> | null, instruments?: Array<{ __typename?: 'NewsInstrument', group?: { __typename?: 'InstrumentGroup', id?: number | null, isin?: string | null, name: string, assetGroup?: AssetGroup | null, seoTag?: string | null, main?: { __typename?: 'Instrument', id: number, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, currency: { __typename?: 'Currency', displayCode?: string | null } } | null } | null }> | null } }>, pageInfo?: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } | null } };

export type ChangeEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ChangeEmailMutation = { __typename?: 'Mutation', requestChangeProfileEmail: { __typename?: 'DefaultServiceResponse', responseCode: number, responseMessage: string } };

export type ChangePasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type ChangePasswordMutation = { __typename?: 'Mutation', requestChangeProfilePassword: { __typename?: 'DefaultServiceResponse', responseCode: number, responseMessage: string } };

export type DeleteProfileMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteProfileMutation = { __typename?: 'Mutation', deleteProfile: { __typename?: 'DefaultServiceResponse', responseCode: number, responseMessage: string } };

export type AddAccountEntryMutationVariables = Exact<{
  portfolioId: Scalars['Long'];
  entry: AccountEntryInput;
}>;


export type AddAccountEntryMutation = { __typename?: 'Mutation', addAccountEntry: { __typename?: 'AccountEntry', id: number, accountTypeId?: any | null, accountTypeDescriptionEn?: string | null, instrumentId?: number | null, portfolioEntryId?: number | null, amount: number, quantity?: number | null, memo?: string | null, securityDescription?: string | null, entryTime: any, instrument?: { __typename?: 'Instrument', id: number, name: string } | null } };

export type EditAccountEntryMutationVariables = Exact<{
  portfolioId: Scalars['Long'];
  accountEntryId: Scalars['Long'];
  entry: AccountEntryInput;
}>;


export type EditAccountEntryMutation = { __typename?: 'Mutation', editAccountEntry: { __typename?: 'AccountEntry', id: number, accountTypeId?: any | null, accountTypeDescriptionEn?: string | null, instrumentId?: number | null, portfolioEntryId?: number | null, amount: number, quantity?: number | null, memo?: string | null, securityDescription?: string | null, entryTime: any, instrument?: { __typename?: 'Instrument', id: number, name: string } | null } };

export type GetOperationTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOperationTypesQuery = { __typename?: 'Query', accountOperationTypes: Array<{ __typename?: 'AccountOperationType', id: any, name: string }> };

export type EditPortfolioOverviewOrderMutationVariables = Exact<{
  viewOrder: Scalars['String'];
  viewOrderAsc?: InputMaybe<Scalars['Boolean']>;
}>;


export type EditPortfolioOverviewOrderMutation = { __typename?: 'Mutation', editPortfolioOverviewOrder: { __typename?: 'DefaultServiceResponse', responseCode: number, responseMessage: string } };

export type EditWatchlistOverviewOrderMutationVariables = Exact<{
  viewOrder: Scalars['String'];
  viewOrderAsc?: InputMaybe<Scalars['Boolean']>;
}>;


export type EditWatchlistOverviewOrderMutation = { __typename?: 'Mutation', editWatchlistOverviewOrder: { __typename?: 'DefaultServiceResponse', responseCode: number, responseMessage: string } };

export type UpdatePortfolioMasterMutationVariables = Exact<{
  changes: Array<FieldChangeBooleanRequest> | FieldChangeBooleanRequest;
}>;


export type UpdatePortfolioMasterMutation = { __typename?: 'Mutation', updatePortfolioMaster?: Array<{ __typename?: 'FieldChangeBooleanResponse', id: any, value: boolean }> | null };

export type UpdateWatchlistMasterMutationVariables = Exact<{
  changes: Array<FieldChangeBooleanRequest> | FieldChangeBooleanRequest;
}>;


export type UpdateWatchlistMasterMutation = { __typename?: 'Mutation', updateWatchlistMaster?: Array<{ __typename?: 'FieldChangeBooleanResponse', id: any, value: boolean }> | null };

export type GetInstrumentHistoryQuotesQueryVariables = Exact<{
  instrumentId: Scalars['Int'];
  criteria: HistoryQuoteCriteria;
}>;


export type GetInstrumentHistoryQuotesQuery = { __typename?: 'Query', instrument?: { __typename: 'Instrument', id: number, name: string, group: { __typename: 'InstrumentGroup', id?: number | null, name: string }, historyQuote: { __typename: 'HistoryQuoteConnection', edges: Array<{ __typename: 'HistoryQuoteEdge', node?: { __typename: 'HistoryQuote', start?: any | null, id?: string | null, lastPrice?: number | null } | null }> } } | null };

export type GetTopFlopInstrumentsListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopFlopInstrumentsListQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } }> | null } | null };

export type EditPortfolioOrderMutationVariables = Exact<{
  viewOrder: Scalars['String'];
  viewOrderAsc?: InputMaybe<Scalars['Boolean']>;
  portfolioId?: InputMaybe<Scalars['Long']>;
}>;


export type EditPortfolioOrderMutation = { __typename?: 'Mutation', editPortfolioOrder: { __typename?: 'DefaultServiceResponse', responseCode: number, responseMessage: string } };

export type EditPortfolioViewMutationVariables = Exact<{
  viewType: Scalars['String'];
  portfolioId?: InputMaybe<Scalars['Long']>;
}>;


export type EditPortfolioViewMutation = { __typename?: 'Mutation', editPortfolioView: { __typename?: 'DefaultServiceResponse', responseCode: number, responseMessage: string } };

export type EditWatchlistOrderMutationVariables = Exact<{
  viewOrder: Scalars['String'];
  viewOrderAsc?: InputMaybe<Scalars['Boolean']>;
  watchlistId?: InputMaybe<Scalars['Long']>;
}>;


export type EditWatchlistOrderMutation = { __typename?: 'Mutation', editWatchlistOrder: { __typename?: 'DefaultServiceResponse', responseCode: number, responseMessage: string } };

export type EditWatchlistViewMutationVariables = Exact<{
  viewType: Scalars['String'];
  watchlistId?: InputMaybe<Scalars['Long']>;
}>;


export type EditWatchlistViewMutation = { __typename?: 'Mutation', editWatchlistView: { __typename?: 'DefaultServiceResponse', responseCode: number, responseMessage: string } };

export type GetInstrumentsCountQueryVariables = Exact<{
  searchString: Scalars['String'];
}>;


export type GetInstrumentsCountQuery = { __typename?: 'Query', search: { __typename?: 'InstrumentDetailConnection', assetGroups: Array<{ __typename?: 'AssetGroupBucket', assetGroup: AssetGroup, count: number }> } };

export type GetInstrumentsSearchQueryVariables = Exact<{
  assetGroup?: InputMaybe<Array<AssetGroup> | AssetGroup>;
  searchString: Scalars['String'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetInstrumentsSearchQuery = { __typename?: 'Query', search: { __typename?: 'InstrumentDetailConnection', edges: Array<{ __typename?: 'InstrumentEdge', cursor: string, node: { __typename?: 'Instrument', id: number, name: string, wkn?: string | null, group: { __typename?: 'InstrumentGroup', name: string, assetGroup?: AssetGroup | null, seoTag?: string | null } } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } | null, assetGroups: Array<{ __typename?: 'AssetGroupBucket', assetGroup: AssetGroup, count: number }> } };

export type GetTopFlopInstrumentsWithAnalysisReportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopFlopInstrumentsWithAnalysisReportQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null, analysisReport?: { __typename?: 'AnalysisReport', positiveCount?: number | null, neutralCount?: number | null, negativeCount?: number | null } | null } }> | null } | null };

export type GetAnalysesShareOverviewQueryVariables = Exact<{
  instrumentGroupId: Scalars['Int'];
  from?: InputMaybe<Scalars['LocalDate']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetAnalysesShareOverviewQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, analysis: { __typename: 'AnalysisConnection', edges: Array<{ __typename: 'AnalysisEdge', cursor: string, node: { __typename: 'Analysis', id: string, date: any, timeFrame?: number | null, recommendation?: AnalysisRecommendation | null, targetPrice?: number | null, referencePrice?: number | null, updated?: boolean | null, latest?: boolean | null, headline?: string | null, body?: string | null, currency?: { __typename: 'Currency', displayCode?: string | null } | null, institute?: { __typename: 'AnalystInstitute', id?: string | null, name: string } | null, analyst?: { __typename: 'Analyst', firstName?: string | null, lastName?: string | null } | null, group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null, main?: { __typename?: 'Instrument', id: number, currency: { __typename?: 'Currency', displayCode?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, quote?: { __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null } | null } | null } | null } | null } }>, pageInfo?: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } | null } } | null };

export type TheScreenerRatingSearchUpdateQueryVariables = Exact<{
  first: Scalars['Int'];
  change?: InputMaybe<TheScreenerRatingChange>;
  instrumentGroupId?: InputMaybe<Scalars['Int']>;
}>;


export type TheScreenerRatingSearchUpdateQuery = { __typename?: 'Query', theScreenerRatingSearch: Array<{ __typename?: 'TheScreenerRating', isin: string, previousRating?: number | null, rating?: number | null, date?: any | null, group: { __typename?: 'InstrumentGroup', name: string, isin?: string | null, seoTag?: string | null, assetGroup?: AssetGroup | null } }> };

export type GetTopFlopInstrumentsCustomQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTopFlopInstrumentsCustomQuery = { __typename?: 'Query', list?: { __typename?: 'List', id: string, content?: Array<{ __typename?: 'Instrument', id: number, name: string, group: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null, analysisReport?: { __typename?: 'AnalysisReport', positiveCount?: number | null, neutralCount?: number | null, negativeCount?: number | null } | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null } }> | null } | null };

export type GetShareOverviewQueryVariables = Exact<{
  groupId: Scalars['Int'];
}>;


export type GetShareOverviewQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, assetGroup?: AssetGroup | null, isin?: string | null, description?: { __typename?: 'InstrumentGroupDescription', text?: string | null } | null, content: Array<{ __typename?: 'Instrument', id: number, isin?: string | null, wkn?: string | null, main: boolean, tickerSymbol?: string | null, name: string, countryId: number, group: { __typename?: 'InstrumentGroup', assetGroup?: AssetGroup | null, seoTag?: string | null }, exchange: { __typename?: 'Exchange', id: number, name?: string | null, code?: string | null }, currency: { __typename?: 'Currency', id?: number | null, name?: string | null, displayCode?: string | null, sign?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, instrumentId: number, lowPrice?: number | null, highPrice?: number | null, firstPrice?: number | null, lastPrice?: number | null, yesterdayPrice?: number | null, cumulativeTrades?: number | null, cumulativeTurnover?: number | null, cumulativeVolume?: any | null, quotes: Array<{ __typename?: 'Quote', delay?: number | null, type?: QuoteType | null, value?: number | null, percentChange?: number | null, change?: number | null, when?: any | null } | null> } | null, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, averagePrice?: number | null, performance?: number | null, sharpe?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, lowPriceDate?: any | null, deltaLowPrice?: number | null, highPrice?: number | null, highPriceDate?: any | null, deltaHighPrice?: number | null }>, rangeCharts?: { __typename?: 'InstrumentRangeCharts', intraday?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null, year?: { __typename?: 'RangeChart', min?: number | null, max?: number | null, current?: number | null, threshold?: number | null } | null } | null }> } | null };

export type GetSearchShareCountQueryVariables = Exact<{
  criterion?: InputMaybe<SearchShareCriterion>;
}>;


export type GetSearchShareCountQuery = { __typename?: 'Query', searchShare: { __typename?: 'InstrumentConnection', count?: any | null } };

export type GetShareRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShareRegionsQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', id: number, name?: string | null }> };

export type GetShareSeachMetaDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShareSeachMetaDataQuery = { __typename?: 'Query', classification: Array<{ __typename?: 'AssetClass', id: number, name: string, typeGroups: Array<{ __typename?: 'AssetTypeGroup', id?: string | null, name?: string | null }> }> };

export type GetShareSearchResultQueryVariables = Exact<{
  criterion?: InputMaybe<SearchShareCriterion>;
  sort?: InputMaybe<Array<SearchShareSort> | SearchShareSort>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
}>;


export type GetShareSearchResultQuery = { __typename?: 'Query', searchShare: { __typename?: 'InstrumentConnection', count?: any | null, edges: Array<{ __typename?: 'InstrumentEdge', cursor: string, node: { __typename?: 'Instrument', id: number, name: string, wkn?: string | null, isin?: string | null, currency: { __typename?: 'Currency', displayCode?: string | null }, exchange: { __typename?: 'Exchange', name?: string | null }, snapQuote?: { __typename?: 'SnapQuote', lastChange?: any | null, lastPrice?: number | null, instrumentId: number, quote?: { __typename?: 'Quote', value?: number | null, change?: number | null, percentChange?: number | null } | null } | null, group: { __typename?: 'InstrumentGroup', id?: number | null, seoTag?: string | null, assetGroup?: AssetGroup | null, sector?: { __typename?: 'Sector', id: number, name?: string | null } | null, refCountry?: { __typename?: 'Country', id: number, name: string } | null, refMarketCapitalization?: { __typename?: 'InstrumentGroupMarketCapitalization', value: number, currency?: { __typename?: 'Currency', displayCode?: string | null } | null } | null, company?: { __typename?: 'Company', id: number, name?: string | null, currency?: { __typename?: 'Currency', displayCode?: string | null } | null, performance?: { __typename?: 'CompanyPerformance', keyFigures?: { __typename?: 'FundamentalKeyFigures', sales?: number | null, operatingCashFlow?: number | null, salesPerShare?: number | null, netIncome?: number | null, dividendPerShare?: number | null, dividendYield?: number | null, salesPerEmployee?: number | null, dividendPayoutRatio?: number | null } | null, items: Array<{ __typename?: 'CompanyPerformanceEntry', year?: number | null, yearPeriod?: number | null, cashFlowChange?: number | null, salesChange?: number | null, netIncomeChange?: number | null, salesYearChange?: number | null, cashFlowChangePercent?: number | null, salesChangePercent?: number | null, netIncomeChangePercent?: number | null, dividendYieldAverage?: number | null, dividendChangePercent?: number | null, salesPerEmployeeChangePercent?: number | null }> } | null } | null }, performance: Array<{ __typename?: 'InstrumentPerformance', period: CalculationPeriod, performance?: number | null, vola?: number | null }>, stats: Array<{ __typename?: 'InstrumentStatistics', period: CalculationPeriod, lowPrice?: number | null, highPrice?: number | null, lowPriceDate?: any | null, highPriceDate?: any | null }> } }>, pageInfo?: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } | null } };

export type GetHomeCalendarEventsQueryVariables = Exact<{
  from: Scalars['LocalDate'];
  count: Scalars['Int'];
}>;


export type GetHomeCalendarEventsQuery = { __typename?: 'Query', economicEvents: { __typename?: 'CalendarEventConnection', edges: Array<{ __typename?: 'CalendarEventEdge', node: { __typename?: 'CalendarEvent', id?: string | null, title?: string | null, eventType?: EventType | null, when?: any | null, country?: { __typename?: 'CalendarCountry', country?: { __typename?: 'Country', isoAlpha2: string, isoAlpha3: string } | null } | null, products?: Array<{ __typename?: 'CalendarProduct', group?: { __typename?: 'InstrumentGroup', name: string, assetGroup?: AssetGroup | null, seoTag?: string | null } | null } | null> | null } }> }, companyEvents: { __typename?: 'CalendarEventConnection', edges: Array<{ __typename?: 'CalendarEventEdge', node: { __typename?: 'CalendarEvent', id?: string | null, title?: string | null, eventType?: EventType | null, when?: any | null, country?: { __typename?: 'CalendarCountry', country?: { __typename?: 'Country', isoAlpha2: string, isoAlpha3: string } | null } | null, products?: Array<{ __typename?: 'CalendarProduct', group?: { __typename?: 'InstrumentGroup', name: string, assetGroup?: AssetGroup | null, seoTag?: string | null } | null } | null> | null } }> } };

export type GetProductCalendarEventsQueryVariables = Exact<{
  groupId: Scalars['Int'];
  from: Scalars['LocalDate'];
  count: Scalars['Int'];
}>;


export type GetProductCalendarEventsQuery = { __typename?: 'Query', group?: { __typename?: 'InstrumentGroup', calendarEvents: { __typename?: 'InstrumentGroupSearchCalendarEventConnection', edges: Array<{ __typename?: 'CalendarEventEdge', node: { __typename?: 'CalendarEvent', title?: string | null, when?: any | null } }> } } | null };

export type CalendarCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendarCategoriesQuery = { __typename?: 'Query', calendarCategories: Array<{ __typename?: 'CalendarCategory', id?: string | null, name?: string | null } | null> };

export type CalendarCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendarCountriesQuery = { __typename?: 'Query', calendarCountries: Array<{ __typename?: 'CalendarCountry', id?: string | null, name?: string | null } | null> };

export type CalendarEventSummaryQueryVariables = Exact<{
  from?: InputMaybe<Scalars['LocalDate']>;
  to?: InputMaybe<Scalars['LocalDate']>;
}>;


export type CalendarEventSummaryQuery = { __typename?: 'Query', calendarEventSummary: Array<{ __typename?: 'CalendarSummary', date?: any | null, count?: number | null }> };

export type SearchCalendarEventsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['ID']>;
  from?: InputMaybe<Scalars['LocalDate']>;
  to?: InputMaybe<Scalars['LocalDate']>;
  countryId?: InputMaybe<Scalars['ID']>;
  categoryId?: InputMaybe<Scalars['ID']>;
  relevance?: InputMaybe<Array<EventRelevance> | EventRelevance>;
}>;


export type SearchCalendarEventsQuery = { __typename?: 'Query', searchCalendarEvents: { __typename?: 'CalendarEventConnection', count?: any | null, edges: Array<{ __typename: 'CalendarEventEdge', cursor: string, node: { __typename: 'CalendarEvent', id?: string | null, title?: string | null, description?: string | null, relevance?: EventRelevance | null, eventType?: EventType | null, consensus?: number | null, relevantTime?: any | null, actual?: number | null, revised?: number | null, previous?: number | null, when?: any | null, country?: { __typename?: 'CalendarCountry', id?: string | null, name?: string | null } | null, currency?: { __typename?: 'CalendarCurrency', id?: string | null, name?: string | null, currency?: { __typename?: 'Currency', sign?: string | null, displayCode?: string | null } | null } | null, category?: { __typename?: 'CalendarCategory', id?: string | null, name?: string | null } | null, products?: Array<{ __typename?: 'CalendarProduct', group?: { __typename?: 'InstrumentGroup', id?: number | null, name: string, seoTag?: string | null, assetGroup?: AssetGroup | null } | null } | null> | null } }>, pageInfo?: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean } | null } };


export const GetCertInfoDocument = gql`
    query getCertInfo($groupId: Int!) {
  group(id: $groupId) {
    id
    name
    assetGroup
    assetClass {
      id
      name
    }
    issuer {
      id
      name
    }
    interestRateInformation {
      interestRate
      finalPaymentDate
      lastPaymentDate
      nextPaymentDate
    }
    derivative {
      optionType
      maturityDate
      securedInstrument
      nominalAmount
      managementFee
    }
    main {
      currency {
        displayCode
      }
      derivativeKeyFigures {
        gearing
        premium
        premiumAbsolute
        premiumAnnual
        implicitVolatility
        breakEven
        moneyness
        intrinsicValue
        timeValuePremium
        spread
        spreadHomogenous
        spreadRelative
        deltaStopLoss
        deltaStopLossAbsolute
        agio
        agioAnnual
        omega
        delta
        gamma
        theta
        rho
        vega
        discountAbsolute
        discountPercent
        sidewaysReturn
        sidewaysReturnAbsolute
        sidewaysAnnualReturn
        outperformanceLevel
        maxAnnualReturn
        maxReturn
        maxReturnAbsolute
        maxRedemptionPrice
        deltaCap
        deltaCapAbsolute
        fairValue
        bonusAnnualReturn
        bonusBuffer
        bonusBufferAbsolute
        bonusReturn
        bonusReturnAbsolute
        deltaBonusLevel
        deltaBonusLevelAbsolute
        deltaStrike
        deltaStrikeAbsolute
        deltaSecurityLevel
        dirtyPrice
        parity
        ismaYield
        accruedInterest
        duration
        modifiedDuration
        update {
          when
          type
          value
          underlyingValue
        }
      }
      snapQuote {
        delay
        lastChange
        instrumentId
        lastPrice
        quotes {
          value
          type
        }
      }
    }
    assetType {
      name
      id
    }
    isin
    wkn
    description {
      text
    }
    underlyings {
      groupId
      referencePrice
      multiplier
      quantity
      percentage
      leverageFactor
      bonusBarrier
      cap
      capitalGuarantee
      conditionalCouponTriggerLevel
      conditionalCouponTriggerLevelLower
      conditionalCouponTriggerLevelUpper
      knockIn
      knockInLower
      knockInUpper
      knockOut
      knockOutLower
      knockOutUpper
      lockIn
      participation
      redemption
      reverseLevel
      security
      start
      strike
      securityBarrierObservationStartAt
      securityBarrierObservationEndAt
      securityBarrierTriggeredAt
      instrument {
        currency {
          displayCode
        }
        snapQuote {
          lastChange
          instrumentId
          quotes {
            type
            value
          }
        }
      }
    }
    content {
      id
      isin
      wkn
      main
      tickerSymbol
      name
      group {
        assetGroup
        seoTag
      }
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          size
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        basePrice
        performance
        sharpe
        vola
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
    }
  }
}
    `;

/**
 * __useGetCertInfoQuery__
 *
 * To run a query within a React component, call `useGetCertInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetCertInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCertInfoQuery, GetCertInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCertInfoQuery, GetCertInfoQueryVariables>(GetCertInfoDocument, options);
      }
export function useGetCertInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCertInfoQuery, GetCertInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCertInfoQuery, GetCertInfoQueryVariables>(GetCertInfoDocument, options);
        }
export type GetCertInfoQueryHookResult = ReturnType<typeof useGetCertInfoQuery>;
export type GetCertInfoLazyQueryHookResult = ReturnType<typeof useGetCertInfoLazyQuery>;
export type GetCertInfoQueryResult = Apollo.QueryResult<GetCertInfoQuery, GetCertInfoQueryVariables>;
export const GetCommodityInfoDocument = gql`
    query getCommodityInfo($groupId: Int!) {
  group(id: $groupId) {
    id
    isin
    wkn
    name
    assetGroup
    underlying
    description {
      natural
      text
    }
    main {
      id
      currency {
        displayCode
      }
    }
    content {
      id
      isin
      wkn
      main
      tickerSymbol
      name
      marketCapitalization
      group {
        assetGroup
        seoTag
        id
        isin
        name
        underlying
        wkn
        sector {
          name
        }
      }
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        delay
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          size
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        basePrice
        performance
        sharpe
        vola
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      indicators {
        relativeStrengthLevy {
          deltaMedian
          indicator
        }
        movingAverage {
          deltaLine200Day
          deltaLine38Day
        }
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
    }
  }
}
    `;

/**
 * __useGetCommodityInfoQuery__
 *
 * To run a query within a React component, call `useGetCommodityInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommodityInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommodityInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetCommodityInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCommodityInfoQuery, GetCommodityInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommodityInfoQuery, GetCommodityInfoQueryVariables>(GetCommodityInfoDocument, options);
      }
export function useGetCommodityInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommodityInfoQuery, GetCommodityInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommodityInfoQuery, GetCommodityInfoQueryVariables>(GetCommodityInfoDocument, options);
        }
export type GetCommodityInfoQueryHookResult = ReturnType<typeof useGetCommodityInfoQuery>;
export type GetCommodityInfoLazyQueryHookResult = ReturnType<typeof useGetCommodityInfoLazyQuery>;
export type GetCommodityInfoQueryResult = Apollo.QueryResult<GetCommodityInfoQuery, GetCommodityInfoQueryVariables>;
export const GetCurrencyInfoDocument = gql`
    query getCurrencyInfo($groupId: Int!) {
  group(id: $groupId) {
    id
    isin
    name
    wkn
    assetGroup
    underlying
    description {
      natural
      text
    }
    main {
      id
      currency {
        displayCode
      }
    }
    content {
      id
      isin
      wkn
      main
      tickerSymbol
      name
      seoTag
      marketCapitalization
      group {
        assetGroup
        seoTag
        id
        isin
        name
        underlying
        wkn
        sector {
          name
        }
      }
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        delay
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          size
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        basePrice
        performance
        sharpe
        vola
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      indicators {
        relativeStrengthLevy {
          deltaMedian
          indicator
        }
        movingAverage {
          deltaLine200Day
          deltaLine38Day
        }
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrencyInfoQuery__
 *
 * To run a query within a React component, call `useGetCurrencyInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetCurrencyInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCurrencyInfoQuery, GetCurrencyInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyInfoQuery, GetCurrencyInfoQueryVariables>(GetCurrencyInfoDocument, options);
      }
export function useGetCurrencyInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyInfoQuery, GetCurrencyInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyInfoQuery, GetCurrencyInfoQueryVariables>(GetCurrencyInfoDocument, options);
        }
export type GetCurrencyInfoQueryHookResult = ReturnType<typeof useGetCurrencyInfoQuery>;
export type GetCurrencyInfoLazyQueryHookResult = ReturnType<typeof useGetCurrencyInfoLazyQuery>;
export type GetCurrencyInfoQueryResult = Apollo.QueryResult<GetCurrencyInfoQuery, GetCurrencyInfoQueryVariables>;
export const GetAlternativeDerivativeProductsDocument = gql`
    query getAlternativeDerivativeProducts($underlyingInstrumentGroupId: Int!, $issuerId: Long!) {
  group(id: $underlyingInstrumentGroupId) {
    id
    alternativeDerivativeProducts(criteria: {issuerId: $issuerId}) {
      optionType
      assetClass {
        id
        name
        investmentRiskLevel {
          level
          name
        }
      }
      count
    }
  }
}
    `;

/**
 * __useGetAlternativeDerivativeProductsQuery__
 *
 * To run a query within a React component, call `useGetAlternativeDerivativeProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlternativeDerivativeProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlternativeDerivativeProductsQuery({
 *   variables: {
 *      underlyingInstrumentGroupId: // value for 'underlyingInstrumentGroupId'
 *      issuerId: // value for 'issuerId'
 *   },
 * });
 */
export function useGetAlternativeDerivativeProductsQuery(baseOptions: Apollo.QueryHookOptions<GetAlternativeDerivativeProductsQuery, GetAlternativeDerivativeProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlternativeDerivativeProductsQuery, GetAlternativeDerivativeProductsQueryVariables>(GetAlternativeDerivativeProductsDocument, options);
      }
export function useGetAlternativeDerivativeProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlternativeDerivativeProductsQuery, GetAlternativeDerivativeProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlternativeDerivativeProductsQuery, GetAlternativeDerivativeProductsQueryVariables>(GetAlternativeDerivativeProductsDocument, options);
        }
export type GetAlternativeDerivativeProductsQueryHookResult = ReturnType<typeof useGetAlternativeDerivativeProductsQuery>;
export type GetAlternativeDerivativeProductsLazyQueryHookResult = ReturnType<typeof useGetAlternativeDerivativeProductsLazyQuery>;
export type GetAlternativeDerivativeProductsQueryResult = Apollo.QueryResult<GetAlternativeDerivativeProductsQuery, GetAlternativeDerivativeProductsQueryVariables>;
export const GetAlternativeIssuerProductsDocument = gql`
    query getAlternativeIssuerProducts($underlyingInstrumentGroupId: Int!, $assetType: String!, $optionType: DerivativeOptionType) {
  group(id: $underlyingInstrumentGroupId) {
    id
    derivativeIssuer(criteria: {assetType: $assetType, optionType: $optionType}) {
      issuer {
        id
        name
      }
      count
    }
  }
}
    `;

/**
 * __useGetAlternativeIssuerProductsQuery__
 *
 * To run a query within a React component, call `useGetAlternativeIssuerProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlternativeIssuerProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlternativeIssuerProductsQuery({
 *   variables: {
 *      underlyingInstrumentGroupId: // value for 'underlyingInstrumentGroupId'
 *      assetType: // value for 'assetType'
 *      optionType: // value for 'optionType'
 *   },
 * });
 */
export function useGetAlternativeIssuerProductsQuery(baseOptions: Apollo.QueryHookOptions<GetAlternativeIssuerProductsQuery, GetAlternativeIssuerProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAlternativeIssuerProductsQuery, GetAlternativeIssuerProductsQueryVariables>(GetAlternativeIssuerProductsDocument, options);
      }
export function useGetAlternativeIssuerProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAlternativeIssuerProductsQuery, GetAlternativeIssuerProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAlternativeIssuerProductsQuery, GetAlternativeIssuerProductsQueryVariables>(GetAlternativeIssuerProductsDocument, options);
        }
export type GetAlternativeIssuerProductsQueryHookResult = ReturnType<typeof useGetAlternativeIssuerProductsQuery>;
export type GetAlternativeIssuerProductsLazyQueryHookResult = ReturnType<typeof useGetAlternativeIssuerProductsLazyQuery>;
export type GetAlternativeIssuerProductsQueryResult = Apollo.QueryResult<GetAlternativeIssuerProductsQuery, GetAlternativeIssuerProductsQueryVariables>;
export const GetInstrumentChartDocument = gql`
    query getInstrumentChart($instrumentId: Int!, $chartScope: ChartScope!) {
  instrument(id: $instrumentId) {
    id
    chart(scope: $chartScope) {
      id
      series {
        label
        type
        data {
          value
          when
        }
      }
      threshold {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentChartQuery__
 *
 * To run a query within a React component, call `useGetInstrumentChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentChartQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      chartScope: // value for 'chartScope'
 *   },
 * });
 */
export function useGetInstrumentChartQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentChartQuery, GetInstrumentChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentChartQuery, GetInstrumentChartQueryVariables>(GetInstrumentChartDocument, options);
      }
export function useGetInstrumentChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentChartQuery, GetInstrumentChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentChartQuery, GetInstrumentChartQueryVariables>(GetInstrumentChartDocument, options);
        }
export type GetInstrumentChartQueryHookResult = ReturnType<typeof useGetInstrumentChartQuery>;
export type GetInstrumentChartLazyQueryHookResult = ReturnType<typeof useGetInstrumentChartLazyQuery>;
export type GetInstrumentChartQueryResult = Apollo.QueryResult<GetInstrumentChartQuery, GetInstrumentChartQueryVariables>;
export const GetDerivativePerformanceCompareDocument = gql`
    query getDerivativePerformanceCompare($groupId: Int!) {
  group(id: $groupId) {
    id
    wkn
    assetGroup
    main {
      performance(period: [WEEK1, MONTH1, MONTH6, CURRENT_YEAR, WEEK52, YEAR3]) {
        period
        performance
      }
    }
    underlyings {
      isin
      group {
        wkn
      }
      instrument {
        id
        performance(period: [WEEK1, MONTH1, MONTH6, CURRENT_YEAR, WEEK52, YEAR3]) {
          period
          performance
        }
      }
    }
  }
}
    `;

/**
 * __useGetDerivativePerformanceCompareQuery__
 *
 * To run a query within a React component, call `useGetDerivativePerformanceCompareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDerivativePerformanceCompareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDerivativePerformanceCompareQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetDerivativePerformanceCompareQuery(baseOptions: Apollo.QueryHookOptions<GetDerivativePerformanceCompareQuery, GetDerivativePerformanceCompareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDerivativePerformanceCompareQuery, GetDerivativePerformanceCompareQueryVariables>(GetDerivativePerformanceCompareDocument, options);
      }
export function useGetDerivativePerformanceCompareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDerivativePerformanceCompareQuery, GetDerivativePerformanceCompareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDerivativePerformanceCompareQuery, GetDerivativePerformanceCompareQueryVariables>(GetDerivativePerformanceCompareDocument, options);
        }
export type GetDerivativePerformanceCompareQueryHookResult = ReturnType<typeof useGetDerivativePerformanceCompareQuery>;
export type GetDerivativePerformanceCompareLazyQueryHookResult = ReturnType<typeof useGetDerivativePerformanceCompareLazyQuery>;
export type GetDerivativePerformanceCompareQueryResult = Apollo.QueryResult<GetDerivativePerformanceCompareQuery, GetDerivativePerformanceCompareQueryVariables>;
export const GetDerivativeUnderlyingProductsDocument = gql`
    query getDerivativeUnderlyingProducts($groupId: Int!) {
  group(id: $groupId) {
    id
    underlyings {
      currency {
        alphaCode
        sign
        name
        displayCode
      }
      exchange {
        code
        delay
        id
        name
        openingTime
        closingTime
      }
      group {
        assetGroup
        id
        name
        underlying
        seoTag
        isin
        wkn
      }
      id
      isin
      name
      instrument {
        exchange {
          name
          id
        }
        snapQuote {
          instrumentId
          delay
          quote(type: TRADE) {
            delay
            value
            change
            percentChange
            when
          }
          quotes {
            type
            change
            percentChange
            value
            when
          }
          highPrice
          lastPrice
          lowPrice
          yesterdayPrice
        }
        id
      }
    }
  }
}
    `;

/**
 * __useGetDerivativeUnderlyingProductsQuery__
 *
 * To run a query within a React component, call `useGetDerivativeUnderlyingProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDerivativeUnderlyingProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDerivativeUnderlyingProductsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetDerivativeUnderlyingProductsQuery(baseOptions: Apollo.QueryHookOptions<GetDerivativeUnderlyingProductsQuery, GetDerivativeUnderlyingProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDerivativeUnderlyingProductsQuery, GetDerivativeUnderlyingProductsQueryVariables>(GetDerivativeUnderlyingProductsDocument, options);
      }
export function useGetDerivativeUnderlyingProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDerivativeUnderlyingProductsQuery, GetDerivativeUnderlyingProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDerivativeUnderlyingProductsQuery, GetDerivativeUnderlyingProductsQueryVariables>(GetDerivativeUnderlyingProductsDocument, options);
        }
export type GetDerivativeUnderlyingProductsQueryHookResult = ReturnType<typeof useGetDerivativeUnderlyingProductsQuery>;
export type GetDerivativeUnderlyingProductsLazyQueryHookResult = ReturnType<typeof useGetDerivativeUnderlyingProductsLazyQuery>;
export type GetDerivativeUnderlyingProductsQueryResult = Apollo.QueryResult<GetDerivativeUnderlyingProductsQuery, GetDerivativeUnderlyingProductsQueryVariables>;
export const GetRefundRelativeScenarioDocument = gql`
    query getRefundRelativeScenario($groupId: Int!) {
  group(id: $groupId) {
    id
    underlyings {
      instrument {
        currency {
          displayCode
        }
      }
    }
    refundRelativeScenario {
      performance
      value
      underlyingValue
      underlyingPerformance
    }
  }
}
    `;

/**
 * __useGetRefundRelativeScenarioQuery__
 *
 * To run a query within a React component, call `useGetRefundRelativeScenarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefundRelativeScenarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefundRelativeScenarioQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetRefundRelativeScenarioQuery(baseOptions: Apollo.QueryHookOptions<GetRefundRelativeScenarioQuery, GetRefundRelativeScenarioQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRefundRelativeScenarioQuery, GetRefundRelativeScenarioQueryVariables>(GetRefundRelativeScenarioDocument, options);
      }
export function useGetRefundRelativeScenarioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefundRelativeScenarioQuery, GetRefundRelativeScenarioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRefundRelativeScenarioQuery, GetRefundRelativeScenarioQueryVariables>(GetRefundRelativeScenarioDocument, options);
        }
export type GetRefundRelativeScenarioQueryHookResult = ReturnType<typeof useGetRefundRelativeScenarioQuery>;
export type GetRefundRelativeScenarioLazyQueryHookResult = ReturnType<typeof useGetRefundRelativeScenarioLazyQuery>;
export type GetRefundRelativeScenarioQueryResult = Apollo.QueryResult<GetRefundRelativeScenarioQuery, GetRefundRelativeScenarioQueryVariables>;
export const GetWarrantKeyfiguresDocument = gql`
    query getWarrantKeyfigures($groupId: Int!) {
  group(id: $groupId) {
    id
    main {
      derivativeKeyFigures {
        gearing
        premium
        premiumAbsolute
        premiumAnnual
        implicitVolatility
        breakEven
        moneyness
        intrinsicValue
        timeValuePremium
        spread
        spreadHomogenous
        spreadRelative
        deltaStopLoss
        deltaStopLossAbsolute
        agio
        agioAnnual
        omega
        delta
        gamma
        theta
        rho
        vega
        discountAbsolute
        discountPercent
        sidewaysReturn
        sidewaysReturnAbsolute
        sidewaysAnnualReturn
        outperformanceLevel
        maxAnnualReturn
        maxReturn
        maxReturnAbsolute
        maxRedemptionPrice
        deltaCap
        deltaCapAbsolute
        fairValue
        bonusAnnualReturn
        bonusBuffer
        bonusBufferAbsolute
        bonusReturn
        bonusReturnAbsolute
        deltaBonusLevel
        deltaBonusLevelAbsolute
        deltaStrike
        deltaStrikeAbsolute
        deltaSecurityLevel
        dirtyPrice
        parity
        ismaYield
        accruedInterest
        duration
        modifiedDuration
        update {
          when
          type
          value
          underlyingValue
        }
      }
      keyFigures {
        gearing
        premium
        premiumAbsolute
        premiumAnnual
        implicitVolatility
        breakEven
        moneyness
        intrinsicValue
        timeValuePremium
        spread
        spreadHomogenous
        spreadRelative
        deltaStopLoss
        deltaStopLossAbsolute
        agio
        omega
        delta
        gamma
        theta
        rho
        vega
        discount
        discountAbsolute
        sidewaysReturn
        sidewaysAnnualReturn
        outperformanceLevel
        maxAnnualReturn
        maxReturn
        maxReturnAbsolute
        deltaCap
        deltaCapAbsolute
        bonusAnnualReturn
        bonusBuffer
        bonusBufferAbsolute
        bonusReturn
        sidewaysReturnAbsolute
        accruedInterest
        dirtyPrice
        parity
        maxRedemptionPrice
        update {
          type
          underlyingValue
          value
          when
        }
      }
      currency {
        displayCode
      }
      snapQuote {
        lastChange
        instrumentId
        quotes {
          value
          type
        }
      }
    }
    derivative {
      maturityDate
      currencyQuanto
      optionType
      settlementType
      nominalAmount
    }
    underlyings {
      exchange {
        name
        closingTime
        openingTime
      }
      instrument {
        snapQuote {
          instrumentId
          quote(type: ASK) {
            change
          }
          quotes {
            type
            when
            change
          }
        }
      }
      currency {
        displayCode
      }
      id
      isin
      name
      referencePrice
      multiplier
      quantity
      percentage
      leverageFactor
      bonusBarrier
      cap
      capitalGuarantee
      conditionalCouponTriggerLevel
      conditionalCouponTriggerLevelLower
      conditionalCouponTriggerLevelUpper
      knockIn
      knockInLower
      knockInUpper
      knockOut
      knockOutLower
      knockOutUpper
      knockInTriggeredAt
      knockOutTriggeredAt
      lockIn
      participation
      redemption
      reverseLevel
      security
      start
      strike
    }
    interestRateInformation {
      interestRate
      nextPaymentDate
      lastPaymentDate
      finalPaymentDate
    }
  }
}
    `;

/**
 * __useGetWarrantKeyfiguresQuery__
 *
 * To run a query within a React component, call `useGetWarrantKeyfiguresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarrantKeyfiguresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarrantKeyfiguresQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetWarrantKeyfiguresQuery(baseOptions: Apollo.QueryHookOptions<GetWarrantKeyfiguresQuery, GetWarrantKeyfiguresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarrantKeyfiguresQuery, GetWarrantKeyfiguresQueryVariables>(GetWarrantKeyfiguresDocument, options);
      }
export function useGetWarrantKeyfiguresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarrantKeyfiguresQuery, GetWarrantKeyfiguresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarrantKeyfiguresQuery, GetWarrantKeyfiguresQueryVariables>(GetWarrantKeyfiguresDocument, options);
        }
export type GetWarrantKeyfiguresQueryHookResult = ReturnType<typeof useGetWarrantKeyfiguresQuery>;
export type GetWarrantKeyfiguresLazyQueryHookResult = ReturnType<typeof useGetWarrantKeyfiguresLazyQuery>;
export type GetWarrantKeyfiguresQueryResult = Apollo.QueryResult<GetWarrantKeyfiguresQuery, GetWarrantKeyfiguresQueryVariables>;
export const GetWarrantStaticDataDocument = gql`
    query getWarrantStaticData($groupId: Int!) {
  group(id: $groupId) {
    id
    main {
      firstTradingDay
      lastTradingDay
      exchange {
        openingTime
        closingTime
        name
      }
      currency {
        displayCode
      }
    }
    derivative {
      issueSize
      issueDate
      issuePrice
      paymentDate
      nameTermSheet
      maturityDate
    }
    underlyings {
      referencePrice
      strike
      exchange {
        name
      }
      instrument {
        snapQuote {
          lastChange
          instrumentId
          lastPrice
        }
      }
      currency {
        displayCode
      }
    }
    issuer {
      name
      id
      partner
    }
  }
}
    `;

/**
 * __useGetWarrantStaticDataQuery__
 *
 * To run a query within a React component, call `useGetWarrantStaticDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarrantStaticDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarrantStaticDataQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetWarrantStaticDataQuery(baseOptions: Apollo.QueryHookOptions<GetWarrantStaticDataQuery, GetWarrantStaticDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarrantStaticDataQuery, GetWarrantStaticDataQueryVariables>(GetWarrantStaticDataDocument, options);
      }
export function useGetWarrantStaticDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarrantStaticDataQuery, GetWarrantStaticDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarrantStaticDataQuery, GetWarrantStaticDataQueryVariables>(GetWarrantStaticDataDocument, options);
        }
export type GetWarrantStaticDataQueryHookResult = ReturnType<typeof useGetWarrantStaticDataQuery>;
export type GetWarrantStaticDataLazyQueryHookResult = ReturnType<typeof useGetWarrantStaticDataLazyQuery>;
export type GetWarrantStaticDataQueryResult = Apollo.QueryResult<GetWarrantStaticDataQuery, GetWarrantStaticDataQueryVariables>;
export const GetEtcAdnEtnInfoDocument = gql`
    query getEtcAdnEtnInfo($groupId: Int!) {
  group(id: $groupId) {
    id
    isin
    name
    assetGroup
    description {
      natural
      text
    }
    content {
      id
      isin
      wkn
      main
      tickerSymbol
      name
      marketCapitalization
      group {
        assetGroup
        seoTag
        sector {
          name
        }
      }
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        delay
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          size
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        basePrice
        performance
        sharpe
        vola
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      indicators {
        relativeStrengthLevy {
          deltaMedian
          indicator
        }
        movingAverage {
          deltaLine200Day
          deltaLine38Day
        }
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
    }
  }
}
    `;

/**
 * __useGetEtcAdnEtnInfoQuery__
 *
 * To run a query within a React component, call `useGetEtcAdnEtnInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEtcAdnEtnInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEtcAdnEtnInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetEtcAdnEtnInfoQuery(baseOptions: Apollo.QueryHookOptions<GetEtcAdnEtnInfoQuery, GetEtcAdnEtnInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEtcAdnEtnInfoQuery, GetEtcAdnEtnInfoQueryVariables>(GetEtcAdnEtnInfoDocument, options);
      }
export function useGetEtcAdnEtnInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEtcAdnEtnInfoQuery, GetEtcAdnEtnInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEtcAdnEtnInfoQuery, GetEtcAdnEtnInfoQueryVariables>(GetEtcAdnEtnInfoDocument, options);
        }
export type GetEtcAdnEtnInfoQueryHookResult = ReturnType<typeof useGetEtcAdnEtnInfoQuery>;
export type GetEtcAdnEtnInfoLazyQueryHookResult = ReturnType<typeof useGetEtcAdnEtnInfoLazyQuery>;
export type GetEtcAdnEtnInfoQueryResult = Apollo.QueryResult<GetEtcAdnEtnInfoQuery, GetEtcAdnEtnInfoQueryVariables>;
export const GetEtfInfoDocument = gql`
    query getEtfInfo($groupId: Int!) {
  group(id: $groupId) {
    id
    isin
    name
    wkn
    assetGroup
    assetClass {
      name
    }
    assetType {
      name
    }
    description {
      natural
      text
    }
    content {
      id
      isin
      wkn
      main
      tickerSymbol
      name
      marketCapitalization
      group {
        assetGroup
        seoTag
        sector {
          name
        }
      }
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        delay
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          size
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        basePrice
        performance
        sharpe
        vola
        alpha
        beta
        betaBear
        betaBull
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      indicators {
        relativeStrengthLevy {
          deltaMedian
          indicator
        }
        movingAverage {
          deltaLine200Day
          deltaLine38Day
        }
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
    }
    etf {
      id
      investmentConcept
      participationFactor
      underlyingRatio
      position
      charge
      distributing
      foundationDate
      quanto
      benchmark {
        name
        group {
          assetType {
            name
          }
          name
          main {
            currency {
              displayCode
            }
          }
        }
      }
      issuer {
        id
        name
      }
      sector {
        name
      }
      region {
        name
      }
      allocation {
        name
      }
      domicile {
        name
      }
      strategy {
        name
      }
      replication {
        name
      }
      investmentVolume {
        date
        value
        currency {
          displayCode
        }
      }
      keyFigures {
        totalExpenseRatio
        jensenAlpha
        betaFactor
        negativeRegression
        positiveRegression
        maxLoosing6Month
        longestLoosingPeriod
        trackingError
      }
      portfolios {
        name
        entries {
          name
          percent
        }
      }
    }
  }
}
    `;

/**
 * __useGetEtfInfoQuery__
 *
 * To run a query within a React component, call `useGetEtfInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEtfInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEtfInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetEtfInfoQuery(baseOptions: Apollo.QueryHookOptions<GetEtfInfoQuery, GetEtfInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEtfInfoQuery, GetEtfInfoQueryVariables>(GetEtfInfoDocument, options);
      }
export function useGetEtfInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEtfInfoQuery, GetEtfInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEtfInfoQuery, GetEtfInfoQueryVariables>(GetEtfInfoDocument, options);
        }
export type GetEtfInfoQueryHookResult = ReturnType<typeof useGetEtfInfoQuery>;
export type GetEtfInfoLazyQueryHookResult = ReturnType<typeof useGetEtfInfoLazyQuery>;
export type GetEtfInfoQueryResult = Apollo.QueryResult<GetEtfInfoQuery, GetEtfInfoQueryVariables>;
export const GetEtfTypeBucketDocument = gql`
    query getEtfTypeBucket($issuerId: Long) {
  assetTypeGroupBucket(criteria: {etfIssuerId: $issuerId}) {
    assetTypeGroup {
      id
      name
    }
    count
  }
}
    `;

/**
 * __useGetEtfTypeBucketQuery__
 *
 * To run a query within a React component, call `useGetEtfTypeBucketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEtfTypeBucketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEtfTypeBucketQuery({
 *   variables: {
 *      issuerId: // value for 'issuerId'
 *   },
 * });
 */
export function useGetEtfTypeBucketQuery(baseOptions?: Apollo.QueryHookOptions<GetEtfTypeBucketQuery, GetEtfTypeBucketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEtfTypeBucketQuery, GetEtfTypeBucketQueryVariables>(GetEtfTypeBucketDocument, options);
      }
export function useGetEtfTypeBucketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEtfTypeBucketQuery, GetEtfTypeBucketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEtfTypeBucketQuery, GetEtfTypeBucketQueryVariables>(GetEtfTypeBucketDocument, options);
        }
export type GetEtfTypeBucketQueryHookResult = ReturnType<typeof useGetEtfTypeBucketQuery>;
export type GetEtfTypeBucketLazyQueryHookResult = ReturnType<typeof useGetEtfTypeBucketLazyQuery>;
export type GetEtfTypeBucketQueryResult = Apollo.QueryResult<GetEtfTypeBucketQuery, GetEtfTypeBucketQueryVariables>;
export const GetFutureInfoDocument = gql`
    query getFutureInfo($groupId: Int!) {
  group(id: $groupId) {
    id
    isin
    name
    assetGroup
    underlying
    description {
      natural
      text
    }
    main {
      id
      currency {
        displayCode
      }
    }
    content {
      id
      isin
      wkn
      main
      tickerSymbol
      name
      marketCapitalization
      group {
        assetGroup
        seoTag
        id
        isin
        name
        underlying
        wkn
        sector {
          name
        }
      }
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          size
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        basePrice
        performance
        sharpe
        vola
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      indicators {
        relativeStrengthLevy {
          deltaMedian
          indicator
        }
        movingAverage {
          deltaLine200Day
          deltaLine38Day
        }
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
    }
  }
}
    `;

/**
 * __useGetFutureInfoQuery__
 *
 * To run a query within a React component, call `useGetFutureInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFutureInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFutureInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetFutureInfoQuery(baseOptions: Apollo.QueryHookOptions<GetFutureInfoQuery, GetFutureInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFutureInfoQuery, GetFutureInfoQueryVariables>(GetFutureInfoDocument, options);
      }
export function useGetFutureInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFutureInfoQuery, GetFutureInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFutureInfoQuery, GetFutureInfoQueryVariables>(GetFutureInfoDocument, options);
        }
export type GetFutureInfoQueryHookResult = ReturnType<typeof useGetFutureInfoQuery>;
export type GetFutureInfoLazyQueryHookResult = ReturnType<typeof useGetFutureInfoLazyQuery>;
export type GetFutureInfoQueryResult = Apollo.QueryResult<GetFutureInfoQuery, GetFutureInfoQueryVariables>;
export const GetFundTypeBucketDocument = gql`
    query getFundTypeBucket($assetClass: Long, $assetTypeGroup: String, $assetType: String, $companyId: Long) {
  fundTypeBucket(
    criteria: {assetClass: $assetClass, assetTypeGroup: $assetTypeGroup, assetType: $assetType, companyId: $companyId}
  ) {
    fundType {
      id
      name
    }
    count
  }
}
    `;

/**
 * __useGetFundTypeBucketQuery__
 *
 * To run a query within a React component, call `useGetFundTypeBucketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundTypeBucketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundTypeBucketQuery({
 *   variables: {
 *      assetClass: // value for 'assetClass'
 *      assetTypeGroup: // value for 'assetTypeGroup'
 *      assetType: // value for 'assetType'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetFundTypeBucketQuery(baseOptions?: Apollo.QueryHookOptions<GetFundTypeBucketQuery, GetFundTypeBucketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundTypeBucketQuery, GetFundTypeBucketQueryVariables>(GetFundTypeBucketDocument, options);
      }
export function useGetFundTypeBucketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFundTypeBucketQuery, GetFundTypeBucketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundTypeBucketQuery, GetFundTypeBucketQueryVariables>(GetFundTypeBucketDocument, options);
        }
export type GetFundTypeBucketQueryHookResult = ReturnType<typeof useGetFundTypeBucketQuery>;
export type GetFundTypeBucketLazyQueryHookResult = ReturnType<typeof useGetFundTypeBucketLazyQuery>;
export type GetFundTypeBucketQueryResult = Apollo.QueryResult<GetFundTypeBucketQuery, GetFundTypeBucketQueryVariables>;
export const GetInstrumentChartComparisonPeerGroupDocument = gql`
    query getInstrumentChartComparisonPeerGroup($instrumentId: Int!, $chartScope: ChartScope!) {
  instrument(id: $instrumentId) {
    id
    name
    group {
      id
      wkn
    }
    chart(scope: $chartScope) {
      id
      series {
        label
        type
        data {
          value
          when
        }
      }
      threshold {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentChartComparisonPeerGroupQuery__
 *
 * To run a query within a React component, call `useGetInstrumentChartComparisonPeerGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentChartComparisonPeerGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentChartComparisonPeerGroupQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      chartScope: // value for 'chartScope'
 *   },
 * });
 */
export function useGetInstrumentChartComparisonPeerGroupQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentChartComparisonPeerGroupQuery, GetInstrumentChartComparisonPeerGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentChartComparisonPeerGroupQuery, GetInstrumentChartComparisonPeerGroupQueryVariables>(GetInstrumentChartComparisonPeerGroupDocument, options);
      }
export function useGetInstrumentChartComparisonPeerGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentChartComparisonPeerGroupQuery, GetInstrumentChartComparisonPeerGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentChartComparisonPeerGroupQuery, GetInstrumentChartComparisonPeerGroupQueryVariables>(GetInstrumentChartComparisonPeerGroupDocument, options);
        }
export type GetInstrumentChartComparisonPeerGroupQueryHookResult = ReturnType<typeof useGetInstrumentChartComparisonPeerGroupQuery>;
export type GetInstrumentChartComparisonPeerGroupLazyQueryHookResult = ReturnType<typeof useGetInstrumentChartComparisonPeerGroupLazyQuery>;
export type GetInstrumentChartComparisonPeerGroupQueryResult = Apollo.QueryResult<GetInstrumentChartComparisonPeerGroupQuery, GetInstrumentChartComparisonPeerGroupQueryVariables>;
export const GetInstrumentFundChartDetailsDocument = gql`
    query getInstrumentFundChartDetails($instrumentCurrentId: Int!, $instrumentMinId: Int!, $instrumentMaxId: Int!, $chartScope: ChartScope!) {
  current: instrument(id: $instrumentCurrentId) {
    id
    name
    group {
      id
      wkn
    }
    chart(scope: $chartScope) {
      id
      series {
        label
        type
        data {
          value
          when
        }
      }
      threshold {
        type
        value
      }
    }
  }
  min: instrument(id: $instrumentMinId) {
    id
    name
    group {
      id
      wkn
    }
    chart(scope: $chartScope) {
      id
      series {
        label
        type
        data {
          value
          when
        }
      }
      threshold {
        type
        value
      }
    }
  }
  max: instrument(id: $instrumentMaxId) {
    id
    name
    group {
      id
      wkn
    }
    chart(scope: $chartScope) {
      id
      series {
        label
        type
        data {
          value
          when
        }
      }
      threshold {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentFundChartDetailsQuery__
 *
 * To run a query within a React component, call `useGetInstrumentFundChartDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentFundChartDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentFundChartDetailsQuery({
 *   variables: {
 *      instrumentCurrentId: // value for 'instrumentCurrentId'
 *      instrumentMinId: // value for 'instrumentMinId'
 *      instrumentMaxId: // value for 'instrumentMaxId'
 *      chartScope: // value for 'chartScope'
 *   },
 * });
 */
export function useGetInstrumentFundChartDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentFundChartDetailsQuery, GetInstrumentFundChartDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentFundChartDetailsQuery, GetInstrumentFundChartDetailsQueryVariables>(GetInstrumentFundChartDetailsDocument, options);
      }
export function useGetInstrumentFundChartDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentFundChartDetailsQuery, GetInstrumentFundChartDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentFundChartDetailsQuery, GetInstrumentFundChartDetailsQueryVariables>(GetInstrumentFundChartDetailsDocument, options);
        }
export type GetInstrumentFundChartDetailsQueryHookResult = ReturnType<typeof useGetInstrumentFundChartDetailsQuery>;
export type GetInstrumentFundChartDetailsLazyQueryHookResult = ReturnType<typeof useGetInstrumentFundChartDetailsLazyQuery>;
export type GetInstrumentFundChartDetailsQueryResult = Apollo.QueryResult<GetInstrumentFundChartDetailsQuery, GetInstrumentFundChartDetailsQueryVariables>;
export const GetInstrumentFundEtfPeergroupsDocument = gql`
    query getInstrumentFundEtfPeergroups($groupId: Int!) {
  group(id: $groupId) {
    id
    fundTranche {
      id
      name
      peerGroup {
        id
        name
        performance {
          minimum
          instrumentGroupMin {
            id
            name
            isin
            assetGroup
            wkn
            seoTag
            main {
              id
            }
          }
          maximum
          instrumentGroupMax {
            id
            name
            assetGroup
            isin
            wkn
            seoTag
            main {
              id
            }
          }
          average
          period
        }
      }
    }
    etf {
      id
      peerGroup {
        performance {
          minimum
          isinMin
          instrumentGroupMin {
            id
            name
            isin
            wkn
            assetGroup
            seoTag
            main {
              id
            }
          }
          maximum
          isinMax
          instrumentGroupMax {
            id
            name
            isin
            assetGroup
            wkn
            seoTag
            main {
              id
            }
          }
          average
          period
        }
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentFundEtfPeergroupsQuery__
 *
 * To run a query within a React component, call `useGetInstrumentFundEtfPeergroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentFundEtfPeergroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentFundEtfPeergroupsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetInstrumentFundEtfPeergroupsQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentFundEtfPeergroupsQuery, GetInstrumentFundEtfPeergroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentFundEtfPeergroupsQuery, GetInstrumentFundEtfPeergroupsQueryVariables>(GetInstrumentFundEtfPeergroupsDocument, options);
      }
export function useGetInstrumentFundEtfPeergroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentFundEtfPeergroupsQuery, GetInstrumentFundEtfPeergroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentFundEtfPeergroupsQuery, GetInstrumentFundEtfPeergroupsQueryVariables>(GetInstrumentFundEtfPeergroupsDocument, options);
        }
export type GetInstrumentFundEtfPeergroupsQueryHookResult = ReturnType<typeof useGetInstrumentFundEtfPeergroupsQuery>;
export type GetInstrumentFundEtfPeergroupsLazyQueryHookResult = ReturnType<typeof useGetInstrumentFundEtfPeergroupsLazyQuery>;
export type GetInstrumentFundEtfPeergroupsQueryResult = Apollo.QueryResult<GetInstrumentFundEtfPeergroupsQuery, GetInstrumentFundEtfPeergroupsQueryVariables>;
export const GetFundsPageDocument = gql`
    query getFundsPage($groupId: Int!) {
  group(id: $groupId) {
    id
    name
    isin
    assetGroup
    wkn
    content {
      id
      isin
      wkn
      main
      tickerSymbol
      name
      marketCapitalization
      group {
        assetGroup
        seoTag
        sector {
          name
        }
      }
      exchange {
        id
        name
        code
        type
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        delay
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          size
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        basePrice
        performance
        deltaAveragePrice
        sharpe
        alpha
        beta
        betaBear
        betaBull
        vola
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      indicators {
        relativeStrengthLevy {
          deltaMedian
          indicator
        }
        movingAverage {
          deltaLine200Day
          deltaLine38Day
        }
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
    }
    fundTranche {
      main
      germanRiesterCapable
      germanVwlCapable
      savingPlanCapable
      distributing
      srri {
        value
      }
      documents {
        type {
          code
          name
        }
        url
        creationDate
      }
      distributionFrequency {
        name
        month
      }
      currency {
        name
      }
      group {
        id
        name
        isin
        wkn
        assetGroup
        seoTag
      }
      charge
      depositFee
      assetBasedFee
      totalExpenseRatio
      rePurchasePrice
      investmentVolume {
        date
        value
      }
      foundationDate
    }
    assetType {
      name
    }
    fund {
      id
      region {
        id
        name
      }
      topic {
        id
        name
      }
      currency {
        id
        name
      }
      type {
        id
        name
      }
      strategy {
        id
        name
      }
      advisor {
        name
        contact {
          phone
          fax
          email
          website
        }
        address {
          postCode
          city
          street
          houseNo
        }
      }
      company {
        id
        name
        contact {
          phone
          fax
          email
          website
        }
        address {
          postCode
          city
          street
          houseNo
        }
      }
      benchmark {
        name
        isin
        group {
          id
          isin
        }
      }
      portfolios {
        name
        entries {
          name
          percent
        }
      }
      investmentConcept
      exchangeTradedFund
      indexFund
      managers {
        firstName
        lastName
        preference
      }
      investmentVolume {
        date
        value
        currency {
          id
          name
          displayCode
          sign
        }
      }
    }
    alternativeFundTranches {
      name
      isin
      main
      germanRiesterCapable
      germanVwlCapable
      distributing
      distributionFrequency {
        name
        month
      }
      charge
      depositFee
      assetBasedFee
      totalExpenseRatio
      rePurchasePrice
      group {
        id
        name
        isin
        wkn
        assetGroup
        seoTag
      }
    }
  }
}
    `;

/**
 * __useGetFundsPageQuery__
 *
 * To run a query within a React component, call `useGetFundsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundsPageQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetFundsPageQuery(baseOptions: Apollo.QueryHookOptions<GetFundsPageQuery, GetFundsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundsPageQuery, GetFundsPageQueryVariables>(GetFundsPageDocument, options);
      }
export function useGetFundsPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFundsPageQuery, GetFundsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundsPageQuery, GetFundsPageQueryVariables>(GetFundsPageDocument, options);
        }
export type GetFundsPageQueryHookResult = ReturnType<typeof useGetFundsPageQuery>;
export type GetFundsPageLazyQueryHookResult = ReturnType<typeof useGetFundsPageLazyQuery>;
export type GetFundsPageQueryResult = Apollo.QueryResult<GetFundsPageQuery, GetFundsPageQueryVariables>;
export const GetImportantIndicesDocument = gql`
    query getImportantIndices {
  list(id: "important_indices") {
    id
    content {
      group {
        name
        seoTag
        assetGroup
      }
    }
  }
}
    `;

/**
 * __useGetImportantIndicesQuery__
 *
 * To run a query within a React component, call `useGetImportantIndicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImportantIndicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImportantIndicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetImportantIndicesQuery(baseOptions?: Apollo.QueryHookOptions<GetImportantIndicesQuery, GetImportantIndicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImportantIndicesQuery, GetImportantIndicesQueryVariables>(GetImportantIndicesDocument, options);
      }
export function useGetImportantIndicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImportantIndicesQuery, GetImportantIndicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImportantIndicesQuery, GetImportantIndicesQueryVariables>(GetImportantIndicesDocument, options);
        }
export type GetImportantIndicesQueryHookResult = ReturnType<typeof useGetImportantIndicesQuery>;
export type GetImportantIndicesLazyQueryHookResult = ReturnType<typeof useGetImportantIndicesLazyQuery>;
export type GetImportantIndicesQueryResult = Apollo.QueryResult<GetImportantIndicesQuery, GetImportantIndicesQueryVariables>;
export const GetInstrumentGroupCompositionCompareDocument = gql`
    query getInstrumentGroupCompositionCompare($groupId: Int!) {
  group(id: $groupId) {
    id
    compositionPerformance {
      periods {
        period
        current {
          group {
            name
            seoTag
            assetGroup
          }
          value
          price
        }
        min {
          group {
            name
            seoTag
            assetGroup
          }
          value
          price
        }
        max {
          group {
            name
            seoTag
            assetGroup
          }
          value
          price
        }
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentGroupCompositionCompareQuery__
 *
 * To run a query within a React component, call `useGetInstrumentGroupCompositionCompareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentGroupCompositionCompareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentGroupCompositionCompareQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetInstrumentGroupCompositionCompareQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentGroupCompositionCompareQuery, GetInstrumentGroupCompositionCompareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentGroupCompositionCompareQuery, GetInstrumentGroupCompositionCompareQueryVariables>(GetInstrumentGroupCompositionCompareDocument, options);
      }
export function useGetInstrumentGroupCompositionCompareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentGroupCompositionCompareQuery, GetInstrumentGroupCompositionCompareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentGroupCompositionCompareQuery, GetInstrumentGroupCompositionCompareQueryVariables>(GetInstrumentGroupCompositionCompareDocument, options);
        }
export type GetInstrumentGroupCompositionCompareQueryHookResult = ReturnType<typeof useGetInstrumentGroupCompositionCompareQuery>;
export type GetInstrumentGroupCompositionCompareLazyQueryHookResult = ReturnType<typeof useGetInstrumentGroupCompositionCompareLazyQuery>;
export type GetInstrumentGroupCompositionCompareQueryResult = Apollo.QueryResult<GetInstrumentGroupCompositionCompareQuery, GetInstrumentGroupCompositionCompareQueryVariables>;
export const GetScreenerRatingIndexesDocument = gql`
    query getScreenerRatingIndexes($first: Int!, $change: TheScreenerRatingChange, $instrumentGroupId: Int!) {
  theScreenerRatingSearch(
    criteria: {update: true, change: $change, instrumentGroupId: $instrumentGroupId}
    first: $first
  ) {
    isin
    previousRating
    rating
    group {
      name
      isin
      seoTag
      assetGroup
    }
    date
  }
}
    `;

/**
 * __useGetScreenerRatingIndexesQuery__
 *
 * To run a query within a React component, call `useGetScreenerRatingIndexesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenerRatingIndexesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenerRatingIndexesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      change: // value for 'change'
 *      instrumentGroupId: // value for 'instrumentGroupId'
 *   },
 * });
 */
export function useGetScreenerRatingIndexesQuery(baseOptions: Apollo.QueryHookOptions<GetScreenerRatingIndexesQuery, GetScreenerRatingIndexesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScreenerRatingIndexesQuery, GetScreenerRatingIndexesQueryVariables>(GetScreenerRatingIndexesDocument, options);
      }
export function useGetScreenerRatingIndexesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScreenerRatingIndexesQuery, GetScreenerRatingIndexesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScreenerRatingIndexesQuery, GetScreenerRatingIndexesQueryVariables>(GetScreenerRatingIndexesDocument, options);
        }
export type GetScreenerRatingIndexesQueryHookResult = ReturnType<typeof useGetScreenerRatingIndexesQuery>;
export type GetScreenerRatingIndexesLazyQueryHookResult = ReturnType<typeof useGetScreenerRatingIndexesLazyQuery>;
export type GetScreenerRatingIndexesQueryResult = Apollo.QueryResult<GetScreenerRatingIndexesQuery, GetScreenerRatingIndexesQueryVariables>;
export const GetIndexDocument = gql`
    query getIndex($groupId: Int!) {
  group(id: $groupId) {
    id
    name
    assetGroup
    wkn
    isin
    underlying
    description {
      text
    }
    main {
      id
      currency {
        id
        displayCode
      }
    }
    compositions {
      id
    }
    content {
      id
      isin
      wkn
      main
      tickerSymbol
      name
      seoTag
      group {
        id
        assetGroup
        seoTag
        isin
        name
        underlying
        wkn
      }
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        delay
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          size
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        basePrice
        performance
        sharpe
        vola
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
    }
  }
}
    `;

/**
 * __useGetIndexQuery__
 *
 * To run a query within a React component, call `useGetIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndexQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetIndexQuery(baseOptions: Apollo.QueryHookOptions<GetIndexQuery, GetIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndexQuery, GetIndexQueryVariables>(GetIndexDocument, options);
      }
export function useGetIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndexQuery, GetIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndexQuery, GetIndexQueryVariables>(GetIndexDocument, options);
        }
export type GetIndexQueryHookResult = ReturnType<typeof useGetIndexQuery>;
export type GetIndexLazyQueryHookResult = ReturnType<typeof useGetIndexLazyQuery>;
export type GetIndexQueryResult = Apollo.QueryResult<GetIndexQuery, GetIndexQueryVariables>;
export const GetKnockOutInfoDocument = gql`
    query getKnockOutInfo($groupId: Int!) {
  group(id: $groupId) {
    id
    name
    assetClass {
      id
      leveraged
      name
    }
    assetGroup
    assetType {
      name
      id
    }
    issuer {
      id
      name
    }
    derivative {
      optionType
    }
    isin
    wkn
    description {
      text
    }
    underlyings {
      groupId
      instrumentId
      strike
      knockOut
    }
    content {
      id
      isin
      wkn
      main
      tickerSymbol
      name
      group {
        assetGroup
        seoTag
      }
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        delay
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          size
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        basePrice
        performance
        sharpe
        vola
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
    }
  }
}
    `;

/**
 * __useGetKnockOutInfoQuery__
 *
 * To run a query within a React component, call `useGetKnockOutInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnockOutInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnockOutInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetKnockOutInfoQuery(baseOptions: Apollo.QueryHookOptions<GetKnockOutInfoQuery, GetKnockOutInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnockOutInfoQuery, GetKnockOutInfoQueryVariables>(GetKnockOutInfoDocument, options);
      }
export function useGetKnockOutInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnockOutInfoQuery, GetKnockOutInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnockOutInfoQuery, GetKnockOutInfoQueryVariables>(GetKnockOutInfoDocument, options);
        }
export type GetKnockOutInfoQueryHookResult = ReturnType<typeof useGetKnockOutInfoQuery>;
export type GetKnockOutInfoLazyQueryHookResult = ReturnType<typeof useGetKnockOutInfoLazyQuery>;
export type GetKnockOutInfoQueryResult = Apollo.QueryResult<GetKnockOutInfoQuery, GetKnockOutInfoQueryVariables>;
export const GetMmrInfoDocument = gql`
    query getMMRInfo($groupId: Int!) {
  group(id: $groupId) {
    id
    isin
    wkn
    name
    assetGroup
    underlying
    description {
      natural
      text
    }
    main {
      id
      currency {
        displayCode
      }
    }
    indexParticipation {
      main {
        id
        name
        group {
          name
          seoTag
          assetGroup
        }
      }
    }
    content {
      id
      isin
      wkn
      main
      tickerSymbol
      name
      marketCapitalization
      group {
        assetGroup
        seoTag
        id
        isin
        name
        underlying
        wkn
        sector {
          name
        }
      }
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          size
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        basePrice
        performance
        sharpe
        vola
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      indicators {
        relativeStrengthLevy {
          deltaMedian
          indicator
        }
        movingAverage {
          deltaLine200Day
          deltaLine38Day
        }
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
    }
  }
}
    `;

/**
 * __useGetMmrInfoQuery__
 *
 * To run a query within a React component, call `useGetMmrInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMmrInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMmrInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetMmrInfoQuery(baseOptions: Apollo.QueryHookOptions<GetMmrInfoQuery, GetMmrInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMmrInfoQuery, GetMmrInfoQueryVariables>(GetMmrInfoDocument, options);
      }
export function useGetMmrInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMmrInfoQuery, GetMmrInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMmrInfoQuery, GetMmrInfoQueryVariables>(GetMmrInfoDocument, options);
        }
export type GetMmrInfoQueryHookResult = ReturnType<typeof useGetMmrInfoQuery>;
export type GetMmrInfoLazyQueryHookResult = ReturnType<typeof useGetMmrInfoLazyQuery>;
export type GetMmrInfoQueryResult = Apollo.QueryResult<GetMmrInfoQuery, GetMmrInfoQueryVariables>;
export const GetWarrInfoDocument = gql`
    query getWarrInfo($groupId: Int!) {
  group(id: $groupId) {
    id
    isin
    wkn
    name
    assetGroup
    underlying
    description {
      natural
      text
    }
    assetType {
      name
      id
    }
    issuer {
      id
      name
    }
    derivative {
      optionType
    }
    description {
      text
    }
    underlyings {
      groupId
      instrumentId
      strike
    }
    content {
      id
      isin
      wkn
      main
      tickerSymbol
      name
      group {
        assetGroup
        seoTag
      }
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        delay
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          size
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        basePrice
        performance
        sharpe
        vola
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
    }
  }
}
    `;

/**
 * __useGetWarrInfoQuery__
 *
 * To run a query within a React component, call `useGetWarrInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWarrInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWarrInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetWarrInfoQuery(baseOptions: Apollo.QueryHookOptions<GetWarrInfoQuery, GetWarrInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWarrInfoQuery, GetWarrInfoQueryVariables>(GetWarrInfoDocument, options);
      }
export function useGetWarrInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWarrInfoQuery, GetWarrInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWarrInfoQuery, GetWarrInfoQueryVariables>(GetWarrInfoDocument, options);
        }
export type GetWarrInfoQueryHookResult = ReturnType<typeof useGetWarrInfoQuery>;
export type GetWarrInfoLazyQueryHookResult = ReturnType<typeof useGetWarrInfoLazyQuery>;
export type GetWarrInfoQueryResult = Apollo.QueryResult<GetWarrInfoQuery, GetWarrInfoQueryVariables>;
export const ChartAnalysesDocument = gql`
    query ChartAnalyses($first: Int, $after: ID, $isin: [String!], $institutes: [String!], $targetFrom: LocalDate, $targetTo: LocalDate, $timeFrame: Int, $updated: Boolean, $recommendation: AnalysisRecommendation) {
  analysisSearch(
    criteria: {latest: true, updated: $updated, timeFrame: $timeFrame, isin: $isin, institutes: $institutes, recommendation: $recommendation, targetFrom: $targetFrom, targetTo: $targetTo}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        date
        timeFrame
        recommendation
        targetPrice
        referencePrice
        updated
        latest
        body
        currency {
          displayCode
        }
        group {
          id
          name
          seoTag
          assetGroup
          main {
            id
            currency {
              displayCode
            }
            snapQuote {
              lastChange
              instrumentId
              quote(type: TRADE) {
                value
                change
                percentChange
              }
            }
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useChartAnalysesQuery__
 *
 * To run a query within a React component, call `useChartAnalysesQuery` and pass it any options that fit your needs.
 * When your component renders, `useChartAnalysesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChartAnalysesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      isin: // value for 'isin'
 *      institutes: // value for 'institutes'
 *      targetFrom: // value for 'targetFrom'
 *      targetTo: // value for 'targetTo'
 *      timeFrame: // value for 'timeFrame'
 *      updated: // value for 'updated'
 *      recommendation: // value for 'recommendation'
 *   },
 * });
 */
export function useChartAnalysesQuery(baseOptions?: Apollo.QueryHookOptions<ChartAnalysesQuery, ChartAnalysesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChartAnalysesQuery, ChartAnalysesQueryVariables>(ChartAnalysesDocument, options);
      }
export function useChartAnalysesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChartAnalysesQuery, ChartAnalysesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChartAnalysesQuery, ChartAnalysesQueryVariables>(ChartAnalysesDocument, options);
        }
export type ChartAnalysesQueryHookResult = ReturnType<typeof useChartAnalysesQuery>;
export type ChartAnalysesLazyQueryHookResult = ReturnType<typeof useChartAnalysesLazyQuery>;
export type ChartAnalysesQueryResult = Apollo.QueryResult<ChartAnalysesQuery, ChartAnalysesQueryVariables>;
export const GetAnalyseReportDocument = gql`
    query getAnalyseReport($groupId: Int!) {
  group(id: $groupId) {
    id
    analysisReport {
      neutralCount
      negativeCount
      positiveCount
      recommendation
      price
      currency {
        displayCode
        sign
      }
      targets {
        recommendation
        price
        count
      }
    }
  }
}
    `;

/**
 * __useGetAnalyseReportQuery__
 *
 * To run a query within a React component, call `useGetAnalyseReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyseReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyseReportQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetAnalyseReportQuery(baseOptions: Apollo.QueryHookOptions<GetAnalyseReportQuery, GetAnalyseReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyseReportQuery, GetAnalyseReportQueryVariables>(GetAnalyseReportDocument, options);
      }
export function useGetAnalyseReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyseReportQuery, GetAnalyseReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyseReportQuery, GetAnalyseReportQueryVariables>(GetAnalyseReportDocument, options);
        }
export type GetAnalyseReportQueryHookResult = ReturnType<typeof useGetAnalyseReportQuery>;
export type GetAnalyseReportLazyQueryHookResult = ReturnType<typeof useGetAnalyseReportLazyQuery>;
export type GetAnalyseReportQueryResult = Apollo.QueryResult<GetAnalyseReportQuery, GetAnalyseReportQueryVariables>;
export const GetShortCompanyInfomartionDocument = gql`
    query getShortCompanyInfomartion($groupId: Int!) {
  group(id: $groupId) {
    id
    company {
      id
      name
      profile {
        text
      }
      shareHolders {
        name
        percent
      }
    }
  }
}
    `;

/**
 * __useGetShortCompanyInfomartionQuery__
 *
 * To run a query within a React component, call `useGetShortCompanyInfomartionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShortCompanyInfomartionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShortCompanyInfomartionQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetShortCompanyInfomartionQuery(baseOptions: Apollo.QueryHookOptions<GetShortCompanyInfomartionQuery, GetShortCompanyInfomartionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShortCompanyInfomartionQuery, GetShortCompanyInfomartionQueryVariables>(GetShortCompanyInfomartionDocument, options);
      }
export function useGetShortCompanyInfomartionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShortCompanyInfomartionQuery, GetShortCompanyInfomartionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShortCompanyInfomartionQuery, GetShortCompanyInfomartionQueryVariables>(GetShortCompanyInfomartionDocument, options);
        }
export type GetShortCompanyInfomartionQueryHookResult = ReturnType<typeof useGetShortCompanyInfomartionQuery>;
export type GetShortCompanyInfomartionLazyQueryHookResult = ReturnType<typeof useGetShortCompanyInfomartionLazyQuery>;
export type GetShortCompanyInfomartionQueryResult = Apollo.QueryResult<GetShortCompanyInfomartionQuery, GetShortCompanyInfomartionQueryVariables>;
export const GetCompanyDividendDocument = gql`
    query getCompanyDividend($groupId: Int!, $from: Int, $to: Int) {
  group(id: $groupId) {
    id
    company {
      id
      name
      currency {
        displayCode
      }
      dividends(criteria: {fromYear: $from, toYear: $to}) {
        date
        value
      }
    }
  }
}
    `;

/**
 * __useGetCompanyDividendQuery__
 *
 * To run a query within a React component, call `useGetCompanyDividendQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDividendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDividendQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetCompanyDividendQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyDividendQuery, GetCompanyDividendQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyDividendQuery, GetCompanyDividendQueryVariables>(GetCompanyDividendDocument, options);
      }
export function useGetCompanyDividendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyDividendQuery, GetCompanyDividendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyDividendQuery, GetCompanyDividendQueryVariables>(GetCompanyDividendDocument, options);
        }
export type GetCompanyDividendQueryHookResult = ReturnType<typeof useGetCompanyDividendQuery>;
export type GetCompanyDividendLazyQueryHookResult = ReturnType<typeof useGetCompanyDividendLazyQuery>;
export type GetCompanyDividendQueryResult = Apollo.QueryResult<GetCompanyDividendQuery, GetCompanyDividendQueryVariables>;
export const GetShareEstimatesDocument = gql`
    query getShareEstimates($groupId: Int!) {
  group(id: $groupId) {
    id
    company {
      currency {
        displayCode
      }
    }
    estimates {
      current {
        year
        dividendYield
        dividendPerShare
        priceToCashFlowRatio
        priceToEarningsRatio
        priceToSalesRatio
      }
      next {
        year
        dividendYield
        dividendPerShare
        priceToCashFlowRatio
        priceToEarningsRatio
        priceToSalesRatio
      }
    }
  }
}
    `;

/**
 * __useGetShareEstimatesQuery__
 *
 * To run a query within a React component, call `useGetShareEstimatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareEstimatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareEstimatesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetShareEstimatesQuery(baseOptions: Apollo.QueryHookOptions<GetShareEstimatesQuery, GetShareEstimatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShareEstimatesQuery, GetShareEstimatesQueryVariables>(GetShareEstimatesDocument, options);
      }
export function useGetShareEstimatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShareEstimatesQuery, GetShareEstimatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShareEstimatesQuery, GetShareEstimatesQueryVariables>(GetShareEstimatesDocument, options);
        }
export type GetShareEstimatesQueryHookResult = ReturnType<typeof useGetShareEstimatesQuery>;
export type GetShareEstimatesLazyQueryHookResult = ReturnType<typeof useGetShareEstimatesLazyQuery>;
export type GetShareEstimatesQueryResult = Apollo.QueryResult<GetShareEstimatesQuery, GetShareEstimatesQueryVariables>;
export const GetScreenerRatingDocument = gql`
    query getScreenerRating($groupId: Int!) {
  group(id: $groupId) {
    id
    name
    theScreenerRating {
      currency {
        name
        sign
        displayCode
      }
      rating
      previousRating
      marketCapitalisation
      beta
      correlation
      earningsPerShareRevision
      referenceIndexName
      numberOfAnalysts
      payout
      performance2week
      premium
      date
      valuationRating
      dividend
      globalPriceEarningsRatio
      badNews {
        factor
        riskZone
      }
      earningsRevisionTrend {
        value
        price
        date
      }
      globalEvaluation {
        value
        date
      }
      mediumTermTechnicalTrend {
        value
        date
      }
      longTermGrowth {
        year
        value
      }
      longTermPriceEarnings
      risk {
        date
        zone
      }
      technicalReverse {
        value
        min
        max
      }
      valueAtRisk {
        value
        relative
      }
      bearMarket {
        riskZone
        factor
      }
    }
  }
}
    `;

/**
 * __useGetScreenerRatingQuery__
 *
 * To run a query within a React component, call `useGetScreenerRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScreenerRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScreenerRatingQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetScreenerRatingQuery(baseOptions: Apollo.QueryHookOptions<GetScreenerRatingQuery, GetScreenerRatingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScreenerRatingQuery, GetScreenerRatingQueryVariables>(GetScreenerRatingDocument, options);
      }
export function useGetScreenerRatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScreenerRatingQuery, GetScreenerRatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScreenerRatingQuery, GetScreenerRatingQueryVariables>(GetScreenerRatingDocument, options);
        }
export type GetScreenerRatingQueryHookResult = ReturnType<typeof useGetScreenerRatingQuery>;
export type GetScreenerRatingLazyQueryHookResult = ReturnType<typeof useGetScreenerRatingLazyQuery>;
export type GetScreenerRatingQueryResult = Apollo.QueryResult<GetScreenerRatingQuery, GetScreenerRatingQueryVariables>;
export const GetSharePeerGroupComparesDocument = gql`
    query getSharePeerGroupCompares($groupId: Int!) {
  group(id: $groupId) {
    id
    peerGroupCompare {
      type
      value
      chart {
        min {
          value
          group {
            name
            seoTag
            assetGroup
          }
        }
        max {
          value
          group {
            name
            seoTag
            assetGroup
          }
        }
        current {
          value
          group {
            name
            seoTag
            assetGroup
          }
        }
        breakPoint
      }
    }
  }
}
    `;

/**
 * __useGetSharePeerGroupComparesQuery__
 *
 * To run a query within a React component, call `useGetSharePeerGroupComparesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharePeerGroupComparesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharePeerGroupComparesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetSharePeerGroupComparesQuery(baseOptions: Apollo.QueryHookOptions<GetSharePeerGroupComparesQuery, GetSharePeerGroupComparesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharePeerGroupComparesQuery, GetSharePeerGroupComparesQueryVariables>(GetSharePeerGroupComparesDocument, options);
      }
export function useGetSharePeerGroupComparesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharePeerGroupComparesQuery, GetSharePeerGroupComparesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharePeerGroupComparesQuery, GetSharePeerGroupComparesQueryVariables>(GetSharePeerGroupComparesDocument, options);
        }
export type GetSharePeerGroupComparesQueryHookResult = ReturnType<typeof useGetSharePeerGroupComparesQuery>;
export type GetSharePeerGroupComparesLazyQueryHookResult = ReturnType<typeof useGetSharePeerGroupComparesLazyQuery>;
export type GetSharePeerGroupComparesQueryResult = Apollo.QueryResult<GetSharePeerGroupComparesQuery, GetSharePeerGroupComparesQueryVariables>;
export const GetPerformancePercentDocument = gql`
    query getPerformancePercent($instrumentId: Int!, $from: LocalDate!, $to: LocalDate!) {
  instrument(id: $instrumentId) {
    id
    quoteHistory(from: $from, to: $to) {
      edges {
        cursor
        node {
          date
          changePercent
        }
      }
    }
  }
}
    `;

/**
 * __useGetPerformancePercentQuery__
 *
 * To run a query within a React component, call `useGetPerformancePercentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerformancePercentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerformancePercentQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetPerformancePercentQuery(baseOptions: Apollo.QueryHookOptions<GetPerformancePercentQuery, GetPerformancePercentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerformancePercentQuery, GetPerformancePercentQueryVariables>(GetPerformancePercentDocument, options);
      }
export function useGetPerformancePercentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerformancePercentQuery, GetPerformancePercentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerformancePercentQuery, GetPerformancePercentQueryVariables>(GetPerformancePercentDocument, options);
        }
export type GetPerformancePercentQueryHookResult = ReturnType<typeof useGetPerformancePercentQuery>;
export type GetPerformancePercentLazyQueryHookResult = ReturnType<typeof useGetPerformancePercentLazyQuery>;
export type GetPerformancePercentQueryResult = Apollo.QueryResult<GetPerformancePercentQuery, GetPerformancePercentQueryVariables>;
export const GetShareInfoDocument = gql`
    query getShareInfo($groupId: Int!) {
  group(id: $groupId) {
    id
    isin
    wkn
    name
    assetGroup
    underlying
    description {
      natural
      text
    }
    company {
      id
    }
    main {
      id
      currency {
        displayCode
      }
    }
    indexParticipation {
      main {
        id
        name
        group {
          name
          seoTag
          assetGroup
        }
      }
    }
    content {
      id
      isin
      wkn
      main
      tickerSymbol
      name
      marketCapitalization
      group {
        assetGroup
        seoTag
        id
        isin
        name
        underlying
        wkn
        sector {
          name
        }
      }
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        delay
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          size
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        basePrice
        performance
        sharpe
        vola
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      indicators {
        relativeStrengthIndex {
          last7Days
          last9Days
          last14Days
          last25Days
        }
        movingAverage {
          deltaLine10Day
          line10Day
          deltaLine20Day
          line20Day
          deltaLine38Day
          line38Day
          deltaLine90Day
          line90Day
          deltaLine200Day
          line200Day
        }
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
    }
  }
}
    `;

/**
 * __useGetShareInfoQuery__
 *
 * To run a query within a React component, call `useGetShareInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareInfoQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetShareInfoQuery(baseOptions: Apollo.QueryHookOptions<GetShareInfoQuery, GetShareInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShareInfoQuery, GetShareInfoQueryVariables>(GetShareInfoDocument, options);
      }
export function useGetShareInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShareInfoQuery, GetShareInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShareInfoQuery, GetShareInfoQueryVariables>(GetShareInfoDocument, options);
        }
export type GetShareInfoQueryHookResult = ReturnType<typeof useGetShareInfoQuery>;
export type GetShareInfoLazyQueryHookResult = ReturnType<typeof useGetShareInfoLazyQuery>;
export type GetShareInfoQueryResult = Apollo.QueryResult<GetShareInfoQuery, GetShareInfoQueryVariables>;
export const GetCompanyBalanceSheetDocument = gql`
    query getCompanyBalanceSheet($groupId: Int!, $categories: [CompanyStatementCategory!], $from: Int, $to: Int) {
  group(id: $groupId) {
    id
    company {
      id
      name
      accountingStandard
      currency {
        name
      }
      fiscal {
        day
        month
      }
      statements(criteria: {category: $categories, fromYear: $from, toYear: $to}) {
        name
        category
        value
        important
        year
      }
    }
  }
}
    `;

/**
 * __useGetCompanyBalanceSheetQuery__
 *
 * To run a query within a React component, call `useGetCompanyBalanceSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyBalanceSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyBalanceSheetQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      categories: // value for 'categories'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetCompanyBalanceSheetQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyBalanceSheetQuery, GetCompanyBalanceSheetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyBalanceSheetQuery, GetCompanyBalanceSheetQueryVariables>(GetCompanyBalanceSheetDocument, options);
      }
export function useGetCompanyBalanceSheetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyBalanceSheetQuery, GetCompanyBalanceSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyBalanceSheetQuery, GetCompanyBalanceSheetQueryVariables>(GetCompanyBalanceSheetDocument, options);
        }
export type GetCompanyBalanceSheetQueryHookResult = ReturnType<typeof useGetCompanyBalanceSheetQuery>;
export type GetCompanyBalanceSheetLazyQueryHookResult = ReturnType<typeof useGetCompanyBalanceSheetLazyQuery>;
export type GetCompanyBalanceSheetQueryResult = Apollo.QueryResult<GetCompanyBalanceSheetQuery, GetCompanyBalanceSheetQueryVariables>;
export const GetCompanyInformationNewsDocument = gql`
    query getCompanyInformationNews($isin: String!, $first: Int) {
  newsSearch(criteria: {isin: [$isin]}, first: $first) {
    edges {
      cursor
      node {
        id
        when
        body
        headline
        teaser
        links {
          name
          href
        }
        source {
          id
          name
        }
        medias {
          source
          width
          height
        }
        streams {
          mimeType
          duration
          width
          height
          source
        }
        feed
        keywords
        instruments {
          group {
            id
            isin
            name
            assetGroup
            seoTag
            main {
              id
              snapQuote {
                lastChange
                instrumentId
                lowPrice
                highPrice
                firstPrice
                lastPrice
                yesterdayPrice
                cumulativeTrades
                cumulativeTurnover
                cumulativeVolume
                quotes {
                  delay
                  type
                  value
                  percentChange
                  change
                  when
                }
              }
              currency {
                displayCode
              }
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useGetCompanyInformationNewsQuery__
 *
 * To run a query within a React component, call `useGetCompanyInformationNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInformationNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInformationNewsQuery({
 *   variables: {
 *      isin: // value for 'isin'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetCompanyInformationNewsQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyInformationNewsQuery, GetCompanyInformationNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyInformationNewsQuery, GetCompanyInformationNewsQueryVariables>(GetCompanyInformationNewsDocument, options);
      }
export function useGetCompanyInformationNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyInformationNewsQuery, GetCompanyInformationNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyInformationNewsQuery, GetCompanyInformationNewsQueryVariables>(GetCompanyInformationNewsDocument, options);
        }
export type GetCompanyInformationNewsQueryHookResult = ReturnType<typeof useGetCompanyInformationNewsQuery>;
export type GetCompanyInformationNewsLazyQueryHookResult = ReturnType<typeof useGetCompanyInformationNewsLazyQuery>;
export type GetCompanyInformationNewsQueryResult = Apollo.QueryResult<GetCompanyInformationNewsQuery, GetCompanyInformationNewsQueryVariables>;
export const GetCompanyInformationDocument = gql`
    query getCompanyInformation($groupId: Int!) {
  group(id: $groupId) {
    id
    company {
      id
      name
      profile {
        text
        website
        address
        phone
        fax
        email
        website
      }
      shareHolders {
        name
        percent
      }
      employees {
        name
        member
        job
        role
      }
    }
  }
}
    `;

/**
 * __useGetCompanyInformationQuery__
 *
 * To run a query within a React component, call `useGetCompanyInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyInformationQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetCompanyInformationQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyInformationQuery, GetCompanyInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyInformationQuery, GetCompanyInformationQueryVariables>(GetCompanyInformationDocument, options);
      }
export function useGetCompanyInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyInformationQuery, GetCompanyInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyInformationQuery, GetCompanyInformationQueryVariables>(GetCompanyInformationDocument, options);
        }
export type GetCompanyInformationQueryHookResult = ReturnType<typeof useGetCompanyInformationQuery>;
export type GetCompanyInformationLazyQueryHookResult = ReturnType<typeof useGetCompanyInformationLazyQuery>;
export type GetCompanyInformationQueryResult = Apollo.QueryResult<GetCompanyInformationQuery, GetCompanyInformationQueryVariables>;
export const GetCompanyKeyFiguresDocument = gql`
    query getCompanyKeyFigures($groupId: Int!, $fromYear: Int!, $toYear: Int!) {
  group(id: $groupId) {
    id
    company {
      keyFigures(criteria: {fromYear: $fromYear, toYear: $toYear}) {
        year
        dividendYield
        dividendPerShare
        priceToCashFlowRatio
        priceToEarningsRatio
        priceToSalesRatio
        salesPerShare
        cashFlowPerShare
        workingCapital
        equityReturn
        salesRatio
        returnOnAssets
        returnOnInvestment
        intensityOfInvestments
        intensityOfLabor
        equityRatio
        debtEquityRatio
        cashGrade1
        cashGrade2
        cashGrade3
        cashRatioGrade1
        cashRatioGrade2
        cashRatioGrade3
        debtRatio
        earningPerShare
        dilutedEarningPerShare
        employees
        personnelExpenses
        salesPerEmployee
      }
    }
  }
}
    `;

/**
 * __useGetCompanyKeyFiguresQuery__
 *
 * To run a query within a React component, call `useGetCompanyKeyFiguresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyKeyFiguresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyKeyFiguresQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      fromYear: // value for 'fromYear'
 *      toYear: // value for 'toYear'
 *   },
 * });
 */
export function useGetCompanyKeyFiguresQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyKeyFiguresQuery, GetCompanyKeyFiguresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyKeyFiguresQuery, GetCompanyKeyFiguresQueryVariables>(GetCompanyKeyFiguresDocument, options);
      }
export function useGetCompanyKeyFiguresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyKeyFiguresQuery, GetCompanyKeyFiguresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyKeyFiguresQuery, GetCompanyKeyFiguresQueryVariables>(GetCompanyKeyFiguresDocument, options);
        }
export type GetCompanyKeyFiguresQueryHookResult = ReturnType<typeof useGetCompanyKeyFiguresQuery>;
export type GetCompanyKeyFiguresLazyQueryHookResult = ReturnType<typeof useGetCompanyKeyFiguresLazyQuery>;
export type GetCompanyKeyFiguresQueryResult = Apollo.QueryResult<GetCompanyKeyFiguresQuery, GetCompanyKeyFiguresQueryVariables>;
export const GetCompanyKeyFiguresEstimatesDocument = gql`
    query getCompanyKeyFiguresEstimates($groupId: Int!) {
  group(id: $groupId) {
    id
    estimates {
      current {
        year
        dividendYield
        dividendPerShare
        priceToCashFlowRatio
        priceToEarningsRatio
        priceToSalesRatio
      }
      next {
        year
        dividendYield
        dividendPerShare
        priceToCashFlowRatio
        priceToEarningsRatio
        priceToSalesRatio
      }
    }
  }
}
    `;

/**
 * __useGetCompanyKeyFiguresEstimatesQuery__
 *
 * To run a query within a React component, call `useGetCompanyKeyFiguresEstimatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyKeyFiguresEstimatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyKeyFiguresEstimatesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetCompanyKeyFiguresEstimatesQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyKeyFiguresEstimatesQuery, GetCompanyKeyFiguresEstimatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyKeyFiguresEstimatesQuery, GetCompanyKeyFiguresEstimatesQueryVariables>(GetCompanyKeyFiguresEstimatesDocument, options);
      }
export function useGetCompanyKeyFiguresEstimatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyKeyFiguresEstimatesQuery, GetCompanyKeyFiguresEstimatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyKeyFiguresEstimatesQuery, GetCompanyKeyFiguresEstimatesQueryVariables>(GetCompanyKeyFiguresEstimatesDocument, options);
        }
export type GetCompanyKeyFiguresEstimatesQueryHookResult = ReturnType<typeof useGetCompanyKeyFiguresEstimatesQuery>;
export type GetCompanyKeyFiguresEstimatesLazyQueryHookResult = ReturnType<typeof useGetCompanyKeyFiguresEstimatesLazyQuery>;
export type GetCompanyKeyFiguresEstimatesQueryResult = Apollo.QueryResult<GetCompanyKeyFiguresEstimatesQuery, GetCompanyKeyFiguresEstimatesQueryVariables>;
export const GetCashFlowTableDocument = gql`
    query getCashFlowTable($groupId: Int!, $category: CompanyStatementCategory!, $from: Int, $to: Int) {
  group(id: $groupId) {
    id
    company {
      id
      name
      accountingStandard
      currency {
        name
      }
      fiscal {
        day
        month
      }
      statements(criteria: {category: [$category], fromYear: $from, toYear: $to}) {
        name
        category
        value
        important
        year
      }
    }
  }
}
    `;

/**
 * __useGetCashFlowTableQuery__
 *
 * To run a query within a React component, call `useGetCashFlowTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashFlowTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashFlowTableQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      category: // value for 'category'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetCashFlowTableQuery(baseOptions: Apollo.QueryHookOptions<GetCashFlowTableQuery, GetCashFlowTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCashFlowTableQuery, GetCashFlowTableQueryVariables>(GetCashFlowTableDocument, options);
      }
export function useGetCashFlowTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCashFlowTableQuery, GetCashFlowTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCashFlowTableQuery, GetCashFlowTableQueryVariables>(GetCashFlowTableDocument, options);
        }
export type GetCashFlowTableQueryHookResult = ReturnType<typeof useGetCashFlowTableQuery>;
export type GetCashFlowTableLazyQueryHookResult = ReturnType<typeof useGetCashFlowTableLazyQuery>;
export type GetCashFlowTableQueryResult = Apollo.QueryResult<GetCashFlowTableQuery, GetCashFlowTableQueryVariables>;
export const GetSnapShotTableDocument = gql`
    query getSnapShotTable($groupId: Int!, $category: CompanyStatementCategory!, $from: Int, $to: Int) {
  group(id: $groupId) {
    id
    company {
      id
      statements(criteria: {category: [$category], fromYear: $from, toYear: $to}) {
        name
        category
        value
        important
        year
      }
      outstandingShares
    }
  }
}
    `;

/**
 * __useGetSnapShotTableQuery__
 *
 * To run a query within a React component, call `useGetSnapShotTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSnapShotTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSnapShotTableQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      category: // value for 'category'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetSnapShotTableQuery(baseOptions: Apollo.QueryHookOptions<GetSnapShotTableQuery, GetSnapShotTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSnapShotTableQuery, GetSnapShotTableQueryVariables>(GetSnapShotTableDocument, options);
      }
export function useGetSnapShotTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSnapShotTableQuery, GetSnapShotTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSnapShotTableQuery, GetSnapShotTableQueryVariables>(GetSnapShotTableDocument, options);
        }
export type GetSnapShotTableQueryHookResult = ReturnType<typeof useGetSnapShotTableQuery>;
export type GetSnapShotTableLazyQueryHookResult = ReturnType<typeof useGetSnapShotTableLazyQuery>;
export type GetSnapShotTableQueryResult = Apollo.QueryResult<GetSnapShotTableQuery, GetSnapShotTableQueryVariables>;
export const GetWinLossTableDocument = gql`
    query getWinLossTable($groupId: Int!, $category: CompanyStatementCategory!, $from: Int, $to: Int) {
  group(id: $groupId) {
    id
    company {
      id
      name
      accountingStandard
      currency {
        name
      }
      fiscal {
        day
        month
      }
      statements(criteria: {category: [$category], fromYear: $from, toYear: $to}) {
        name
        category
        value
        important
        year
      }
    }
  }
}
    `;

/**
 * __useGetWinLossTableQuery__
 *
 * To run a query within a React component, call `useGetWinLossTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWinLossTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWinLossTableQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      category: // value for 'category'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetWinLossTableQuery(baseOptions: Apollo.QueryHookOptions<GetWinLossTableQuery, GetWinLossTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWinLossTableQuery, GetWinLossTableQueryVariables>(GetWinLossTableDocument, options);
      }
export function useGetWinLossTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWinLossTableQuery, GetWinLossTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWinLossTableQuery, GetWinLossTableQueryVariables>(GetWinLossTableDocument, options);
        }
export type GetWinLossTableQueryHookResult = ReturnType<typeof useGetWinLossTableQuery>;
export type GetWinLossTableLazyQueryHookResult = ReturnType<typeof useGetWinLossTableLazyQuery>;
export type GetWinLossTableQueryResult = Apollo.QueryResult<GetWinLossTableQuery, GetWinLossTableQueryVariables>;
export const GetTradedAssetsDocument = gql`
    query getTradedAssets($days: Long!, $buy: Boolean!, $itemsReturned: Long!) {
  instrumentGroupTradesTopVolume(
    days: $days
    buy: $buy
    itemsReturned: $itemsReturned
  ) {
    group {
      id
      name
      main {
        id
        name
        exchange {
          code
        }
        group {
          seoTag
          assetGroup
        }
        currency {
          displayCode
        }
      }
    }
    quantity
  }
  instrumentGroupTradesTopTrades(
    days: $days
    buy: $buy
    itemsReturned: $itemsReturned
  ) {
    group {
      id
      name
      main {
        id
        name
        exchange {
          code
        }
        group {
          seoTag
          assetGroup
        }
        currency {
          displayCode
        }
      }
    }
    trades
  }
}
    `;

/**
 * __useGetTradedAssetsQuery__
 *
 * To run a query within a React component, call `useGetTradedAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTradedAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTradedAssetsQuery({
 *   variables: {
 *      days: // value for 'days'
 *      buy: // value for 'buy'
 *      itemsReturned: // value for 'itemsReturned'
 *   },
 * });
 */
export function useGetTradedAssetsQuery(baseOptions: Apollo.QueryHookOptions<GetTradedAssetsQuery, GetTradedAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTradedAssetsQuery, GetTradedAssetsQueryVariables>(GetTradedAssetsDocument, options);
      }
export function useGetTradedAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTradedAssetsQuery, GetTradedAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTradedAssetsQuery, GetTradedAssetsQueryVariables>(GetTradedAssetsDocument, options);
        }
export type GetTradedAssetsQueryHookResult = ReturnType<typeof useGetTradedAssetsQuery>;
export type GetTradedAssetsLazyQueryHookResult = ReturnType<typeof useGetTradedAssetsLazyQuery>;
export type GetTradedAssetsQueryResult = Apollo.QueryResult<GetTradedAssetsQuery, GetTradedAssetsQueryVariables>;
export const GetInstrumentsHotDocument = gql`
    query getInstrumentsHot($id: String!, $chartScope: ChartScope!) {
  list(id: $id) {
    id
    content {
      id
      name
      wkn
      isin
      chart(scope: $chartScope) {
        id
        series {
          label
          type
          data {
            value
            when
          }
        }
        threshold {
          type
          value
        }
      }
      group {
        id
        name
        seoTag
        assetGroup
        assetClass {
          name
        }
        underlying
        underlyings {
          name
          strike
          currency {
            displayCode
          }
        }
      }
      currency {
        displayCode
      }
      exchange {
        code
        delay
      }
      snapQuote {
        instrumentId
        lastChange
        cumulativeVolume
        quotes {
          type
          change
          percentChange
          value
          when
          size
        }
      }
      bestWarrantRnd(days: 120) {
        issuerGroupId
        issuerName
        instrument {
          id
          isin
          wkn
          name
          seoTag
          currencyId
          countryId
          country {
            name
          }
          snapQuote {
            instrumentId
            quotes {
              type
              change
              percentChange
              value
              when
              size
            }
          }
          keyFigures {
            gearing
          }
          sectorId
          currency {
            name
          }
          exchangeId
          exchange {
            name
          }
          securityCategoryId
          tickerSymbol
          sector {
            name
          }
          group {
            id
            seoTag
            assetGroup
            derivative {
              optionType
              issueDate
              maturityDate
            }
            issuer {
              id
              name
              partner
            }
            underlying
            underlyings {
              strike
              currency {
                displayCode
              }
            }
          }
          firstTradingDay
          lastTradingDay
        }
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentsHotQuery__
 *
 * To run a query within a React component, call `useGetInstrumentsHotQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentsHotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentsHotQuery({
 *   variables: {
 *      id: // value for 'id'
 *      chartScope: // value for 'chartScope'
 *   },
 * });
 */
export function useGetInstrumentsHotQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentsHotQuery, GetInstrumentsHotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentsHotQuery, GetInstrumentsHotQueryVariables>(GetInstrumentsHotDocument, options);
      }
export function useGetInstrumentsHotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentsHotQuery, GetInstrumentsHotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentsHotQuery, GetInstrumentsHotQueryVariables>(GetInstrumentsHotDocument, options);
        }
export type GetInstrumentsHotQueryHookResult = ReturnType<typeof useGetInstrumentsHotQuery>;
export type GetInstrumentsHotLazyQueryHookResult = ReturnType<typeof useGetInstrumentsHotLazyQuery>;
export type GetInstrumentsHotQueryResult = Apollo.QueryResult<GetInstrumentsHotQuery, GetInstrumentsHotQueryVariables>;
export const GetIndexListSectionDocument = gql`
    query getIndexListSection {
  list(id: "market_products") {
    id
    content {
      id
      name
      snapQuote {
        lastChange
        instrumentId
        quote(type: TRADE) {
          type
          when
          delay
          value
          percentChange
          change
        }
      }
      currency {
        displayCode
      }
      exchange {
        code
      }
      group {
        id
        name
        seoTag
        assetGroup
      }
    }
  }
}
    `;

/**
 * __useGetIndexListSectionQuery__
 *
 * To run a query within a React component, call `useGetIndexListSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndexListSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndexListSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIndexListSectionQuery(baseOptions?: Apollo.QueryHookOptions<GetIndexListSectionQuery, GetIndexListSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndexListSectionQuery, GetIndexListSectionQueryVariables>(GetIndexListSectionDocument, options);
      }
export function useGetIndexListSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndexListSectionQuery, GetIndexListSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndexListSectionQuery, GetIndexListSectionQueryVariables>(GetIndexListSectionDocument, options);
        }
export type GetIndexListSectionQueryHookResult = ReturnType<typeof useGetIndexListSectionQuery>;
export type GetIndexListSectionLazyQueryHookResult = ReturnType<typeof useGetIndexListSectionLazyQuery>;
export type GetIndexListSectionQueryResult = Apollo.QueryResult<GetIndexListSectionQuery, GetIndexListSectionQueryVariables>;
export const GetAnalysesDocument = gql`
    query getAnalyses($instrumentGroupId: Int!, $first: Int, $after: ID) {
  group(id: $instrumentGroupId) {
    id
    analysis(first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          date
          timeFrame
          recommendation
          targetPrice
          referencePrice
          updated
          latest
          currency {
            displayCode
            __typename
          }
          institute {
            id
            name
            __typename
          }
          analyst {
            firstName
            lastName
            __typename
          }
          group {
            id
            name
            seoTag
            assetGroup
            main {
              id
              currency {
                displayCode
              }
              snapQuote {
                lastChange
                instrumentId
                quote(type: TRADE) {
                  value
                  change
                  percentChange
                }
              }
            }
          }
          headline
          body
          __typename
        }
        __typename
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        __typename
      }
      __typename
    }
  }
}
    `;

/**
 * __useGetAnalysesQuery__
 *
 * To run a query within a React component, call `useGetAnalysesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalysesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalysesQuery({
 *   variables: {
 *      instrumentGroupId: // value for 'instrumentGroupId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAnalysesQuery(baseOptions: Apollo.QueryHookOptions<GetAnalysesQuery, GetAnalysesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalysesQuery, GetAnalysesQueryVariables>(GetAnalysesDocument, options);
      }
export function useGetAnalysesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalysesQuery, GetAnalysesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalysesQuery, GetAnalysesQueryVariables>(GetAnalysesDocument, options);
        }
export type GetAnalysesQueryHookResult = ReturnType<typeof useGetAnalysesQuery>;
export type GetAnalysesLazyQueryHookResult = ReturnType<typeof useGetAnalysesLazyQuery>;
export type GetAnalysesQueryResult = Apollo.QueryResult<GetAnalysesQuery, GetAnalysesQueryVariables>;
export const GetHomeAnalysesDocument = gql`
    query getHomeAnalyses($first: Int, $after: ID, $isin: [String!], $institutes: [String!], $targetFrom: LocalDate, $targetTo: LocalDate, $timeFrame: Int, $updated: Boolean, $recommendation: AnalysisRecommendation) {
  analysisSearch(
    criteria: {latest: true, updated: $updated, timeFrame: $timeFrame, isin: $isin, institutes: $institutes, recommendation: $recommendation, targetFrom: $targetFrom, targetTo: $targetTo}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        date
        timeFrame
        recommendation
        targetPrice
        referencePrice
        updated
        latest
        currency {
          displayCode
        }
        institute {
          id
          name
        }
        analyst {
          firstName
          lastName
        }
        group {
          id
          name
          isin
          seoTag
          assetGroup
          main {
            id
            currency {
              displayCode
            }
            snapQuote {
              lastChange
              instrumentId
              quotes {
                value
                change
                percentChange
                type
              }
            }
          }
        }
        headline
        body
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetHomeAnalysesQuery__
 *
 * To run a query within a React component, call `useGetHomeAnalysesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeAnalysesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeAnalysesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      isin: // value for 'isin'
 *      institutes: // value for 'institutes'
 *      targetFrom: // value for 'targetFrom'
 *      targetTo: // value for 'targetTo'
 *      timeFrame: // value for 'timeFrame'
 *      updated: // value for 'updated'
 *      recommendation: // value for 'recommendation'
 *   },
 * });
 */
export function useGetHomeAnalysesQuery(baseOptions?: Apollo.QueryHookOptions<GetHomeAnalysesQuery, GetHomeAnalysesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeAnalysesQuery, GetHomeAnalysesQueryVariables>(GetHomeAnalysesDocument, options);
      }
export function useGetHomeAnalysesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeAnalysesQuery, GetHomeAnalysesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeAnalysesQuery, GetHomeAnalysesQueryVariables>(GetHomeAnalysesDocument, options);
        }
export type GetHomeAnalysesQueryHookResult = ReturnType<typeof useGetHomeAnalysesQuery>;
export type GetHomeAnalysesLazyQueryHookResult = ReturnType<typeof useGetHomeAnalysesLazyQuery>;
export type GetHomeAnalysesQueryResult = Apollo.QueryResult<GetHomeAnalysesQuery, GetHomeAnalysesQueryVariables>;
export const GetNewsAllTopicsDocument = gql`
    query getNewsAllTopics {
  newsTopics {
    id
    name
    videoCapable
  }
}
    `;

/**
 * __useGetNewsAllTopicsQuery__
 *
 * To run a query within a React component, call `useGetNewsAllTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsAllTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsAllTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsAllTopicsQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsAllTopicsQuery, GetNewsAllTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsAllTopicsQuery, GetNewsAllTopicsQueryVariables>(GetNewsAllTopicsDocument, options);
      }
export function useGetNewsAllTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsAllTopicsQuery, GetNewsAllTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsAllTopicsQuery, GetNewsAllTopicsQueryVariables>(GetNewsAllTopicsDocument, options);
        }
export type GetNewsAllTopicsQueryHookResult = ReturnType<typeof useGetNewsAllTopicsQuery>;
export type GetNewsAllTopicsLazyQueryHookResult = ReturnType<typeof useGetNewsAllTopicsLazyQuery>;
export type GetNewsAllTopicsQueryResult = Apollo.QueryResult<GetNewsAllTopicsQuery, GetNewsAllTopicsQueryVariables>;
export const GetNewsOverviewFeedDocument = gql`
    query getNewsOverviewFeed($source: [ID!], $topic: [ID!], $first: Int, $after: ID) {
  newsSearch(
    criteria: {source: $source, topic: $topic}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        when
        body
        headline
        teaser
        links {
          name
          href
        }
        source {
          id
          name
        }
        medias {
          source
          width
          height
        }
        streams {
          mimeType
          duration
          width
          height
          source
        }
        feed
        keywords
        instruments {
          group {
            id
            isin
            name
            assetGroup
            seoTag
            main {
              id
              snapQuote {
                lastChange
                instrumentId
                lowPrice
                highPrice
                firstPrice
                lastPrice
                yesterdayPrice
                cumulativeTrades
                cumulativeTurnover
                cumulativeVolume
                quotes {
                  delay
                  type
                  value
                  percentChange
                  change
                  when
                }
              }
              currency {
                displayCode
              }
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useGetNewsOverviewFeedQuery__
 *
 * To run a query within a React component, call `useGetNewsOverviewFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsOverviewFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsOverviewFeedQuery({
 *   variables: {
 *      source: // value for 'source'
 *      topic: // value for 'topic'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetNewsOverviewFeedQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsOverviewFeedQuery, GetNewsOverviewFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsOverviewFeedQuery, GetNewsOverviewFeedQueryVariables>(GetNewsOverviewFeedDocument, options);
      }
export function useGetNewsOverviewFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsOverviewFeedQuery, GetNewsOverviewFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsOverviewFeedQuery, GetNewsOverviewFeedQueryVariables>(GetNewsOverviewFeedDocument, options);
        }
export type GetNewsOverviewFeedQueryHookResult = ReturnType<typeof useGetNewsOverviewFeedQuery>;
export type GetNewsOverviewFeedLazyQueryHookResult = ReturnType<typeof useGetNewsOverviewFeedLazyQuery>;
export type GetNewsOverviewFeedQueryResult = Apollo.QueryResult<GetNewsOverviewFeedQuery, GetNewsOverviewFeedQueryVariables>;
export const GetSecuritiesInFocusDocument = gql`
    query getSecuritiesInFocus($period: ReportPeriod) {
  newsProductCount(period: $period) {
    isin
    count
    group {
      id
      name
      wkn
      assetGroup
      seoTag
      main {
        id
        snapQuote {
          instrumentId
          lastChange
          lastPrice
          quotes {
            type
            percentChange
            value
          }
        }
      }
      news(first: 1) {
        edges {
          node {
            id
            headline
            body
            feed
            source {
              name
            }
            when
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSecuritiesInFocusQuery__
 *
 * To run a query within a React component, call `useGetSecuritiesInFocusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSecuritiesInFocusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSecuritiesInFocusQuery({
 *   variables: {
 *      period: // value for 'period'
 *   },
 * });
 */
export function useGetSecuritiesInFocusQuery(baseOptions?: Apollo.QueryHookOptions<GetSecuritiesInFocusQuery, GetSecuritiesInFocusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSecuritiesInFocusQuery, GetSecuritiesInFocusQueryVariables>(GetSecuritiesInFocusDocument, options);
      }
export function useGetSecuritiesInFocusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSecuritiesInFocusQuery, GetSecuritiesInFocusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSecuritiesInFocusQuery, GetSecuritiesInFocusQueryVariables>(GetSecuritiesInFocusDocument, options);
        }
export type GetSecuritiesInFocusQueryHookResult = ReturnType<typeof useGetSecuritiesInFocusQuery>;
export type GetSecuritiesInFocusLazyQueryHookResult = ReturnType<typeof useGetSecuritiesInFocusLazyQuery>;
export type GetSecuritiesInFocusQueryResult = Apollo.QueryResult<GetSecuritiesInFocusQuery, GetSecuritiesInFocusQueryVariables>;
export const GetTopFlopContentDocument = gql`
    query getTopFlopContent($groupId: Int!, $historyFrom: OffsetDateTime!, $historyTo: OffsetDateTime!) {
  group(id: $groupId) {
    id
    name
    seoTag
    assetGroup
    main {
      id
    }
    topFlop {
      instrument {
        id
        name
        isin
        group {
          name
          seoTag
          assetGroup
          sector {
            name
          }
        }
        currency {
          displayCode
        }
        exchange {
          id
          name
          code
        }
        bestWarrantRnd(days: 180) {
          instrument {
            id
            name
            wkn
            group {
              id
              name
              seoTag
              assetGroup
              issuer {
                id
                name
                partner
              }
              sector {
                name
              }
              underlyings {
                strike
                currency {
                  displayCode
                }
              }
            }
            currency {
              displayCode
            }
            exchange {
              id
              name
              code
            }
            keyFigures {
              gearing
            }
            snapQuote {
              instrumentId
              quotes {
                type
                percentChange
                size
                value
                when
              }
            }
          }
        }
        historyQuote(criteria: {from: $historyFrom, to: $historyTo}) {
          edges {
            node {
              id
              firstPrice
              lastPrice
              start
            }
          }
        }
        monteCarlo(days: 120) {
          min
          max
        }
      }
      snapQuote {
        lastChange
        instrumentId
        quote(type: TRADE) {
          percentChange
          value
          when
        }
      }
    }
  }
}
    `;

/**
 * __useGetTopFlopContentQuery__
 *
 * To run a query within a React component, call `useGetTopFlopContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopFlopContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopFlopContentQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      historyFrom: // value for 'historyFrom'
 *      historyTo: // value for 'historyTo'
 *   },
 * });
 */
export function useGetTopFlopContentQuery(baseOptions: Apollo.QueryHookOptions<GetTopFlopContentQuery, GetTopFlopContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopFlopContentQuery, GetTopFlopContentQueryVariables>(GetTopFlopContentDocument, options);
      }
export function useGetTopFlopContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopFlopContentQuery, GetTopFlopContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopFlopContentQuery, GetTopFlopContentQueryVariables>(GetTopFlopContentDocument, options);
        }
export type GetTopFlopContentQueryHookResult = ReturnType<typeof useGetTopFlopContentQuery>;
export type GetTopFlopContentLazyQueryHookResult = ReturnType<typeof useGetTopFlopContentLazyQuery>;
export type GetTopFlopContentQueryResult = Apollo.QueryResult<GetTopFlopContentQuery, GetTopFlopContentQueryVariables>;
export const GetTopFlopInstrumentsDocument = gql`
    query getTopFlopInstruments {
  list(id: "topflop_instruments") {
    id
    content {
      id
      name
      group {
        id
        name
        seoTag
        assetGroup
      }
      exchange {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useGetTopFlopInstrumentsQuery__
 *
 * To run a query within a React component, call `useGetTopFlopInstrumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopFlopInstrumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopFlopInstrumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopFlopInstrumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetTopFlopInstrumentsQuery, GetTopFlopInstrumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopFlopInstrumentsQuery, GetTopFlopInstrumentsQueryVariables>(GetTopFlopInstrumentsDocument, options);
      }
export function useGetTopFlopInstrumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopFlopInstrumentsQuery, GetTopFlopInstrumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopFlopInstrumentsQuery, GetTopFlopInstrumentsQueryVariables>(GetTopFlopInstrumentsDocument, options);
        }
export type GetTopFlopInstrumentsQueryHookResult = ReturnType<typeof useGetTopFlopInstrumentsQuery>;
export type GetTopFlopInstrumentsLazyQueryHookResult = ReturnType<typeof useGetTopFlopInstrumentsLazyQuery>;
export type GetTopFlopInstrumentsQueryResult = Apollo.QueryResult<GetTopFlopInstrumentsQuery, GetTopFlopInstrumentsQueryVariables>;
export const GetApplicationMetadataDocument = gql`
    query getApplicationMetadata {
  classification(category: ETF) {
    id
    name
    assetGroup
    typeGroups {
      id
      name
    }
  }
  etfAllocation {
    id
    name
  }
  etfPosition {
    id
    name
  }
  etfRegions {
    id
    name
  }
  etfSectors {
    id
    name
  }
  etfStrategies {
    id
    name
  }
  etfReplications {
    id
    name
  }
  etfIssuers {
    id
    name
  }
  bondNominalCurrencyBuckets {
    currency {
      id
      displayCode
      alphaCode
      name
    }
    count
  }
  bondTradingCurrencyBuckets {
    currency {
      id
      displayCode
      alphaCode
      name
    }
    count
  }
  bondTypes {
    name
    id
  }
  bondIssuers {
    id
    legalName
  }
  fundCurrencies {
    id
    name
  }
  fundRegions {
    id
    name
    countryIsoAlpha3
  }
  fundTopics {
    id
    name
  }
  fundStrategies {
    id
    name
  }
  fundTypes {
    id
    name
  }
  regions {
    id
    name
  }
}
    `;

/**
 * __useGetApplicationMetadataQuery__
 *
 * To run a query within a React component, call `useGetApplicationMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApplicationMetadataQuery(baseOptions?: Apollo.QueryHookOptions<GetApplicationMetadataQuery, GetApplicationMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationMetadataQuery, GetApplicationMetadataQueryVariables>(GetApplicationMetadataDocument, options);
      }
export function useGetApplicationMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationMetadataQuery, GetApplicationMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationMetadataQuery, GetApplicationMetadataQueryVariables>(GetApplicationMetadataDocument, options);
        }
export type GetApplicationMetadataQueryHookResult = ReturnType<typeof useGetApplicationMetadataQuery>;
export type GetApplicationMetadataLazyQueryHookResult = ReturnType<typeof useGetApplicationMetadataLazyQuery>;
export type GetApplicationMetadataQueryResult = Apollo.QueryResult<GetApplicationMetadataQuery, GetApplicationMetadataQueryVariables>;
export const AnalysisDocument = gql`
    query analysis($id: ID) {
  analysis: analysis(id: $id) {
    id
    date
    timeFrame
    recommendation
    targetPrice
    referencePrice
    updated
    latest
    currency {
      displayCode
    }
    institute {
      id
      name
    }
    analyst {
      firstName
      lastName
    }
    group {
      id
      name
      isin
      seoTag
      assetGroup
      main {
        id
        currency {
          displayCode
        }
        snapQuote {
          lastChange
          instrumentId
          quotes {
            value
            change
            percentChange
            type
          }
        }
      }
    }
    headline
    body
  }
}
    `;

/**
 * __useAnalysisQuery__
 *
 * To run a query within a React component, call `useAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalysisQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAnalysisQuery(baseOptions?: Apollo.QueryHookOptions<AnalysisQuery, AnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalysisQuery, AnalysisQueryVariables>(AnalysisDocument, options);
      }
export function useAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalysisQuery, AnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalysisQuery, AnalysisQueryVariables>(AnalysisDocument, options);
        }
export type AnalysisQueryHookResult = ReturnType<typeof useAnalysisQuery>;
export type AnalysisLazyQueryHookResult = ReturnType<typeof useAnalysisLazyQuery>;
export type AnalysisQueryResult = Apollo.QueryResult<AnalysisQuery, AnalysisQueryVariables>;
export const GetAnalysisHistoryDocument = gql`
    query getAnalysisHistory($isin: String!, $institute: String!, $first: Int!, $after: ID) {
  analysisSearch(
    criteria: {isin: [$isin], institutes: [$institute]}
    first: $first
    after: $after
  ) {
    edges {
      node {
        id
        date
        recommendation
        recommendationPrevious
        targetPrice
        targetPricePrevious
        updated
        group {
          id
          name
          seoTag
          assetGroup
          main {
            id
            currency {
              displayCode
            }
            snapQuote {
              lastChange
              instrumentId
              quote(type: TRADE) {
                value
                change
                percentChange
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAnalysisHistoryQuery__
 *
 * To run a query within a React component, call `useGetAnalysisHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalysisHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalysisHistoryQuery({
 *   variables: {
 *      isin: // value for 'isin'
 *      institute: // value for 'institute'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAnalysisHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetAnalysisHistoryQuery, GetAnalysisHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalysisHistoryQuery, GetAnalysisHistoryQueryVariables>(GetAnalysisHistoryDocument, options);
      }
export function useGetAnalysisHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalysisHistoryQuery, GetAnalysisHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalysisHistoryQuery, GetAnalysisHistoryQueryVariables>(GetAnalysisHistoryDocument, options);
        }
export type GetAnalysisHistoryQueryHookResult = ReturnType<typeof useGetAnalysisHistoryQuery>;
export type GetAnalysisHistoryLazyQueryHookResult = ReturnType<typeof useGetAnalysisHistoryLazyQuery>;
export type GetAnalysisHistoryQueryResult = Apollo.QueryResult<GetAnalysisHistoryQuery, GetAnalysisHistoryQueryVariables>;
export const GetAnalysisInstitutesDocument = gql`
    query getAnalysisInstitutes {
  analysisInstitute {
    id
    name
  }
}
    `;

/**
 * __useGetAnalysisInstitutesQuery__
 *
 * To run a query within a React component, call `useGetAnalysisInstitutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalysisInstitutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalysisInstitutesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAnalysisInstitutesQuery(baseOptions?: Apollo.QueryHookOptions<GetAnalysisInstitutesQuery, GetAnalysisInstitutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalysisInstitutesQuery, GetAnalysisInstitutesQueryVariables>(GetAnalysisInstitutesDocument, options);
      }
export function useGetAnalysisInstitutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalysisInstitutesQuery, GetAnalysisInstitutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalysisInstitutesQuery, GetAnalysisInstitutesQueryVariables>(GetAnalysisInstitutesDocument, options);
        }
export type GetAnalysisInstitutesQueryHookResult = ReturnType<typeof useGetAnalysisInstitutesQuery>;
export type GetAnalysisInstitutesLazyQueryHookResult = ReturnType<typeof useGetAnalysisInstitutesLazyQuery>;
export type GetAnalysisInstitutesQueryResult = Apollo.QueryResult<GetAnalysisInstitutesQuery, GetAnalysisInstitutesQueryVariables>;
export const GetAnalysesPageDocument = gql`
    query getAnalysesPage($first: Int, $after: ID, $isin: [String!], $institutes: [String!], $targetFrom: LocalDate, $targetTo: LocalDate, $timeFrame: Int, $updated: Boolean, $recommendation: AnalysisRecommendation) {
  analysisSearch(
    criteria: {latest: true, updated: $updated, timeFrame: $timeFrame, isin: $isin, institutes: $institutes, recommendation: $recommendation, targetFrom: $targetFrom, targetTo: $targetTo}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        date
        timeFrame
        recommendation
        targetPrice
        referencePrice
        updated
        latest
        currency {
          displayCode
        }
        institute {
          id
          name
        }
        analyst {
          firstName
          lastName
        }
        group {
          id
          name
          isin
          seoTag
          assetGroup
          main {
            id
            currency {
              displayCode
            }
            snapQuote {
              lastChange
              instrumentId
              quotes {
                value
                change
                percentChange
                type
              }
            }
          }
        }
        headline
        body
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetAnalysesPageQuery__
 *
 * To run a query within a React component, call `useGetAnalysesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalysesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalysesPageQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      isin: // value for 'isin'
 *      institutes: // value for 'institutes'
 *      targetFrom: // value for 'targetFrom'
 *      targetTo: // value for 'targetTo'
 *      timeFrame: // value for 'timeFrame'
 *      updated: // value for 'updated'
 *      recommendation: // value for 'recommendation'
 *   },
 * });
 */
export function useGetAnalysesPageQuery(baseOptions?: Apollo.QueryHookOptions<GetAnalysesPageQuery, GetAnalysesPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalysesPageQuery, GetAnalysesPageQueryVariables>(GetAnalysesPageDocument, options);
      }
export function useGetAnalysesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalysesPageQuery, GetAnalysesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalysesPageQuery, GetAnalysesPageQueryVariables>(GetAnalysesPageDocument, options);
        }
export type GetAnalysesPageQueryHookResult = ReturnType<typeof useGetAnalysesPageQuery>;
export type GetAnalysesPageLazyQueryHookResult = ReturnType<typeof useGetAnalysesPageLazyQuery>;
export type GetAnalysesPageQueryResult = Apollo.QueryResult<GetAnalysesPageQuery, GetAnalysesPageQueryVariables>;
export const GetBondPageDocument = gql`
    query getBondPage($groupId: Int!) {
  group(id: $groupId) {
    id
    name
    isin
    wkn
    assetGroup
    content {
      country {
        name
      }
      id
      isin
      wkn
      main
      tickerSymbol
      name
      group {
        assetGroup
        seoTag
        sector {
          name
        }
      }
      exchange {
        id
        name
        code
        type
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        delay
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          size
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        basePrice
        performance
        deltaAveragePrice
        sharpe
        vola
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      indicators {
        relativeStrengthLevy {
          deltaMedian
          indicator
        }
        movingAverage {
          deltaLine200Day
          deltaLine38Day
        }
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
      derivativeKeyFigures {
        dirtyPrice
        ismaYield
        accruedInterest
        duration
        modifiedDuration
        spread
        spreadRelative
      }
    }
    assetType {
      name
    }
    bond {
      name
      isin
      status {
        id
        name
      }
      type {
        id
        name
      }
      issueSize
      issueDate
      firstTradingDate
      maturityDate
      minTradableLot
      interestLoan
      minTradableLot
      minAmountTradableLot
      fiatIssuance
      subordinatedDebt
      nominalValue
      nominalCurrency {
        id
        alphaCode
        name
        displayCode
      }
      tradingCurrency {
        id
        alphaCode
        displayCode
        name
      }
      settlementCurrency {
        id
        alphaCode
        displayCode
        name
      }
      priceAttribute {
        id
        name
      }
      issuer {
        id
        id
        lei
        legalName
        name
        isin
        group {
          id
          name
          assetClass {
            id
            name
          }
          assetGroup
        }
      }
    }
  }
}
    `;

/**
 * __useGetBondPageQuery__
 *
 * To run a query within a React component, call `useGetBondPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBondPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBondPageQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetBondPageQuery(baseOptions: Apollo.QueryHookOptions<GetBondPageQuery, GetBondPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBondPageQuery, GetBondPageQueryVariables>(GetBondPageDocument, options);
      }
export function useGetBondPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBondPageQuery, GetBondPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBondPageQuery, GetBondPageQueryVariables>(GetBondPageDocument, options);
        }
export type GetBondPageQueryHookResult = ReturnType<typeof useGetBondPageQuery>;
export type GetBondPageLazyQueryHookResult = ReturnType<typeof useGetBondPageLazyQuery>;
export type GetBondPageQueryResult = Apollo.QueryResult<GetBondPageQuery, GetBondPageQueryVariables>;
export const GetBondSearchCountDocument = gql`
    query getBondSearchCount($criterion: SearchBondCriterion, $sort: [SearchBondSort!] = []) {
  searchBond(criterion: $criterion, sort: $sort, first: 0) {
    count
  }
}
    `;

/**
 * __useGetBondSearchCountQuery__
 *
 * To run a query within a React component, call `useGetBondSearchCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBondSearchCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBondSearchCountQuery({
 *   variables: {
 *      criterion: // value for 'criterion'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetBondSearchCountQuery(baseOptions?: Apollo.QueryHookOptions<GetBondSearchCountQuery, GetBondSearchCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBondSearchCountQuery, GetBondSearchCountQueryVariables>(GetBondSearchCountDocument, options);
      }
export function useGetBondSearchCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBondSearchCountQuery, GetBondSearchCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBondSearchCountQuery, GetBondSearchCountQueryVariables>(GetBondSearchCountDocument, options);
        }
export type GetBondSearchCountQueryHookResult = ReturnType<typeof useGetBondSearchCountQuery>;
export type GetBondSearchCountLazyQueryHookResult = ReturnType<typeof useGetBondSearchCountLazyQuery>;
export type GetBondSearchCountQueryResult = Apollo.QueryResult<GetBondSearchCountQuery, GetBondSearchCountQueryVariables>;
export const GetBondSearchMetadataDocument = gql`
    query getBondSearchMetadata {
  classification(category: BOND) {
    id
    name
  }
  bondTypes {
    id
    name
  }
  bondNominalCurrencyBuckets {
    currency {
      id
      displayCode
      alphaCode
      name
    }
    count
  }
  bondTradingCurrencyBuckets {
    currency {
      id
      displayCode
      alphaCode
      name
    }
    count
  }
  bondIssuers {
    id
    legalName
  }
}
    `;

/**
 * __useGetBondSearchMetadataQuery__
 *
 * To run a query within a React component, call `useGetBondSearchMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBondSearchMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBondSearchMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBondSearchMetadataQuery(baseOptions?: Apollo.QueryHookOptions<GetBondSearchMetadataQuery, GetBondSearchMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBondSearchMetadataQuery, GetBondSearchMetadataQueryVariables>(GetBondSearchMetadataDocument, options);
      }
export function useGetBondSearchMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBondSearchMetadataQuery, GetBondSearchMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBondSearchMetadataQuery, GetBondSearchMetadataQueryVariables>(GetBondSearchMetadataDocument, options);
        }
export type GetBondSearchMetadataQueryHookResult = ReturnType<typeof useGetBondSearchMetadataQuery>;
export type GetBondSearchMetadataLazyQueryHookResult = ReturnType<typeof useGetBondSearchMetadataLazyQuery>;
export type GetBondSearchMetadataQueryResult = Apollo.QueryResult<GetBondSearchMetadataQuery, GetBondSearchMetadataQueryVariables>;
export const GetBondSearchResultDocument = gql`
    query getBondSearchResult($criterion: SearchBondCriterion, $sort: [SearchBondSort!] = [], $first: Int, $after: ID) {
  searchBond(criterion: $criterion, sort: $sort, first: $first, after: $after) {
    edges {
      node {
        id
        isin
        wkn
        main
        name
        group {
          id
          name
          assetGroup
          assetClass {
            name
          }
          seoTag
          bond {
            name
            isin
            status {
              id
              name
            }
            type {
              id
              name
            }
            issueSize
            issueDate
            firstTradingDate
            maturityDate
            minTradableLot
            interestLoan
            minTradableLot
            minAmountTradableLot
            fiatIssuance
            subordinatedDebt
            nominalValue
            nominalCurrency {
              id
              alphaCode
              name
              displayCode
            }
            tradingCurrency {
              id
              alphaCode
              displayCode
              name
            }
            settlementCurrency {
              id
              alphaCode
              displayCode
              name
            }
            priceAttribute {
              id
              name
            }
            issuer {
              id
              id
              lei
              legalName
              name
              isin
              group {
                id
                name
                assetClass {
                  id
                  name
                }
                assetGroup
              }
            }
          }
        }
        currency {
          displayCode
          sign
        }
        exchange {
          id
          name
          code
        }
        snapQuote {
          lastChange
          instrumentId
          quotes {
            type
            value
            when
          }
        }
        performance(period: [WEEK52]) {
          period
          performance
          deltaAveragePrice
        }
        derivativeKeyFigures {
          dirtyPrice
          ismaYield
          accruedInterest
          duration
          modifiedDuration
          spread
          spreadRelative
        }
      }
    }
    count
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetBondSearchResultQuery__
 *
 * To run a query within a React component, call `useGetBondSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBondSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBondSearchResultQuery({
 *   variables: {
 *      criterion: // value for 'criterion'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetBondSearchResultQuery(baseOptions?: Apollo.QueryHookOptions<GetBondSearchResultQuery, GetBondSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBondSearchResultQuery, GetBondSearchResultQueryVariables>(GetBondSearchResultDocument, options);
      }
export function useGetBondSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBondSearchResultQuery, GetBondSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBondSearchResultQuery, GetBondSearchResultQueryVariables>(GetBondSearchResultDocument, options);
        }
export type GetBondSearchResultQueryHookResult = ReturnType<typeof useGetBondSearchResultQuery>;
export type GetBondSearchResultLazyQueryHookResult = ReturnType<typeof useGetBondSearchResultLazyQuery>;
export type GetBondSearchResultQueryResult = Apollo.QueryResult<GetBondSearchResultQuery, GetBondSearchResultQueryVariables>;
export const GetCommodityInstrumentsDocument = gql`
    query getCommodityInstruments($chartScope: ChartScope!) {
  list(id: "commodity_instruments") {
    id
    content {
      id
      name
      chart(scope: $chartScope) {
        id
        series {
          label
          type
          data {
            value
            when
          }
        }
        threshold {
          type
          value
        }
      }
      group {
        id
        name
        seoTag
        assetGroup
        main {
          stats(periods: [ALL_TIME, WEEK52]) {
            period
            lowPrice
            lowPriceDate
            deltaLowPrice
            highPrice
            highPriceDate
            deltaHighPrice
          }
          indicators {
            relativeStrengthLevy {
              deltaMedian
              indicator
            }
            movingAverage {
              deltaLine200Day
              deltaLine38Day
            }
          }
          chart(scope: INTRADAY) {
            series {
              label
              type
              data {
                value
                when
              }
            }
            threshold {
              type
              value
            }
          }
        }
      }
      currency {
        displayCode
      }
      snapQuote {
        lastChange
        instrumentId
        quote(type: TRADE) {
          value
          change
          percentChange
        }
      }
    }
  }
}
    `;

/**
 * __useGetCommodityInstrumentsQuery__
 *
 * To run a query within a React component, call `useGetCommodityInstrumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommodityInstrumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommodityInstrumentsQuery({
 *   variables: {
 *      chartScope: // value for 'chartScope'
 *   },
 * });
 */
export function useGetCommodityInstrumentsQuery(baseOptions: Apollo.QueryHookOptions<GetCommodityInstrumentsQuery, GetCommodityInstrumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommodityInstrumentsQuery, GetCommodityInstrumentsQueryVariables>(GetCommodityInstrumentsDocument, options);
      }
export function useGetCommodityInstrumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommodityInstrumentsQuery, GetCommodityInstrumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommodityInstrumentsQuery, GetCommodityInstrumentsQueryVariables>(GetCommodityInstrumentsDocument, options);
        }
export type GetCommodityInstrumentsQueryHookResult = ReturnType<typeof useGetCommodityInstrumentsQuery>;
export type GetCommodityInstrumentsLazyQueryHookResult = ReturnType<typeof useGetCommodityInstrumentsLazyQuery>;
export type GetCommodityInstrumentsQueryResult = Apollo.QueryResult<GetCommodityInstrumentsQuery, GetCommodityInstrumentsQueryVariables>;
export const GetEtfSearchCountDocument = gql`
    query getEtfSearchCount($criterion: SearchEtfCriterion, $sort: [SearchEtfSort!] = []) {
  searchEtf(criterion: $criterion, sort: $sort, first: 0) {
    count
  }
}
    `;

/**
 * __useGetEtfSearchCountQuery__
 *
 * To run a query within a React component, call `useGetEtfSearchCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEtfSearchCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEtfSearchCountQuery({
 *   variables: {
 *      criterion: // value for 'criterion'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetEtfSearchCountQuery(baseOptions?: Apollo.QueryHookOptions<GetEtfSearchCountQuery, GetEtfSearchCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEtfSearchCountQuery, GetEtfSearchCountQueryVariables>(GetEtfSearchCountDocument, options);
      }
export function useGetEtfSearchCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEtfSearchCountQuery, GetEtfSearchCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEtfSearchCountQuery, GetEtfSearchCountQueryVariables>(GetEtfSearchCountDocument, options);
        }
export type GetEtfSearchCountQueryHookResult = ReturnType<typeof useGetEtfSearchCountQuery>;
export type GetEtfSearchCountLazyQueryHookResult = ReturnType<typeof useGetEtfSearchCountLazyQuery>;
export type GetEtfSearchCountQueryResult = Apollo.QueryResult<GetEtfSearchCountQuery, GetEtfSearchCountQueryVariables>;
export const GetEtfSearchMetadataDocument = gql`
    query getEtfSearchMetadata {
  classification(category: ETF) {
    id
    name
    typeGroups {
      id
      name
    }
  }
  etfAllocation {
    id
    name
  }
  etfPosition {
    id
    name
  }
  etfRegions {
    id
    name
  }
  etfSectors {
    id
    name
  }
  etfStrategies {
    id
    name
  }
  etfReplications {
    id
    name
  }
  etfIssuers {
    id
    name
  }
}
    `;

/**
 * __useGetEtfSearchMetadataQuery__
 *
 * To run a query within a React component, call `useGetEtfSearchMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEtfSearchMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEtfSearchMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEtfSearchMetadataQuery(baseOptions?: Apollo.QueryHookOptions<GetEtfSearchMetadataQuery, GetEtfSearchMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEtfSearchMetadataQuery, GetEtfSearchMetadataQueryVariables>(GetEtfSearchMetadataDocument, options);
      }
export function useGetEtfSearchMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEtfSearchMetadataQuery, GetEtfSearchMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEtfSearchMetadataQuery, GetEtfSearchMetadataQueryVariables>(GetEtfSearchMetadataDocument, options);
        }
export type GetEtfSearchMetadataQueryHookResult = ReturnType<typeof useGetEtfSearchMetadataQuery>;
export type GetEtfSearchMetadataLazyQueryHookResult = ReturnType<typeof useGetEtfSearchMetadataLazyQuery>;
export type GetEtfSearchMetadataQueryResult = Apollo.QueryResult<GetEtfSearchMetadataQuery, GetEtfSearchMetadataQueryVariables>;
export const GetEtfSearchResultDocument = gql`
    query getEtfSearchResult($criterion: SearchEtfCriterion, $sort: [SearchEtfSort!] = [], $first: Int, $after: ID) {
  searchEtf(criterion: $criterion, sort: $sort, first: $first, after: $after) {
    count
    edges {
      node {
        id
        isin
        wkn
        main
        tickerSymbol
        name
        exchange {
          id
          name
          code
        }
        currency {
          id
          name
          displayCode
          sign
        }
        snapQuote {
          lastChange
          instrumentId
          lowPrice
          highPrice
          firstPrice
          lastPrice
          yesterdayPrice
          cumulativeTrades
          cumulativeTurnover
          cumulativeVolume
          quotes {
            delay
            type
            value
            percentChange
            change
            when
          }
        }
        performance(period: [WEEK52, YEAR3]) {
          period
          basePrice
          averagePrice
          performance
          sharpe
          vola
        }
        stats(periods: [WEEK52]) {
          period
          lowPrice
          lowPriceDate
          deltaLowPrice
          highPrice
          highPriceDate
          deltaHighPrice
        }
        group {
          id
          isin
          name
          seoTag
          assetGroup
          assetClass {
            name
          }
          assetTypeGroup {
            name
          }
          assetType {
            name
          }
          etf {
            id
            investmentConcept
            participationFactor
            underlyingRatio
            position
            charge
            distributing
            foundationDate
            quanto
            issuer {
              name
            }
            sector {
              name
            }
            region {
              name
            }
            allocation {
              name
            }
            domicile {
              name
            }
            strategy {
              name
            }
            replication {
              name
            }
            investmentVolume {
              date
              value
              currency {
                displayCode
              }
            }
            keyFigures {
              totalExpenseRatio
              jensenAlpha
              betaFactor
              negativeRegression
              positiveRegression
              maxLoosing6Month
              longestLoosingPeriod
              trackingError
            }
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetEtfSearchResultQuery__
 *
 * To run a query within a React component, call `useGetEtfSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEtfSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEtfSearchResultQuery({
 *   variables: {
 *      criterion: // value for 'criterion'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetEtfSearchResultQuery(baseOptions?: Apollo.QueryHookOptions<GetEtfSearchResultQuery, GetEtfSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEtfSearchResultQuery, GetEtfSearchResultQueryVariables>(GetEtfSearchResultDocument, options);
      }
export function useGetEtfSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEtfSearchResultQuery, GetEtfSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEtfSearchResultQuery, GetEtfSearchResultQueryVariables>(GetEtfSearchResultDocument, options);
        }
export type GetEtfSearchResultQueryHookResult = ReturnType<typeof useGetEtfSearchResultQuery>;
export type GetEtfSearchResultLazyQueryHookResult = ReturnType<typeof useGetEtfSearchResultLazyQuery>;
export type GetEtfSearchResultQueryResult = Apollo.QueryResult<GetEtfSearchResultQuery, GetEtfSearchResultQueryVariables>;
export const GetCommoditiesDocument = gql`
    query getCommodities($assetGroup: [AssetGroup!], $searchString: String!, $first: Int!, $after: ID) {
  search(
    criteria: {assetGroup: $assetGroup, searchString: $searchString}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        group {
          id
          name
          wkn
          seoTag
          assetGroup
          main {
            id
            country {
              name
              isoAlpha3
            }
            stats(periods: [ALL_TIME]) {
              period
              lowPrice
              lowPriceDate
              deltaLowPrice
              highPrice
              highPriceDate
              deltaHighPrice
            }
            indicators {
              movingAverage {
                deltaLine200Day
              }
            }
          }
          compositions {
            id
            name
          }
        }
        snapQuote {
          lastChange
          instrumentId
          quote(type: TRADE) {
            value
            change
            percentChange
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetCommoditiesQuery__
 *
 * To run a query within a React component, call `useGetCommoditiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommoditiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommoditiesQuery({
 *   variables: {
 *      assetGroup: // value for 'assetGroup'
 *      searchString: // value for 'searchString'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCommoditiesQuery(baseOptions: Apollo.QueryHookOptions<GetCommoditiesQuery, GetCommoditiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommoditiesQuery, GetCommoditiesQueryVariables>(GetCommoditiesDocument, options);
      }
export function useGetCommoditiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommoditiesQuery, GetCommoditiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommoditiesQuery, GetCommoditiesQueryVariables>(GetCommoditiesDocument, options);
        }
export type GetCommoditiesQueryHookResult = ReturnType<typeof useGetCommoditiesQuery>;
export type GetCommoditiesLazyQueryHookResult = ReturnType<typeof useGetCommoditiesLazyQuery>;
export type GetCommoditiesQueryResult = Apollo.QueryResult<GetCommoditiesQuery, GetCommoditiesQueryVariables>;
export const GetInstrumentGroupIncludedDocument = gql`
    query getInstrumentGroupIncluded($instrumentGroupId: Long!, $days: Long!) {
  instrumentGroupIncluded(instrumentGroupId: $instrumentGroupId) {
    portfolios
    totalPortfolios
    watchlists
    totalWatchlists
    limitsUpper
    limitsLower
    limits
    totalLimits
  }
  instrumentGroupTrades(instrumentGroupId: $instrumentGroupId, days: $days) {
    instrument {
      id
    }
    price
    quantity
    buy
  }
}
    `;

/**
 * __useGetInstrumentGroupIncludedQuery__
 *
 * To run a query within a React component, call `useGetInstrumentGroupIncludedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentGroupIncludedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentGroupIncludedQuery({
 *   variables: {
 *      instrumentGroupId: // value for 'instrumentGroupId'
 *      days: // value for 'days'
 *   },
 * });
 */
export function useGetInstrumentGroupIncludedQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentGroupIncludedQuery, GetInstrumentGroupIncludedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentGroupIncludedQuery, GetInstrumentGroupIncludedQueryVariables>(GetInstrumentGroupIncludedDocument, options);
      }
export function useGetInstrumentGroupIncludedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentGroupIncludedQuery, GetInstrumentGroupIncludedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentGroupIncludedQuery, GetInstrumentGroupIncludedQueryVariables>(GetInstrumentGroupIncludedDocument, options);
        }
export type GetInstrumentGroupIncludedQueryHookResult = ReturnType<typeof useGetInstrumentGroupIncludedQuery>;
export type GetInstrumentGroupIncludedLazyQueryHookResult = ReturnType<typeof useGetInstrumentGroupIncludedLazyQuery>;
export type GetInstrumentGroupIncludedQueryResult = Apollo.QueryResult<GetInstrumentGroupIncludedQuery, GetInstrumentGroupIncludedQueryVariables>;
export const GetInstrumentChartPerformanceDocument = gql`
    query getInstrumentChartPerformance($instrumentId: Int!, $from: LocalDate!, $to: LocalDate!) {
  instrument(id: $instrumentId) {
    id
    name
    isin
    monteCarlo(days: 120) {
      min
      avg
      max
      up
      down
    }
    snapQuote {
      lastChange
      instrumentId
      quote(type: TRADE) {
        value
        change
        percentChange
      }
    }
    currency {
      id
      displayCode
    }
    quoteHistory(from: $from, to: $to) {
      edges {
        node {
          date
          lastPrice
        }
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentChartPerformanceQuery__
 *
 * To run a query within a React component, call `useGetInstrumentChartPerformanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentChartPerformanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentChartPerformanceQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetInstrumentChartPerformanceQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentChartPerformanceQuery, GetInstrumentChartPerformanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentChartPerformanceQuery, GetInstrumentChartPerformanceQueryVariables>(GetInstrumentChartPerformanceDocument, options);
      }
export function useGetInstrumentChartPerformanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentChartPerformanceQuery, GetInstrumentChartPerformanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentChartPerformanceQuery, GetInstrumentChartPerformanceQueryVariables>(GetInstrumentChartPerformanceDocument, options);
        }
export type GetInstrumentChartPerformanceQueryHookResult = ReturnType<typeof useGetInstrumentChartPerformanceQuery>;
export type GetInstrumentChartPerformanceLazyQueryHookResult = ReturnType<typeof useGetInstrumentChartPerformanceLazyQuery>;
export type GetInstrumentChartPerformanceQueryResult = Apollo.QueryResult<GetInstrumentChartPerformanceQuery, GetInstrumentChartPerformanceQueryVariables>;
export const GetInstrumentChartForCompareDocument = gql`
    query getInstrumentChartForCompare($instrumentId: Int!, $chartScope: ChartScope!) {
  instrument(id: $instrumentId) {
    id
    name
    group {
      id
      name
    }
    chart(scope: $chartScope) {
      id
      series {
        label
        type
        data {
          value
          when
        }
      }
      threshold {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentChartForCompareQuery__
 *
 * To run a query within a React component, call `useGetInstrumentChartForCompareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentChartForCompareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentChartForCompareQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      chartScope: // value for 'chartScope'
 *   },
 * });
 */
export function useGetInstrumentChartForCompareQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentChartForCompareQuery, GetInstrumentChartForCompareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentChartForCompareQuery, GetInstrumentChartForCompareQueryVariables>(GetInstrumentChartForCompareDocument, options);
      }
export function useGetInstrumentChartForCompareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentChartForCompareQuery, GetInstrumentChartForCompareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentChartForCompareQuery, GetInstrumentChartForCompareQueryVariables>(GetInstrumentChartForCompareDocument, options);
        }
export type GetInstrumentChartForCompareQueryHookResult = ReturnType<typeof useGetInstrumentChartForCompareQuery>;
export type GetInstrumentChartForCompareLazyQueryHookResult = ReturnType<typeof useGetInstrumentChartForCompareLazyQuery>;
export type GetInstrumentChartForCompareQueryResult = Apollo.QueryResult<GetInstrumentChartForCompareQuery, GetInstrumentChartForCompareQueryVariables>;
export const GetInstrumentChartToolModalDocument = gql`
    query getInstrumentChartToolModal($instrumentId: Int!, $chartScope: ChartScope!, $criteria: HistoryQuoteCriteria!) {
  instrument(id: $instrumentId) {
    id
    name
    group {
      id
      name
    }
    historyQuote(criteria: $criteria) {
      edges {
        node {
          cumulativeVolume
          start
          firstPrice
          highPrice
          id
          lastPrice
          lowPrice
        }
      }
    }
    chart(scope: $chartScope) {
      id
      series {
        label
        type
        data {
          value
          when
        }
      }
      threshold {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentChartToolModalQuery__
 *
 * To run a query within a React component, call `useGetInstrumentChartToolModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentChartToolModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentChartToolModalQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      chartScope: // value for 'chartScope'
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useGetInstrumentChartToolModalQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentChartToolModalQuery, GetInstrumentChartToolModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentChartToolModalQuery, GetInstrumentChartToolModalQueryVariables>(GetInstrumentChartToolModalDocument, options);
      }
export function useGetInstrumentChartToolModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentChartToolModalQuery, GetInstrumentChartToolModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentChartToolModalQuery, GetInstrumentChartToolModalQueryVariables>(GetInstrumentChartToolModalDocument, options);
        }
export type GetInstrumentChartToolModalQueryHookResult = ReturnType<typeof useGetInstrumentChartToolModalQuery>;
export type GetInstrumentChartToolModalLazyQueryHookResult = ReturnType<typeof useGetInstrumentChartToolModalLazyQuery>;
export type GetInstrumentChartToolModalQueryResult = Apollo.QueryResult<GetInstrumentChartToolModalQuery, GetInstrumentChartToolModalQueryVariables>;
export const GetTopsFlopsIndicesDocument = gql`
    query getTopsFlopsIndices {
  list(id: "topflop_instruments") {
    id
    content {
      id
      name
      group {
        id
        name
        seoTag
        assetGroup
      }
    }
  }
}
    `;

/**
 * __useGetTopsFlopsIndicesQuery__
 *
 * To run a query within a React component, call `useGetTopsFlopsIndicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopsFlopsIndicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopsFlopsIndicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopsFlopsIndicesQuery(baseOptions?: Apollo.QueryHookOptions<GetTopsFlopsIndicesQuery, GetTopsFlopsIndicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopsFlopsIndicesQuery, GetTopsFlopsIndicesQueryVariables>(GetTopsFlopsIndicesDocument, options);
      }
export function useGetTopsFlopsIndicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopsFlopsIndicesQuery, GetTopsFlopsIndicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopsFlopsIndicesQuery, GetTopsFlopsIndicesQueryVariables>(GetTopsFlopsIndicesDocument, options);
        }
export type GetTopsFlopsIndicesQueryHookResult = ReturnType<typeof useGetTopsFlopsIndicesQuery>;
export type GetTopsFlopsIndicesLazyQueryHookResult = ReturnType<typeof useGetTopsFlopsIndicesLazyQuery>;
export type GetTopsFlopsIndicesQueryResult = Apollo.QueryResult<GetTopsFlopsIndicesQuery, GetTopsFlopsIndicesQueryVariables>;
export const GetInstrumentChartBannerDocument = gql`
    query getInstrumentChartBanner($instrumentId: Int!, $chartScope: ChartScope!) {
  instrument(id: $instrumentId) {
    id
    chart(scope: $chartScope) {
      id
      series {
        label
        type
        data {
          value
          when
        }
      }
      threshold {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentChartBannerQuery__
 *
 * To run a query within a React component, call `useGetInstrumentChartBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentChartBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentChartBannerQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      chartScope: // value for 'chartScope'
 *   },
 * });
 */
export function useGetInstrumentChartBannerQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentChartBannerQuery, GetInstrumentChartBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentChartBannerQuery, GetInstrumentChartBannerQueryVariables>(GetInstrumentChartBannerDocument, options);
      }
export function useGetInstrumentChartBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentChartBannerQuery, GetInstrumentChartBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentChartBannerQuery, GetInstrumentChartBannerQueryVariables>(GetInstrumentChartBannerDocument, options);
        }
export type GetInstrumentChartBannerQueryHookResult = ReturnType<typeof useGetInstrumentChartBannerQuery>;
export type GetInstrumentChartBannerLazyQueryHookResult = ReturnType<typeof useGetInstrumentChartBannerLazyQuery>;
export type GetInstrumentChartBannerQueryResult = Apollo.QueryResult<GetInstrumentChartBannerQuery, GetInstrumentChartBannerQueryVariables>;
export const GetInstrumentSnapQuoteCardInfoDocument = gql`
    query getInstrumentSnapQuoteCardInfo($instrumentId: Int!) {
  instrument(id: $instrumentId) {
    id
    name
    group {
      assetGroup
      seoTag
    }
    snapQuote {
      lastChange
      instrumentId
      quotes {
        type
        delay
        value
        change
        percentChange
        when
      }
    }
    exchange {
      id
      code
    }
    currency {
      id
      displayCode
    }
  }
}
    `;

/**
 * __useGetInstrumentSnapQuoteCardInfoQuery__
 *
 * To run a query within a React component, call `useGetInstrumentSnapQuoteCardInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentSnapQuoteCardInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentSnapQuoteCardInfoQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *   },
 * });
 */
export function useGetInstrumentSnapQuoteCardInfoQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentSnapQuoteCardInfoQuery, GetInstrumentSnapQuoteCardInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentSnapQuoteCardInfoQuery, GetInstrumentSnapQuoteCardInfoQueryVariables>(GetInstrumentSnapQuoteCardInfoDocument, options);
      }
export function useGetInstrumentSnapQuoteCardInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentSnapQuoteCardInfoQuery, GetInstrumentSnapQuoteCardInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentSnapQuoteCardInfoQuery, GetInstrumentSnapQuoteCardInfoQueryVariables>(GetInstrumentSnapQuoteCardInfoDocument, options);
        }
export type GetInstrumentSnapQuoteCardInfoQueryHookResult = ReturnType<typeof useGetInstrumentSnapQuoteCardInfoQuery>;
export type GetInstrumentSnapQuoteCardInfoLazyQueryHookResult = ReturnType<typeof useGetInstrumentSnapQuoteCardInfoLazyQuery>;
export type GetInstrumentSnapQuoteCardInfoQueryResult = Apollo.QueryResult<GetInstrumentSnapQuoteCardInfoQuery, GetInstrumentSnapQuoteCardInfoQueryVariables>;
export const GetInstrumentSnapQuoteChartDocument = gql`
    query getInstrumentSnapQuoteChart($instrumentId: Int!) {
  instrument(id: $instrumentId) {
    id
    chart(scope: INTRADAY) {
      id
      series {
        label
        type
        data {
          value
          when
        }
      }
      threshold {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentSnapQuoteChartQuery__
 *
 * To run a query within a React component, call `useGetInstrumentSnapQuoteChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentSnapQuoteChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentSnapQuoteChartQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *   },
 * });
 */
export function useGetInstrumentSnapQuoteChartQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentSnapQuoteChartQuery, GetInstrumentSnapQuoteChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentSnapQuoteChartQuery, GetInstrumentSnapQuoteChartQueryVariables>(GetInstrumentSnapQuoteChartDocument, options);
      }
export function useGetInstrumentSnapQuoteChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentSnapQuoteChartQuery, GetInstrumentSnapQuoteChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentSnapQuoteChartQuery, GetInstrumentSnapQuoteChartQueryVariables>(GetInstrumentSnapQuoteChartDocument, options);
        }
export type GetInstrumentSnapQuoteChartQueryHookResult = ReturnType<typeof useGetInstrumentSnapQuoteChartQuery>;
export type GetInstrumentSnapQuoteChartLazyQueryHookResult = ReturnType<typeof useGetInstrumentSnapQuoteChartLazyQuery>;
export type GetInstrumentSnapQuoteChartQueryResult = Apollo.QueryResult<GetInstrumentSnapQuoteChartQuery, GetInstrumentSnapQuoteChartQueryVariables>;
export const GetInstrumentChartComparisonDocument = gql`
    query getInstrumentChartComparison($instrumentId: Int!, $chartScope: ChartScope!) {
  instrument(id: $instrumentId) {
    id
    name
    chart(scope: $chartScope) {
      id
      series {
        label
        type
        data {
          value
          when
        }
      }
      threshold {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentChartComparisonQuery__
 *
 * To run a query within a React component, call `useGetInstrumentChartComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentChartComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentChartComparisonQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      chartScope: // value for 'chartScope'
 *   },
 * });
 */
export function useGetInstrumentChartComparisonQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentChartComparisonQuery, GetInstrumentChartComparisonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentChartComparisonQuery, GetInstrumentChartComparisonQueryVariables>(GetInstrumentChartComparisonDocument, options);
      }
export function useGetInstrumentChartComparisonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentChartComparisonQuery, GetInstrumentChartComparisonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentChartComparisonQuery, GetInstrumentChartComparisonQueryVariables>(GetInstrumentChartComparisonDocument, options);
        }
export type GetInstrumentChartComparisonQueryHookResult = ReturnType<typeof useGetInstrumentChartComparisonQuery>;
export type GetInstrumentChartComparisonLazyQueryHookResult = ReturnType<typeof useGetInstrumentChartComparisonLazyQuery>;
export type GetInstrumentChartComparisonQueryResult = Apollo.QueryResult<GetInstrumentChartComparisonQuery, GetInstrumentChartComparisonQueryVariables>;
export const GetModalAnalysesReportDocument = gql`
    query getModalAnalysesReport($groupId: Int!) {
  group(id: $groupId) {
    id
    analysisReport {
      neutralCount
      negativeCount
      positiveCount
      recommendation
      price
      currency {
        displayCode
      }
      targets {
        recommendation
        price
        count
      }
    }
  }
}
    `;

/**
 * __useGetModalAnalysesReportQuery__
 *
 * To run a query within a React component, call `useGetModalAnalysesReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModalAnalysesReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModalAnalysesReportQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetModalAnalysesReportQuery(baseOptions: Apollo.QueryHookOptions<GetModalAnalysesReportQuery, GetModalAnalysesReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetModalAnalysesReportQuery, GetModalAnalysesReportQueryVariables>(GetModalAnalysesReportDocument, options);
      }
export function useGetModalAnalysesReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModalAnalysesReportQuery, GetModalAnalysesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetModalAnalysesReportQuery, GetModalAnalysesReportQueryVariables>(GetModalAnalysesReportDocument, options);
        }
export type GetModalAnalysesReportQueryHookResult = ReturnType<typeof useGetModalAnalysesReportQuery>;
export type GetModalAnalysesReportLazyQueryHookResult = ReturnType<typeof useGetModalAnalysesReportLazyQuery>;
export type GetModalAnalysesReportQueryResult = Apollo.QueryResult<GetModalAnalysesReportQuery, GetModalAnalysesReportQueryVariables>;
export const GetInstrumentHistoryInfoDocument = gql`
    query getInstrumentHistoryInfo($instrumentId: Int!, $from: LocalDate!, $to: LocalDate!) {
  instrument(id: $instrumentId) {
    currency {
      displayCode
    }
    snapQuote {
      lastChange
      instrumentId
      firstPrice
      lowPrice
      highPrice
      cumulativeVolume
      quote(type: TRADE) {
        value
        when
      }
    }
    group {
      assetGroup
    }
    quoteHistory(from: $from, to: $to) {
      edges {
        node {
          date
          firstPrice
          lastPrice
          lowPrice
          highPrice
          volume
        }
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentHistoryInfoQuery__
 *
 * To run a query within a React component, call `useGetInstrumentHistoryInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentHistoryInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentHistoryInfoQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetInstrumentHistoryInfoQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentHistoryInfoQuery, GetInstrumentHistoryInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentHistoryInfoQuery, GetInstrumentHistoryInfoQueryVariables>(GetInstrumentHistoryInfoDocument, options);
      }
export function useGetInstrumentHistoryInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentHistoryInfoQuery, GetInstrumentHistoryInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentHistoryInfoQuery, GetInstrumentHistoryInfoQueryVariables>(GetInstrumentHistoryInfoDocument, options);
        }
export type GetInstrumentHistoryInfoQueryHookResult = ReturnType<typeof useGetInstrumentHistoryInfoQuery>;
export type GetInstrumentHistoryInfoLazyQueryHookResult = ReturnType<typeof useGetInstrumentHistoryInfoLazyQuery>;
export type GetInstrumentHistoryInfoQueryResult = Apollo.QueryResult<GetInstrumentHistoryInfoQuery, GetInstrumentHistoryInfoQueryVariables>;
export const GetProfilePortfolioDocument = gql`
    query getProfilePortfolio {
  user {
    username
    profile {
      portfolioViewType
      portfolios {
        id
        name
        real
        entries {
          id
          name
          instrumentId
          instrumentGroupId
          instrument {
            id
            name
            exchange {
              id
              name
            }
            currency {
              id
              displayCode
            }
          }
          quantity
          price
          buyCharges
          buyCurrencyPrice
          entryTime
          memo
        }
      }
    }
  }
}
    `;

/**
 * __useGetProfilePortfolioQuery__
 *
 * To run a query within a React component, call `useGetProfilePortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilePortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilePortfolioQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfilePortfolioQuery(baseOptions?: Apollo.QueryHookOptions<GetProfilePortfolioQuery, GetProfilePortfolioQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfilePortfolioQuery, GetProfilePortfolioQueryVariables>(GetProfilePortfolioDocument, options);
      }
export function useGetProfilePortfolioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfilePortfolioQuery, GetProfilePortfolioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfilePortfolioQuery, GetProfilePortfolioQueryVariables>(GetProfilePortfolioDocument, options);
        }
export type GetProfilePortfolioQueryHookResult = ReturnType<typeof useGetProfilePortfolioQuery>;
export type GetProfilePortfolioLazyQueryHookResult = ReturnType<typeof useGetProfilePortfolioLazyQuery>;
export type GetProfilePortfolioQueryResult = Apollo.QueryResult<GetProfilePortfolioQuery, GetProfilePortfolioQueryVariables>;
export const InstrumentIncludedDocument = gql`
    query InstrumentIncluded($id: Int!) {
  instrumentIncluded(id: $id) {
    portfolios {
      id
      name
      real
    }
    watchlists {
      id
      name
    }
    limitsNumber
  }
}
    `;

/**
 * __useInstrumentIncludedQuery__
 *
 * To run a query within a React component, call `useInstrumentIncludedQuery` and pass it any options that fit your needs.
 * When your component renders, `useInstrumentIncludedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInstrumentIncludedQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInstrumentIncludedQuery(baseOptions: Apollo.QueryHookOptions<InstrumentIncludedQuery, InstrumentIncludedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InstrumentIncludedQuery, InstrumentIncludedQueryVariables>(InstrumentIncludedDocument, options);
      }
export function useInstrumentIncludedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InstrumentIncludedQuery, InstrumentIncludedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InstrumentIncludedQuery, InstrumentIncludedQueryVariables>(InstrumentIncludedDocument, options);
        }
export type InstrumentIncludedQueryHookResult = ReturnType<typeof useInstrumentIncludedQuery>;
export type InstrumentIncludedLazyQueryHookResult = ReturnType<typeof useInstrumentIncludedLazyQuery>;
export type InstrumentIncludedQueryResult = Apollo.QueryResult<InstrumentIncludedQuery, InstrumentIncludedQueryVariables>;
export const GetInstrumentQuoteHistoryInfoDocument = gql`
    query getInstrumentQuoteHistoryInfo($instrumentId: Int!, $from: LocalDate!, $to: LocalDate!) {
  instrument(id: $instrumentId) {
    currency {
      displayCode
    }
    quoteHistory(from: $from, to: $to) {
      edges {
        node {
          date
          firstPrice
          lastPrice
          lowPrice
          highPrice
          volume
        }
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentQuoteHistoryInfoQuery__
 *
 * To run a query within a React component, call `useGetInstrumentQuoteHistoryInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentQuoteHistoryInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentQuoteHistoryInfoQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetInstrumentQuoteHistoryInfoQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentQuoteHistoryInfoQuery, GetInstrumentQuoteHistoryInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentQuoteHistoryInfoQuery, GetInstrumentQuoteHistoryInfoQueryVariables>(GetInstrumentQuoteHistoryInfoDocument, options);
      }
export function useGetInstrumentQuoteHistoryInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentQuoteHistoryInfoQuery, GetInstrumentQuoteHistoryInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentQuoteHistoryInfoQuery, GetInstrumentQuoteHistoryInfoQueryVariables>(GetInstrumentQuoteHistoryInfoDocument, options);
        }
export type GetInstrumentQuoteHistoryInfoQueryHookResult = ReturnType<typeof useGetInstrumentQuoteHistoryInfoQuery>;
export type GetInstrumentQuoteHistoryInfoLazyQueryHookResult = ReturnType<typeof useGetInstrumentQuoteHistoryInfoLazyQuery>;
export type GetInstrumentQuoteHistoryInfoQueryResult = Apollo.QueryResult<GetInstrumentQuoteHistoryInfoQuery, GetInstrumentQuoteHistoryInfoQueryVariables>;
export const GetTimeAndSalesDocument = gql`
    query getTimeAndSales($instrumentId: Int!, $from: OffsetDateTime!, $to: OffsetDateTime!, $before: ID) {
  instrument(id: $instrumentId) {
    currency {
      displayCode
    }
    timeAndSales(criteria: {from: $from, to: $to}, before: $before) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
      }
      edges {
        cursor
        node {
          when
          firstPrice
          lowPrice
          highPrice
          lastPrice
          askVolume
          bidVolume
          volume
        }
      }
    }
  }
}
    `;

/**
 * __useGetTimeAndSalesQuery__
 *
 * To run a query within a React component, call `useGetTimeAndSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeAndSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeAndSalesQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetTimeAndSalesQuery(baseOptions: Apollo.QueryHookOptions<GetTimeAndSalesQuery, GetTimeAndSalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeAndSalesQuery, GetTimeAndSalesQueryVariables>(GetTimeAndSalesDocument, options);
      }
export function useGetTimeAndSalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeAndSalesQuery, GetTimeAndSalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeAndSalesQuery, GetTimeAndSalesQueryVariables>(GetTimeAndSalesDocument, options);
        }
export type GetTimeAndSalesQueryHookResult = ReturnType<typeof useGetTimeAndSalesQuery>;
export type GetTimeAndSalesLazyQueryHookResult = ReturnType<typeof useGetTimeAndSalesLazyQuery>;
export type GetTimeAndSalesQueryResult = Apollo.QueryResult<GetTimeAndSalesQuery, GetTimeAndSalesQueryVariables>;
export const GetAssetNewsFeedDocument = gql`
    query getAssetNewsFeed($isin: String!, $first: Int, $after: ID) {
  newsSearch(criteria: {isin: [$isin]}, first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        headline
        teaser
        body
        feed
        links {
          name
          href
        }
        source {
          id
          name
        }
        instruments {
          group {
            id
            isin
            name
            assetGroup
            seoTag
            main {
              id
              snapQuote {
                lastChange
                instrumentId
                lowPrice
                highPrice
                firstPrice
                lastPrice
                yesterdayPrice
                cumulativeTrades
                cumulativeTurnover
                cumulativeVolume
                quotes {
                  delay
                  type
                  value
                  percentChange
                  change
                  when
                }
              }
              currency {
                alphaCode
                sign
                name
                displayCode
              }
            }
          }
        }
        when
        medias {
          source
          width
          height
        }
        streams {
          mimeType
          duration
          width
          height
          source
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useGetAssetNewsFeedQuery__
 *
 * To run a query within a React component, call `useGetAssetNewsFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetNewsFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetNewsFeedQuery({
 *   variables: {
 *      isin: // value for 'isin'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAssetNewsFeedQuery(baseOptions: Apollo.QueryHookOptions<GetAssetNewsFeedQuery, GetAssetNewsFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetNewsFeedQuery, GetAssetNewsFeedQueryVariables>(GetAssetNewsFeedDocument, options);
      }
export function useGetAssetNewsFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetNewsFeedQuery, GetAssetNewsFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetNewsFeedQuery, GetAssetNewsFeedQueryVariables>(GetAssetNewsFeedDocument, options);
        }
export type GetAssetNewsFeedQueryHookResult = ReturnType<typeof useGetAssetNewsFeedQuery>;
export type GetAssetNewsFeedLazyQueryHookResult = ReturnType<typeof useGetAssetNewsFeedLazyQuery>;
export type GetAssetNewsFeedQueryResult = Apollo.QueryResult<GetAssetNewsFeedQuery, GetAssetNewsFeedQueryVariables>;
export const GetNewsEditorialFeedDocument = gql`
    query getNewsEditorialFeed {
  newsSearch(criteria: {source: ["EDITORIAL_FEED"]}, first: 12) {
    edges {
      cursor
      node {
        id
        when
        body
        headline
        teaser
        links {
          name
          href
        }
        source {
          id
          name
        }
        medias {
          source
          width
          height
        }
        streams {
          mimeType
          duration
          width
          height
          source
        }
        feed
        keywords
        instruments {
          group {
            id
            isin
            name
            assetGroup
            seoTag
            main {
              id
              snapQuote {
                lastChange
                instrumentId
                lowPrice
                highPrice
                firstPrice
                lastPrice
                yesterdayPrice
                cumulativeTrades
                cumulativeTurnover
                cumulativeVolume
                quotes {
                  delay
                  type
                  value
                  percentChange
                  change
                  when
                }
              }
              currency {
                displayCode
              }
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useGetNewsEditorialFeedQuery__
 *
 * To run a query within a React component, call `useGetNewsEditorialFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsEditorialFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsEditorialFeedQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsEditorialFeedQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsEditorialFeedQuery, GetNewsEditorialFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsEditorialFeedQuery, GetNewsEditorialFeedQueryVariables>(GetNewsEditorialFeedDocument, options);
      }
export function useGetNewsEditorialFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsEditorialFeedQuery, GetNewsEditorialFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsEditorialFeedQuery, GetNewsEditorialFeedQueryVariables>(GetNewsEditorialFeedDocument, options);
        }
export type GetNewsEditorialFeedQueryHookResult = ReturnType<typeof useGetNewsEditorialFeedQuery>;
export type GetNewsEditorialFeedLazyQueryHookResult = ReturnType<typeof useGetNewsEditorialFeedLazyQuery>;
export type GetNewsEditorialFeedQueryResult = Apollo.QueryResult<GetNewsEditorialFeedQuery, GetNewsEditorialFeedQueryVariables>;
export const GetNewsGridModalDocument = gql`
    query getNewsGridModal($criteria: NewsCriteria, $first: Int, $after: ID) {
  newsSearch(criteria: $criteria, first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        when
        body
        headline
        teaser
        links {
          name
          href
        }
        source {
          id
          name
        }
        medias {
          source
          width
          height
        }
        streams {
          mimeType
          duration
          width
          height
          source
        }
        feed
        keywords
        instruments {
          group {
            id
            isin
            name
            assetGroup
            seoTag
            main {
              id
              snapQuote {
                instrumentId
                lastChange
                lowPrice
                highPrice
                firstPrice
                lastPrice
                yesterdayPrice
                cumulativeTrades
                cumulativeTurnover
                cumulativeVolume
                quotes {
                  delay
                  type
                  value
                  percentChange
                  change
                  when
                }
              }
              currency {
                displayCode
              }
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useGetNewsGridModalQuery__
 *
 * To run a query within a React component, call `useGetNewsGridModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsGridModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsGridModalQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetNewsGridModalQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsGridModalQuery, GetNewsGridModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsGridModalQuery, GetNewsGridModalQueryVariables>(GetNewsGridModalDocument, options);
      }
export function useGetNewsGridModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsGridModalQuery, GetNewsGridModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsGridModalQuery, GetNewsGridModalQueryVariables>(GetNewsGridModalDocument, options);
        }
export type GetNewsGridModalQueryHookResult = ReturnType<typeof useGetNewsGridModalQuery>;
export type GetNewsGridModalLazyQueryHookResult = ReturnType<typeof useGetNewsGridModalLazyQuery>;
export type GetNewsGridModalQueryResult = Apollo.QueryResult<GetNewsGridModalQuery, GetNewsGridModalQueryVariables>;
export const GetInstrumentSnapQuoteDocument = gql`
    query getInstrumentSnapQuote($instrumentId: Int!) {
  instrument(id: $instrumentId) {
    currency {
      displayCode
    }
    snapQuote {
      lastChange
      instrumentId
      quote(type: TRADE) {
        value
        change
        percentChange
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentSnapQuoteQuery__
 *
 * To run a query within a React component, call `useGetInstrumentSnapQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentSnapQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentSnapQuoteQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *   },
 * });
 */
export function useGetInstrumentSnapQuoteQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentSnapQuoteQuery, GetInstrumentSnapQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentSnapQuoteQuery, GetInstrumentSnapQuoteQueryVariables>(GetInstrumentSnapQuoteDocument, options);
      }
export function useGetInstrumentSnapQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentSnapQuoteQuery, GetInstrumentSnapQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentSnapQuoteQuery, GetInstrumentSnapQuoteQueryVariables>(GetInstrumentSnapQuoteDocument, options);
        }
export type GetInstrumentSnapQuoteQueryHookResult = ReturnType<typeof useGetInstrumentSnapQuoteQuery>;
export type GetInstrumentSnapQuoteLazyQueryHookResult = ReturnType<typeof useGetInstrumentSnapQuoteLazyQuery>;
export type GetInstrumentSnapQuoteQueryResult = Apollo.QueryResult<GetInstrumentSnapQuoteQuery, GetInstrumentSnapQuoteQueryVariables>;
export const GetNewsInstrumentSnapQuoteDocument = gql`
    query getNewsInstrumentSnapQuote($instrumentId: Int!) {
  instrument(id: $instrumentId) {
    id
    currency {
      displayCode
    }
    snapQuote {
      lastChange
      instrumentId
      lowPrice
      highPrice
      firstPrice
      lastPrice
      yesterdayPrice
      cumulativeTrades
      cumulativeTurnover
      cumulativeVolume
      quotes {
        delay
        type
        value
        percentChange
        change
        when
      }
    }
  }
}
    `;

/**
 * __useGetNewsInstrumentSnapQuoteQuery__
 *
 * To run a query within a React component, call `useGetNewsInstrumentSnapQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsInstrumentSnapQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsInstrumentSnapQuoteQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *   },
 * });
 */
export function useGetNewsInstrumentSnapQuoteQuery(baseOptions: Apollo.QueryHookOptions<GetNewsInstrumentSnapQuoteQuery, GetNewsInstrumentSnapQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsInstrumentSnapQuoteQuery, GetNewsInstrumentSnapQuoteQueryVariables>(GetNewsInstrumentSnapQuoteDocument, options);
      }
export function useGetNewsInstrumentSnapQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsInstrumentSnapQuoteQuery, GetNewsInstrumentSnapQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsInstrumentSnapQuoteQuery, GetNewsInstrumentSnapQuoteQueryVariables>(GetNewsInstrumentSnapQuoteDocument, options);
        }
export type GetNewsInstrumentSnapQuoteQueryHookResult = ReturnType<typeof useGetNewsInstrumentSnapQuoteQuery>;
export type GetNewsInstrumentSnapQuoteLazyQueryHookResult = ReturnType<typeof useGetNewsInstrumentSnapQuoteLazyQuery>;
export type GetNewsInstrumentSnapQuoteQueryResult = Apollo.QueryResult<GetNewsInstrumentSnapQuoteQuery, GetNewsInstrumentSnapQuoteQueryVariables>;
export const GetCurrentNewsDocument = gql`
    query getCurrentNews($id: ID!) {
  news(id: $id) {
    id
    when
    body
    headline
    teaser
    links {
      name
      href
    }
    source {
      id
      name
    }
    medias {
      source
      width
      height
    }
    streams {
      mimeType
      duration
      width
      height
      source
    }
    feed
    keywords
    instruments {
      group {
        id
        isin
        name
        assetGroup
        seoTag
        main {
          id
          snapQuote {
            lastChange
            instrumentId
            lowPrice
            highPrice
            firstPrice
            lastPrice
            yesterdayPrice
            cumulativeTrades
            cumulativeTurnover
            cumulativeVolume
            quotes {
              delay
              type
              value
              percentChange
              change
              when
            }
          }
          currency {
            displayCode
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCurrentNewsQuery__
 *
 * To run a query within a React component, call `useGetCurrentNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentNewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCurrentNewsQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentNewsQuery, GetCurrentNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentNewsQuery, GetCurrentNewsQueryVariables>(GetCurrentNewsDocument, options);
      }
export function useGetCurrentNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentNewsQuery, GetCurrentNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentNewsQuery, GetCurrentNewsQueryVariables>(GetCurrentNewsDocument, options);
        }
export type GetCurrentNewsQueryHookResult = ReturnType<typeof useGetCurrentNewsQuery>;
export type GetCurrentNewsLazyQueryHookResult = ReturnType<typeof useGetCurrentNewsLazyQuery>;
export type GetCurrentNewsQueryResult = Apollo.QueryResult<GetCurrentNewsQuery, GetCurrentNewsQueryVariables>;
export const GetNewsUrlModalDocument = gql`
    query getNewsUrlModal($criteria: NewsCriteria, $first: Int, $after: ID) {
  newsSearch(criteria: $criteria, first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        when
        body
        headline
        teaser
        links {
          name
          href
        }
        source {
          id
          name
        }
        medias {
          source
          width
          height
        }
        streams {
          mimeType
          duration
          width
          height
          source
        }
        feed
        keywords
        instruments {
          group {
            id
            isin
            name
            assetGroup
            seoTag
            main {
              id
              snapQuote {
                lastChange
                instrumentId
                lowPrice
                highPrice
                firstPrice
                lastPrice
                yesterdayPrice
                cumulativeTrades
                cumulativeTurnover
                cumulativeVolume
                quotes {
                  delay
                  type
                  value
                  percentChange
                  change
                  when
                }
              }
              currency {
                displayCode
              }
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useGetNewsUrlModalQuery__
 *
 * To run a query within a React component, call `useGetNewsUrlModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsUrlModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsUrlModalQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetNewsUrlModalQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsUrlModalQuery, GetNewsUrlModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsUrlModalQuery, GetNewsUrlModalQueryVariables>(GetNewsUrlModalDocument, options);
      }
export function useGetNewsUrlModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsUrlModalQuery, GetNewsUrlModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsUrlModalQuery, GetNewsUrlModalQueryVariables>(GetNewsUrlModalDocument, options);
        }
export type GetNewsUrlModalQueryHookResult = ReturnType<typeof useGetNewsUrlModalQuery>;
export type GetNewsUrlModalLazyQueryHookResult = ReturnType<typeof useGetNewsUrlModalLazyQuery>;
export type GetNewsUrlModalQueryResult = Apollo.QueryResult<GetNewsUrlModalQuery, GetNewsUrlModalQueryVariables>;
export const GetNewsMainModalDocument = gql`
    query getNewsMainModal($id: ID!) {
  news(id: $id) {
    id
    headline
    teaser
    body
    feed
    keywords
    links {
      name
      href
    }
    source {
      id
      name
    }
    instruments {
      group {
        id
        isin
        name
        assetGroup
        seoTag
        main {
          id
          snapQuote {
            lastChange
            instrumentId
            lowPrice
            highPrice
            firstPrice
            lastPrice
            yesterdayPrice
            cumulativeTrades
            cumulativeTurnover
            cumulativeVolume
            quotes {
              delay
              type
              value
              percentChange
              change
              when
            }
          }
          currency {
            alphaCode
            sign
            name
            displayCode
          }
        }
      }
    }
    when
    medias {
      source
      width
      height
    }
    streams {
      mimeType
      duration
      width
      height
      source
    }
  }
}
    `;

/**
 * __useGetNewsMainModalQuery__
 *
 * To run a query within a React component, call `useGetNewsMainModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsMainModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsMainModalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNewsMainModalQuery(baseOptions: Apollo.QueryHookOptions<GetNewsMainModalQuery, GetNewsMainModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsMainModalQuery, GetNewsMainModalQueryVariables>(GetNewsMainModalDocument, options);
      }
export function useGetNewsMainModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsMainModalQuery, GetNewsMainModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsMainModalQuery, GetNewsMainModalQueryVariables>(GetNewsMainModalDocument, options);
        }
export type GetNewsMainModalQueryHookResult = ReturnType<typeof useGetNewsMainModalQuery>;
export type GetNewsMainModalLazyQueryHookResult = ReturnType<typeof useGetNewsMainModalLazyQuery>;
export type GetNewsMainModalQueryResult = Apollo.QueryResult<GetNewsMainModalQuery, GetNewsMainModalQueryVariables>;
export const ClosePortfolioEntryDocument = gql`
    mutation closePortfolioEntry($portfolioId: Long!, $portfolioEntryId: Long!, $instrumentId: Long, $price: Float!, $quantity: Float!, $charges: Float!, $closeTime: OffsetDateTime!, $memo: String, $currencyCode: String) {
  closePortfolioEntry(
    entry: {portfolioId: $portfolioId, portfolioEntryId: $portfolioEntryId, instrumentId: $instrumentId, price: $price, quantity: $quantity, charges: $charges, closeTime: $closeTime, memo: $memo, currencyCode: $currencyCode}
  ) {
    id
    name
    price
    quantity
    memo
  }
}
    `;
export type ClosePortfolioEntryMutationFn = Apollo.MutationFunction<ClosePortfolioEntryMutation, ClosePortfolioEntryMutationVariables>;

/**
 * __useClosePortfolioEntryMutation__
 *
 * To run a mutation, you first call `useClosePortfolioEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClosePortfolioEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closePortfolioEntryMutation, { data, loading, error }] = useClosePortfolioEntryMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      portfolioEntryId: // value for 'portfolioEntryId'
 *      instrumentId: // value for 'instrumentId'
 *      price: // value for 'price'
 *      quantity: // value for 'quantity'
 *      charges: // value for 'charges'
 *      closeTime: // value for 'closeTime'
 *      memo: // value for 'memo'
 *      currencyCode: // value for 'currencyCode'
 *   },
 * });
 */
export function useClosePortfolioEntryMutation(baseOptions?: Apollo.MutationHookOptions<ClosePortfolioEntryMutation, ClosePortfolioEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClosePortfolioEntryMutation, ClosePortfolioEntryMutationVariables>(ClosePortfolioEntryDocument, options);
      }
export type ClosePortfolioEntryMutationHookResult = ReturnType<typeof useClosePortfolioEntryMutation>;
export type ClosePortfolioEntryMutationResult = Apollo.MutationResult<ClosePortfolioEntryMutation>;
export type ClosePortfolioEntryMutationOptions = Apollo.BaseMutationOptions<ClosePortfolioEntryMutation, ClosePortfolioEntryMutationVariables>;
export const CreatePortfolioEntryDocument = gql`
    mutation createPortfolioEntry($portfolioId: Long!, $instrumentId: Long!, $price: Float!, $quantity: Float!, $charges: Float!, $entryTime: OffsetDateTime!, $memo: String, $currencyCode: String) {
  createPortfolioEntry(
    entry: {portfolioId: $portfolioId, instrumentId: $instrumentId, price: $price, quantity: $quantity, charges: $charges, entryTime: $entryTime, memo: $memo, currencyCode: $currencyCode}
  ) {
    id
    name
    price
    quantity
    memo
  }
}
    `;
export type CreatePortfolioEntryMutationFn = Apollo.MutationFunction<CreatePortfolioEntryMutation, CreatePortfolioEntryMutationVariables>;

/**
 * __useCreatePortfolioEntryMutation__
 *
 * To run a mutation, you first call `useCreatePortfolioEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortfolioEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortfolioEntryMutation, { data, loading, error }] = useCreatePortfolioEntryMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      instrumentId: // value for 'instrumentId'
 *      price: // value for 'price'
 *      quantity: // value for 'quantity'
 *      charges: // value for 'charges'
 *      entryTime: // value for 'entryTime'
 *      memo: // value for 'memo'
 *      currencyCode: // value for 'currencyCode'
 *   },
 * });
 */
export function useCreatePortfolioEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreatePortfolioEntryMutation, CreatePortfolioEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePortfolioEntryMutation, CreatePortfolioEntryMutationVariables>(CreatePortfolioEntryDocument, options);
      }
export type CreatePortfolioEntryMutationHookResult = ReturnType<typeof useCreatePortfolioEntryMutation>;
export type CreatePortfolioEntryMutationResult = Apollo.MutationResult<CreatePortfolioEntryMutation>;
export type CreatePortfolioEntryMutationOptions = Apollo.BaseMutationOptions<CreatePortfolioEntryMutation, CreatePortfolioEntryMutationVariables>;
export const GetInstrumentGroupUserPortfoliosDocument = gql`
    query getInstrumentGroupUserPortfolios($groupId: Int!) {
  group(id: $groupId) {
    id
    name
    isin
    content {
      id
      main
      isin
      name
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      group {
        id
        seoTag
        assetGroup
        sector {
          name
        }
      }
      countryId
      snapQuote {
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          delay
          type
          size
          value
          percentChange
          change
          when
        }
      }
      stats(periods: [WEEK52]) {
        period
        lowPrice
        highPrice
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentGroupUserPortfoliosQuery__
 *
 * To run a query within a React component, call `useGetInstrumentGroupUserPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentGroupUserPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentGroupUserPortfoliosQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetInstrumentGroupUserPortfoliosQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentGroupUserPortfoliosQuery, GetInstrumentGroupUserPortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentGroupUserPortfoliosQuery, GetInstrumentGroupUserPortfoliosQueryVariables>(GetInstrumentGroupUserPortfoliosDocument, options);
      }
export function useGetInstrumentGroupUserPortfoliosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentGroupUserPortfoliosQuery, GetInstrumentGroupUserPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentGroupUserPortfoliosQuery, GetInstrumentGroupUserPortfoliosQueryVariables>(GetInstrumentGroupUserPortfoliosDocument, options);
        }
export type GetInstrumentGroupUserPortfoliosQueryHookResult = ReturnType<typeof useGetInstrumentGroupUserPortfoliosQuery>;
export type GetInstrumentGroupUserPortfoliosLazyQueryHookResult = ReturnType<typeof useGetInstrumentGroupUserPortfoliosLazyQuery>;
export type GetInstrumentGroupUserPortfoliosQueryResult = Apollo.QueryResult<GetInstrumentGroupUserPortfoliosQuery, GetInstrumentGroupUserPortfoliosQueryVariables>;
export const GetInstrumentUserPortfoliosDocument = gql`
    query getInstrumentUserPortfolios($instrumentId: Int!) {
  instrument(id: $instrumentId) {
    id
    name
    isin
    exchange {
      id
      name
    }
    group {
      id
      assetGroup
      bond {
        nominalCurrencyCode
      }
    }
    snapQuote {
      lastChange
      instrumentId
      lastPrice
      quotes {
        delay
        type
        value
        percentChange
        change
        when
      }
    }
    currency {
      id
      displayCode
    }
  }
}
    `;

/**
 * __useGetInstrumentUserPortfoliosQuery__
 *
 * To run a query within a React component, call `useGetInstrumentUserPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentUserPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentUserPortfoliosQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *   },
 * });
 */
export function useGetInstrumentUserPortfoliosQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentUserPortfoliosQuery, GetInstrumentUserPortfoliosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentUserPortfoliosQuery, GetInstrumentUserPortfoliosQueryVariables>(GetInstrumentUserPortfoliosDocument, options);
      }
export function useGetInstrumentUserPortfoliosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentUserPortfoliosQuery, GetInstrumentUserPortfoliosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentUserPortfoliosQuery, GetInstrumentUserPortfoliosQueryVariables>(GetInstrumentUserPortfoliosDocument, options);
        }
export type GetInstrumentUserPortfoliosQueryHookResult = ReturnType<typeof useGetInstrumentUserPortfoliosQuery>;
export type GetInstrumentUserPortfoliosLazyQueryHookResult = ReturnType<typeof useGetInstrumentUserPortfoliosLazyQuery>;
export type GetInstrumentUserPortfoliosQueryResult = Apollo.QueryResult<GetInstrumentUserPortfoliosQuery, GetInstrumentUserPortfoliosQueryVariables>;
export const GetUserPortfoliosAddDocument = gql`
    query getUserPortfoliosAdd {
  user {
    username
    profile {
      id
      portfolios {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetUserPortfoliosAddQuery__
 *
 * To run a query within a React component, call `useGetUserPortfoliosAddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPortfoliosAddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPortfoliosAddQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPortfoliosAddQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPortfoliosAddQuery, GetUserPortfoliosAddQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPortfoliosAddQuery, GetUserPortfoliosAddQueryVariables>(GetUserPortfoliosAddDocument, options);
      }
export function useGetUserPortfoliosAddLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPortfoliosAddQuery, GetUserPortfoliosAddQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPortfoliosAddQuery, GetUserPortfoliosAddQueryVariables>(GetUserPortfoliosAddDocument, options);
        }
export type GetUserPortfoliosAddQueryHookResult = ReturnType<typeof useGetUserPortfoliosAddQuery>;
export type GetUserPortfoliosAddLazyQueryHookResult = ReturnType<typeof useGetUserPortfoliosAddLazyQuery>;
export type GetUserPortfoliosAddQueryResult = Apollo.QueryResult<GetUserPortfoliosAddQuery, GetUserPortfoliosAddQueryVariables>;
export const CreateWatchlistEntryDocument = gql`
    mutation createWatchlistEntry($watchlistId: Long!, $instrumentId: Long!, $price: Float!, $memo: String) {
  createWatchlistEntry(
    entry: {watchlistId: $watchlistId, instrumentId: $instrumentId, price: $price, memo: $memo}
  ) {
    id
    name
    price
    quantity
    memo
  }
}
    `;
export type CreateWatchlistEntryMutationFn = Apollo.MutationFunction<CreateWatchlistEntryMutation, CreateWatchlistEntryMutationVariables>;

/**
 * __useCreateWatchlistEntryMutation__
 *
 * To run a mutation, you first call `useCreateWatchlistEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWatchlistEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWatchlistEntryMutation, { data, loading, error }] = useCreateWatchlistEntryMutation({
 *   variables: {
 *      watchlistId: // value for 'watchlistId'
 *      instrumentId: // value for 'instrumentId'
 *      price: // value for 'price'
 *      memo: // value for 'memo'
 *   },
 * });
 */
export function useCreateWatchlistEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateWatchlistEntryMutation, CreateWatchlistEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWatchlistEntryMutation, CreateWatchlistEntryMutationVariables>(CreateWatchlistEntryDocument, options);
      }
export type CreateWatchlistEntryMutationHookResult = ReturnType<typeof useCreateWatchlistEntryMutation>;
export type CreateWatchlistEntryMutationResult = Apollo.MutationResult<CreateWatchlistEntryMutation>;
export type CreateWatchlistEntryMutationOptions = Apollo.BaseMutationOptions<CreateWatchlistEntryMutation, CreateWatchlistEntryMutationVariables>;
export const GetInstrumentGroupUserWatchListDocument = gql`
    query getInstrumentGroupUserWatchList($groupId: Int!) {
  group(id: $groupId) {
    id
    name
    isin
    content {
      id
      main
      isin
      name
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      group {
        id
        seoTag
        assetGroup
        sector {
          name
        }
      }
      countryId
      snapQuote {
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          delay
          type
          size
          value
          percentChange
          change
          when
        }
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentGroupUserWatchListQuery__
 *
 * To run a query within a React component, call `useGetInstrumentGroupUserWatchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentGroupUserWatchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentGroupUserWatchListQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetInstrumentGroupUserWatchListQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentGroupUserWatchListQuery, GetInstrumentGroupUserWatchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentGroupUserWatchListQuery, GetInstrumentGroupUserWatchListQueryVariables>(GetInstrumentGroupUserWatchListDocument, options);
      }
export function useGetInstrumentGroupUserWatchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentGroupUserWatchListQuery, GetInstrumentGroupUserWatchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentGroupUserWatchListQuery, GetInstrumentGroupUserWatchListQueryVariables>(GetInstrumentGroupUserWatchListDocument, options);
        }
export type GetInstrumentGroupUserWatchListQueryHookResult = ReturnType<typeof useGetInstrumentGroupUserWatchListQuery>;
export type GetInstrumentGroupUserWatchListLazyQueryHookResult = ReturnType<typeof useGetInstrumentGroupUserWatchListLazyQuery>;
export type GetInstrumentGroupUserWatchListQueryResult = Apollo.QueryResult<GetInstrumentGroupUserWatchListQuery, GetInstrumentGroupUserWatchListQueryVariables>;
export const GetInstrumentUserWatchListDocument = gql`
    query getInstrumentUserWatchList($instrumentId: Int!) {
  instrument(id: $instrumentId) {
    id
    name
    isin
    exchange {
      id
      name
    }
    currency {
      id
      displayCode
    }
    snapQuote {
      instrumentId
      lastPrice
    }
  }
}
    `;

/**
 * __useGetInstrumentUserWatchListQuery__
 *
 * To run a query within a React component, call `useGetInstrumentUserWatchListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentUserWatchListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentUserWatchListQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *   },
 * });
 */
export function useGetInstrumentUserWatchListQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentUserWatchListQuery, GetInstrumentUserWatchListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentUserWatchListQuery, GetInstrumentUserWatchListQueryVariables>(GetInstrumentUserWatchListDocument, options);
      }
export function useGetInstrumentUserWatchListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentUserWatchListQuery, GetInstrumentUserWatchListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentUserWatchListQuery, GetInstrumentUserWatchListQueryVariables>(GetInstrumentUserWatchListDocument, options);
        }
export type GetInstrumentUserWatchListQueryHookResult = ReturnType<typeof useGetInstrumentUserWatchListQuery>;
export type GetInstrumentUserWatchListLazyQueryHookResult = ReturnType<typeof useGetInstrumentUserWatchListLazyQuery>;
export type GetInstrumentUserWatchListQueryResult = Apollo.QueryResult<GetInstrumentUserWatchListQuery, GetInstrumentUserWatchListQueryVariables>;
export const GetUserWatchListsAddDocument = gql`
    query getUserWatchListsAdd {
  user {
    username
    profile {
      id
      watchlists {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetUserWatchListsAddQuery__
 *
 * To run a query within a React component, call `useGetUserWatchListsAddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWatchListsAddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWatchListsAddQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWatchListsAddQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWatchListsAddQuery, GetUserWatchListsAddQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWatchListsAddQuery, GetUserWatchListsAddQueryVariables>(GetUserWatchListsAddDocument, options);
      }
export function useGetUserWatchListsAddLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWatchListsAddQuery, GetUserWatchListsAddQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWatchListsAddQuery, GetUserWatchListsAddQueryVariables>(GetUserWatchListsAddDocument, options);
        }
export type GetUserWatchListsAddQueryHookResult = ReturnType<typeof useGetUserWatchListsAddQuery>;
export type GetUserWatchListsAddLazyQueryHookResult = ReturnType<typeof useGetUserWatchListsAddLazyQuery>;
export type GetUserWatchListsAddQueryResult = Apollo.QueryResult<GetUserWatchListsAddQuery, GetUserWatchListsAddQueryVariables>;
export const GetInstrumentGroupSelectedDocument = gql`
    query getInstrumentGroupSelected($assetGroup: [AssetGroup!], $searchString: String!, $first: Int!, $after: ID) {
  search(
    criteria: {assetGroup: $assetGroup, searchString: $searchString}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        name
        wkn
        group {
          id
          name
          assetGroup
          seoTag
        }
        snapQuote {
          lastChange
          instrumentId
          quotes {
            type
            value
            change
            when
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    assetGroups {
      assetGroup
      count
    }
  }
}
    `;

/**
 * __useGetInstrumentGroupSelectedQuery__
 *
 * To run a query within a React component, call `useGetInstrumentGroupSelectedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentGroupSelectedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentGroupSelectedQuery({
 *   variables: {
 *      assetGroup: // value for 'assetGroup'
 *      searchString: // value for 'searchString'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetInstrumentGroupSelectedQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentGroupSelectedQuery, GetInstrumentGroupSelectedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentGroupSelectedQuery, GetInstrumentGroupSelectedQueryVariables>(GetInstrumentGroupSelectedDocument, options);
      }
export function useGetInstrumentGroupSelectedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentGroupSelectedQuery, GetInstrumentGroupSelectedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentGroupSelectedQuery, GetInstrumentGroupSelectedQueryVariables>(GetInstrumentGroupSelectedDocument, options);
        }
export type GetInstrumentGroupSelectedQueryHookResult = ReturnType<typeof useGetInstrumentGroupSelectedQuery>;
export type GetInstrumentGroupSelectedLazyQueryHookResult = ReturnType<typeof useGetInstrumentGroupSelectedLazyQuery>;
export type GetInstrumentGroupSelectedQueryResult = Apollo.QueryResult<GetInstrumentGroupSelectedQuery, GetInstrumentGroupSelectedQueryVariables>;
export const GetInstrumentGroupSelectedCountDocument = gql`
    query getInstrumentGroupSelectedCount($searchString: String!) {
  search(criteria: {searchString: $searchString}, first: 0) {
    assetGroups {
      assetGroup
      count
    }
  }
}
    `;

/**
 * __useGetInstrumentGroupSelectedCountQuery__
 *
 * To run a query within a React component, call `useGetInstrumentGroupSelectedCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentGroupSelectedCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentGroupSelectedCountQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useGetInstrumentGroupSelectedCountQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentGroupSelectedCountQuery, GetInstrumentGroupSelectedCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentGroupSelectedCountQuery, GetInstrumentGroupSelectedCountQueryVariables>(GetInstrumentGroupSelectedCountDocument, options);
      }
export function useGetInstrumentGroupSelectedCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentGroupSelectedCountQuery, GetInstrumentGroupSelectedCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentGroupSelectedCountQuery, GetInstrumentGroupSelectedCountQueryVariables>(GetInstrumentGroupSelectedCountDocument, options);
        }
export type GetInstrumentGroupSelectedCountQueryHookResult = ReturnType<typeof useGetInstrumentGroupSelectedCountQuery>;
export type GetInstrumentGroupSelectedCountLazyQueryHookResult = ReturnType<typeof useGetInstrumentGroupSelectedCountLazyQuery>;
export type GetInstrumentGroupSelectedCountQueryResult = Apollo.QueryResult<GetInstrumentGroupSelectedCountQuery, GetInstrumentGroupSelectedCountQueryVariables>;
export const GetAssetTypeGroupDocument = gql`
    query getAssetTypeGroup($underlyingInstrumentGroupId: Int!, $assetClassId: Long!) {
  group(id: $underlyingInstrumentGroupId) {
    id
    derivativeAssetTypeGroupBucket(criteria: {assetClass: $assetClassId}) {
      assetTypeGroup {
        id
        name
      }
      count
    }
  }
}
    `;

/**
 * __useGetAssetTypeGroupQuery__
 *
 * To run a query within a React component, call `useGetAssetTypeGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetTypeGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetTypeGroupQuery({
 *   variables: {
 *      underlyingInstrumentGroupId: // value for 'underlyingInstrumentGroupId'
 *      assetClassId: // value for 'assetClassId'
 *   },
 * });
 */
export function useGetAssetTypeGroupQuery(baseOptions: Apollo.QueryHookOptions<GetAssetTypeGroupQuery, GetAssetTypeGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetTypeGroupQuery, GetAssetTypeGroupQueryVariables>(GetAssetTypeGroupDocument, options);
      }
export function useGetAssetTypeGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetTypeGroupQuery, GetAssetTypeGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetTypeGroupQuery, GetAssetTypeGroupQueryVariables>(GetAssetTypeGroupDocument, options);
        }
export type GetAssetTypeGroupQueryHookResult = ReturnType<typeof useGetAssetTypeGroupQuery>;
export type GetAssetTypeGroupLazyQueryHookResult = ReturnType<typeof useGetAssetTypeGroupLazyQuery>;
export type GetAssetTypeGroupQueryResult = Apollo.QueryResult<GetAssetTypeGroupQuery, GetAssetTypeGroupQueryVariables>;
export const DerivativeAssetTypeBucketDocument = gql`
    query derivativeAssetTypeBucket($instrumentGroupId: Int!, $assetClassId: Long) {
  group(id: $instrumentGroupId) {
    derivativeAssetTypeBucket(criteria: {assetClass: $assetClassId}) {
      assetType {
        name
      }
      count
    }
  }
}
    `;

/**
 * __useDerivativeAssetTypeBucketQuery__
 *
 * To run a query within a React component, call `useDerivativeAssetTypeBucketQuery` and pass it any options that fit your needs.
 * When your component renders, `useDerivativeAssetTypeBucketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDerivativeAssetTypeBucketQuery({
 *   variables: {
 *      instrumentGroupId: // value for 'instrumentGroupId'
 *      assetClassId: // value for 'assetClassId'
 *   },
 * });
 */
export function useDerivativeAssetTypeBucketQuery(baseOptions: Apollo.QueryHookOptions<DerivativeAssetTypeBucketQuery, DerivativeAssetTypeBucketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DerivativeAssetTypeBucketQuery, DerivativeAssetTypeBucketQueryVariables>(DerivativeAssetTypeBucketDocument, options);
      }
export function useDerivativeAssetTypeBucketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DerivativeAssetTypeBucketQuery, DerivativeAssetTypeBucketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DerivativeAssetTypeBucketQuery, DerivativeAssetTypeBucketQueryVariables>(DerivativeAssetTypeBucketDocument, options);
        }
export type DerivativeAssetTypeBucketQueryHookResult = ReturnType<typeof useDerivativeAssetTypeBucketQuery>;
export type DerivativeAssetTypeBucketLazyQueryHookResult = ReturnType<typeof useDerivativeAssetTypeBucketLazyQuery>;
export type DerivativeAssetTypeBucketQueryResult = Apollo.QueryResult<DerivativeAssetTypeBucketQuery, DerivativeAssetTypeBucketQueryVariables>;
export const GetDerivativeOverviewAnalogeResultDocument = gql`
    query getDerivativeOverviewAnalogeResult($assetClass: Long, $underlyingInstrumentGroupId: Int, $first: Int, $after: ID) {
  searchDerivative(
    criterion: {assetClass: $assetClass, underlyingInstrumentGroupId: $underlyingInstrumentGroupId}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        name
        wkn
        keyFigures {
          gearing
          deltaStopLoss
          deltaStopLossAbsolute
          moneyness
          premiumAnnual
          sidewaysAnnualReturn
        }
        group {
          id
          seoTag
          assetGroup
          assetTypeGroup {
            id
            name
          }
          assetType {
            id
            name
          }
          issuerId
          issuer {
            name
            partner
          }
          derivative {
            id
            maturityDate
            optionType
          }
          underlyings {
            id
            strike
            currency {
              displayCode
            }
          }
        }
        snapQuote {
          lastChange
          instrumentId
          quotes {
            type
            value
            when
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    count
  }
}
    `;

/**
 * __useGetDerivativeOverviewAnalogeResultQuery__
 *
 * To run a query within a React component, call `useGetDerivativeOverviewAnalogeResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDerivativeOverviewAnalogeResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDerivativeOverviewAnalogeResultQuery({
 *   variables: {
 *      assetClass: // value for 'assetClass'
 *      underlyingInstrumentGroupId: // value for 'underlyingInstrumentGroupId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetDerivativeOverviewAnalogeResultQuery(baseOptions?: Apollo.QueryHookOptions<GetDerivativeOverviewAnalogeResultQuery, GetDerivativeOverviewAnalogeResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDerivativeOverviewAnalogeResultQuery, GetDerivativeOverviewAnalogeResultQueryVariables>(GetDerivativeOverviewAnalogeResultDocument, options);
      }
export function useGetDerivativeOverviewAnalogeResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDerivativeOverviewAnalogeResultQuery, GetDerivativeOverviewAnalogeResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDerivativeOverviewAnalogeResultQuery, GetDerivativeOverviewAnalogeResultQueryVariables>(GetDerivativeOverviewAnalogeResultDocument, options);
        }
export type GetDerivativeOverviewAnalogeResultQueryHookResult = ReturnType<typeof useGetDerivativeOverviewAnalogeResultQuery>;
export type GetDerivativeOverviewAnalogeResultLazyQueryHookResult = ReturnType<typeof useGetDerivativeOverviewAnalogeResultLazyQuery>;
export type GetDerivativeOverviewAnalogeResultQueryResult = Apollo.QueryResult<GetDerivativeOverviewAnalogeResultQuery, GetDerivativeOverviewAnalogeResultQueryVariables>;
export const GetDerivativeOverviewResultDocument = gql`
    query getDerivativeOverviewResult($assetClass: Long, $underlyingInstrumentGroupId: Int!, $gearingFrom: Float, $gearingTo: Float, $first: Int, $after: ID) {
  callOption: searchDerivative(
    criterion: {assetClass: $assetClass, underlyingInstrumentGroupId: $underlyingInstrumentGroupId, optionType: CALL, keyFigures: [{keyFigure: GEARING, from: $gearingFrom, to: $gearingTo}]}
    first: $first
    after: $after
  ) {
    edges {
      node {
        id
        name
        wkn
        derivativeKeyFigures {
          gearing
          premiumAnnual
        }
        group {
          id
          seoTag
          assetGroup
          assetType {
            id
            name
          }
          issuerId
          issuer {
            name
            partner
          }
          derivative {
            id
            maturityDate
            optionType
          }
        }
        snapQuote {
          lastChange
          instrumentId
          quotes {
            type
            value
            when
          }
        }
      }
    }
  }
  putOption: searchDerivative(
    criterion: {assetClass: $assetClass, underlyingInstrumentGroupId: $underlyingInstrumentGroupId, optionType: PUT, keyFigures: [{keyFigure: GEARING, from: $gearingFrom, to: $gearingTo}]}
    first: $first
    after: $after
  ) {
    edges {
      node {
        id
        name
        wkn
        derivativeKeyFigures {
          gearing
          premiumAnnual
        }
        group {
          id
          seoTag
          assetGroup
          assetType {
            id
            name
          }
          issuerId
          issuer {
            name
            partner
          }
          derivative {
            id
            maturityDate
            optionType
          }
        }
        snapQuote {
          lastChange
          instrumentId
          quotes {
            type
            value
            when
          }
        }
      }
    }
  }
  buckets: group(id: $underlyingInstrumentGroupId) {
    derivativeKeyFigureRangeBucket(
      criteria: {assetClass: $assetClass}
      ranges: {gearing: [{to: 10}, {from: 10, to: 20}, {from: 20}]}
    ) {
      optionType
      from
      to
      count
    }
  }
}
    `;

/**
 * __useGetDerivativeOverviewResultQuery__
 *
 * To run a query within a React component, call `useGetDerivativeOverviewResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDerivativeOverviewResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDerivativeOverviewResultQuery({
 *   variables: {
 *      assetClass: // value for 'assetClass'
 *      underlyingInstrumentGroupId: // value for 'underlyingInstrumentGroupId'
 *      gearingFrom: // value for 'gearingFrom'
 *      gearingTo: // value for 'gearingTo'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetDerivativeOverviewResultQuery(baseOptions: Apollo.QueryHookOptions<GetDerivativeOverviewResultQuery, GetDerivativeOverviewResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDerivativeOverviewResultQuery, GetDerivativeOverviewResultQueryVariables>(GetDerivativeOverviewResultDocument, options);
      }
export function useGetDerivativeOverviewResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDerivativeOverviewResultQuery, GetDerivativeOverviewResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDerivativeOverviewResultQuery, GetDerivativeOverviewResultQueryVariables>(GetDerivativeOverviewResultDocument, options);
        }
export type GetDerivativeOverviewResultQueryHookResult = ReturnType<typeof useGetDerivativeOverviewResultQuery>;
export type GetDerivativeOverviewResultLazyQueryHookResult = ReturnType<typeof useGetDerivativeOverviewResultLazyQuery>;
export type GetDerivativeOverviewResultQueryResult = Apollo.QueryResult<GetDerivativeOverviewResultQuery, GetDerivativeOverviewResultQueryVariables>;
export const GetDerivativeSearchResultNewVersionDocument = gql`
    query getDerivativeSearchResultNewVersion($optionType: DerivativeOptionType, $assetGroup: AssetGroup, $assetTypeGroup: String, $assetType: String, $underlyingInstrumentGroupId: Int, $keyFigures: [DerivativeKeyFigureCriteria!] = [], $maturityDateFrom: LocalDate, $maturityDateTo: LocalDate, $issuerId: [Long!], $sort: [SearchDerivativeSort!] = [], $first: Int, $after: ID) {
  searchDerivative(
    criterion: {optionType: $optionType, assetGroup: $assetGroup, assetTypeGroup: $assetTypeGroup, assetType: $assetType, underlyingInstrumentGroupId: $underlyingInstrumentGroupId, issuerId: $issuerId, maturityDate: {from: $maturityDateFrom, to: $maturityDateTo}, keyFigures: $keyFigures}
    sort: $sort
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        name
        wkn
        group {
          id
          seoTag
          assetGroup
          assetTypeGroup {
            id
            name
            __typename
          }
          assetType {
            id
            name
            __typename
          }
          issuerId
          issuer {
            name
            partner
            __typename
          }
          main {
            lastTradingDay
          }
          derivative {
            id
            maturityDate
            optionType
            managementFee
            __typename
          }
          underlyings {
            id
            strike
            knockOut
            knockOutLower
            knockOutUpper
            cap
            bonusBarrier
            security
            securityBarrierObservationStartAt
            securityBarrierTriggeredAt
            securityBarrierObservationStartAt
            securityBarrierObservationEndAt
            currency {
              displayCode
              __typename
            }
            instrument {
              snapQuote {
                lastChange
                instrumentId
                quotes {
                  value
                  type
                }
              }
            }
            __typename
          }
          interestRateInformation {
            interestRate
            nextPaymentDate
            lastPaymentDate
            finalPaymentDate
          }
          __typename
        }
        __typename
        derivativeKeyFigures {
          gearing
          premium
          premiumAbsolute
          premiumAnnual
          implicitVolatility
          breakEven
          moneyness
          intrinsicValue
          timeValuePremium
          spread
          spreadHomogenous
          spreadRelative
          deltaStopLoss
          deltaStopLossAbsolute
          agio
          agioAnnual
          omega
          delta
          gamma
          theta
          rho
          vega
          discountAbsolute
          discountPercent
          sidewaysReturn
          sidewaysReturnAbsolute
          sidewaysAnnualReturn
          outperformanceLevel
          maxAnnualReturn
          maxReturn
          maxReturnAbsolute
          maxRedemptionPrice
          deltaCap
          deltaCapAbsolute
          fairValue
          bonusAnnualReturn
          bonusBuffer
          bonusBufferAbsolute
          bonusReturn
          bonusReturnAbsolute
          deltaBonusLevel
          deltaBonusLevelAbsolute
          deltaStrike
          deltaStrikeAbsolute
          deltaSecurityLevel
          dirtyPrice
          parity
          ismaYield
          accruedInterest
          duration
          modifiedDuration
          update {
            when
            type
            value
            underlyingValue
          }
          __typename
        }
        snapQuote {
          lastChange
          instrumentId
          quotes {
            delay
            type
            value
            when
            __typename
          }
          __typename
        }
        performance(period: [MONTH1, WEEK52]) {
          period
          performance
          __typename
        }
      }
      __typename
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
      __typename
    }
    count
    __typename
  }
}
    `;

/**
 * __useGetDerivativeSearchResultNewVersionQuery__
 *
 * To run a query within a React component, call `useGetDerivativeSearchResultNewVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDerivativeSearchResultNewVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDerivativeSearchResultNewVersionQuery({
 *   variables: {
 *      optionType: // value for 'optionType'
 *      assetGroup: // value for 'assetGroup'
 *      assetTypeGroup: // value for 'assetTypeGroup'
 *      assetType: // value for 'assetType'
 *      underlyingInstrumentGroupId: // value for 'underlyingInstrumentGroupId'
 *      keyFigures: // value for 'keyFigures'
 *      maturityDateFrom: // value for 'maturityDateFrom'
 *      maturityDateTo: // value for 'maturityDateTo'
 *      issuerId: // value for 'issuerId'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetDerivativeSearchResultNewVersionQuery(baseOptions?: Apollo.QueryHookOptions<GetDerivativeSearchResultNewVersionQuery, GetDerivativeSearchResultNewVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDerivativeSearchResultNewVersionQuery, GetDerivativeSearchResultNewVersionQueryVariables>(GetDerivativeSearchResultNewVersionDocument, options);
      }
export function useGetDerivativeSearchResultNewVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDerivativeSearchResultNewVersionQuery, GetDerivativeSearchResultNewVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDerivativeSearchResultNewVersionQuery, GetDerivativeSearchResultNewVersionQueryVariables>(GetDerivativeSearchResultNewVersionDocument, options);
        }
export type GetDerivativeSearchResultNewVersionQueryHookResult = ReturnType<typeof useGetDerivativeSearchResultNewVersionQuery>;
export type GetDerivativeSearchResultNewVersionLazyQueryHookResult = ReturnType<typeof useGetDerivativeSearchResultNewVersionLazyQuery>;
export type GetDerivativeSearchResultNewVersionQueryResult = Apollo.QueryResult<GetDerivativeSearchResultNewVersionQuery, GetDerivativeSearchResultNewVersionQueryVariables>;
export const UnderlyingRangeBucketDocument = gql`
    query underlyingRangeBucket($assetClassId: Long, $underlyingInstrumentGroupId: Int!) {
  group(id: $underlyingInstrumentGroupId) {
    derivativeKeyFigureRangeBucket(
      criteria: {assetClass: $assetClassId}
      ranges: {gearing: [{to: 10}, {from: 10, to: 20}, {from: 20}]}
    ) {
      optionType
      from
      to
      count
    }
  }
}
    `;

/**
 * __useUnderlyingRangeBucketQuery__
 *
 * To run a query within a React component, call `useUnderlyingRangeBucketQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnderlyingRangeBucketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnderlyingRangeBucketQuery({
 *   variables: {
 *      assetClassId: // value for 'assetClassId'
 *      underlyingInstrumentGroupId: // value for 'underlyingInstrumentGroupId'
 *   },
 * });
 */
export function useUnderlyingRangeBucketQuery(baseOptions: Apollo.QueryHookOptions<UnderlyingRangeBucketQuery, UnderlyingRangeBucketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnderlyingRangeBucketQuery, UnderlyingRangeBucketQueryVariables>(UnderlyingRangeBucketDocument, options);
      }
export function useUnderlyingRangeBucketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnderlyingRangeBucketQuery, UnderlyingRangeBucketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnderlyingRangeBucketQuery, UnderlyingRangeBucketQueryVariables>(UnderlyingRangeBucketDocument, options);
        }
export type UnderlyingRangeBucketQueryHookResult = ReturnType<typeof useUnderlyingRangeBucketQuery>;
export type UnderlyingRangeBucketLazyQueryHookResult = ReturnType<typeof useUnderlyingRangeBucketLazyQuery>;
export type UnderlyingRangeBucketQueryResult = Apollo.QueryResult<UnderlyingRangeBucketQuery, UnderlyingRangeBucketQueryVariables>;
export const GetDerivativeSearchQuoteCellsDocument = gql`
    query getDerivativeSearchQuoteCells($id: Int!) {
  instrument(id: $id) {
    snapQuote {
      lastChange
      instrumentId
      quotes {
        delay
        type
        value
        when
      }
    }
  }
}
    `;

/**
 * __useGetDerivativeSearchQuoteCellsQuery__
 *
 * To run a query within a React component, call `useGetDerivativeSearchQuoteCellsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDerivativeSearchQuoteCellsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDerivativeSearchQuoteCellsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDerivativeSearchQuoteCellsQuery(baseOptions: Apollo.QueryHookOptions<GetDerivativeSearchQuoteCellsQuery, GetDerivativeSearchQuoteCellsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDerivativeSearchQuoteCellsQuery, GetDerivativeSearchQuoteCellsQueryVariables>(GetDerivativeSearchQuoteCellsDocument, options);
      }
export function useGetDerivativeSearchQuoteCellsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDerivativeSearchQuoteCellsQuery, GetDerivativeSearchQuoteCellsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDerivativeSearchQuoteCellsQuery, GetDerivativeSearchQuoteCellsQueryVariables>(GetDerivativeSearchQuoteCellsDocument, options);
        }
export type GetDerivativeSearchQuoteCellsQueryHookResult = ReturnType<typeof useGetDerivativeSearchQuoteCellsQuery>;
export type GetDerivativeSearchQuoteCellsLazyQueryHookResult = ReturnType<typeof useGetDerivativeSearchQuoteCellsLazyQuery>;
export type GetDerivativeSearchQuoteCellsQueryResult = Apollo.QueryResult<GetDerivativeSearchQuoteCellsQuery, GetDerivativeSearchQuoteCellsQueryVariables>;
export const GetInstrumentsDocument = gql`
    query getInstruments($assetGroup: [AssetGroup!], $searchString: String!, $first: Int!, $after: ID, $underlying: Boolean) {
  search(
    criteria: {assetGroup: $assetGroup, searchString: $searchString, underlying: $underlying}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        name
        seoTag
        wkn
        isin
        group {
          id
          assetGroup
          name
          seoTag
          underlying
        }
        snapQuote {
          lastChange
          instrumentId
          quote(type: TRADE) {
            type
            when
            delay
            value
            percentChange
            change
          }
        }
        currency {
          displayCode
        }
        exchange {
          code
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetInstrumentsQuery__
 *
 * To run a query within a React component, call `useGetInstrumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentsQuery({
 *   variables: {
 *      assetGroup: // value for 'assetGroup'
 *      searchString: // value for 'searchString'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      underlying: // value for 'underlying'
 *   },
 * });
 */
export function useGetInstrumentsQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentsQuery, GetInstrumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentsQuery, GetInstrumentsQueryVariables>(GetInstrumentsDocument, options);
      }
export function useGetInstrumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentsQuery, GetInstrumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentsQuery, GetInstrumentsQueryVariables>(GetInstrumentsDocument, options);
        }
export type GetInstrumentsQueryHookResult = ReturnType<typeof useGetInstrumentsQuery>;
export type GetInstrumentsLazyQueryHookResult = ReturnType<typeof useGetInstrumentsLazyQuery>;
export type GetInstrumentsQueryResult = Apollo.QueryResult<GetInstrumentsQuery, GetInstrumentsQueryVariables>;
export const GetAssetClassDocument = gql`
    query getAssetClass($underlyingInstrumentGroupId: Int!) {
  group(id: $underlyingInstrumentGroupId) {
    id
    derivativeAssetClassBucket {
      assetClass {
        id
        name
      }
      count
    }
  }
}
    `;

/**
 * __useGetAssetClassQuery__
 *
 * To run a query within a React component, call `useGetAssetClassQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetClassQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetClassQuery({
 *   variables: {
 *      underlyingInstrumentGroupId: // value for 'underlyingInstrumentGroupId'
 *   },
 * });
 */
export function useGetAssetClassQuery(baseOptions: Apollo.QueryHookOptions<GetAssetClassQuery, GetAssetClassQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetClassQuery, GetAssetClassQueryVariables>(GetAssetClassDocument, options);
      }
export function useGetAssetClassLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetClassQuery, GetAssetClassQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetClassQuery, GetAssetClassQueryVariables>(GetAssetClassDocument, options);
        }
export type GetAssetClassQueryHookResult = ReturnType<typeof useGetAssetClassQuery>;
export type GetAssetClassLazyQueryHookResult = ReturnType<typeof useGetAssetClassLazyQuery>;
export type GetAssetClassQueryResult = Apollo.QueryResult<GetAssetClassQuery, GetAssetClassQueryVariables>;
export const GetAssetTypeDocument = gql`
    query getAssetType($underlyingInstrumentGroupId: Int!, $assetTypeGroupId: String) {
  group(id: $underlyingInstrumentGroupId) {
    id
    derivativeAssetTypeBucket(criteria: {assetTypeGroup: $assetTypeGroupId}) {
      assetType {
        id
        name
      }
      count
    }
  }
}
    `;

/**
 * __useGetAssetTypeQuery__
 *
 * To run a query within a React component, call `useGetAssetTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetTypeQuery({
 *   variables: {
 *      underlyingInstrumentGroupId: // value for 'underlyingInstrumentGroupId'
 *      assetTypeGroupId: // value for 'assetTypeGroupId'
 *   },
 * });
 */
export function useGetAssetTypeQuery(baseOptions: Apollo.QueryHookOptions<GetAssetTypeQuery, GetAssetTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetTypeQuery, GetAssetTypeQueryVariables>(GetAssetTypeDocument, options);
      }
export function useGetAssetTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetTypeQuery, GetAssetTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetTypeQuery, GetAssetTypeQueryVariables>(GetAssetTypeDocument, options);
        }
export type GetAssetTypeQueryHookResult = ReturnType<typeof useGetAssetTypeQuery>;
export type GetAssetTypeLazyQueryHookResult = ReturnType<typeof useGetAssetTypeLazyQuery>;
export type GetAssetTypeQueryResult = Apollo.QueryResult<GetAssetTypeQuery, GetAssetTypeQueryVariables>;
export const GetAssetTypeClassIdDocument = gql`
    query getAssetTypeClassID($underlyingInstrumentGroupId: Int!, $assetClassId: Long!) {
  group(id: $underlyingInstrumentGroupId) {
    id
    derivativeAssetTypeBucket(criteria: {assetClass: $assetClassId}) {
      assetType {
        id
        name
      }
      count
    }
  }
}
    `;

/**
 * __useGetAssetTypeClassIdQuery__
 *
 * To run a query within a React component, call `useGetAssetTypeClassIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetTypeClassIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetTypeClassIdQuery({
 *   variables: {
 *      underlyingInstrumentGroupId: // value for 'underlyingInstrumentGroupId'
 *      assetClassId: // value for 'assetClassId'
 *   },
 * });
 */
export function useGetAssetTypeClassIdQuery(baseOptions: Apollo.QueryHookOptions<GetAssetTypeClassIdQuery, GetAssetTypeClassIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetTypeClassIdQuery, GetAssetTypeClassIdQueryVariables>(GetAssetTypeClassIdDocument, options);
      }
export function useGetAssetTypeClassIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetTypeClassIdQuery, GetAssetTypeClassIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetTypeClassIdQuery, GetAssetTypeClassIdQueryVariables>(GetAssetTypeClassIdDocument, options);
        }
export type GetAssetTypeClassIdQueryHookResult = ReturnType<typeof useGetAssetTypeClassIdQuery>;
export type GetAssetTypeClassIdLazyQueryHookResult = ReturnType<typeof useGetAssetTypeClassIdLazyQuery>;
export type GetAssetTypeClassIdQueryResult = Apollo.QueryResult<GetAssetTypeClassIdQuery, GetAssetTypeClassIdQueryVariables>;
export const GetIssuersResultDocument = gql`
    query getIssuersResult {
  issuers {
    id
    name
  }
}
    `;

/**
 * __useGetIssuersResultQuery__
 *
 * To run a query within a React component, call `useGetIssuersResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIssuersResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIssuersResultQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIssuersResultQuery(baseOptions?: Apollo.QueryHookOptions<GetIssuersResultQuery, GetIssuersResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIssuersResultQuery, GetIssuersResultQueryVariables>(GetIssuersResultDocument, options);
      }
export function useGetIssuersResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIssuersResultQuery, GetIssuersResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIssuersResultQuery, GetIssuersResultQueryVariables>(GetIssuersResultDocument, options);
        }
export type GetIssuersResultQueryHookResult = ReturnType<typeof useGetIssuersResultQuery>;
export type GetIssuersResultLazyQueryHookResult = ReturnType<typeof useGetIssuersResultLazyQuery>;
export type GetIssuersResultQueryResult = Apollo.QueryResult<GetIssuersResultQuery, GetIssuersResultQueryVariables>;
export const GetDerivativeSearchResultDocument = gql`
    query getDerivativeSearchResult($optionType: DerivativeOptionType, $assetGroup: AssetGroup, $assetType: String, $underlyingInstrumentGroupId: Int, $strikeFrom: Float, $strikeTo: Float, $gearingFrom: Float, $gearingTo: Float, $moneynessFrom: Float, $moneynessTo: Float, $capFrom: Float, $capTo: Float, $knockInFrom: Float, $knockInTo: Float, $knockOutFrom: Float, $knockOutTo: Float, $knockInLowerFrom: Float, $knockInLowerTo: Float, $knockInUpperFrom: Float, $knockInUpperTo: Float, $maturityDateFrom: LocalDate, $maturityDateTo: LocalDate, $issuerId: [Long!], $first: Int, $after: ID) {
  searchDerivative(
    criterion: {assetGroup: $assetGroup, assetType: $assetType, underlyingInstrumentGroupId: $underlyingInstrumentGroupId, optionType: $optionType, issuerId: $issuerId, maturityDate: {from: $maturityDateFrom, to: $maturityDateTo}}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        name
        wkn
        group {
          id
          seoTag
          assetGroup
          assetType {
            id
            name
          }
          issuerId
          issuer {
            name
            partner
          }
          main {
            id
            keyFigures {
              gearing
              deltaStopLoss
              deltaStopLossAbsolute
              moneyness
            }
            snapQuote {
              lastChange
              instrumentId
              quotes {
                delay
                type
                value
                when
              }
            }
          }
          derivative {
            id
            maturityDate
            optionType
          }
          underlyings {
            id
            strike
            knockOut
            currency {
              displayCode
            }
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    count
  }
}
    `;

/**
 * __useGetDerivativeSearchResultQuery__
 *
 * To run a query within a React component, call `useGetDerivativeSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDerivativeSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDerivativeSearchResultQuery({
 *   variables: {
 *      optionType: // value for 'optionType'
 *      assetGroup: // value for 'assetGroup'
 *      assetType: // value for 'assetType'
 *      underlyingInstrumentGroupId: // value for 'underlyingInstrumentGroupId'
 *      strikeFrom: // value for 'strikeFrom'
 *      strikeTo: // value for 'strikeTo'
 *      gearingFrom: // value for 'gearingFrom'
 *      gearingTo: // value for 'gearingTo'
 *      moneynessFrom: // value for 'moneynessFrom'
 *      moneynessTo: // value for 'moneynessTo'
 *      capFrom: // value for 'capFrom'
 *      capTo: // value for 'capTo'
 *      knockInFrom: // value for 'knockInFrom'
 *      knockInTo: // value for 'knockInTo'
 *      knockOutFrom: // value for 'knockOutFrom'
 *      knockOutTo: // value for 'knockOutTo'
 *      knockInLowerFrom: // value for 'knockInLowerFrom'
 *      knockInLowerTo: // value for 'knockInLowerTo'
 *      knockInUpperFrom: // value for 'knockInUpperFrom'
 *      knockInUpperTo: // value for 'knockInUpperTo'
 *      maturityDateFrom: // value for 'maturityDateFrom'
 *      maturityDateTo: // value for 'maturityDateTo'
 *      issuerId: // value for 'issuerId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetDerivativeSearchResultQuery(baseOptions?: Apollo.QueryHookOptions<GetDerivativeSearchResultQuery, GetDerivativeSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDerivativeSearchResultQuery, GetDerivativeSearchResultQueryVariables>(GetDerivativeSearchResultDocument, options);
      }
export function useGetDerivativeSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDerivativeSearchResultQuery, GetDerivativeSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDerivativeSearchResultQuery, GetDerivativeSearchResultQueryVariables>(GetDerivativeSearchResultDocument, options);
        }
export type GetDerivativeSearchResultQueryHookResult = ReturnType<typeof useGetDerivativeSearchResultQuery>;
export type GetDerivativeSearchResultLazyQueryHookResult = ReturnType<typeof useGetDerivativeSearchResultLazyQuery>;
export type GetDerivativeSearchResultQueryResult = Apollo.QueryResult<GetDerivativeSearchResultQuery, GetDerivativeSearchResultQueryVariables>;
export const GetDerivativeTypeInputDocument = gql`
    query getDerivativeTypeInput {
  classification(category: [WARR, KNOCK, CERT]) {
    id
    name
    leveraged
    assetGroup
    typeGroups {
      id
      name
    }
    types {
      id
      name
    }
  }
}
    `;

/**
 * __useGetDerivativeTypeInputQuery__
 *
 * To run a query within a React component, call `useGetDerivativeTypeInputQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDerivativeTypeInputQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDerivativeTypeInputQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDerivativeTypeInputQuery(baseOptions?: Apollo.QueryHookOptions<GetDerivativeTypeInputQuery, GetDerivativeTypeInputQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDerivativeTypeInputQuery, GetDerivativeTypeInputQueryVariables>(GetDerivativeTypeInputDocument, options);
      }
export function useGetDerivativeTypeInputLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDerivativeTypeInputQuery, GetDerivativeTypeInputQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDerivativeTypeInputQuery, GetDerivativeTypeInputQueryVariables>(GetDerivativeTypeInputDocument, options);
        }
export type GetDerivativeTypeInputQueryHookResult = ReturnType<typeof useGetDerivativeTypeInputQuery>;
export type GetDerivativeTypeInputLazyQueryHookResult = ReturnType<typeof useGetDerivativeTypeInputLazyQuery>;
export type GetDerivativeTypeInputQueryResult = Apollo.QueryResult<GetDerivativeTypeInputQuery, GetDerivativeTypeInputQueryVariables>;
export const GetKnockOutSearchResultDocument = gql`
    query getKnockOutSearchResult($assetGroup: [AssetGroup!], $assetType: String, $underlyingInstrumentGroupId: Long, $first: Int, $after: ID) {
  search(
    criteria: {assetGroup: $assetGroup, assetType: $assetType, underlyingInstrumentGroupId: $underlyingInstrumentGroupId}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        name
        wkn
        group {
          id
          seoTag
          assetGroup
          issuerId
          issuer {
            name
            partner
          }
          main {
            keyFigures {
              gearing
              deltaStopLoss
              deltaStopLossAbsolute
            }
          }
          derivative {
            maturityDate
            optionType
          }
          underlyings {
            strike
            currency {
              displayCode
            }
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetKnockOutSearchResultQuery__
 *
 * To run a query within a React component, call `useGetKnockOutSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnockOutSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnockOutSearchResultQuery({
 *   variables: {
 *      assetGroup: // value for 'assetGroup'
 *      assetType: // value for 'assetType'
 *      underlyingInstrumentGroupId: // value for 'underlyingInstrumentGroupId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetKnockOutSearchResultQuery(baseOptions?: Apollo.QueryHookOptions<GetKnockOutSearchResultQuery, GetKnockOutSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnockOutSearchResultQuery, GetKnockOutSearchResultQueryVariables>(GetKnockOutSearchResultDocument, options);
      }
export function useGetKnockOutSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnockOutSearchResultQuery, GetKnockOutSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnockOutSearchResultQuery, GetKnockOutSearchResultQueryVariables>(GetKnockOutSearchResultDocument, options);
        }
export type GetKnockOutSearchResultQueryHookResult = ReturnType<typeof useGetKnockOutSearchResultQuery>;
export type GetKnockOutSearchResultLazyQueryHookResult = ReturnType<typeof useGetKnockOutSearchResultLazyQuery>;
export type GetKnockOutSearchResultQueryResult = Apollo.QueryResult<GetKnockOutSearchResultQuery, GetKnockOutSearchResultQueryVariables>;
export const GetMainDocument = gql`
    query getMain($id: Int!) {
  group(id: $id) {
    main {
      id
      name
      seoTag
      wkn
      isin
      group {
        id
        assetGroup
      }
      snapQuote {
        lastChange
        instrumentId
        quote(type: TRADE) {
          type
          when
          delay
          value
          percentChange
          change
        }
      }
      currency {
        displayCode
      }
      exchange {
        code
      }
    }
  }
}
    `;

/**
 * __useGetMainQuery__
 *
 * To run a query within a React component, call `useGetMainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMainQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMainQuery(baseOptions: Apollo.QueryHookOptions<GetMainQuery, GetMainQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMainQuery, GetMainQueryVariables>(GetMainDocument, options);
      }
export function useGetMainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMainQuery, GetMainQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMainQuery, GetMainQueryVariables>(GetMainDocument, options);
        }
export type GetMainQueryHookResult = ReturnType<typeof useGetMainQuery>;
export type GetMainLazyQueryHookResult = ReturnType<typeof useGetMainLazyQuery>;
export type GetMainQueryResult = Apollo.QueryResult<GetMainQuery, GetMainQueryVariables>;
export const GetCardPairsCrossRatesDocument = gql`
    query getCardPairsCrossRates($homeCurrencyCode: String, $sortField: CrossRateSortField, $descending: Boolean, $chartScope: ChartScope!, $first: Int!, $after: ID) {
  searchCrossRate(
    criteria: {homeCurrencyCode: $homeCurrencyCode}
    sort: {field: $sortField, descending: $descending}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        currency {
          displayCode
        }
        exchange {
          code
        }
        group {
          id
          name
          wkn
          seoTag
          assetGroup
          main {
            id
            country {
              name
              isoAlpha3
            }
            snapQuote {
              instrumentId
              quote(type: TRADE) {
                value
                change
                percentChange
              }
            }
            chart(scope: $chartScope) {
              series {
                label
                type
                data {
                  value
                  when
                }
              }
              threshold {
                type
                value
              }
            }
            performance {
              period
              basePrice
              averagePrice
              performance
              performanceAbsolute
            }
          }
          crossRate {
            homeCurrency {
              displayCode
            }
            foreignCurrency {
              displayCode
            }
          }
        }
        snapQuote {
          instrumentId
          quote(type: TRADE) {
            value
            change
            percentChange
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    count
  }
}
    `;

/**
 * __useGetCardPairsCrossRatesQuery__
 *
 * To run a query within a React component, call `useGetCardPairsCrossRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardPairsCrossRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardPairsCrossRatesQuery({
 *   variables: {
 *      homeCurrencyCode: // value for 'homeCurrencyCode'
 *      sortField: // value for 'sortField'
 *      descending: // value for 'descending'
 *      chartScope: // value for 'chartScope'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCardPairsCrossRatesQuery(baseOptions: Apollo.QueryHookOptions<GetCardPairsCrossRatesQuery, GetCardPairsCrossRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardPairsCrossRatesQuery, GetCardPairsCrossRatesQueryVariables>(GetCardPairsCrossRatesDocument, options);
      }
export function useGetCardPairsCrossRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardPairsCrossRatesQuery, GetCardPairsCrossRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardPairsCrossRatesQuery, GetCardPairsCrossRatesQueryVariables>(GetCardPairsCrossRatesDocument, options);
        }
export type GetCardPairsCrossRatesQueryHookResult = ReturnType<typeof useGetCardPairsCrossRatesQuery>;
export type GetCardPairsCrossRatesLazyQueryHookResult = ReturnType<typeof useGetCardPairsCrossRatesLazyQuery>;
export type GetCardPairsCrossRatesQueryResult = Apollo.QueryResult<GetCardPairsCrossRatesQuery, GetCardPairsCrossRatesQueryVariables>;
export const GetCurrencyEntriesDocument = gql`
    query getCurrencyEntries {
  analysisInstitute {
    id
    name
  }
}
    `;

/**
 * __useGetCurrencyEntriesQuery__
 *
 * To run a query within a React component, call `useGetCurrencyEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyEntriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrencyEntriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrencyEntriesQuery, GetCurrencyEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyEntriesQuery, GetCurrencyEntriesQueryVariables>(GetCurrencyEntriesDocument, options);
      }
export function useGetCurrencyEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyEntriesQuery, GetCurrencyEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyEntriesQuery, GetCurrencyEntriesQueryVariables>(GetCurrencyEntriesDocument, options);
        }
export type GetCurrencyEntriesQueryHookResult = ReturnType<typeof useGetCurrencyEntriesQuery>;
export type GetCurrencyEntriesLazyQueryHookResult = ReturnType<typeof useGetCurrencyEntriesLazyQuery>;
export type GetCurrencyEntriesQueryResult = Apollo.QueryResult<GetCurrencyEntriesQuery, GetCurrencyEntriesQueryVariables>;
export const GetComparisonListDocument = gql`
    query getComparisonList($listId: String!, $chartScope: ChartScope!) {
  list(id: $listId) {
    id
    content {
      id
      name
      chart(scope: $chartScope) {
        id
        series {
          label
          type
          data {
            value
            when
          }
        }
        threshold {
          type
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetComparisonListQuery__
 *
 * To run a query within a React component, call `useGetComparisonListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetComparisonListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetComparisonListQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *      chartScope: // value for 'chartScope'
 *   },
 * });
 */
export function useGetComparisonListQuery(baseOptions: Apollo.QueryHookOptions<GetComparisonListQuery, GetComparisonListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetComparisonListQuery, GetComparisonListQueryVariables>(GetComparisonListDocument, options);
      }
export function useGetComparisonListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetComparisonListQuery, GetComparisonListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetComparisonListQuery, GetComparisonListQueryVariables>(GetComparisonListDocument, options);
        }
export type GetComparisonListQueryHookResult = ReturnType<typeof useGetComparisonListQuery>;
export type GetComparisonListLazyQueryHookResult = ReturnType<typeof useGetComparisonListLazyQuery>;
export type GetComparisonListQueryResult = Apollo.QueryResult<GetComparisonListQuery, GetComparisonListQueryVariables>;
export const CurrencyQuoteDocument = gql`
    query CurrencyQuote($baseCode: String!, $quoteCode: String!) {
  currencyQuote(baseCode: $baseCode, quoteCode: $quoteCode) {
    lastPrice
  }
}
    `;

/**
 * __useCurrencyQuoteQuery__
 *
 * To run a query within a React component, call `useCurrencyQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrencyQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrencyQuoteQuery({
 *   variables: {
 *      baseCode: // value for 'baseCode'
 *      quoteCode: // value for 'quoteCode'
 *   },
 * });
 */
export function useCurrencyQuoteQuery(baseOptions: Apollo.QueryHookOptions<CurrencyQuoteQuery, CurrencyQuoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrencyQuoteQuery, CurrencyQuoteQueryVariables>(CurrencyQuoteDocument, options);
      }
export function useCurrencyQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrencyQuoteQuery, CurrencyQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrencyQuoteQuery, CurrencyQuoteQueryVariables>(CurrencyQuoteDocument, options);
        }
export type CurrencyQuoteQueryHookResult = ReturnType<typeof useCurrencyQuoteQuery>;
export type CurrencyQuoteLazyQueryHookResult = ReturnType<typeof useCurrencyQuoteLazyQuery>;
export type CurrencyQuoteQueryResult = Apollo.QueryResult<CurrencyQuoteQuery, CurrencyQuoteQueryVariables>;
export const GetCurrencyMatrixDocument = gql`
    query getCurrencyMatrix($id: String!) {
  list(id: $id) {
    id
    content {
      id
      name
      group {
        crossRate {
          homeCurrency {
            alphaCode
          }
          foreignCurrency {
            alphaCode
          }
        }
      }
      snapQuote {
        lastChange
        instrumentId
        lastPrice
      }
    }
  }
}
    `;

/**
 * __useGetCurrencyMatrixQuery__
 *
 * To run a query within a React component, call `useGetCurrencyMatrixQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyMatrixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyMatrixQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCurrencyMatrixQuery(baseOptions: Apollo.QueryHookOptions<GetCurrencyMatrixQuery, GetCurrencyMatrixQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyMatrixQuery, GetCurrencyMatrixQueryVariables>(GetCurrencyMatrixDocument, options);
      }
export function useGetCurrencyMatrixLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyMatrixQuery, GetCurrencyMatrixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyMatrixQuery, GetCurrencyMatrixQueryVariables>(GetCurrencyMatrixDocument, options);
        }
export type GetCurrencyMatrixQueryHookResult = ReturnType<typeof useGetCurrencyMatrixQuery>;
export type GetCurrencyMatrixLazyQueryHookResult = ReturnType<typeof useGetCurrencyMatrixLazyQuery>;
export type GetCurrencyMatrixQueryResult = Apollo.QueryResult<GetCurrencyMatrixQuery, GetCurrencyMatrixQueryVariables>;
export const GetPerformanceInstrumentDevisenDocument = gql`
    query getPerformanceInstrumentDevisen($instrumentId: Int!) {
  instrument(id: $instrumentId) {
    id
    name
    group {
      assetGroup
      seoTag
    }
    currency {
      sign
      displayCode
    }
    performance(
      period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
    ) {
      period
      basePrice
      performance
      sharpe
      vola
    }
  }
}
    `;

/**
 * __useGetPerformanceInstrumentDevisenQuery__
 *
 * To run a query within a React component, call `useGetPerformanceInstrumentDevisenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPerformanceInstrumentDevisenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPerformanceInstrumentDevisenQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *   },
 * });
 */
export function useGetPerformanceInstrumentDevisenQuery(baseOptions: Apollo.QueryHookOptions<GetPerformanceInstrumentDevisenQuery, GetPerformanceInstrumentDevisenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPerformanceInstrumentDevisenQuery, GetPerformanceInstrumentDevisenQueryVariables>(GetPerformanceInstrumentDevisenDocument, options);
      }
export function useGetPerformanceInstrumentDevisenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPerformanceInstrumentDevisenQuery, GetPerformanceInstrumentDevisenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPerformanceInstrumentDevisenQuery, GetPerformanceInstrumentDevisenQueryVariables>(GetPerformanceInstrumentDevisenDocument, options);
        }
export type GetPerformanceInstrumentDevisenQueryHookResult = ReturnType<typeof useGetPerformanceInstrumentDevisenQuery>;
export type GetPerformanceInstrumentDevisenLazyQueryHookResult = ReturnType<typeof useGetPerformanceInstrumentDevisenLazyQuery>;
export type GetPerformanceInstrumentDevisenQueryResult = Apollo.QueryResult<GetPerformanceInstrumentDevisenQuery, GetPerformanceInstrumentDevisenQueryVariables>;
export const GetFundCompaniesDocument = gql`
    query getFundCompanies {
  fundCompanies {
    id
    name
  }
}
    `;

/**
 * __useGetFundCompaniesQuery__
 *
 * To run a query within a React component, call `useGetFundCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFundCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetFundCompaniesQuery, GetFundCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundCompaniesQuery, GetFundCompaniesQueryVariables>(GetFundCompaniesDocument, options);
      }
export function useGetFundCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFundCompaniesQuery, GetFundCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundCompaniesQuery, GetFundCompaniesQueryVariables>(GetFundCompaniesDocument, options);
        }
export type GetFundCompaniesQueryHookResult = ReturnType<typeof useGetFundCompaniesQuery>;
export type GetFundCompaniesLazyQueryHookResult = ReturnType<typeof useGetFundCompaniesLazyQuery>;
export type GetFundCompaniesQueryResult = Apollo.QueryResult<GetFundCompaniesQuery, GetFundCompaniesQueryVariables>;
export const GetFundPerformanceChartDocument = gql`
    query getFundPerformanceChart($instrumentId: Int!, $chartScope: ChartScope!) {
  instrument(id: $instrumentId) {
    id
    chart(scope: $chartScope) {
      id
      series {
        label
        type
        data {
          value
          when
        }
      }
    }
  }
}
    `;

/**
 * __useGetFundPerformanceChartQuery__
 *
 * To run a query within a React component, call `useGetFundPerformanceChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundPerformanceChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundPerformanceChartQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      chartScope: // value for 'chartScope'
 *   },
 * });
 */
export function useGetFundPerformanceChartQuery(baseOptions: Apollo.QueryHookOptions<GetFundPerformanceChartQuery, GetFundPerformanceChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundPerformanceChartQuery, GetFundPerformanceChartQueryVariables>(GetFundPerformanceChartDocument, options);
      }
export function useGetFundPerformanceChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFundPerformanceChartQuery, GetFundPerformanceChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundPerformanceChartQuery, GetFundPerformanceChartQueryVariables>(GetFundPerformanceChartDocument, options);
        }
export type GetFundPerformanceChartQueryHookResult = ReturnType<typeof useGetFundPerformanceChartQuery>;
export type GetFundPerformanceChartLazyQueryHookResult = ReturnType<typeof useGetFundPerformanceChartLazyQuery>;
export type GetFundPerformanceChartQueryResult = Apollo.QueryResult<GetFundPerformanceChartQuery, GetFundPerformanceChartQueryVariables>;
export const GetFundSearchCountDocument = gql`
    query getFundSearchCount($criterion: SearchFundCriterion, $sort: [SearchFundSort!] = []) {
  searchFund(criterion: $criterion, sort: $sort, first: 0) {
    count
  }
}
    `;

/**
 * __useGetFundSearchCountQuery__
 *
 * To run a query within a React component, call `useGetFundSearchCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundSearchCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundSearchCountQuery({
 *   variables: {
 *      criterion: // value for 'criterion'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetFundSearchCountQuery(baseOptions?: Apollo.QueryHookOptions<GetFundSearchCountQuery, GetFundSearchCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundSearchCountQuery, GetFundSearchCountQueryVariables>(GetFundSearchCountDocument, options);
      }
export function useGetFundSearchCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFundSearchCountQuery, GetFundSearchCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundSearchCountQuery, GetFundSearchCountQueryVariables>(GetFundSearchCountDocument, options);
        }
export type GetFundSearchCountQueryHookResult = ReturnType<typeof useGetFundSearchCountQuery>;
export type GetFundSearchCountLazyQueryHookResult = ReturnType<typeof useGetFundSearchCountLazyQuery>;
export type GetFundSearchCountQueryResult = Apollo.QueryResult<GetFundSearchCountQuery, GetFundSearchCountQueryVariables>;
export const GetFundSearchMetadataDocument = gql`
    query getFundSearchMetadata {
  fundCurrencies {
    id
    name
  }
  fundRegions {
    id
    name
    countryIsoAlpha3
  }
  fundTopics {
    id
    name
  }
  fundStrategies {
    id
    name
  }
  fundTypes {
    id
    name
  }
}
    `;

/**
 * __useGetFundSearchMetadataQuery__
 *
 * To run a query within a React component, call `useGetFundSearchMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundSearchMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundSearchMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFundSearchMetadataQuery(baseOptions?: Apollo.QueryHookOptions<GetFundSearchMetadataQuery, GetFundSearchMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundSearchMetadataQuery, GetFundSearchMetadataQueryVariables>(GetFundSearchMetadataDocument, options);
      }
export function useGetFundSearchMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFundSearchMetadataQuery, GetFundSearchMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundSearchMetadataQuery, GetFundSearchMetadataQueryVariables>(GetFundSearchMetadataDocument, options);
        }
export type GetFundSearchMetadataQueryHookResult = ReturnType<typeof useGetFundSearchMetadataQuery>;
export type GetFundSearchMetadataLazyQueryHookResult = ReturnType<typeof useGetFundSearchMetadataLazyQuery>;
export type GetFundSearchMetadataQueryResult = Apollo.QueryResult<GetFundSearchMetadataQuery, GetFundSearchMetadataQueryVariables>;
export const GetFundSearchResultDocument = gql`
    query getFundSearchResult($criteria: SearchFundCriterion, $sort: [SearchFundSort!], $first: Int, $after: ID) {
  searchFund(criterion: $criteria, sort: $sort, first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        isin
        wkn
        main
        name
        group {
          id
          assetGroup
          seoTag
          fundTranche {
            main
            savingPlanCapable
            germanVwlCapable
            distributing
            currency {
              name
              displayCode
            }
            totalExpenseRatio
            investmentVolume {
              date
              value
            }
            foundationDate
            srri {
              value
            }
          }
          assetType {
            name
          }
          fund {
            id
            region {
              name
            }
            topic {
              name
            }
            currency {
              name
            }
            type {
              name
            }
            strategy {
              name
            }
            company {
              name
            }
          }
        }
        exchange {
          id
          name
        }
        snapQuote {
          lastChange
          instrumentId
          quotes {
            type
            value
            when
          }
        }
        performance(period: [WEEK52, YEAR3]) {
          performance
          deltaAveragePrice
          period
        }
        stats(periods: [WEEK52]) {
          period
          deltaHighPrice
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    count
  }
}
    `;

/**
 * __useGetFundSearchResultQuery__
 *
 * To run a query within a React component, call `useGetFundSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundSearchResultQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetFundSearchResultQuery(baseOptions?: Apollo.QueryHookOptions<GetFundSearchResultQuery, GetFundSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundSearchResultQuery, GetFundSearchResultQueryVariables>(GetFundSearchResultDocument, options);
      }
export function useGetFundSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFundSearchResultQuery, GetFundSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundSearchResultQuery, GetFundSearchResultQueryVariables>(GetFundSearchResultDocument, options);
        }
export type GetFundSearchResultQueryHookResult = ReturnType<typeof useGetFundSearchResultQuery>;
export type GetFundSearchResultLazyQueryHookResult = ReturnType<typeof useGetFundSearchResultLazyQuery>;
export type GetFundSearchResultQueryResult = Apollo.QueryResult<GetFundSearchResultQuery, GetFundSearchResultQueryVariables>;
export const GetFundSearchResultCountDocument = gql`
    query getFundSearchResultCount($fundTopicId: Int, $fundCurrencyId: Int, $fundRegionId: Int, $fundCompanyId: Int, $fundTypeId: Int, $fundStrategyId: Int, $keyFigures: [FundKeyFigureCriteria!] = [], $sort: [SearchFundSort!] = [], $first: Int, $after: ID) {
  searchFund(
    criterion: {fundCompanyId: $fundCompanyId, fundTopicId: $fundTopicId, fundCurrencyId: $fundCurrencyId, fundRegionId: $fundRegionId, fundTypeId: $fundTypeId, fundStrategyId: $fundStrategyId, keyFigures: $keyFigures}
    sort: $sort
    first: $first
    after: $after
  ) {
    count
  }
}
    `;

/**
 * __useGetFundSearchResultCountQuery__
 *
 * To run a query within a React component, call `useGetFundSearchResultCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundSearchResultCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundSearchResultCountQuery({
 *   variables: {
 *      fundTopicId: // value for 'fundTopicId'
 *      fundCurrencyId: // value for 'fundCurrencyId'
 *      fundRegionId: // value for 'fundRegionId'
 *      fundCompanyId: // value for 'fundCompanyId'
 *      fundTypeId: // value for 'fundTypeId'
 *      fundStrategyId: // value for 'fundStrategyId'
 *      keyFigures: // value for 'keyFigures'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetFundSearchResultCountQuery(baseOptions?: Apollo.QueryHookOptions<GetFundSearchResultCountQuery, GetFundSearchResultCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundSearchResultCountQuery, GetFundSearchResultCountQueryVariables>(GetFundSearchResultCountDocument, options);
      }
export function useGetFundSearchResultCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFundSearchResultCountQuery, GetFundSearchResultCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundSearchResultCountQuery, GetFundSearchResultCountQueryVariables>(GetFundSearchResultCountDocument, options);
        }
export type GetFundSearchResultCountQueryHookResult = ReturnType<typeof useGetFundSearchResultCountQuery>;
export type GetFundSearchResultCountLazyQueryHookResult = ReturnType<typeof useGetFundSearchResultCountLazyQuery>;
export type GetFundSearchResultCountQueryResult = Apollo.QueryResult<GetFundSearchResultCountQuery, GetFundSearchResultCountQueryVariables>;
export const GetFundTypesDocument = gql`
    query getFundTypes {
  fundTypes {
    id
    name
  }
}
    `;

/**
 * __useGetFundTypesQuery__
 *
 * To run a query within a React component, call `useGetFundTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFundTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetFundTypesQuery, GetFundTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundTypesQuery, GetFundTypesQueryVariables>(GetFundTypesDocument, options);
      }
export function useGetFundTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFundTypesQuery, GetFundTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundTypesQuery, GetFundTypesQueryVariables>(GetFundTypesDocument, options);
        }
export type GetFundTypesQueryHookResult = ReturnType<typeof useGetFundTypesQuery>;
export type GetFundTypesLazyQueryHookResult = ReturnType<typeof useGetFundTypesLazyQuery>;
export type GetFundTypesQueryResult = Apollo.QueryResult<GetFundTypesQuery, GetFundTypesQueryVariables>;
export const GetRegionsDocument = gql`
    query getRegions {
  regions {
    id
    name
    countries {
      currencyId
      name
    }
  }
}
    `;

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
      }
export function useGetRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegionsQuery, GetRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegionsQuery, GetRegionsQueryVariables>(GetRegionsDocument, options);
        }
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsQueryResult = Apollo.QueryResult<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetSectorsDocument = gql`
    query getSectors {
  sectors {
    id
    name
  }
}
    `;

/**
 * __useGetSectorsQuery__
 *
 * To run a query within a React component, call `useGetSectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSectorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSectorsQuery(baseOptions?: Apollo.QueryHookOptions<GetSectorsQuery, GetSectorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSectorsQuery, GetSectorsQueryVariables>(GetSectorsDocument, options);
      }
export function useGetSectorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSectorsQuery, GetSectorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSectorsQuery, GetSectorsQueryVariables>(GetSectorsDocument, options);
        }
export type GetSectorsQueryHookResult = ReturnType<typeof useGetSectorsQuery>;
export type GetSectorsLazyQueryHookResult = ReturnType<typeof useGetSectorsLazyQuery>;
export type GetSectorsQueryResult = Apollo.QueryResult<GetSectorsQuery, GetSectorsQueryVariables>;
export const SearchIndexDocument = gql`
    query searchIndex($regionId: Long, $sectorId: Long, $first: Int, $after: ID) {
  searchIndex(
    criteria: {regionId: $regionId, sectorId: $sectorId}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        name
        wkn
        group {
          id
          name
          wkn
          seoTag
          assetGroup
          refCountry {
            name
            isoAlpha3
          }
          assetType {
            id
            name
          }
          main {
            id
            country {
              name
              isoAlpha3
            }
            chart(scope: INTRADAY) {
              series {
                label
                type
                data {
                  value
                  when
                }
              }
              threshold {
                type
                value
              }
            }
          }
          compositions {
            id
            name
          }
        }
        currency {
          displayCode
        }
        snapQuote {
          lastChange
          instrumentId
          quote(type: TRADE) {
            value
            change
            percentChange
          }
          quotes {
            type
            value
            change
            percentChange
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    count
  }
}
    `;

/**
 * __useSearchIndexQuery__
 *
 * To run a query within a React component, call `useSearchIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchIndexQuery({
 *   variables: {
 *      regionId: // value for 'regionId'
 *      sectorId: // value for 'sectorId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchIndexQuery(baseOptions?: Apollo.QueryHookOptions<SearchIndexQuery, SearchIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchIndexQuery, SearchIndexQueryVariables>(SearchIndexDocument, options);
      }
export function useSearchIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchIndexQuery, SearchIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchIndexQuery, SearchIndexQueryVariables>(SearchIndexDocument, options);
        }
export type SearchIndexQueryHookResult = ReturnType<typeof useSearchIndexQuery>;
export type SearchIndexLazyQueryHookResult = ReturnType<typeof useSearchIndexLazyQuery>;
export type SearchIndexQueryResult = Apollo.QueryResult<SearchIndexQuery, SearchIndexQueryVariables>;
export const GetIndexCompositionDocument = gql`
    query getIndexComposition($groupId: Int!) {
  group(id: $groupId) {
    id
    name
    wkn
    seoTag
    assetGroup
    refCountry {
      name
      isoAlpha3
    }
    assetType {
      id
      name
    }
    main {
      id
      country {
        name
        isoAlpha3
      }
      chart(scope: INTRADAY) {
        series {
          label
          type
          data {
            value
            when
          }
        }
        threshold {
          type
          value
        }
      }
    }
    compositions {
      id
      name
    }
  }
}
    `;

/**
 * __useGetIndexCompositionQuery__
 *
 * To run a query within a React component, call `useGetIndexCompositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndexCompositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndexCompositionQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetIndexCompositionQuery(baseOptions: Apollo.QueryHookOptions<GetIndexCompositionQuery, GetIndexCompositionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndexCompositionQuery, GetIndexCompositionQueryVariables>(GetIndexCompositionDocument, options);
      }
export function useGetIndexCompositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndexCompositionQuery, GetIndexCompositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndexCompositionQuery, GetIndexCompositionQueryVariables>(GetIndexCompositionDocument, options);
        }
export type GetIndexCompositionQueryHookResult = ReturnType<typeof useGetIndexCompositionQuery>;
export type GetIndexCompositionLazyQueryHookResult = ReturnType<typeof useGetIndexCompositionLazyQuery>;
export type GetIndexCompositionQueryResult = Apollo.QueryResult<GetIndexCompositionQuery, GetIndexCompositionQueryVariables>;
export const GetIndexPageListSectionDocument = gql`
    query getIndexPageListSection {
  list(id: "index_overview_products") {
    id
    content {
      id
      name
      snapQuote {
        lastChange
        instrumentId
        quote(type: TRADE) {
          type
          when
          delay
          value
          percentChange
          change
        }
      }
      currency {
        displayCode
      }
      exchange {
        code
      }
      group {
        id
        name
        seoTag
        assetGroup
      }
    }
  }
}
    `;

/**
 * __useGetIndexPageListSectionQuery__
 *
 * To run a query within a React component, call `useGetIndexPageListSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndexPageListSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndexPageListSectionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIndexPageListSectionQuery(baseOptions?: Apollo.QueryHookOptions<GetIndexPageListSectionQuery, GetIndexPageListSectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndexPageListSectionQuery, GetIndexPageListSectionQueryVariables>(GetIndexPageListSectionDocument, options);
      }
export function useGetIndexPageListSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndexPageListSectionQuery, GetIndexPageListSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndexPageListSectionQuery, GetIndexPageListSectionQueryVariables>(GetIndexPageListSectionDocument, options);
        }
export type GetIndexPageListSectionQueryHookResult = ReturnType<typeof useGetIndexPageListSectionQuery>;
export type GetIndexPageListSectionLazyQueryHookResult = ReturnType<typeof useGetIndexPageListSectionLazyQuery>;
export type GetIndexPageListSectionQueryResult = Apollo.QueryResult<GetIndexPageListSectionQuery, GetIndexPageListSectionQueryVariables>;
export const GetListInstrumentsChartDocument = gql`
    query getListInstrumentsChart($listId: String!) {
  list(id: $listId) {
    id
    content {
      name
      id
      chart(scope: FIVE_YEAR) {
        id
        series {
          label
          type
          data {
            value
            when
          }
        }
        threshold {
          type
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetListInstrumentsChartQuery__
 *
 * To run a query within a React component, call `useGetListInstrumentsChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListInstrumentsChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListInstrumentsChartQuery({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useGetListInstrumentsChartQuery(baseOptions: Apollo.QueryHookOptions<GetListInstrumentsChartQuery, GetListInstrumentsChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetListInstrumentsChartQuery, GetListInstrumentsChartQueryVariables>(GetListInstrumentsChartDocument, options);
      }
export function useGetListInstrumentsChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetListInstrumentsChartQuery, GetListInstrumentsChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetListInstrumentsChartQuery, GetListInstrumentsChartQueryVariables>(GetListInstrumentsChartDocument, options);
        }
export type GetListInstrumentsChartQueryHookResult = ReturnType<typeof useGetListInstrumentsChartQuery>;
export type GetListInstrumentsChartLazyQueryHookResult = ReturnType<typeof useGetListInstrumentsChartLazyQuery>;
export type GetListInstrumentsChartQueryResult = Apollo.QueryResult<GetListInstrumentsChartQuery, GetListInstrumentsChartQueryVariables>;
export const GetTopFlopInstrumentsWithAnalysisDocument = gql`
    query getTopFlopInstrumentsWithAnalysis {
  list(id: "topflop_instruments") {
    id
    content {
      id
      name
      group {
        id
        name
        seoTag
        assetGroup
        analysisReport {
          positiveCount
          neutralCount
          negativeCount
        }
      }
      exchange {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useGetTopFlopInstrumentsWithAnalysisQuery__
 *
 * To run a query within a React component, call `useGetTopFlopInstrumentsWithAnalysisQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopFlopInstrumentsWithAnalysisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopFlopInstrumentsWithAnalysisQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopFlopInstrumentsWithAnalysisQuery(baseOptions?: Apollo.QueryHookOptions<GetTopFlopInstrumentsWithAnalysisQuery, GetTopFlopInstrumentsWithAnalysisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopFlopInstrumentsWithAnalysisQuery, GetTopFlopInstrumentsWithAnalysisQueryVariables>(GetTopFlopInstrumentsWithAnalysisDocument, options);
      }
export function useGetTopFlopInstrumentsWithAnalysisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopFlopInstrumentsWithAnalysisQuery, GetTopFlopInstrumentsWithAnalysisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopFlopInstrumentsWithAnalysisQuery, GetTopFlopInstrumentsWithAnalysisQueryVariables>(GetTopFlopInstrumentsWithAnalysisDocument, options);
        }
export type GetTopFlopInstrumentsWithAnalysisQueryHookResult = ReturnType<typeof useGetTopFlopInstrumentsWithAnalysisQuery>;
export type GetTopFlopInstrumentsWithAnalysisLazyQueryHookResult = ReturnType<typeof useGetTopFlopInstrumentsWithAnalysisLazyQuery>;
export type GetTopFlopInstrumentsWithAnalysisQueryResult = Apollo.QueryResult<GetTopFlopInstrumentsWithAnalysisQuery, GetTopFlopInstrumentsWithAnalysisQueryVariables>;
export const GetTopFlopInstrumentsIndexDocument = gql`
    query getTopFlopInstrumentsIndex {
  list(id: "topflop_instruments") {
    id
    content {
      id
      name
      group {
        id
        name
        seoTag
        assetGroup
      }
    }
  }
}
    `;

/**
 * __useGetTopFlopInstrumentsIndexQuery__
 *
 * To run a query within a React component, call `useGetTopFlopInstrumentsIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopFlopInstrumentsIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopFlopInstrumentsIndexQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopFlopInstrumentsIndexQuery(baseOptions?: Apollo.QueryHookOptions<GetTopFlopInstrumentsIndexQuery, GetTopFlopInstrumentsIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopFlopInstrumentsIndexQuery, GetTopFlopInstrumentsIndexQueryVariables>(GetTopFlopInstrumentsIndexDocument, options);
      }
export function useGetTopFlopInstrumentsIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopFlopInstrumentsIndexQuery, GetTopFlopInstrumentsIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopFlopInstrumentsIndexQuery, GetTopFlopInstrumentsIndexQueryVariables>(GetTopFlopInstrumentsIndexDocument, options);
        }
export type GetTopFlopInstrumentsIndexQueryHookResult = ReturnType<typeof useGetTopFlopInstrumentsIndexQuery>;
export type GetTopFlopInstrumentsIndexLazyQueryHookResult = ReturnType<typeof useGetTopFlopInstrumentsIndexLazyQuery>;
export type GetTopFlopInstrumentsIndexQueryResult = Apollo.QueryResult<GetTopFlopInstrumentsIndexQuery, GetTopFlopInstrumentsIndexQueryVariables>;
export const UpdateStickyInstrumentDocument = gql`
    subscription updateStickyInstrument($id: Int!) {
  update(instrument: $id) {
    instrumentId
    lastPrice
    lowPrice
    highPrice
    firstPrice
    cumulativeTrades
    cumulativeVolume
    cumulativeTurnover
    quotes {
      delay
      type
      value
      percentChange
      change
      size
      when
    }
  }
}
    `;

/**
 * __useUpdateStickyInstrumentSubscription__
 *
 * To run a query within a React component, call `useUpdateStickyInstrumentSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUpdateStickyInstrumentSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateStickyInstrumentSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateStickyInstrumentSubscription(baseOptions: Apollo.SubscriptionHookOptions<UpdateStickyInstrumentSubscription, UpdateStickyInstrumentSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UpdateStickyInstrumentSubscription, UpdateStickyInstrumentSubscriptionVariables>(UpdateStickyInstrumentDocument, options);
      }
export type UpdateStickyInstrumentSubscriptionHookResult = ReturnType<typeof useUpdateStickyInstrumentSubscription>;
export type UpdateStickyInstrumentSubscriptionResult = Apollo.SubscriptionResult<UpdateStickyInstrumentSubscription>;
export const GetSingleInstrumentSearchDocument = gql`
    query getSingleInstrumentSearch($assetGroup: [AssetGroup!], $searchString: String!, $first: Int!, $after: ID) {
  search(
    criteria: {assetGroup: $assetGroup, searchString: $searchString}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        name
        group {
          id
          name
          isin
          wkn
          assetGroup
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useGetSingleInstrumentSearchQuery__
 *
 * To run a query within a React component, call `useGetSingleInstrumentSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleInstrumentSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleInstrumentSearchQuery({
 *   variables: {
 *      assetGroup: // value for 'assetGroup'
 *      searchString: // value for 'searchString'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetSingleInstrumentSearchQuery(baseOptions: Apollo.QueryHookOptions<GetSingleInstrumentSearchQuery, GetSingleInstrumentSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleInstrumentSearchQuery, GetSingleInstrumentSearchQueryVariables>(GetSingleInstrumentSearchDocument, options);
      }
export function useGetSingleInstrumentSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleInstrumentSearchQuery, GetSingleInstrumentSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleInstrumentSearchQuery, GetSingleInstrumentSearchQueryVariables>(GetSingleInstrumentSearchDocument, options);
        }
export type GetSingleInstrumentSearchQueryHookResult = ReturnType<typeof useGetSingleInstrumentSearchQuery>;
export type GetSingleInstrumentSearchLazyQueryHookResult = ReturnType<typeof useGetSingleInstrumentSearchLazyQuery>;
export type GetSingleInstrumentSearchQueryResult = Apollo.QueryResult<GetSingleInstrumentSearchQuery, GetSingleInstrumentSearchQueryVariables>;
export const GetSimpleAssetSelectorDefaultListDocument = gql`
    query getSimpleAssetSelectorDefaultList {
  list(id: "hot_instruments") {
    id
    content {
      group {
        id
        name
        isin
        wkn
        seoTag
        assetGroup
      }
    }
  }
}
    `;

/**
 * __useGetSimpleAssetSelectorDefaultListQuery__
 *
 * To run a query within a React component, call `useGetSimpleAssetSelectorDefaultListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleAssetSelectorDefaultListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleAssetSelectorDefaultListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSimpleAssetSelectorDefaultListQuery(baseOptions?: Apollo.QueryHookOptions<GetSimpleAssetSelectorDefaultListQuery, GetSimpleAssetSelectorDefaultListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimpleAssetSelectorDefaultListQuery, GetSimpleAssetSelectorDefaultListQueryVariables>(GetSimpleAssetSelectorDefaultListDocument, options);
      }
export function useGetSimpleAssetSelectorDefaultListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimpleAssetSelectorDefaultListQuery, GetSimpleAssetSelectorDefaultListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimpleAssetSelectorDefaultListQuery, GetSimpleAssetSelectorDefaultListQueryVariables>(GetSimpleAssetSelectorDefaultListDocument, options);
        }
export type GetSimpleAssetSelectorDefaultListQueryHookResult = ReturnType<typeof useGetSimpleAssetSelectorDefaultListQuery>;
export type GetSimpleAssetSelectorDefaultListLazyQueryHookResult = ReturnType<typeof useGetSimpleAssetSelectorDefaultListLazyQuery>;
export type GetSimpleAssetSelectorDefaultListQueryResult = Apollo.QueryResult<GetSimpleAssetSelectorDefaultListQuery, GetSimpleAssetSelectorDefaultListQueryVariables>;
export const GetNewsSourceDocument = gql`
    query getNewsSource {
  newsSource {
    id
    name
    code
  }
}
    `;

/**
 * __useGetNewsSourceQuery__
 *
 * To run a query within a React component, call `useGetNewsSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsSourceQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsSourceQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsSourceQuery, GetNewsSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsSourceQuery, GetNewsSourceQueryVariables>(GetNewsSourceDocument, options);
      }
export function useGetNewsSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsSourceQuery, GetNewsSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsSourceQuery, GetNewsSourceQueryVariables>(GetNewsSourceDocument, options);
        }
export type GetNewsSourceQueryHookResult = ReturnType<typeof useGetNewsSourceQuery>;
export type GetNewsSourceLazyQueryHookResult = ReturnType<typeof useGetNewsSourceLazyQuery>;
export type GetNewsSourceQueryResult = Apollo.QueryResult<GetNewsSourceQuery, GetNewsSourceQueryVariables>;
export const GetNewsTopicsDocument = gql`
    query getNewsTopics {
  newsTopics {
    id
    name
  }
}
    `;

/**
 * __useGetNewsTopicsQuery__
 *
 * To run a query within a React component, call `useGetNewsTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsTopicsQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsTopicsQuery, GetNewsTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsTopicsQuery, GetNewsTopicsQueryVariables>(GetNewsTopicsDocument, options);
      }
export function useGetNewsTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsTopicsQuery, GetNewsTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsTopicsQuery, GetNewsTopicsQueryVariables>(GetNewsTopicsDocument, options);
        }
export type GetNewsTopicsQueryHookResult = ReturnType<typeof useGetNewsTopicsQuery>;
export type GetNewsTopicsLazyQueryHookResult = ReturnType<typeof useGetNewsTopicsLazyQuery>;
export type GetNewsTopicsQueryResult = Apollo.QueryResult<GetNewsTopicsQuery, GetNewsTopicsQueryVariables>;
export const GetNewsFeedDocument = gql`
    query getNewsFeed($criteria: NewsCriteria, $first: Int, $after: ID) {
  newsSearch(criteria: $criteria, first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        when
        source {
          id
          name
        }
        body
        headline
        teaser
        medias {
          source
          width
          height
        }
        streams {
          mimeType
          duration
          width
          height
          source
        }
        links {
          name
          href
        }
        feed
        keywords
        instruments {
          group {
            id
            isin
            name
            assetGroup
            seoTag
            main {
              id
              snapQuote {
                lastChange
                instrumentId
                lowPrice
                highPrice
                firstPrice
                lastPrice
                yesterdayPrice
                cumulativeTrades
                cumulativeTurnover
                cumulativeVolume
                quotes {
                  delay
                  type
                  value
                  percentChange
                  change
                  when
                }
              }
              currency {
                displayCode
              }
            }
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    `;

/**
 * __useGetNewsFeedQuery__
 *
 * To run a query within a React component, call `useGetNewsFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsFeedQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetNewsFeedQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsFeedQuery, GetNewsFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsFeedQuery, GetNewsFeedQueryVariables>(GetNewsFeedDocument, options);
      }
export function useGetNewsFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsFeedQuery, GetNewsFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsFeedQuery, GetNewsFeedQueryVariables>(GetNewsFeedDocument, options);
        }
export type GetNewsFeedQueryHookResult = ReturnType<typeof useGetNewsFeedQuery>;
export type GetNewsFeedLazyQueryHookResult = ReturnType<typeof useGetNewsFeedLazyQuery>;
export type GetNewsFeedQueryResult = Apollo.QueryResult<GetNewsFeedQuery, GetNewsFeedQueryVariables>;
export const GetNewsMetadataDocument = gql`
    query getNewsMetadata {
  newsSource {
    id
    name
    code
  }
  newsTopics {
    id
    name
  }
}
    `;

/**
 * __useGetNewsMetadataQuery__
 *
 * To run a query within a React component, call `useGetNewsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNewsMetadataQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsMetadataQuery, GetNewsMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsMetadataQuery, GetNewsMetadataQueryVariables>(GetNewsMetadataDocument, options);
      }
export function useGetNewsMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsMetadataQuery, GetNewsMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsMetadataQuery, GetNewsMetadataQueryVariables>(GetNewsMetadataDocument, options);
        }
export type GetNewsMetadataQueryHookResult = ReturnType<typeof useGetNewsMetadataQuery>;
export type GetNewsMetadataLazyQueryHookResult = ReturnType<typeof useGetNewsMetadataLazyQuery>;
export type GetNewsMetadataQueryResult = Apollo.QueryResult<GetNewsMetadataQuery, GetNewsMetadataQueryVariables>;
export const GetInstrumentGroupUserLimitsDocument = gql`
    query getInstrumentGroupUserLimits($groupId: Int!) {
  group(id: $groupId) {
    id
    assetGroup
    name
    isin
    wkn
    content {
      id
      main
      isin
      name
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      group {
        id
        seoTag
        assetGroup
        sector {
          name
        }
      }
      countryId
      snapQuote {
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          delay
          type
          size
          value
          percentChange
          change
          when
        }
      }
      stats(periods: [WEEK52]) {
        period
        lowPrice
        highPrice
      }
    }
  }
}
    `;

/**
 * __useGetInstrumentGroupUserLimitsQuery__
 *
 * To run a query within a React component, call `useGetInstrumentGroupUserLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentGroupUserLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentGroupUserLimitsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetInstrumentGroupUserLimitsQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentGroupUserLimitsQuery, GetInstrumentGroupUserLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentGroupUserLimitsQuery, GetInstrumentGroupUserLimitsQueryVariables>(GetInstrumentGroupUserLimitsDocument, options);
      }
export function useGetInstrumentGroupUserLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentGroupUserLimitsQuery, GetInstrumentGroupUserLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentGroupUserLimitsQuery, GetInstrumentGroupUserLimitsQueryVariables>(GetInstrumentGroupUserLimitsDocument, options);
        }
export type GetInstrumentGroupUserLimitsQueryHookResult = ReturnType<typeof useGetInstrumentGroupUserLimitsQuery>;
export type GetInstrumentGroupUserLimitsLazyQueryHookResult = ReturnType<typeof useGetInstrumentGroupUserLimitsLazyQuery>;
export type GetInstrumentGroupUserLimitsQueryResult = Apollo.QueryResult<GetInstrumentGroupUserLimitsQuery, GetInstrumentGroupUserLimitsQueryVariables>;
export const GetInstrumentUserLimitsDocument = gql`
    query getInstrumentUserLimits($instrumentId: Int!) {
  instrument(id: $instrumentId) {
    id
    name
    isin
    wkn
    exchange {
      id
      name
      code
    }
    currency {
      id
      displayCode
      alphaCode
    }
    snapQuote {
      lastChange
      instrumentId
      quote(type: TRADE) {
        value
        change
        percentChange
        when
      }
    }
    group {
      id
      name
      assetGroup
      seoTag
    }
  }
}
    `;

/**
 * __useGetInstrumentUserLimitsQuery__
 *
 * To run a query within a React component, call `useGetInstrumentUserLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentUserLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentUserLimitsQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *   },
 * });
 */
export function useGetInstrumentUserLimitsQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentUserLimitsQuery, GetInstrumentUserLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentUserLimitsQuery, GetInstrumentUserLimitsQueryVariables>(GetInstrumentUserLimitsDocument, options);
      }
export function useGetInstrumentUserLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentUserLimitsQuery, GetInstrumentUserLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentUserLimitsQuery, GetInstrumentUserLimitsQueryVariables>(GetInstrumentUserLimitsDocument, options);
        }
export type GetInstrumentUserLimitsQueryHookResult = ReturnType<typeof useGetInstrumentUserLimitsQuery>;
export type GetInstrumentUserLimitsLazyQueryHookResult = ReturnType<typeof useGetInstrumentUserLimitsLazyQuery>;
export type GetInstrumentUserLimitsQueryResult = Apollo.QueryResult<GetInstrumentUserLimitsQuery, GetInstrumentUserLimitsQueryVariables>;
export const EditLimitOrderDocument = gql`
    mutation EditLimitOrder($viewOrder: String!, $viewOrderAsc: Boolean) {
  editLimitOrder(viewOrder: $viewOrder, viewOrderAsc: $viewOrderAsc) {
    responseCode
    responseMessage
  }
}
    `;
export type EditLimitOrderMutationFn = Apollo.MutationFunction<EditLimitOrderMutation, EditLimitOrderMutationVariables>;

/**
 * __useEditLimitOrderMutation__
 *
 * To run a mutation, you first call `useEditLimitOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLimitOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLimitOrderMutation, { data, loading, error }] = useEditLimitOrderMutation({
 *   variables: {
 *      viewOrder: // value for 'viewOrder'
 *      viewOrderAsc: // value for 'viewOrderAsc'
 *   },
 * });
 */
export function useEditLimitOrderMutation(baseOptions?: Apollo.MutationHookOptions<EditLimitOrderMutation, EditLimitOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLimitOrderMutation, EditLimitOrderMutationVariables>(EditLimitOrderDocument, options);
      }
export type EditLimitOrderMutationHookResult = ReturnType<typeof useEditLimitOrderMutation>;
export type EditLimitOrderMutationResult = Apollo.MutationResult<EditLimitOrderMutation>;
export type EditLimitOrderMutationOptions = Apollo.BaseMutationOptions<EditLimitOrderMutation, EditLimitOrderMutationVariables>;
export const EditLimitViewDocument = gql`
    mutation EditLimitView($viewType: String!) {
  editLimitView(viewType: $viewType) {
    responseCode
    responseMessage
  }
}
    `;
export type EditLimitViewMutationFn = Apollo.MutationFunction<EditLimitViewMutation, EditLimitViewMutationVariables>;

/**
 * __useEditLimitViewMutation__
 *
 * To run a mutation, you first call `useEditLimitViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLimitViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLimitViewMutation, { data, loading, error }] = useEditLimitViewMutation({
 *   variables: {
 *      viewType: // value for 'viewType'
 *   },
 * });
 */
export function useEditLimitViewMutation(baseOptions?: Apollo.MutationHookOptions<EditLimitViewMutation, EditLimitViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLimitViewMutation, EditLimitViewMutationVariables>(EditLimitViewDocument, options);
      }
export type EditLimitViewMutationHookResult = ReturnType<typeof useEditLimitViewMutation>;
export type EditLimitViewMutationResult = Apollo.MutationResult<EditLimitViewMutation>;
export type EditLimitViewMutationOptions = Apollo.BaseMutationOptions<EditLimitViewMutation, EditLimitViewMutationVariables>;
export const GetProfileInstrumentChartDocument = gql`
    query getProfileInstrumentChart($instrumentId: Int!, $chartScope: ChartScope!) {
  instrument(id: $instrumentId) {
    id
    chart(scope: $chartScope) {
      id
      series {
        label
        type
        data {
          value
          when
        }
      }
      threshold {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useGetProfileInstrumentChartQuery__
 *
 * To run a query within a React component, call `useGetProfileInstrumentChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileInstrumentChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileInstrumentChartQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      chartScope: // value for 'chartScope'
 *   },
 * });
 */
export function useGetProfileInstrumentChartQuery(baseOptions: Apollo.QueryHookOptions<GetProfileInstrumentChartQuery, GetProfileInstrumentChartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileInstrumentChartQuery, GetProfileInstrumentChartQueryVariables>(GetProfileInstrumentChartDocument, options);
      }
export function useGetProfileInstrumentChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileInstrumentChartQuery, GetProfileInstrumentChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileInstrumentChartQuery, GetProfileInstrumentChartQueryVariables>(GetProfileInstrumentChartDocument, options);
        }
export type GetProfileInstrumentChartQueryHookResult = ReturnType<typeof useGetProfileInstrumentChartQuery>;
export type GetProfileInstrumentChartLazyQueryHookResult = ReturnType<typeof useGetProfileInstrumentChartLazyQuery>;
export type GetProfileInstrumentChartQueryResult = Apollo.QueryResult<GetProfileInstrumentChartQuery, GetProfileInstrumentChartQueryVariables>;
export const GetDailyAnalysisCountDocument = gql`
    query getDailyAnalysisCount($isins: [String!]!, $startDate: LocalDate!, $endDate: LocalDate) {
  analysesIsinCount(
    criteria: {isins: $isins, startDate: $startDate, endDate: $endDate}
  ) {
    newsCount
    isin
    date
  }
}
    `;

/**
 * __useGetDailyAnalysisCountQuery__
 *
 * To run a query within a React component, call `useGetDailyAnalysisCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyAnalysisCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyAnalysisCountQuery({
 *   variables: {
 *      isins: // value for 'isins'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDailyAnalysisCountQuery(baseOptions: Apollo.QueryHookOptions<GetDailyAnalysisCountQuery, GetDailyAnalysisCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyAnalysisCountQuery, GetDailyAnalysisCountQueryVariables>(GetDailyAnalysisCountDocument, options);
      }
export function useGetDailyAnalysisCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyAnalysisCountQuery, GetDailyAnalysisCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyAnalysisCountQuery, GetDailyAnalysisCountQueryVariables>(GetDailyAnalysisCountDocument, options);
        }
export type GetDailyAnalysisCountQueryHookResult = ReturnType<typeof useGetDailyAnalysisCountQuery>;
export type GetDailyAnalysisCountLazyQueryHookResult = ReturnType<typeof useGetDailyAnalysisCountLazyQuery>;
export type GetDailyAnalysisCountQueryResult = Apollo.QueryResult<GetDailyAnalysisCountQuery, GetDailyAnalysisCountQueryVariables>;
export const GetDailyNewsSummaryDocument = gql`
    query getDailyNewsSummary($isins: [String!]!, $date: LocalDate!) {
  newsDailyCount(criteria: {isins: $isins, startDate: $date, endDate: $date}) {
    count
    isin
    date
  }
}
    `;

/**
 * __useGetDailyNewsSummaryQuery__
 *
 * To run a query within a React component, call `useGetDailyNewsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyNewsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyNewsSummaryQuery({
 *   variables: {
 *      isins: // value for 'isins'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetDailyNewsSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetDailyNewsSummaryQuery, GetDailyNewsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyNewsSummaryQuery, GetDailyNewsSummaryQueryVariables>(GetDailyNewsSummaryDocument, options);
      }
export function useGetDailyNewsSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyNewsSummaryQuery, GetDailyNewsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyNewsSummaryQuery, GetDailyNewsSummaryQueryVariables>(GetDailyNewsSummaryDocument, options);
        }
export type GetDailyNewsSummaryQueryHookResult = ReturnType<typeof useGetDailyNewsSummaryQuery>;
export type GetDailyNewsSummaryLazyQueryHookResult = ReturnType<typeof useGetDailyNewsSummaryLazyQuery>;
export type GetDailyNewsSummaryQueryResult = Apollo.QueryResult<GetDailyNewsSummaryQuery, GetDailyNewsSummaryQueryVariables>;
export const GetDailyNewsCountDocument = gql`
    query getDailyNewsCount($isins: [String!]!, $startDate: LocalDate!, $endDate: LocalDate) {
  newsDailyCount(
    criteria: {isins: $isins, startDate: $startDate, endDate: $endDate}
  ) {
    count
    isin
    date
  }
}
    `;

/**
 * __useGetDailyNewsCountQuery__
 *
 * To run a query within a React component, call `useGetDailyNewsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDailyNewsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDailyNewsCountQuery({
 *   variables: {
 *      isins: // value for 'isins'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDailyNewsCountQuery(baseOptions: Apollo.QueryHookOptions<GetDailyNewsCountQuery, GetDailyNewsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDailyNewsCountQuery, GetDailyNewsCountQueryVariables>(GetDailyNewsCountDocument, options);
      }
export function useGetDailyNewsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDailyNewsCountQuery, GetDailyNewsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDailyNewsCountQuery, GetDailyNewsCountQueryVariables>(GetDailyNewsCountDocument, options);
        }
export type GetDailyNewsCountQueryHookResult = ReturnType<typeof useGetDailyNewsCountQuery>;
export type GetDailyNewsCountLazyQueryHookResult = ReturnType<typeof useGetDailyNewsCountLazyQuery>;
export type GetDailyNewsCountQueryResult = Apollo.QueryResult<GetDailyNewsCountQuery, GetDailyNewsCountQueryVariables>;
export const GetBrokersDocument = gql`
    query getBrokers {
  brokers {
    id
    name
  }
}
    `;

/**
 * __useGetBrokersQuery__
 *
 * To run a query within a React component, call `useGetBrokersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBrokersQuery(baseOptions?: Apollo.QueryHookOptions<GetBrokersQuery, GetBrokersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrokersQuery, GetBrokersQueryVariables>(GetBrokersDocument, options);
      }
export function useGetBrokersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrokersQuery, GetBrokersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrokersQuery, GetBrokersQueryVariables>(GetBrokersDocument, options);
        }
export type GetBrokersQueryHookResult = ReturnType<typeof useGetBrokersQuery>;
export type GetBrokersLazyQueryHookResult = ReturnType<typeof useGetBrokersLazyQuery>;
export type GetBrokersQueryResult = Apollo.QueryResult<GetBrokersQuery, GetBrokersQueryVariables>;
export const GetUserWatchlistsAddDocument = gql`
    query getUserWatchlistsAdd {
  user {
    username
    profile {
      watchlists {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetUserWatchlistsAddQuery__
 *
 * To run a query within a React component, call `useGetUserWatchlistsAddQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWatchlistsAddQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWatchlistsAddQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserWatchlistsAddQuery(baseOptions?: Apollo.QueryHookOptions<GetUserWatchlistsAddQuery, GetUserWatchlistsAddQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWatchlistsAddQuery, GetUserWatchlistsAddQueryVariables>(GetUserWatchlistsAddDocument, options);
      }
export function useGetUserWatchlistsAddLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWatchlistsAddQuery, GetUserWatchlistsAddQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWatchlistsAddQuery, GetUserWatchlistsAddQueryVariables>(GetUserWatchlistsAddDocument, options);
        }
export type GetUserWatchlistsAddQueryHookResult = ReturnType<typeof useGetUserWatchlistsAddQuery>;
export type GetUserWatchlistsAddLazyQueryHookResult = ReturnType<typeof useGetUserWatchlistsAddLazyQuery>;
export type GetUserWatchlistsAddQueryResult = Apollo.QueryResult<GetUserWatchlistsAddQuery, GetUserWatchlistsAddQueryVariables>;
export const GetNewsCountDocument = gql`
    query getNewsCount($isins: [String!]!, $intervalStart: OffsetDateTime, $intervalEnd: OffsetDateTime, $first: Int, $after: ID) {
  newsSearch(
    criteria: {isin: $isins, intervalStart: $intervalStart, intervalEnd: $intervalEnd}
    first: $first
    after: $after
  ) {
    edges {
      node {
        id
      }
    }
  }
}
    `;

/**
 * __useGetNewsCountQuery__
 *
 * To run a query within a React component, call `useGetNewsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsCountQuery({
 *   variables: {
 *      isins: // value for 'isins'
 *      intervalStart: // value for 'intervalStart'
 *      intervalEnd: // value for 'intervalEnd'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetNewsCountQuery(baseOptions: Apollo.QueryHookOptions<GetNewsCountQuery, GetNewsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsCountQuery, GetNewsCountQueryVariables>(GetNewsCountDocument, options);
      }
export function useGetNewsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsCountQuery, GetNewsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsCountQuery, GetNewsCountQueryVariables>(GetNewsCountDocument, options);
        }
export type GetNewsCountQueryHookResult = ReturnType<typeof useGetNewsCountQuery>;
export type GetNewsCountLazyQueryHookResult = ReturnType<typeof useGetNewsCountLazyQuery>;
export type GetNewsCountQueryResult = Apollo.QueryResult<GetNewsCountQuery, GetNewsCountQueryVariables>;
export const GetNewsInfoDocument = gql`
    query getNewsInfo($isins: [String!]!) {
  newsSearch(criteria: {isin: $isins}, first: 1) {
    edges {
      node {
        id
        when
      }
    }
  }
}
    `;

/**
 * __useGetNewsInfoQuery__
 *
 * To run a query within a React component, call `useGetNewsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsInfoQuery({
 *   variables: {
 *      isins: // value for 'isins'
 *   },
 * });
 */
export function useGetNewsInfoQuery(baseOptions: Apollo.QueryHookOptions<GetNewsInfoQuery, GetNewsInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsInfoQuery, GetNewsInfoQueryVariables>(GetNewsInfoDocument, options);
      }
export function useGetNewsInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsInfoQuery, GetNewsInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsInfoQuery, GetNewsInfoQueryVariables>(GetNewsInfoDocument, options);
        }
export type GetNewsInfoQueryHookResult = ReturnType<typeof useGetNewsInfoQuery>;
export type GetNewsInfoLazyQueryHookResult = ReturnType<typeof useGetNewsInfoLazyQuery>;
export type GetNewsInfoQueryResult = Apollo.QueryResult<GetNewsInfoQuery, GetNewsInfoQueryVariables>;
export const GetNewsModalDocument = gql`
    query getNewsModal($isins: [String!]!, $intervalStart: OffsetDateTime, $intervalEnd: OffsetDateTime, $first: Int, $after: ID) {
  newsSearch(
    criteria: {isin: $isins, intervalStart: $intervalStart, intervalEnd: $intervalEnd}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        when
        body
        headline
        teaser
        links {
          name
          href
        }
        source {
          id
          name
        }
        medias {
          source
          width
          height
        }
        streams {
          mimeType
          duration
          width
          height
          source
        }
        feed
        keywords
        instruments {
          group {
            id
            isin
            name
            assetGroup
            seoTag
            main {
              id
              snapQuote {
                lastChange
                instrumentId
                lowPrice
                highPrice
                firstPrice
                lastPrice
                yesterdayPrice
                cumulativeTrades
                cumulativeTurnover
                cumulativeVolume
                quotes {
                  delay
                  type
                  value
                  percentChange
                  change
                  when
                }
              }
              currency {
                displayCode
              }
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
      startCursor
    }
  }
}
    `;

/**
 * __useGetNewsModalQuery__
 *
 * To run a query within a React component, call `useGetNewsModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsModalQuery({
 *   variables: {
 *      isins: // value for 'isins'
 *      intervalStart: // value for 'intervalStart'
 *      intervalEnd: // value for 'intervalEnd'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetNewsModalQuery(baseOptions: Apollo.QueryHookOptions<GetNewsModalQuery, GetNewsModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsModalQuery, GetNewsModalQueryVariables>(GetNewsModalDocument, options);
      }
export function useGetNewsModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsModalQuery, GetNewsModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsModalQuery, GetNewsModalQueryVariables>(GetNewsModalDocument, options);
        }
export type GetNewsModalQueryHookResult = ReturnType<typeof useGetNewsModalQuery>;
export type GetNewsModalLazyQueryHookResult = ReturnType<typeof useGetNewsModalLazyQuery>;
export type GetNewsModalQueryResult = Apollo.QueryResult<GetNewsModalQuery, GetNewsModalQueryVariables>;
export const ChangeEmailDocument = gql`
    mutation ChangeEmail($email: String!) {
  requestChangeProfileEmail(email: $email) {
    responseCode
    responseMessage
  }
}
    `;
export type ChangeEmailMutationFn = Apollo.MutationFunction<ChangeEmailMutation, ChangeEmailMutationVariables>;

/**
 * __useChangeEmailMutation__
 *
 * To run a mutation, you first call `useChangeEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailMutation, { data, loading, error }] = useChangeEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useChangeEmailMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEmailMutation, ChangeEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEmailMutation, ChangeEmailMutationVariables>(ChangeEmailDocument, options);
      }
export type ChangeEmailMutationHookResult = ReturnType<typeof useChangeEmailMutation>;
export type ChangeEmailMutationResult = Apollo.MutationResult<ChangeEmailMutation>;
export type ChangeEmailMutationOptions = Apollo.BaseMutationOptions<ChangeEmailMutation, ChangeEmailMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword {
  requestChangeProfilePassword {
    responseCode
    responseMessage
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const DeleteProfileDocument = gql`
    mutation DeleteProfile {
  deleteProfile {
    responseCode
    responseMessage
  }
}
    `;
export type DeleteProfileMutationFn = Apollo.MutationFunction<DeleteProfileMutation, DeleteProfileMutationVariables>;

/**
 * __useDeleteProfileMutation__
 *
 * To run a mutation, you first call `useDeleteProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProfileMutation, { data, loading, error }] = useDeleteProfileMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteProfileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProfileMutation, DeleteProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProfileMutation, DeleteProfileMutationVariables>(DeleteProfileDocument, options);
      }
export type DeleteProfileMutationHookResult = ReturnType<typeof useDeleteProfileMutation>;
export type DeleteProfileMutationResult = Apollo.MutationResult<DeleteProfileMutation>;
export type DeleteProfileMutationOptions = Apollo.BaseMutationOptions<DeleteProfileMutation, DeleteProfileMutationVariables>;
export const AddAccountEntryDocument = gql`
    mutation AddAccountEntry($portfolioId: Long!, $entry: AccountEntryInput!) {
  addAccountEntry(portfolioId: $portfolioId, entry: $entry) {
    id
    accountTypeId
    accountTypeDescriptionEn
    instrumentId
    portfolioEntryId
    instrument {
      id
      name
    }
    amount
    quantity
    memo
    securityDescription
    entryTime
  }
}
    `;
export type AddAccountEntryMutationFn = Apollo.MutationFunction<AddAccountEntryMutation, AddAccountEntryMutationVariables>;

/**
 * __useAddAccountEntryMutation__
 *
 * To run a mutation, you first call `useAddAccountEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccountEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccountEntryMutation, { data, loading, error }] = useAddAccountEntryMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      entry: // value for 'entry'
 *   },
 * });
 */
export function useAddAccountEntryMutation(baseOptions?: Apollo.MutationHookOptions<AddAccountEntryMutation, AddAccountEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccountEntryMutation, AddAccountEntryMutationVariables>(AddAccountEntryDocument, options);
      }
export type AddAccountEntryMutationHookResult = ReturnType<typeof useAddAccountEntryMutation>;
export type AddAccountEntryMutationResult = Apollo.MutationResult<AddAccountEntryMutation>;
export type AddAccountEntryMutationOptions = Apollo.BaseMutationOptions<AddAccountEntryMutation, AddAccountEntryMutationVariables>;
export const EditAccountEntryDocument = gql`
    mutation EditAccountEntry($portfolioId: Long!, $accountEntryId: Long!, $entry: AccountEntryInput!) {
  editAccountEntry(
    portfolioId: $portfolioId
    entry: $entry
    accountEntryId: $accountEntryId
  ) {
    id
    accountTypeId
    accountTypeDescriptionEn
    instrumentId
    portfolioEntryId
    instrument {
      id
      name
    }
    amount
    quantity
    memo
    securityDescription
    entryTime
  }
}
    `;
export type EditAccountEntryMutationFn = Apollo.MutationFunction<EditAccountEntryMutation, EditAccountEntryMutationVariables>;

/**
 * __useEditAccountEntryMutation__
 *
 * To run a mutation, you first call `useEditAccountEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAccountEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAccountEntryMutation, { data, loading, error }] = useEditAccountEntryMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      accountEntryId: // value for 'accountEntryId'
 *      entry: // value for 'entry'
 *   },
 * });
 */
export function useEditAccountEntryMutation(baseOptions?: Apollo.MutationHookOptions<EditAccountEntryMutation, EditAccountEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditAccountEntryMutation, EditAccountEntryMutationVariables>(EditAccountEntryDocument, options);
      }
export type EditAccountEntryMutationHookResult = ReturnType<typeof useEditAccountEntryMutation>;
export type EditAccountEntryMutationResult = Apollo.MutationResult<EditAccountEntryMutation>;
export type EditAccountEntryMutationOptions = Apollo.BaseMutationOptions<EditAccountEntryMutation, EditAccountEntryMutationVariables>;
export const GetOperationTypesDocument = gql`
    query getOperationTypes {
  accountOperationTypes {
    id
    name
  }
}
    `;

/**
 * __useGetOperationTypesQuery__
 *
 * To run a query within a React component, call `useGetOperationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOperationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOperationTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOperationTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetOperationTypesQuery, GetOperationTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOperationTypesQuery, GetOperationTypesQueryVariables>(GetOperationTypesDocument, options);
      }
export function useGetOperationTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOperationTypesQuery, GetOperationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOperationTypesQuery, GetOperationTypesQueryVariables>(GetOperationTypesDocument, options);
        }
export type GetOperationTypesQueryHookResult = ReturnType<typeof useGetOperationTypesQuery>;
export type GetOperationTypesLazyQueryHookResult = ReturnType<typeof useGetOperationTypesLazyQuery>;
export type GetOperationTypesQueryResult = Apollo.QueryResult<GetOperationTypesQuery, GetOperationTypesQueryVariables>;
export const EditPortfolioOverviewOrderDocument = gql`
    mutation EditPortfolioOverviewOrder($viewOrder: String!, $viewOrderAsc: Boolean) {
  editPortfolioOverviewOrder(viewOrder: $viewOrder, viewOrderAsc: $viewOrderAsc) {
    responseCode
    responseMessage
  }
}
    `;
export type EditPortfolioOverviewOrderMutationFn = Apollo.MutationFunction<EditPortfolioOverviewOrderMutation, EditPortfolioOverviewOrderMutationVariables>;

/**
 * __useEditPortfolioOverviewOrderMutation__
 *
 * To run a mutation, you first call `useEditPortfolioOverviewOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPortfolioOverviewOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPortfolioOverviewOrderMutation, { data, loading, error }] = useEditPortfolioOverviewOrderMutation({
 *   variables: {
 *      viewOrder: // value for 'viewOrder'
 *      viewOrderAsc: // value for 'viewOrderAsc'
 *   },
 * });
 */
export function useEditPortfolioOverviewOrderMutation(baseOptions?: Apollo.MutationHookOptions<EditPortfolioOverviewOrderMutation, EditPortfolioOverviewOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPortfolioOverviewOrderMutation, EditPortfolioOverviewOrderMutationVariables>(EditPortfolioOverviewOrderDocument, options);
      }
export type EditPortfolioOverviewOrderMutationHookResult = ReturnType<typeof useEditPortfolioOverviewOrderMutation>;
export type EditPortfolioOverviewOrderMutationResult = Apollo.MutationResult<EditPortfolioOverviewOrderMutation>;
export type EditPortfolioOverviewOrderMutationOptions = Apollo.BaseMutationOptions<EditPortfolioOverviewOrderMutation, EditPortfolioOverviewOrderMutationVariables>;
export const EditWatchlistOverviewOrderDocument = gql`
    mutation EditWatchlistOverviewOrder($viewOrder: String!, $viewOrderAsc: Boolean) {
  editWatchlistOverviewOrder(viewOrder: $viewOrder, viewOrderAsc: $viewOrderAsc) {
    responseCode
    responseMessage
  }
}
    `;
export type EditWatchlistOverviewOrderMutationFn = Apollo.MutationFunction<EditWatchlistOverviewOrderMutation, EditWatchlistOverviewOrderMutationVariables>;

/**
 * __useEditWatchlistOverviewOrderMutation__
 *
 * To run a mutation, you first call `useEditWatchlistOverviewOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWatchlistOverviewOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWatchlistOverviewOrderMutation, { data, loading, error }] = useEditWatchlistOverviewOrderMutation({
 *   variables: {
 *      viewOrder: // value for 'viewOrder'
 *      viewOrderAsc: // value for 'viewOrderAsc'
 *   },
 * });
 */
export function useEditWatchlistOverviewOrderMutation(baseOptions?: Apollo.MutationHookOptions<EditWatchlistOverviewOrderMutation, EditWatchlistOverviewOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWatchlistOverviewOrderMutation, EditWatchlistOverviewOrderMutationVariables>(EditWatchlistOverviewOrderDocument, options);
      }
export type EditWatchlistOverviewOrderMutationHookResult = ReturnType<typeof useEditWatchlistOverviewOrderMutation>;
export type EditWatchlistOverviewOrderMutationResult = Apollo.MutationResult<EditWatchlistOverviewOrderMutation>;
export type EditWatchlistOverviewOrderMutationOptions = Apollo.BaseMutationOptions<EditWatchlistOverviewOrderMutation, EditWatchlistOverviewOrderMutationVariables>;
export const UpdatePortfolioMasterDocument = gql`
    mutation UpdatePortfolioMaster($changes: [FieldChangeBooleanRequest!]!) {
  updatePortfolioMaster(changes: $changes) {
    id
    value
  }
}
    `;
export type UpdatePortfolioMasterMutationFn = Apollo.MutationFunction<UpdatePortfolioMasterMutation, UpdatePortfolioMasterMutationVariables>;

/**
 * __useUpdatePortfolioMasterMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioMasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioMasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioMasterMutation, { data, loading, error }] = useUpdatePortfolioMasterMutation({
 *   variables: {
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdatePortfolioMasterMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioMasterMutation, UpdatePortfolioMasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioMasterMutation, UpdatePortfolioMasterMutationVariables>(UpdatePortfolioMasterDocument, options);
      }
export type UpdatePortfolioMasterMutationHookResult = ReturnType<typeof useUpdatePortfolioMasterMutation>;
export type UpdatePortfolioMasterMutationResult = Apollo.MutationResult<UpdatePortfolioMasterMutation>;
export type UpdatePortfolioMasterMutationOptions = Apollo.BaseMutationOptions<UpdatePortfolioMasterMutation, UpdatePortfolioMasterMutationVariables>;
export const UpdateWatchlistMasterDocument = gql`
    mutation UpdateWatchlistMaster($changes: [FieldChangeBooleanRequest!]!) {
  updateWatchlistMaster(changes: $changes) {
    id
    value
  }
}
    `;
export type UpdateWatchlistMasterMutationFn = Apollo.MutationFunction<UpdateWatchlistMasterMutation, UpdateWatchlistMasterMutationVariables>;

/**
 * __useUpdateWatchlistMasterMutation__
 *
 * To run a mutation, you first call `useUpdateWatchlistMasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWatchlistMasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWatchlistMasterMutation, { data, loading, error }] = useUpdateWatchlistMasterMutation({
 *   variables: {
 *      changes: // value for 'changes'
 *   },
 * });
 */
export function useUpdateWatchlistMasterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWatchlistMasterMutation, UpdateWatchlistMasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWatchlistMasterMutation, UpdateWatchlistMasterMutationVariables>(UpdateWatchlistMasterDocument, options);
      }
export type UpdateWatchlistMasterMutationHookResult = ReturnType<typeof useUpdateWatchlistMasterMutation>;
export type UpdateWatchlistMasterMutationResult = Apollo.MutationResult<UpdateWatchlistMasterMutation>;
export type UpdateWatchlistMasterMutationOptions = Apollo.BaseMutationOptions<UpdateWatchlistMasterMutation, UpdateWatchlistMasterMutationVariables>;
export const GetInstrumentHistoryQuotesDocument = gql`
    query getInstrumentHistoryQuotes($instrumentId: Int!, $criteria: HistoryQuoteCriteria!) {
  instrument(id: $instrumentId) {
    id
    name
    group {
      id
      name
      __typename
    }
    historyQuote(criteria: $criteria) {
      edges {
        node {
          start
          id
          lastPrice
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useGetInstrumentHistoryQuotesQuery__
 *
 * To run a query within a React component, call `useGetInstrumentHistoryQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentHistoryQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentHistoryQuotesQuery({
 *   variables: {
 *      instrumentId: // value for 'instrumentId'
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useGetInstrumentHistoryQuotesQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentHistoryQuotesQuery, GetInstrumentHistoryQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentHistoryQuotesQuery, GetInstrumentHistoryQuotesQueryVariables>(GetInstrumentHistoryQuotesDocument, options);
      }
export function useGetInstrumentHistoryQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentHistoryQuotesQuery, GetInstrumentHistoryQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentHistoryQuotesQuery, GetInstrumentHistoryQuotesQueryVariables>(GetInstrumentHistoryQuotesDocument, options);
        }
export type GetInstrumentHistoryQuotesQueryHookResult = ReturnType<typeof useGetInstrumentHistoryQuotesQuery>;
export type GetInstrumentHistoryQuotesLazyQueryHookResult = ReturnType<typeof useGetInstrumentHistoryQuotesLazyQuery>;
export type GetInstrumentHistoryQuotesQueryResult = Apollo.QueryResult<GetInstrumentHistoryQuotesQuery, GetInstrumentHistoryQuotesQueryVariables>;
export const GetTopFlopInstrumentsListDocument = gql`
    query getTopFlopInstrumentsList {
  list(id: "topflop_instruments") {
    id
    content {
      id
      name
      group {
        id
        name
        seoTag
        assetGroup
      }
    }
  }
}
    `;

/**
 * __useGetTopFlopInstrumentsListQuery__
 *
 * To run a query within a React component, call `useGetTopFlopInstrumentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopFlopInstrumentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopFlopInstrumentsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopFlopInstrumentsListQuery(baseOptions?: Apollo.QueryHookOptions<GetTopFlopInstrumentsListQuery, GetTopFlopInstrumentsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopFlopInstrumentsListQuery, GetTopFlopInstrumentsListQueryVariables>(GetTopFlopInstrumentsListDocument, options);
      }
export function useGetTopFlopInstrumentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopFlopInstrumentsListQuery, GetTopFlopInstrumentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopFlopInstrumentsListQuery, GetTopFlopInstrumentsListQueryVariables>(GetTopFlopInstrumentsListDocument, options);
        }
export type GetTopFlopInstrumentsListQueryHookResult = ReturnType<typeof useGetTopFlopInstrumentsListQuery>;
export type GetTopFlopInstrumentsListLazyQueryHookResult = ReturnType<typeof useGetTopFlopInstrumentsListLazyQuery>;
export type GetTopFlopInstrumentsListQueryResult = Apollo.QueryResult<GetTopFlopInstrumentsListQuery, GetTopFlopInstrumentsListQueryVariables>;
export const EditPortfolioOrderDocument = gql`
    mutation EditPortfolioOrder($viewOrder: String!, $viewOrderAsc: Boolean, $portfolioId: Long) {
  editPortfolioOrder(
    viewOrder: $viewOrder
    viewOrderAsc: $viewOrderAsc
    portfolioId: $portfolioId
  ) {
    responseCode
    responseMessage
  }
}
    `;
export type EditPortfolioOrderMutationFn = Apollo.MutationFunction<EditPortfolioOrderMutation, EditPortfolioOrderMutationVariables>;

/**
 * __useEditPortfolioOrderMutation__
 *
 * To run a mutation, you first call `useEditPortfolioOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPortfolioOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPortfolioOrderMutation, { data, loading, error }] = useEditPortfolioOrderMutation({
 *   variables: {
 *      viewOrder: // value for 'viewOrder'
 *      viewOrderAsc: // value for 'viewOrderAsc'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useEditPortfolioOrderMutation(baseOptions?: Apollo.MutationHookOptions<EditPortfolioOrderMutation, EditPortfolioOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPortfolioOrderMutation, EditPortfolioOrderMutationVariables>(EditPortfolioOrderDocument, options);
      }
export type EditPortfolioOrderMutationHookResult = ReturnType<typeof useEditPortfolioOrderMutation>;
export type EditPortfolioOrderMutationResult = Apollo.MutationResult<EditPortfolioOrderMutation>;
export type EditPortfolioOrderMutationOptions = Apollo.BaseMutationOptions<EditPortfolioOrderMutation, EditPortfolioOrderMutationVariables>;
export const EditPortfolioViewDocument = gql`
    mutation EditPortfolioView($viewType: String!, $portfolioId: Long) {
  editPortfolioView(viewType: $viewType, portfolioId: $portfolioId) {
    responseCode
    responseMessage
  }
}
    `;
export type EditPortfolioViewMutationFn = Apollo.MutationFunction<EditPortfolioViewMutation, EditPortfolioViewMutationVariables>;

/**
 * __useEditPortfolioViewMutation__
 *
 * To run a mutation, you first call `useEditPortfolioViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPortfolioViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPortfolioViewMutation, { data, loading, error }] = useEditPortfolioViewMutation({
 *   variables: {
 *      viewType: // value for 'viewType'
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function useEditPortfolioViewMutation(baseOptions?: Apollo.MutationHookOptions<EditPortfolioViewMutation, EditPortfolioViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditPortfolioViewMutation, EditPortfolioViewMutationVariables>(EditPortfolioViewDocument, options);
      }
export type EditPortfolioViewMutationHookResult = ReturnType<typeof useEditPortfolioViewMutation>;
export type EditPortfolioViewMutationResult = Apollo.MutationResult<EditPortfolioViewMutation>;
export type EditPortfolioViewMutationOptions = Apollo.BaseMutationOptions<EditPortfolioViewMutation, EditPortfolioViewMutationVariables>;
export const EditWatchlistOrderDocument = gql`
    mutation EditWatchlistOrder($viewOrder: String!, $viewOrderAsc: Boolean, $watchlistId: Long) {
  editWatchlistOrder(
    viewOrder: $viewOrder
    viewOrderAsc: $viewOrderAsc
    watchlistId: $watchlistId
  ) {
    responseCode
    responseMessage
  }
}
    `;
export type EditWatchlistOrderMutationFn = Apollo.MutationFunction<EditWatchlistOrderMutation, EditWatchlistOrderMutationVariables>;

/**
 * __useEditWatchlistOrderMutation__
 *
 * To run a mutation, you first call `useEditWatchlistOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWatchlistOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWatchlistOrderMutation, { data, loading, error }] = useEditWatchlistOrderMutation({
 *   variables: {
 *      viewOrder: // value for 'viewOrder'
 *      viewOrderAsc: // value for 'viewOrderAsc'
 *      watchlistId: // value for 'watchlistId'
 *   },
 * });
 */
export function useEditWatchlistOrderMutation(baseOptions?: Apollo.MutationHookOptions<EditWatchlistOrderMutation, EditWatchlistOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWatchlistOrderMutation, EditWatchlistOrderMutationVariables>(EditWatchlistOrderDocument, options);
      }
export type EditWatchlistOrderMutationHookResult = ReturnType<typeof useEditWatchlistOrderMutation>;
export type EditWatchlistOrderMutationResult = Apollo.MutationResult<EditWatchlistOrderMutation>;
export type EditWatchlistOrderMutationOptions = Apollo.BaseMutationOptions<EditWatchlistOrderMutation, EditWatchlistOrderMutationVariables>;
export const EditWatchlistViewDocument = gql`
    mutation EditWatchlistView($viewType: String!, $watchlistId: Long) {
  editWatchlistView(viewType: $viewType, watchlistId: $watchlistId) {
    responseCode
    responseMessage
  }
}
    `;
export type EditWatchlistViewMutationFn = Apollo.MutationFunction<EditWatchlistViewMutation, EditWatchlistViewMutationVariables>;

/**
 * __useEditWatchlistViewMutation__
 *
 * To run a mutation, you first call `useEditWatchlistViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditWatchlistViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editWatchlistViewMutation, { data, loading, error }] = useEditWatchlistViewMutation({
 *   variables: {
 *      viewType: // value for 'viewType'
 *      watchlistId: // value for 'watchlistId'
 *   },
 * });
 */
export function useEditWatchlistViewMutation(baseOptions?: Apollo.MutationHookOptions<EditWatchlistViewMutation, EditWatchlistViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditWatchlistViewMutation, EditWatchlistViewMutationVariables>(EditWatchlistViewDocument, options);
      }
export type EditWatchlistViewMutationHookResult = ReturnType<typeof useEditWatchlistViewMutation>;
export type EditWatchlistViewMutationResult = Apollo.MutationResult<EditWatchlistViewMutation>;
export type EditWatchlistViewMutationOptions = Apollo.BaseMutationOptions<EditWatchlistViewMutation, EditWatchlistViewMutationVariables>;
export const GetInstrumentsCountDocument = gql`
    query getInstrumentsCount($searchString: String!) {
  search(criteria: {searchString: $searchString}, first: 0) {
    assetGroups {
      assetGroup
      count
    }
  }
}
    `;

/**
 * __useGetInstrumentsCountQuery__
 *
 * To run a query within a React component, call `useGetInstrumentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentsCountQuery({
 *   variables: {
 *      searchString: // value for 'searchString'
 *   },
 * });
 */
export function useGetInstrumentsCountQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentsCountQuery, GetInstrumentsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentsCountQuery, GetInstrumentsCountQueryVariables>(GetInstrumentsCountDocument, options);
      }
export function useGetInstrumentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentsCountQuery, GetInstrumentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentsCountQuery, GetInstrumentsCountQueryVariables>(GetInstrumentsCountDocument, options);
        }
export type GetInstrumentsCountQueryHookResult = ReturnType<typeof useGetInstrumentsCountQuery>;
export type GetInstrumentsCountLazyQueryHookResult = ReturnType<typeof useGetInstrumentsCountLazyQuery>;
export type GetInstrumentsCountQueryResult = Apollo.QueryResult<GetInstrumentsCountQuery, GetInstrumentsCountQueryVariables>;
export const GetInstrumentsSearchDocument = gql`
    query getInstrumentsSearch($assetGroup: [AssetGroup!], $searchString: String!, $first: Int!, $after: ID) {
  search(
    criteria: {assetGroup: $assetGroup, searchString: $searchString}
    first: $first
    after: $after
  ) {
    edges {
      cursor
      node {
        id
        name
        wkn
        group {
          name
          assetGroup
          seoTag
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    assetGroups {
      assetGroup
      count
    }
  }
}
    `;

/**
 * __useGetInstrumentsSearchQuery__
 *
 * To run a query within a React component, call `useGetInstrumentsSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInstrumentsSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInstrumentsSearchQuery({
 *   variables: {
 *      assetGroup: // value for 'assetGroup'
 *      searchString: // value for 'searchString'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetInstrumentsSearchQuery(baseOptions: Apollo.QueryHookOptions<GetInstrumentsSearchQuery, GetInstrumentsSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInstrumentsSearchQuery, GetInstrumentsSearchQueryVariables>(GetInstrumentsSearchDocument, options);
      }
export function useGetInstrumentsSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInstrumentsSearchQuery, GetInstrumentsSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInstrumentsSearchQuery, GetInstrumentsSearchQueryVariables>(GetInstrumentsSearchDocument, options);
        }
export type GetInstrumentsSearchQueryHookResult = ReturnType<typeof useGetInstrumentsSearchQuery>;
export type GetInstrumentsSearchLazyQueryHookResult = ReturnType<typeof useGetInstrumentsSearchLazyQuery>;
export type GetInstrumentsSearchQueryResult = Apollo.QueryResult<GetInstrumentsSearchQuery, GetInstrumentsSearchQueryVariables>;
export const GetTopFlopInstrumentsWithAnalysisReportDocument = gql`
    query getTopFlopInstrumentsWithAnalysisReport {
  list(id: "topflop_instruments") {
    id
    content {
      id
      name
      group {
        id
        name
        seoTag
        assetGroup
        analysisReport {
          positiveCount
          neutralCount
          negativeCount
        }
      }
    }
  }
}
    `;

/**
 * __useGetTopFlopInstrumentsWithAnalysisReportQuery__
 *
 * To run a query within a React component, call `useGetTopFlopInstrumentsWithAnalysisReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopFlopInstrumentsWithAnalysisReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopFlopInstrumentsWithAnalysisReportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopFlopInstrumentsWithAnalysisReportQuery(baseOptions?: Apollo.QueryHookOptions<GetTopFlopInstrumentsWithAnalysisReportQuery, GetTopFlopInstrumentsWithAnalysisReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopFlopInstrumentsWithAnalysisReportQuery, GetTopFlopInstrumentsWithAnalysisReportQueryVariables>(GetTopFlopInstrumentsWithAnalysisReportDocument, options);
      }
export function useGetTopFlopInstrumentsWithAnalysisReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopFlopInstrumentsWithAnalysisReportQuery, GetTopFlopInstrumentsWithAnalysisReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopFlopInstrumentsWithAnalysisReportQuery, GetTopFlopInstrumentsWithAnalysisReportQueryVariables>(GetTopFlopInstrumentsWithAnalysisReportDocument, options);
        }
export type GetTopFlopInstrumentsWithAnalysisReportQueryHookResult = ReturnType<typeof useGetTopFlopInstrumentsWithAnalysisReportQuery>;
export type GetTopFlopInstrumentsWithAnalysisReportLazyQueryHookResult = ReturnType<typeof useGetTopFlopInstrumentsWithAnalysisReportLazyQuery>;
export type GetTopFlopInstrumentsWithAnalysisReportQueryResult = Apollo.QueryResult<GetTopFlopInstrumentsWithAnalysisReportQuery, GetTopFlopInstrumentsWithAnalysisReportQueryVariables>;
export const GetAnalysesShareOverviewDocument = gql`
    query getAnalysesShareOverview($instrumentGroupId: Int!, $from: LocalDate, $first: Int, $after: ID) {
  group(id: $instrumentGroupId) {
    id
    analysis(criteria: {from: $from}, first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          date
          timeFrame
          recommendation
          targetPrice
          referencePrice
          updated
          latest
          currency {
            displayCode
            __typename
          }
          institute {
            id
            name
            __typename
          }
          analyst {
            firstName
            lastName
            __typename
          }
          group {
            id
            name
            seoTag
            assetGroup
            main {
              id
              currency {
                displayCode
              }
              snapQuote {
                lastChange
                instrumentId
                quote(type: TRADE) {
                  value
                  change
                  percentChange
                }
              }
            }
          }
          headline
          body
          __typename
        }
        __typename
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        __typename
      }
      __typename
    }
  }
}
    `;

/**
 * __useGetAnalysesShareOverviewQuery__
 *
 * To run a query within a React component, call `useGetAnalysesShareOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalysesShareOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalysesShareOverviewQuery({
 *   variables: {
 *      instrumentGroupId: // value for 'instrumentGroupId'
 *      from: // value for 'from'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetAnalysesShareOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetAnalysesShareOverviewQuery, GetAnalysesShareOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalysesShareOverviewQuery, GetAnalysesShareOverviewQueryVariables>(GetAnalysesShareOverviewDocument, options);
      }
export function useGetAnalysesShareOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalysesShareOverviewQuery, GetAnalysesShareOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalysesShareOverviewQuery, GetAnalysesShareOverviewQueryVariables>(GetAnalysesShareOverviewDocument, options);
        }
export type GetAnalysesShareOverviewQueryHookResult = ReturnType<typeof useGetAnalysesShareOverviewQuery>;
export type GetAnalysesShareOverviewLazyQueryHookResult = ReturnType<typeof useGetAnalysesShareOverviewLazyQuery>;
export type GetAnalysesShareOverviewQueryResult = Apollo.QueryResult<GetAnalysesShareOverviewQuery, GetAnalysesShareOverviewQueryVariables>;
export const TheScreenerRatingSearchUpdateDocument = gql`
    query theScreenerRatingSearchUpdate($first: Int!, $change: TheScreenerRatingChange, $instrumentGroupId: Int) {
  theScreenerRatingSearch(
    criteria: {update: true, change: $change, instrumentGroupId: $instrumentGroupId}
    first: $first
  ) {
    isin
    previousRating
    rating
    group {
      name
      isin
      seoTag
      assetGroup
    }
    date
  }
}
    `;

/**
 * __useTheScreenerRatingSearchUpdateQuery__
 *
 * To run a query within a React component, call `useTheScreenerRatingSearchUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTheScreenerRatingSearchUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTheScreenerRatingSearchUpdateQuery({
 *   variables: {
 *      first: // value for 'first'
 *      change: // value for 'change'
 *      instrumentGroupId: // value for 'instrumentGroupId'
 *   },
 * });
 */
export function useTheScreenerRatingSearchUpdateQuery(baseOptions: Apollo.QueryHookOptions<TheScreenerRatingSearchUpdateQuery, TheScreenerRatingSearchUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TheScreenerRatingSearchUpdateQuery, TheScreenerRatingSearchUpdateQueryVariables>(TheScreenerRatingSearchUpdateDocument, options);
      }
export function useTheScreenerRatingSearchUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TheScreenerRatingSearchUpdateQuery, TheScreenerRatingSearchUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TheScreenerRatingSearchUpdateQuery, TheScreenerRatingSearchUpdateQueryVariables>(TheScreenerRatingSearchUpdateDocument, options);
        }
export type TheScreenerRatingSearchUpdateQueryHookResult = ReturnType<typeof useTheScreenerRatingSearchUpdateQuery>;
export type TheScreenerRatingSearchUpdateLazyQueryHookResult = ReturnType<typeof useTheScreenerRatingSearchUpdateLazyQuery>;
export type TheScreenerRatingSearchUpdateQueryResult = Apollo.QueryResult<TheScreenerRatingSearchUpdateQuery, TheScreenerRatingSearchUpdateQueryVariables>;
export const GetTopFlopInstrumentsCustomDocument = gql`
    query getTopFlopInstrumentsCustom {
  list(id: "topflop_instruments") {
    id
    content {
      id
      name
      group {
        id
        name
        seoTag
        assetGroup
        analysisReport {
          positiveCount
          neutralCount
          negativeCount
        }
      }
      exchange {
        id
        name
        code
      }
    }
  }
}
    `;

/**
 * __useGetTopFlopInstrumentsCustomQuery__
 *
 * To run a query within a React component, call `useGetTopFlopInstrumentsCustomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopFlopInstrumentsCustomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopFlopInstrumentsCustomQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopFlopInstrumentsCustomQuery(baseOptions?: Apollo.QueryHookOptions<GetTopFlopInstrumentsCustomQuery, GetTopFlopInstrumentsCustomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopFlopInstrumentsCustomQuery, GetTopFlopInstrumentsCustomQueryVariables>(GetTopFlopInstrumentsCustomDocument, options);
      }
export function useGetTopFlopInstrumentsCustomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTopFlopInstrumentsCustomQuery, GetTopFlopInstrumentsCustomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopFlopInstrumentsCustomQuery, GetTopFlopInstrumentsCustomQueryVariables>(GetTopFlopInstrumentsCustomDocument, options);
        }
export type GetTopFlopInstrumentsCustomQueryHookResult = ReturnType<typeof useGetTopFlopInstrumentsCustomQuery>;
export type GetTopFlopInstrumentsCustomLazyQueryHookResult = ReturnType<typeof useGetTopFlopInstrumentsCustomLazyQuery>;
export type GetTopFlopInstrumentsCustomQueryResult = Apollo.QueryResult<GetTopFlopInstrumentsCustomQuery, GetTopFlopInstrumentsCustomQueryVariables>;
export const GetShareOverviewDocument = gql`
    query getShareOverview($groupId: Int!) {
  group(id: $groupId) {
    id
    name
    assetGroup
    isin
    description {
      text
    }
    content {
      id
      isin
      wkn
      main
      tickerSymbol
      name
      group {
        assetGroup
        seoTag
      }
      exchange {
        id
        name
        code
      }
      currency {
        id
        name
        displayCode
        sign
      }
      countryId
      snapQuote {
        lastChange
        instrumentId
        lowPrice
        highPrice
        firstPrice
        lastPrice
        yesterdayPrice
        cumulativeTrades
        cumulativeTurnover
        cumulativeVolume
        quotes {
          delay
          type
          value
          percentChange
          change
          when
        }
      }
      performance(
        period: [WEEK1, MONTH1, MONTH3, MONTH6, WEEK52, YEAR3, YEAR5, YEAR10]
      ) {
        period
        averagePrice
        performance
        sharpe
        vola
      }
      stats(periods: [ALL_TIME, WEEK52]) {
        period
        lowPrice
        lowPriceDate
        deltaLowPrice
        highPrice
        highPriceDate
        deltaHighPrice
      }
      rangeCharts {
        intraday {
          min
          max
          current
          threshold
        }
        year {
          min
          max
          current
          threshold
        }
      }
    }
  }
}
    `;

/**
 * __useGetShareOverviewQuery__
 *
 * To run a query within a React component, call `useGetShareOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareOverviewQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetShareOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetShareOverviewQuery, GetShareOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShareOverviewQuery, GetShareOverviewQueryVariables>(GetShareOverviewDocument, options);
      }
export function useGetShareOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShareOverviewQuery, GetShareOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShareOverviewQuery, GetShareOverviewQueryVariables>(GetShareOverviewDocument, options);
        }
export type GetShareOverviewQueryHookResult = ReturnType<typeof useGetShareOverviewQuery>;
export type GetShareOverviewLazyQueryHookResult = ReturnType<typeof useGetShareOverviewLazyQuery>;
export type GetShareOverviewQueryResult = Apollo.QueryResult<GetShareOverviewQuery, GetShareOverviewQueryVariables>;
export const GetSearchShareCountDocument = gql`
    query getSearchShareCount($criterion: SearchShareCriterion) {
  searchShare(criterion: $criterion, first: 0) {
    count
  }
}
    `;

/**
 * __useGetSearchShareCountQuery__
 *
 * To run a query within a React component, call `useGetSearchShareCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchShareCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchShareCountQuery({
 *   variables: {
 *      criterion: // value for 'criterion'
 *   },
 * });
 */
export function useGetSearchShareCountQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchShareCountQuery, GetSearchShareCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchShareCountQuery, GetSearchShareCountQueryVariables>(GetSearchShareCountDocument, options);
      }
export function useGetSearchShareCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchShareCountQuery, GetSearchShareCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchShareCountQuery, GetSearchShareCountQueryVariables>(GetSearchShareCountDocument, options);
        }
export type GetSearchShareCountQueryHookResult = ReturnType<typeof useGetSearchShareCountQuery>;
export type GetSearchShareCountLazyQueryHookResult = ReturnType<typeof useGetSearchShareCountLazyQuery>;
export type GetSearchShareCountQueryResult = Apollo.QueryResult<GetSearchShareCountQuery, GetSearchShareCountQueryVariables>;
export const GetShareRegionsDocument = gql`
    query getShareRegions {
  regions {
    id
    name
  }
}
    `;

/**
 * __useGetShareRegionsQuery__
 *
 * To run a query within a React component, call `useGetShareRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShareRegionsQuery(baseOptions?: Apollo.QueryHookOptions<GetShareRegionsQuery, GetShareRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShareRegionsQuery, GetShareRegionsQueryVariables>(GetShareRegionsDocument, options);
      }
export function useGetShareRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShareRegionsQuery, GetShareRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShareRegionsQuery, GetShareRegionsQueryVariables>(GetShareRegionsDocument, options);
        }
export type GetShareRegionsQueryHookResult = ReturnType<typeof useGetShareRegionsQuery>;
export type GetShareRegionsLazyQueryHookResult = ReturnType<typeof useGetShareRegionsLazyQuery>;
export type GetShareRegionsQueryResult = Apollo.QueryResult<GetShareRegionsQuery, GetShareRegionsQueryVariables>;
export const GetShareSeachMetaDataDocument = gql`
    query getShareSeachMetaData {
  classification(category: SHARE) {
    id
    name
    typeGroups {
      id
      name
    }
  }
}
    `;

/**
 * __useGetShareSeachMetaDataQuery__
 *
 * To run a query within a React component, call `useGetShareSeachMetaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareSeachMetaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareSeachMetaDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShareSeachMetaDataQuery(baseOptions?: Apollo.QueryHookOptions<GetShareSeachMetaDataQuery, GetShareSeachMetaDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShareSeachMetaDataQuery, GetShareSeachMetaDataQueryVariables>(GetShareSeachMetaDataDocument, options);
      }
export function useGetShareSeachMetaDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShareSeachMetaDataQuery, GetShareSeachMetaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShareSeachMetaDataQuery, GetShareSeachMetaDataQueryVariables>(GetShareSeachMetaDataDocument, options);
        }
export type GetShareSeachMetaDataQueryHookResult = ReturnType<typeof useGetShareSeachMetaDataQuery>;
export type GetShareSeachMetaDataLazyQueryHookResult = ReturnType<typeof useGetShareSeachMetaDataLazyQuery>;
export type GetShareSeachMetaDataQueryResult = Apollo.QueryResult<GetShareSeachMetaDataQuery, GetShareSeachMetaDataQueryVariables>;
export const GetShareSearchResultDocument = gql`
    query getShareSearchResult($criterion: SearchShareCriterion, $sort: [SearchShareSort!] = [], $first: Int, $after: ID) {
  searchShare(criterion: $criterion, sort: $sort, first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        name
        wkn
        isin
        currency {
          displayCode
        }
        exchange {
          name
        }
        snapQuote {
          lastChange
          lastPrice
          instrumentId
          quote(type: TRADE) {
            value
            change
            percentChange
          }
        }
        group {
          id
          seoTag
          assetGroup
          sector {
            id
            name
          }
          refCountry {
            id
            name
          }
          refMarketCapitalization {
            value
            currency {
              displayCode
            }
          }
          company {
            currency {
              displayCode
            }
            id
            name
            performance {
              keyFigures {
                sales
                operatingCashFlow
                salesPerShare
                netIncome
                dividendPerShare
                dividendYield
                salesPerEmployee
                dividendPayoutRatio
                dividendPerShare
              }
              items {
                year
                yearPeriod
                cashFlowChange
                salesChange
                netIncomeChange
                salesYearChange
                cashFlowChangePercent
                salesChangePercent
                netIncomeChangePercent
                dividendYieldAverage
                dividendChangePercent
                salesPerEmployeeChangePercent
              }
            }
          }
        }
        performance {
          period
          performance
          vola
        }
        stats(periods: [ALL_TIME, WEEK52]) {
          period
          lowPrice
          highPrice
          lowPriceDate
          highPriceDate
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
    count
  }
}
    `;

/**
 * __useGetShareSearchResultQuery__
 *
 * To run a query within a React component, call `useGetShareSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShareSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShareSearchResultQuery({
 *   variables: {
 *      criterion: // value for 'criterion'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetShareSearchResultQuery(baseOptions?: Apollo.QueryHookOptions<GetShareSearchResultQuery, GetShareSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShareSearchResultQuery, GetShareSearchResultQueryVariables>(GetShareSearchResultDocument, options);
      }
export function useGetShareSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShareSearchResultQuery, GetShareSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShareSearchResultQuery, GetShareSearchResultQueryVariables>(GetShareSearchResultDocument, options);
        }
export type GetShareSearchResultQueryHookResult = ReturnType<typeof useGetShareSearchResultQuery>;
export type GetShareSearchResultLazyQueryHookResult = ReturnType<typeof useGetShareSearchResultLazyQuery>;
export type GetShareSearchResultQueryResult = Apollo.QueryResult<GetShareSearchResultQuery, GetShareSearchResultQueryVariables>;
export const GetHomeCalendarEventsDocument = gql`
    query getHomeCalendarEvents($from: LocalDate!, $count: Int!) {
  economicEvents: searchCalendarEvents(
    criteria: {from: $from, future: true, eventType: ECONOMIC}
    first: $count
  ) {
    edges {
      node {
        id
        title
        eventType
        country {
          country {
            isoAlpha2
            isoAlpha3
          }
        }
        products {
          group {
            name
            assetGroup
            seoTag
          }
        }
        when
      }
    }
  }
  companyEvents: searchCalendarEvents(
    criteria: {from: $from, to: $from, eventType: COMPANY}
    first: $count
  ) {
    edges {
      node {
        id
        title
        eventType
        country {
          country {
            isoAlpha2
            isoAlpha3
          }
        }
        products {
          group {
            name
            assetGroup
            seoTag
          }
        }
        when
      }
    }
  }
}
    `;

/**
 * __useGetHomeCalendarEventsQuery__
 *
 * To run a query within a React component, call `useGetHomeCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeCalendarEventsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetHomeCalendarEventsQuery(baseOptions: Apollo.QueryHookOptions<GetHomeCalendarEventsQuery, GetHomeCalendarEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHomeCalendarEventsQuery, GetHomeCalendarEventsQueryVariables>(GetHomeCalendarEventsDocument, options);
      }
export function useGetHomeCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeCalendarEventsQuery, GetHomeCalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHomeCalendarEventsQuery, GetHomeCalendarEventsQueryVariables>(GetHomeCalendarEventsDocument, options);
        }
export type GetHomeCalendarEventsQueryHookResult = ReturnType<typeof useGetHomeCalendarEventsQuery>;
export type GetHomeCalendarEventsLazyQueryHookResult = ReturnType<typeof useGetHomeCalendarEventsLazyQuery>;
export type GetHomeCalendarEventsQueryResult = Apollo.QueryResult<GetHomeCalendarEventsQuery, GetHomeCalendarEventsQueryVariables>;
export const GetProductCalendarEventsDocument = gql`
    query getProductCalendarEvents($groupId: Int!, $from: LocalDate!, $count: Int!) {
  group(id: $groupId) {
    calendarEvents(criteria: {from: $from}, first: $count) {
      edges {
        node {
          title
          when
        }
      }
    }
  }
}
    `;

/**
 * __useGetProductCalendarEventsQuery__
 *
 * To run a query within a React component, call `useGetProductCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductCalendarEventsQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      from: // value for 'from'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useGetProductCalendarEventsQuery(baseOptions: Apollo.QueryHookOptions<GetProductCalendarEventsQuery, GetProductCalendarEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductCalendarEventsQuery, GetProductCalendarEventsQueryVariables>(GetProductCalendarEventsDocument, options);
      }
export function useGetProductCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductCalendarEventsQuery, GetProductCalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductCalendarEventsQuery, GetProductCalendarEventsQueryVariables>(GetProductCalendarEventsDocument, options);
        }
export type GetProductCalendarEventsQueryHookResult = ReturnType<typeof useGetProductCalendarEventsQuery>;
export type GetProductCalendarEventsLazyQueryHookResult = ReturnType<typeof useGetProductCalendarEventsLazyQuery>;
export type GetProductCalendarEventsQueryResult = Apollo.QueryResult<GetProductCalendarEventsQuery, GetProductCalendarEventsQueryVariables>;
export const CalendarCategoriesDocument = gql`
    query CalendarCategories {
  calendarCategories {
    id
    name
  }
}
    `;

/**
 * __useCalendarCategoriesQuery__
 *
 * To run a query within a React component, call `useCalendarCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendarCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<CalendarCategoriesQuery, CalendarCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarCategoriesQuery, CalendarCategoriesQueryVariables>(CalendarCategoriesDocument, options);
      }
export function useCalendarCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarCategoriesQuery, CalendarCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarCategoriesQuery, CalendarCategoriesQueryVariables>(CalendarCategoriesDocument, options);
        }
export type CalendarCategoriesQueryHookResult = ReturnType<typeof useCalendarCategoriesQuery>;
export type CalendarCategoriesLazyQueryHookResult = ReturnType<typeof useCalendarCategoriesLazyQuery>;
export type CalendarCategoriesQueryResult = Apollo.QueryResult<CalendarCategoriesQuery, CalendarCategoriesQueryVariables>;
export const CalendarCountriesDocument = gql`
    query CalendarCountries {
  calendarCountries {
    id
    name
  }
}
    `;

/**
 * __useCalendarCountriesQuery__
 *
 * To run a query within a React component, call `useCalendarCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCalendarCountriesQuery(baseOptions?: Apollo.QueryHookOptions<CalendarCountriesQuery, CalendarCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarCountriesQuery, CalendarCountriesQueryVariables>(CalendarCountriesDocument, options);
      }
export function useCalendarCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarCountriesQuery, CalendarCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarCountriesQuery, CalendarCountriesQueryVariables>(CalendarCountriesDocument, options);
        }
export type CalendarCountriesQueryHookResult = ReturnType<typeof useCalendarCountriesQuery>;
export type CalendarCountriesLazyQueryHookResult = ReturnType<typeof useCalendarCountriesLazyQuery>;
export type CalendarCountriesQueryResult = Apollo.QueryResult<CalendarCountriesQuery, CalendarCountriesQueryVariables>;
export const CalendarEventSummaryDocument = gql`
    query CalendarEventSummary($from: LocalDate, $to: LocalDate) {
  calendarEventSummary(from: $from, to: $to) {
    date
    count
  }
}
    `;

/**
 * __useCalendarEventSummaryQuery__
 *
 * To run a query within a React component, call `useCalendarEventSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarEventSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarEventSummaryQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCalendarEventSummaryQuery(baseOptions?: Apollo.QueryHookOptions<CalendarEventSummaryQuery, CalendarEventSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarEventSummaryQuery, CalendarEventSummaryQueryVariables>(CalendarEventSummaryDocument, options);
      }
export function useCalendarEventSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarEventSummaryQuery, CalendarEventSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarEventSummaryQuery, CalendarEventSummaryQueryVariables>(CalendarEventSummaryDocument, options);
        }
export type CalendarEventSummaryQueryHookResult = ReturnType<typeof useCalendarEventSummaryQuery>;
export type CalendarEventSummaryLazyQueryHookResult = ReturnType<typeof useCalendarEventSummaryLazyQuery>;
export type CalendarEventSummaryQueryResult = Apollo.QueryResult<CalendarEventSummaryQuery, CalendarEventSummaryQueryVariables>;
export const SearchCalendarEventsDocument = gql`
    query SearchCalendarEvents($first: Int, $after: ID, $from: LocalDate, $to: LocalDate, $countryId: ID, $categoryId: ID, $relevance: [EventRelevance!]) {
  searchCalendarEvents(
    first: $first
    after: $after
    criteria: {from: $from, to: $to, countryId: $countryId, categoryId: $categoryId, relevance: $relevance}
  ) {
    edges {
      node {
        id
        title
        description
        country {
          id
          name
        }
        currency {
          id
          name
          currency {
            sign
            displayCode
          }
        }
        category {
          id
          name
        }
        products {
          group {
            id
            name
            seoTag
            assetGroup
          }
        }
        relevance
        eventType
        consensus
        relevantTime
        actual
        revised
        previous
        when
        __typename
      }
      cursor
      __typename
    }
    count
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
      __typename
    }
  }
}
    `;

/**
 * __useSearchCalendarEventsQuery__
 *
 * To run a query within a React component, call `useSearchCalendarEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCalendarEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCalendarEventsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      countryId: // value for 'countryId'
 *      categoryId: // value for 'categoryId'
 *      relevance: // value for 'relevance'
 *   },
 * });
 */
export function useSearchCalendarEventsQuery(baseOptions?: Apollo.QueryHookOptions<SearchCalendarEventsQuery, SearchCalendarEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCalendarEventsQuery, SearchCalendarEventsQueryVariables>(SearchCalendarEventsDocument, options);
      }
export function useSearchCalendarEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCalendarEventsQuery, SearchCalendarEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCalendarEventsQuery, SearchCalendarEventsQueryVariables>(SearchCalendarEventsDocument, options);
        }
export type SearchCalendarEventsQueryHookResult = ReturnType<typeof useSearchCalendarEventsQuery>;
export type SearchCalendarEventsLazyQueryHookResult = ReturnType<typeof useSearchCalendarEventsLazyQuery>;
export type SearchCalendarEventsQueryResult = Apollo.QueryResult<SearchCalendarEventsQuery, SearchCalendarEventsQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Node": [
      "News"
    ]
  }
};
      export default result;
    